// Generated by purs bundle 0.14.7
var PS = {};
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Function"] = $PS["Data.Function"] || {};
  var exports = $PS["Data.Function"];
  var flip = function (f) {
      return function (b) {
          return function (a) {
              return f(a)(b);
          };
      };
  };
  var $$const = function (a) {
      return function (v) {
          return a;
      };
  };
  exports["flip"] = flip;
  exports["const"] = $$const;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Bind"] = $PS["Control.Bind"] || {};
  var exports = $PS["Control.Bind"];
  var Data_Function = $PS["Data.Function"];          
  var discard = function (dict) {
      return dict.discard;
  };
  var bind = function (dict) {
      return dict.bind;
  };
  var bindFlipped = function (dictBind) {
      return Data_Function.flip(bind(dictBind));
  };
  var composeKleisliFlipped = function (dictBind) {
      return function (f) {
          return function (g) {
              return function (a) {
                  return bindFlipped(dictBind)(f)(g(a));
              };
          };
      };
  };
  var composeKleisli = function (dictBind) {
      return function (f) {
          return function (g) {
              return function (a) {
                  return bind(dictBind)(f(a))(g);
              };
          };
      };
  };
  var discardUnit = {
      discard: function (dictBind) {
          return bind(dictBind);
      }
  };
  exports["bind"] = bind;
  exports["bindFlipped"] = bindFlipped;
  exports["discard"] = discard;
  exports["composeKleisli"] = composeKleisli;
  exports["composeKleisliFlipped"] = composeKleisliFlipped;
  exports["discardUnit"] = discardUnit;
})(PS);
(function(exports) {
  "use strict";

  var refEq = function (r1) {
    return function (r2) {
      return r1 === r2;
    };
  };

  exports.eqBooleanImpl = refEq;
  exports.eqIntImpl = refEq; 
  exports.eqStringImpl = refEq;

  exports.eqArrayImpl = function (f) {
    return function (xs) {
      return function (ys) {
        if (xs.length !== ys.length) return false;
        for (var i = 0; i < xs.length; i++) {
          if (!f(xs[i])(ys[i])) return false;
        }
        return true;
      };
    };
  };
})(PS["Data.Eq"] = PS["Data.Eq"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Symbol"] = $PS["Data.Symbol"] || {};
  var exports = $PS["Data.Symbol"];
  var reflectSymbol = function (dict) {
      return dict.reflectSymbol;
  };
  exports["reflectSymbol"] = reflectSymbol;
})(PS);
(function(exports) {
  "use strict";

  exports.unsafeGet = function (label) {
    return function (rec) {
      return rec[label];
    };
  };
})(PS["Record.Unsafe"] = PS["Record.Unsafe"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Record.Unsafe"] = $PS["Record.Unsafe"] || {};
  var exports = $PS["Record.Unsafe"];
  var $foreign = $PS["Record.Unsafe"];
  exports["unsafeGet"] = $foreign.unsafeGet;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Type.Proxy"] = $PS["Type.Proxy"] || {};
  var exports = $PS["Type.Proxy"];
  var $$Proxy = (function () {
      function $$Proxy() {

      };
      $$Proxy.value = new $$Proxy();
      return $$Proxy;
  })();
  exports["Proxy"] = $$Proxy;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Eq"] = $PS["Data.Eq"] || {};
  var exports = $PS["Data.Eq"];
  var $foreign = $PS["Data.Eq"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Record_Unsafe = $PS["Record.Unsafe"];
  var Type_Proxy = $PS["Type.Proxy"];
  var eqString = {
      eq: $foreign.eqStringImpl
  };
  var eqRowNil = {
      eqRecord: function (v) {
          return function (v1) {
              return function (v2) {
                  return true;
              };
          };
      }
  };
  var eqRecord = function (dict) {
      return dict.eqRecord;
  };
  var eqRec = function () {
      return function (dictEqRecord) {
          return {
              eq: eqRecord(dictEqRecord)(Type_Proxy["Proxy"].value)
          };
      };
  };
  var eqInt = {
      eq: $foreign.eqIntImpl
  };
  var eqBoolean = {
      eq: $foreign.eqBooleanImpl
  };
  var eq = function (dict) {
      return dict.eq;
  };
  var eqArray = function (dictEq) {
      return {
          eq: $foreign.eqArrayImpl(eq(dictEq))
      };
  };
  var eqRowCons = function (dictEqRecord) {
      return function () {
          return function (dictIsSymbol) {
              return function (dictEq) {
                  return {
                      eqRecord: function (v) {
                          return function (ra) {
                              return function (rb) {
                                  var tail = eqRecord(dictEqRecord)(Type_Proxy["Proxy"].value)(ra)(rb);
                                  var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                                  var get = Record_Unsafe.unsafeGet(key);
                                  return eq(dictEq)(get(ra))(get(rb)) && tail;
                              };
                          };
                      }
                  };
              };
          };
      };
  };
  var notEq = function (dictEq) {
      return function (x) {
          return function (y) {
              return eq(eqBoolean)(eq(dictEq)(x)(y))(false);
          };
      };
  };
  exports["eq"] = eq;
  exports["notEq"] = notEq;
  exports["eqInt"] = eqInt;
  exports["eqString"] = eqString;
  exports["eqArray"] = eqArray;
  exports["eqRec"] = eqRec;
  exports["eqRowNil"] = eqRowNil;
  exports["eqRowCons"] = eqRowCons;
})(PS);
(function(exports) {
  "use strict";

  var unsafeCompareImpl = function (lt) {
    return function (eq) {
      return function (gt) {
        return function (x) {
          return function (y) {
            return x < y ? lt : x === y ? eq : gt;
          };
        };
      };
    };
  };                                         
  exports.ordIntImpl = unsafeCompareImpl;   
  exports.ordStringImpl = unsafeCompareImpl;
})(PS["Data.Ord"] = PS["Data.Ord"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Ordering"] = $PS["Data.Ordering"] || {};
  var exports = $PS["Data.Ordering"];
  var LT = (function () {
      function LT() {

      };
      LT.value = new LT();
      return LT;
  })();
  var GT = (function () {
      function GT() {

      };
      GT.value = new GT();
      return GT;
  })();
  var EQ = (function () {
      function EQ() {

      };
      EQ.value = new EQ();
      return EQ;
  })();
  exports["LT"] = LT;
  exports["GT"] = GT;
  exports["EQ"] = EQ;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Ord"] = $PS["Data.Ord"] || {};
  var exports = $PS["Data.Ord"];
  var $foreign = $PS["Data.Ord"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Ordering = $PS["Data.Ordering"];
  var ordString = {
      compare: $foreign.ordStringImpl(Data_Ordering.LT.value)(Data_Ordering.EQ.value)(Data_Ordering.GT.value),
      Eq0: function () {
          return Data_Eq.eqString;
      }
  };
  var ordInt = {
      compare: $foreign.ordIntImpl(Data_Ordering.LT.value)(Data_Ordering.EQ.value)(Data_Ordering.GT.value),
      Eq0: function () {
          return Data_Eq.eqInt;
      }
  };
  var compare = function (dict) {
      return dict.compare;
  };
  var greaterThan = function (dictOrd) {
      return function (a1) {
          return function (a2) {
              var v = compare(dictOrd)(a1)(a2);
              if (v instanceof Data_Ordering.GT) {
                  return true;
              };
              return false;
          };
      };
  };
  var lessThan = function (dictOrd) {
      return function (a1) {
          return function (a2) {
              var v = compare(dictOrd)(a1)(a2);
              if (v instanceof Data_Ordering.LT) {
                  return true;
              };
              return false;
          };
      };
  };
  var lessThanOrEq = function (dictOrd) {
      return function (a1) {
          return function (a2) {
              var v = compare(dictOrd)(a1)(a2);
              if (v instanceof Data_Ordering.GT) {
                  return false;
              };
              return true;
          };
      };
  };
  exports["compare"] = compare;
  exports["lessThan"] = lessThan;
  exports["lessThanOrEq"] = lessThanOrEq;
  exports["greaterThan"] = greaterThan;
  exports["ordInt"] = ordInt;
  exports["ordString"] = ordString;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Tuple"] = $PS["Data.Tuple"] || {};
  var exports = $PS["Data.Tuple"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Ordering = $PS["Data.Ordering"];        
  var Tuple = (function () {
      function Tuple(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Tuple.create = function (value0) {
          return function (value1) {
              return new Tuple(value0, value1);
          };
      };
      return Tuple;
  })();
  var uncurry = function (f) {
      return function (v) {
          return f(v.value0)(v.value1);
      };
  };
  var snd = function (v) {
      return v.value1;
  };
  var functorTuple = {
      map: function (f) {
          return function (m) {
              return new Tuple(m.value0, f(m.value1));
          };
      }
  };
  var fst = function (v) {
      return v.value0;
  };
  var eqTuple = function (dictEq) {
      return function (dictEq1) {
          return {
              eq: function (x) {
                  return function (y) {
                      return Data_Eq.eq(dictEq)(x.value0)(y.value0) && Data_Eq.eq(dictEq1)(x.value1)(y.value1);
                  };
              }
          };
      };
  };
  var ordTuple = function (dictOrd) {
      return function (dictOrd1) {
          return {
              compare: function (x) {
                  return function (y) {
                      var v = Data_Ord.compare(dictOrd)(x.value0)(y.value0);
                      if (v instanceof Data_Ordering.LT) {
                          return Data_Ordering.LT.value;
                      };
                      if (v instanceof Data_Ordering.GT) {
                          return Data_Ordering.GT.value;
                      };
                      return Data_Ord.compare(dictOrd1)(x.value1)(y.value1);
                  };
              },
              Eq0: function () {
                  return eqTuple(dictOrd.Eq0())(dictOrd1.Eq0());
              }
          };
      };
  };
  exports["Tuple"] = Tuple;
  exports["fst"] = fst;
  exports["snd"] = snd;
  exports["uncurry"] = uncurry;
  exports["ordTuple"] = ordTuple;
  exports["functorTuple"] = functorTuple;
})(PS);
(function(exports) {
  "use strict";

  exports.unit = {};
})(PS["Data.Unit"] = PS["Data.Unit"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Unit"] = $PS["Data.Unit"] || {};
  var exports = $PS["Data.Unit"];
  var $foreign = $PS["Data.Unit"];
  exports["unit"] = $foreign.unit;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Monad.State.Class"] = $PS["Control.Monad.State.Class"] || {};
  var exports = $PS["Control.Monad.State.Class"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Data_Unit = $PS["Data.Unit"];                
  var state = function (dict) {
      return dict.state;
  };
  var put = function (dictMonadState) {
      return function (s) {
          return state(dictMonadState)(function (v) {
              return new Data_Tuple.Tuple(Data_Unit.unit, s);
          });
      };
  };
  var modify_ = function (dictMonadState) {
      return function (f) {
          return state(dictMonadState)(function (s) {
              return new Data_Tuple.Tuple(Data_Unit.unit, f(s));
          });
      };
  };
  var get = function (dictMonadState) {
      return state(dictMonadState)(function (s) {
          return new Data_Tuple.Tuple(s, s);
      });
  };
  exports["get"] = get;
  exports["put"] = put;
  exports["modify_"] = modify_;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["DOM.HTML.Indexed.InputType"] = $PS["DOM.HTML.Indexed.InputType"] || {};
  var exports = $PS["DOM.HTML.Indexed.InputType"];
  var InputButton = (function () {
      function InputButton() {

      };
      InputButton.value = new InputButton();
      return InputButton;
  })();
  var InputCheckbox = (function () {
      function InputCheckbox() {

      };
      InputCheckbox.value = new InputCheckbox();
      return InputCheckbox;
  })();
  var InputColor = (function () {
      function InputColor() {

      };
      InputColor.value = new InputColor();
      return InputColor;
  })();
  var InputDate = (function () {
      function InputDate() {

      };
      InputDate.value = new InputDate();
      return InputDate;
  })();
  var InputDatetimeLocal = (function () {
      function InputDatetimeLocal() {

      };
      InputDatetimeLocal.value = new InputDatetimeLocal();
      return InputDatetimeLocal;
  })();
  var InputEmail = (function () {
      function InputEmail() {

      };
      InputEmail.value = new InputEmail();
      return InputEmail;
  })();
  var InputFile = (function () {
      function InputFile() {

      };
      InputFile.value = new InputFile();
      return InputFile;
  })();
  var InputHidden = (function () {
      function InputHidden() {

      };
      InputHidden.value = new InputHidden();
      return InputHidden;
  })();
  var InputImage = (function () {
      function InputImage() {

      };
      InputImage.value = new InputImage();
      return InputImage;
  })();
  var InputMonth = (function () {
      function InputMonth() {

      };
      InputMonth.value = new InputMonth();
      return InputMonth;
  })();
  var InputNumber = (function () {
      function InputNumber() {

      };
      InputNumber.value = new InputNumber();
      return InputNumber;
  })();
  var InputPassword = (function () {
      function InputPassword() {

      };
      InputPassword.value = new InputPassword();
      return InputPassword;
  })();
  var InputRadio = (function () {
      function InputRadio() {

      };
      InputRadio.value = new InputRadio();
      return InputRadio;
  })();
  var InputRange = (function () {
      function InputRange() {

      };
      InputRange.value = new InputRange();
      return InputRange;
  })();
  var InputReset = (function () {
      function InputReset() {

      };
      InputReset.value = new InputReset();
      return InputReset;
  })();
  var InputSearch = (function () {
      function InputSearch() {

      };
      InputSearch.value = new InputSearch();
      return InputSearch;
  })();
  var InputSubmit = (function () {
      function InputSubmit() {

      };
      InputSubmit.value = new InputSubmit();
      return InputSubmit;
  })();
  var InputTel = (function () {
      function InputTel() {

      };
      InputTel.value = new InputTel();
      return InputTel;
  })();
  var InputText = (function () {
      function InputText() {

      };
      InputText.value = new InputText();
      return InputText;
  })();
  var InputTime = (function () {
      function InputTime() {

      };
      InputTime.value = new InputTime();
      return InputTime;
  })();
  var InputUrl = (function () {
      function InputUrl() {

      };
      InputUrl.value = new InputUrl();
      return InputUrl;
  })();
  var InputWeek = (function () {
      function InputWeek() {

      };
      InputWeek.value = new InputWeek();
      return InputWeek;
  })();
  var renderInputType = function (v) {
      if (v instanceof InputButton) {
          return "button";
      };
      if (v instanceof InputCheckbox) {
          return "checkbox";
      };
      if (v instanceof InputColor) {
          return "color";
      };
      if (v instanceof InputDate) {
          return "date";
      };
      if (v instanceof InputDatetimeLocal) {
          return "datetime-local";
      };
      if (v instanceof InputEmail) {
          return "email";
      };
      if (v instanceof InputFile) {
          return "file";
      };
      if (v instanceof InputHidden) {
          return "hidden";
      };
      if (v instanceof InputImage) {
          return "image";
      };
      if (v instanceof InputMonth) {
          return "month";
      };
      if (v instanceof InputNumber) {
          return "number";
      };
      if (v instanceof InputPassword) {
          return "password";
      };
      if (v instanceof InputRadio) {
          return "radio";
      };
      if (v instanceof InputRange) {
          return "range";
      };
      if (v instanceof InputReset) {
          return "reset";
      };
      if (v instanceof InputSearch) {
          return "search";
      };
      if (v instanceof InputSubmit) {
          return "submit";
      };
      if (v instanceof InputTel) {
          return "tel";
      };
      if (v instanceof InputText) {
          return "text";
      };
      if (v instanceof InputTime) {
          return "time";
      };
      if (v instanceof InputUrl) {
          return "url";
      };
      if (v instanceof InputWeek) {
          return "week";
      };
      throw new Error("Failed pattern match at DOM.HTML.Indexed.InputType (line 28, column 19 - line 50, column 22): " + [ v.constructor.name ]);
  };
  exports["InputCheckbox"] = InputCheckbox;
  exports["InputNumber"] = InputNumber;
  exports["renderInputType"] = renderInputType;
})(PS);
(function(exports) {
  "use strict";

  //------------------------------------------------------------------------------
  // Array creation --------------------------------------------------------------
  //------------------------------------------------------------------------------

  exports.range = function (start) {
    return function (end) {
      var step = start > end ? -1 : 1;
      var result = new Array(step * (end - start) + 1);
      var i = start, n = 0;
      while (i !== end) {
        result[n++] = i;
        i += step;
      }
      result[n] = i;
      return result;
    };
  };                                                                                                 

  exports.fromFoldableImpl = (function () {
    function Cons(head, tail) {
      this.head = head;
      this.tail = tail;
    }
    var emptyList = {};

    function curryCons(head) {
      return function (tail) {
        return new Cons(head, tail);
      };
    }

    function listToArray(list) {
      var result = [];
      var count = 0;
      var xs = list;
      while (xs !== emptyList) {
        result[count++] = xs.head;
        xs = xs.tail;
      }
      return result;
    }

    return function (foldr) {
      return function (xs) {
        return listToArray(foldr(curryCons)(emptyList)(xs));
      };
    };
  })();

  //------------------------------------------------------------------------------
  // Array size ------------------------------------------------------------------
  //------------------------------------------------------------------------------

  exports.length = function (xs) {
    return xs.length;
  };

  //------------------------------------------------------------------------------
  // Indexed operations ----------------------------------------------------------
  //------------------------------------------------------------------------------

  exports.indexImpl = function (just) {
    return function (nothing) {
      return function (xs) {
        return function (i) {
          return i < 0 || i >= xs.length ? nothing :  just(xs[i]);
        };
      };
    };
  };

  exports.findIndexImpl = function (just) {
    return function (nothing) {
      return function (f) {
        return function (xs) {
          for (var i = 0, l = xs.length; i < l; i++) {
            if (f(xs[i])) return just(i);
          }
          return nothing;
        };
      };
    };
  };

  exports._deleteAt = function (just) {
    return function (nothing) {
      return function (i) {
        return function (l) {
          if (i < 0 || i >= l.length) return nothing;
          var l1 = l.slice();
          l1.splice(i, 1);
          return just(l1);
        };
      };
    };
  };   

  //------------------------------------------------------------------------------
  // Subarrays -------------------------------------------------------------------
  //------------------------------------------------------------------------------

  exports.slice = function (s) {
    return function (e) {
      return function (l) {
        return l.slice(s, e);
      };
    };
  };

  //------------------------------------------------------------------------------
  // Zipping ---------------------------------------------------------------------
  //------------------------------------------------------------------------------

  exports.zipWith = function (f) {
    return function (xs) {
      return function (ys) {
        var l = xs.length < ys.length ? xs.length : ys.length;
        var result = new Array(l);
        for (var i = 0; i < l; i++) {
          result[i] = f(xs[i])(ys[i]);
        }
        return result;
      };
    };
  };
})(PS["Data.Array"] = PS["Data.Array"] || {});
(function(exports) {
  "use strict";

  exports.foldrArray = function (f) {
    return function (init) {
      return function (xs) {
        var acc = init;
        var len = xs.length;
        for (var i = len - 1; i >= 0; i--) {
          acc = f(xs[i])(acc);
        }
        return acc;
      };
    };
  };

  exports.foldlArray = function (f) {
    return function (init) {
      return function (xs) {
        var acc = init;
        var len = xs.length;
        for (var i = 0; i < len; i++) {
          acc = f(acc)(xs[i]);
        }
        return acc;
      };
    };
  };
})(PS["Data.Foldable"] = PS["Data.Foldable"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Semigroupoid"] = $PS["Control.Semigroupoid"] || {};
  var exports = $PS["Control.Semigroupoid"];
  var semigroupoidFn = {
      compose: function (f) {
          return function (g) {
              return function (x) {
                  return f(g(x));
              };
          };
      }
  };
  exports["semigroupoidFn"] = semigroupoidFn;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Category"] = $PS["Control.Category"] || {};
  var exports = $PS["Control.Category"];
  var Control_Semigroupoid = $PS["Control.Semigroupoid"];                
  var identity = function (dict) {
      return dict.identity;
  };
  var categoryFn = {
      identity: function (x) {
          return x;
      },
      Semigroupoid0: function () {
          return Control_Semigroupoid.semigroupoidFn;
      }
  };
  exports["identity"] = identity;
  exports["categoryFn"] = categoryFn;
})(PS);
(function(exports) {
  "use strict";

  exports.arrayMap = function (f) {
    return function (arr) {
      var l = arr.length;
      var result = new Array(l);
      for (var i = 0; i < l; i++) {
        result[i] = f(arr[i]);
      }
      return result;
    };
  };
})(PS["Data.Functor"] = PS["Data.Functor"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Functor"] = $PS["Data.Functor"] || {};
  var exports = $PS["Data.Functor"];
  var $foreign = $PS["Data.Functor"];
  var Data_Function = $PS["Data.Function"];
  var Data_Unit = $PS["Data.Unit"];                  
  var map = function (dict) {
      return dict.map;
  };
  var $$void = function (dictFunctor) {
      return map(dictFunctor)(Data_Function["const"](Data_Unit.unit));
  };
  var voidLeft = function (dictFunctor) {
      return function (f) {
          return function (x) {
              return map(dictFunctor)(Data_Function["const"](x))(f);
          };
      };
  };
  var functorArray = {
      map: $foreign.arrayMap
  };
  exports["map"] = map;
  exports["void"] = $$void;
  exports["voidLeft"] = voidLeft;
  exports["functorArray"] = functorArray;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Apply"] = $PS["Control.Apply"] || {};
  var exports = $PS["Control.Apply"];
  var Control_Category = $PS["Control.Category"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var apply = function (dict) {
      return dict.apply;
  };
  var applySecond = function (dictApply) {
      return function (a) {
          return function (b) {
              return apply(dictApply)(Data_Functor.map(dictApply.Functor0())(Data_Function["const"](Control_Category.identity(Control_Category.categoryFn)))(a))(b);
          };
      };
  };
  exports["apply"] = apply;
  exports["applySecond"] = applySecond;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Applicative"] = $PS["Control.Applicative"] || {};
  var exports = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Data_Unit = $PS["Data.Unit"];                  
  var pure = function (dict) {
      return dict.pure;
  };
  var unless = function (dictApplicative) {
      return function (v) {
          return function (v1) {
              if (!v) {
                  return v1;
              };
              if (v) {
                  return pure(dictApplicative)(Data_Unit.unit);
              };
              throw new Error("Failed pattern match at Control.Applicative (line 66, column 1 - line 66, column 65): " + [ v.constructor.name, v1.constructor.name ]);
          };
      };
  };
  var when = function (dictApplicative) {
      return function (v) {
          return function (v1) {
              if (v) {
                  return v1;
              };
              if (!v) {
                  return pure(dictApplicative)(Data_Unit.unit);
              };
              throw new Error("Failed pattern match at Control.Applicative (line 61, column 1 - line 61, column 63): " + [ v.constructor.name, v1.constructor.name ]);
          };
      };
  };
  var liftA1 = function (dictApplicative) {
      return function (f) {
          return function (a) {
              return Control_Apply.apply(dictApplicative.Apply0())(pure(dictApplicative)(f))(a);
          };
      };
  };
  exports["pure"] = pure;
  exports["liftA1"] = liftA1;
  exports["unless"] = unless;
  exports["when"] = when;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Maybe"] = $PS["Data.Maybe"] || {};
  var exports = $PS["Data.Maybe"];
  var Control_Category = $PS["Control.Category"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];          
  var Nothing = (function () {
      function Nothing() {

      };
      Nothing.value = new Nothing();
      return Nothing;
  })();
  var Just = (function () {
      function Just(value0) {
          this.value0 = value0;
      };
      Just.create = function (value0) {
          return new Just(value0);
      };
      return Just;
  })();
  var maybe = function (v) {
      return function (v1) {
          return function (v2) {
              if (v2 instanceof Nothing) {
                  return v;
              };
              if (v2 instanceof Just) {
                  return v1(v2.value0);
              };
              throw new Error("Failed pattern match at Data.Maybe (line 230, column 1 - line 230, column 51): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
          };
      };
  };
  var isNothing = maybe(true)(Data_Function["const"](false));
  var isJust = maybe(false)(Data_Function["const"](true));
  var functorMaybe = {
      map: function (v) {
          return function (v1) {
              if (v1 instanceof Just) {
                  return new Just(v(v1.value0));
              };
              return Nothing.value;
          };
      }
  };
  var fromMaybe = function (a) {
      return maybe(a)(Control_Category.identity(Control_Category.categoryFn));
  };
  var fromJust = function () {
      return function (v) {
          if (v instanceof Just) {
              return v.value0;
          };
          throw new Error("Failed pattern match at Data.Maybe (line 281, column 1 - line 281, column 46): " + [ v.constructor.name ]);
      };
  };
  var applyMaybe = {
      apply: function (v) {
          return function (v1) {
              if (v instanceof Just) {
                  return Data_Functor.map(functorMaybe)(v.value0)(v1);
              };
              if (v instanceof Nothing) {
                  return Nothing.value;
              };
              throw new Error("Failed pattern match at Data.Maybe (line 68, column 1 - line 70, column 30): " + [ v.constructor.name, v1.constructor.name ]);
          };
      },
      Functor0: function () {
          return functorMaybe;
      }
  };
  var bindMaybe = {
      bind: function (v) {
          return function (v1) {
              if (v instanceof Just) {
                  return v1(v.value0);
              };
              if (v instanceof Nothing) {
                  return Nothing.value;
              };
              throw new Error("Failed pattern match at Data.Maybe (line 126, column 1 - line 128, column 28): " + [ v.constructor.name, v1.constructor.name ]);
          };
      },
      Apply0: function () {
          return applyMaybe;
      }
  };
  exports["Nothing"] = Nothing;
  exports["Just"] = Just;
  exports["maybe"] = maybe;
  exports["fromMaybe"] = fromMaybe;
  exports["isJust"] = isJust;
  exports["isNothing"] = isNothing;
  exports["fromJust"] = fromJust;
  exports["functorMaybe"] = functorMaybe;
  exports["bindMaybe"] = bindMaybe;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Monoid"] = $PS["Data.Monoid"] || {};
  var exports = $PS["Data.Monoid"];
  var mempty = function (dict) {
      return dict.mempty;
  };
  exports["mempty"] = mempty;
})(PS);
(function(exports) {
  "use strict";

  exports.concatArray = function (xs) {
    return function (ys) {
      if (xs.length === 0) return ys;
      if (ys.length === 0) return xs;
      return xs.concat(ys);
    };
  };
})(PS["Data.Semigroup"] = PS["Data.Semigroup"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Semigroup"] = $PS["Data.Semigroup"] || {};
  var exports = $PS["Data.Semigroup"];
  var $foreign = $PS["Data.Semigroup"];
  var semigroupArray = {
      append: $foreign.concatArray
  };
  var append = function (dict) {
      return dict.append;
  };
  exports["append"] = append;
  exports["semigroupArray"] = semigroupArray;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Foldable"] = $PS["Data.Foldable"] || {};
  var exports = $PS["Data.Foldable"];
  var $foreign = $PS["Data.Foldable"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Data_Function = $PS["Data.Function"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Monoid = $PS["Data.Monoid"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Unit = $PS["Data.Unit"];                
  var foldr = function (dict) {
      return dict.foldr;
  };
  var traverse_ = function (dictApplicative) {
      return function (dictFoldable) {
          return function (f) {
              return foldr(dictFoldable)((function () {
                  var $316 = Control_Apply.applySecond(dictApplicative.Apply0());
                  return function ($317) {
                      return $316(f($317));
                  };
              })())(Control_Applicative.pure(dictApplicative)(Data_Unit.unit));
          };
      };
  };
  var for_ = function (dictApplicative) {
      return function (dictFoldable) {
          return Data_Function.flip(traverse_(dictApplicative)(dictFoldable));
      };
  };
  var foldl = function (dict) {
      return dict.foldl;
  };
  var foldableMaybe = {
      foldr: function (v) {
          return function (z) {
              return function (v1) {
                  if (v1 instanceof Data_Maybe.Nothing) {
                      return z;
                  };
                  if (v1 instanceof Data_Maybe.Just) {
                      return v(v1.value0)(z);
                  };
                  throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [ v.constructor.name, z.constructor.name, v1.constructor.name ]);
              };
          };
      },
      foldl: function (v) {
          return function (z) {
              return function (v1) {
                  if (v1 instanceof Data_Maybe.Nothing) {
                      return z;
                  };
                  if (v1 instanceof Data_Maybe.Just) {
                      return v(z)(v1.value0);
                  };
                  throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [ v.constructor.name, z.constructor.name, v1.constructor.name ]);
              };
          };
      },
      foldMap: function (dictMonoid) {
          return function (v) {
              return function (v1) {
                  if (v1 instanceof Data_Maybe.Nothing) {
                      return Data_Monoid.mempty(dictMonoid);
                  };
                  if (v1 instanceof Data_Maybe.Just) {
                      return v(v1.value0);
                  };
                  throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [ v.constructor.name, v1.constructor.name ]);
              };
          };
      }
  };
  var foldMapDefaultR = function (dictFoldable) {
      return function (dictMonoid) {
          return function (f) {
              return foldr(dictFoldable)(function (x) {
                  return function (acc) {
                      return Data_Semigroup.append(dictMonoid.Semigroup0())(f(x))(acc);
                  };
              })(Data_Monoid.mempty(dictMonoid));
          };
      };
  };
  var foldableArray = {
      foldr: $foreign.foldrArray,
      foldl: $foreign.foldlArray,
      foldMap: function (dictMonoid) {
          return foldMapDefaultR(foldableArray)(dictMonoid);
      }
  };
  var foldMap = function (dict) {
      return dict.foldMap;
  };
  exports["foldr"] = foldr;
  exports["foldl"] = foldl;
  exports["foldMap"] = foldMap;
  exports["traverse_"] = traverse_;
  exports["for_"] = for_;
  exports["foldableArray"] = foldableArray;
  exports["foldableMaybe"] = foldableMaybe;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Array"] = $PS["Data.Array"] || {};
  var exports = $PS["Data.Array"];
  var $foreign = $PS["Data.Array"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Maybe = $PS["Data.Maybe"];
  var take = function (n) {
      return function (xs) {
          var $58 = n < 1;
          if ($58) {
              return [  ];
          };
          return $foreign.slice(0)(n)(xs);
      };
  };
  var $$null = function (xs) {
      return $foreign.length(xs) === 0;
  };
  var mapWithIndex = function (f) {
      return function (xs) {
          return $foreign.zipWith(f)($foreign.range(0)($foreign.length(xs) - 1 | 0))(xs);
      };
  };
  var index = $foreign.indexImpl(Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
  var fromFoldable = function (dictFoldable) {
      return $foreign.fromFoldableImpl(Data_Foldable.foldr(dictFoldable));
  };
  var foldr = Data_Foldable.foldr(Data_Foldable.foldableArray);
  var foldl = Data_Foldable.foldl(Data_Foldable.foldableArray);
  var findIndex = $foreign.findIndexImpl(Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
  var deleteAt = $foreign["_deleteAt"](Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
  var deleteBy = function (v) {
      return function (v1) {
          return function (v2) {
              if (v2.length === 0) {
                  return [  ];
              };
              return Data_Maybe.maybe(v2)(function (i) {
                  return Data_Maybe.fromJust()(deleteAt(i)(v2));
              })(findIndex(v(v1))(v2));
          };
      };
  };
  exports["fromFoldable"] = fromFoldable;
  exports["null"] = $$null;
  exports["index"] = index;
  exports["mapWithIndex"] = mapWithIndex;
  exports["foldl"] = foldl;
  exports["take"] = take;
  exports["deleteBy"] = deleteBy;
  exports["range"] = $foreign.range;
  exports["length"] = $foreign.length;
})(PS);
(function(exports) {
  
  var bigInt =require("big-integer");

  exports.fromInt = function(n) {
    return bigInt(n);
  };

  exports.toBase = function(base) {
    return function (x) {
      return x.toString(base);
    };
  };

  exports.toNumber = function(x) {
    return x.toJSNumber();
  };

  exports.biAdd = function(x) {
    return function(y) {
      return x.add(y);
    };
  };

  exports.biMul = function(x) {
    return function(y) {
      return x.multiply(y);
    };
  };

  exports.biSub = function(x) {
    return function(y) {
      return x.minus(y);
    };
  };

  exports.biMod = function(x) {
    return function(y) {
      return x.mod(y);
    };
  };

  exports.biDiv = function(x) {
    return function(y) {
      return x.divide(y);
    };
  };

  exports.abs = function(x) {
    return x.abs();
  };
})(PS["Data.BigInt"] = PS["Data.BigInt"] || {});
(function(exports) {
  "use strict";

  exports.intDegree = function (x) {
    return Math.min(Math.abs(x), 2147483647);
  };

  // See the Euclidean definition in
  // https://en.m.wikipedia.org/wiki/Modulo_operation.
  exports.intDiv = function (x) {
    return function (y) {
      if (y === 0) return 0;
      return y > 0 ? Math.floor(x / y) : -Math.floor(x / -y);
    };
  };

  exports.intMod = function (x) {
    return function (y) {
      if (y === 0) return 0;
      var yy = Math.abs(y);
      return ((x % yy) + yy) % yy;
    };
  };
})(PS["Data.EuclideanRing"] = PS["Data.EuclideanRing"] || {});
(function(exports) {
  "use strict";

  exports.intSub = function (x) {
    return function (y) {
      /* jshint bitwise: false */
      return x - y | 0;
    };
  };
})(PS["Data.Ring"] = PS["Data.Ring"] || {});
(function(exports) {
  "use strict";

  exports.intAdd = function (x) {
    return function (y) {
      /* jshint bitwise: false */
      return x + y | 0;
    };
  };

  exports.intMul = function (x) {
    return function (y) {
      /* jshint bitwise: false */
      return x * y | 0;
    };
  };
})(PS["Data.Semiring"] = PS["Data.Semiring"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Semiring"] = $PS["Data.Semiring"] || {};
  var exports = $PS["Data.Semiring"];
  var $foreign = $PS["Data.Semiring"];
  var semiringInt = {
      add: $foreign.intAdd,
      zero: 0,
      mul: $foreign.intMul,
      one: 1
  };
  var mul = function (dict) {
      return dict.mul;
  };
  var add = function (dict) {
      return dict.add;
  };
  exports["add"] = add;
  exports["mul"] = mul;
  exports["semiringInt"] = semiringInt;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Ring"] = $PS["Data.Ring"] || {};
  var exports = $PS["Data.Ring"];
  var $foreign = $PS["Data.Ring"];
  var Data_Semiring = $PS["Data.Semiring"];
  var sub = function (dict) {
      return dict.sub;
  };
  var ringInt = {
      sub: $foreign.intSub,
      Semiring0: function () {
          return Data_Semiring.semiringInt;
      }
  };
  exports["sub"] = sub;
  exports["ringInt"] = ringInt;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.CommutativeRing"] = $PS["Data.CommutativeRing"] || {};
  var exports = $PS["Data.CommutativeRing"];
  var Data_Ring = $PS["Data.Ring"];
  var commutativeRingInt = {
      Ring0: function () {
          return Data_Ring.ringInt;
      }
  };
  exports["commutativeRingInt"] = commutativeRingInt;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.EuclideanRing"] = $PS["Data.EuclideanRing"] || {};
  var exports = $PS["Data.EuclideanRing"];
  var $foreign = $PS["Data.EuclideanRing"];
  var Data_CommutativeRing = $PS["Data.CommutativeRing"];  
  var mod = function (dict) {
      return dict.mod;
  };
  var euclideanRingInt = {
      degree: $foreign.intDegree,
      div: $foreign.intDiv,
      mod: $foreign.intMod,
      CommutativeRing0: function () {
          return Data_CommutativeRing.commutativeRingInt;
      }
  };
  var div = function (dict) {
      return dict.div;
  };
  exports["div"] = div;
  exports["mod"] = mod;
  exports["euclideanRingInt"] = euclideanRingInt;
})(PS);
(function(exports) {
  "use strict";

  exports.fromNumberImpl = function (just) {
    return function (nothing) {
      return function (n) {
        /* jshint bitwise: false */
        return (n | 0) === n ? just(n) : nothing;
      };
    };
  };

  exports.toNumber = function (n) {
    return n;
  };

  exports.fromStringAsImpl = function (just) {
    return function (nothing) {
      return function (radix) {
        var digits;
        if (radix < 11) {
          digits = "[0-" + (radix - 1).toString() + "]";
        } else if (radix === 11) {
          digits = "[0-9a]";
        } else {
          digits = "[0-9a-" + String.fromCharCode(86 + radix) + "]";
        }
        var pattern = new RegExp("^[\\+\\-]?" + digits + "+$", "i");

        return function (s) {
          /* jshint bitwise: false */
          if (pattern.test(s)) {
            var i = parseInt(s, radix);
            return (i | 0) === i ? just(i) : nothing;
          } else {
            return nothing;
          }
        };
      };
    };
  };

  exports.toStringAs = function (radix) {
    return function (i) {
      return i.toString(radix);
    };
  };
})(PS["Data.Int"] = PS["Data.Int"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Boolean"] = $PS["Data.Boolean"] || {};
  var exports = $PS["Data.Boolean"];
  var otherwise = true;
  exports["otherwise"] = otherwise;
})(PS);
(function(exports) {
  "use strict";

  exports.topInt = 2147483647;
  exports.bottomInt = -2147483648;
})(PS["Data.Bounded"] = PS["Data.Bounded"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Bounded"] = $PS["Data.Bounded"] || {};
  var exports = $PS["Data.Bounded"];
  var $foreign = $PS["Data.Bounded"];
  var Data_Ord = $PS["Data.Ord"];
  var top = function (dict) {
      return dict.top;
  };
  var boundedInt = {
      top: $foreign.topInt,
      bottom: $foreign.bottomInt,
      Ord0: function () {
          return Data_Ord.ordInt;
      }
  };
  var bottom = function (dict) {
      return dict.bottom;
  };
  exports["bottom"] = bottom;
  exports["top"] = top;
  exports["boundedInt"] = boundedInt;
})(PS);
(function(exports) {
  /* globals exports */
  "use strict";               

  exports.isFinite = isFinite;
})(PS["Data.Number"] = PS["Data.Number"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Number"] = $PS["Data.Number"] || {};
  var exports = $PS["Data.Number"];
  var $foreign = $PS["Data.Number"];
  exports["isFinite"] = $foreign["isFinite"];
})(PS);
(function(exports) {
  "use strict";          

  exports.floor = Math.floor;
})(PS["Math"] = PS["Math"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Math"] = $PS["Math"] || {};
  var exports = $PS["Math"];
  var $foreign = $PS["Math"];
  exports["floor"] = $foreign.floor;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Int"] = $PS["Data.Int"] || {};
  var exports = $PS["Data.Int"];
  var $foreign = $PS["Data.Int"];
  var Data_Boolean = $PS["Data.Boolean"];
  var Data_Bounded = $PS["Data.Bounded"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Number = $PS["Data.Number"];
  var $$Math = $PS["Math"];
  var radix = function (n) {
      if (n >= 2 && n <= 36) {
          return new Data_Maybe.Just(n);
      };
      if (Data_Boolean.otherwise) {
          return Data_Maybe.Nothing.value;
      };
      throw new Error("Failed pattern match at Data.Int (line 192, column 1 - line 192, column 28): " + [ n.constructor.name ]);
  };                   
  var fromStringAs = $foreign.fromStringAsImpl(Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
  var fromString = fromStringAs(10);
  var fromNumber = $foreign.fromNumberImpl(Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
  var unsafeClamp = function (x) {
      if (!Data_Number["isFinite"](x)) {
          return 0;
      };
      if (x >= $foreign.toNumber(Data_Bounded.top(Data_Bounded.boundedInt))) {
          return Data_Bounded.top(Data_Bounded.boundedInt);
      };
      if (x <= $foreign.toNumber(Data_Bounded.bottom(Data_Bounded.boundedInt))) {
          return Data_Bounded.bottom(Data_Bounded.boundedInt);
      };
      if (Data_Boolean.otherwise) {
          return Data_Maybe.fromMaybe(0)(fromNumber(x));
      };
      throw new Error("Failed pattern match at Data.Int (line 66, column 1 - line 66, column 29): " + [ x.constructor.name ]);
  };
  var floor = function ($24) {
      return unsafeClamp($$Math.floor($24));
  };
  exports["floor"] = floor;
  exports["fromString"] = fromString;
  exports["radix"] = radix;
  exports["toStringAs"] = $foreign.toStringAs;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.BigInt"] = $PS["Data.BigInt"] || {};
  var exports = $PS["Data.BigInt"];
  var $foreign = $PS["Data.BigInt"];
  var Data_EuclideanRing = $PS["Data.EuclideanRing"];
  var Data_Int = $PS["Data.Int"];
  var Data_Ring = $PS["Data.Ring"];
  var Data_Semiring = $PS["Data.Semiring"];                                                
  var toString = $foreign.toBase(10);
  var semiringBigInt = {
      add: $foreign.biAdd,
      zero: $foreign.fromInt(0),
      mul: $foreign.biMul,
      one: $foreign.fromInt(1)
  };
  var ringBigInt = {
      sub: $foreign.biSub,
      Semiring0: function () {
          return semiringBigInt;
      }
  };
  var commutativeRingBigInt = {
      Ring0: function () {
          return ringBigInt;
      }
  };
  var euclideanRingBigInt = {
      div: function (x) {
          return function (y) {
              return $foreign.biDiv(Data_Ring.sub(ringBigInt)(x)(Data_EuclideanRing.mod(euclideanRingBigInt)(x)(y)))(y);
          };
      },
      mod: function (x) {
          return function (y) {
              var yy = $foreign.abs(y);
              return $foreign.biMod(Data_Semiring.add(semiringBigInt)($foreign.biMod(x)(yy))(yy))(yy);
          };
      },
      degree: function ($4) {
          return Data_Int.floor($foreign.toNumber($foreign.abs($4)));
      },
      CommutativeRing0: function () {
          return commutativeRingBigInt;
      }
  };
  exports["toString"] = toString;
  exports["semiringBigInt"] = semiringBigInt;
  exports["euclideanRingBigInt"] = euclideanRingBigInt;
  exports["fromInt"] = $foreign.fromInt;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.List.Types"] = $PS["Data.List.Types"] || {};
  var exports = $PS["Data.List.Types"];
  var Control_Apply = $PS["Control.Apply"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Monoid = $PS["Data.Monoid"];
  var Data_Semigroup = $PS["Data.Semigroup"];        
  var Nil = (function () {
      function Nil() {

      };
      Nil.value = new Nil();
      return Nil;
  })();
  var Cons = (function () {
      function Cons(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Cons.create = function (value0) {
          return function (value1) {
              return new Cons(value0, value1);
          };
      };
      return Cons;
  })();
  var NonEmptyList = function (x) {
      return x;
  };
  var listMap = function (f) {
      var chunkedRevMap = function ($copy_chunksAcc) {
          return function ($copy_v) {
              var $tco_var_chunksAcc = $copy_chunksAcc;
              var $tco_done = false;
              var $tco_result;
              function $tco_loop(chunksAcc, v) {
                  if (v instanceof Cons && (v.value1 instanceof Cons && v.value1.value1 instanceof Cons)) {
                      $tco_var_chunksAcc = new Cons(v, chunksAcc);
                      $copy_v = v.value1.value1.value1;
                      return;
                  };
                  var unrolledMap = function (v1) {
                      if (v1 instanceof Cons && (v1.value1 instanceof Cons && v1.value1.value1 instanceof Nil)) {
                          return new Cons(f(v1.value0), new Cons(f(v1.value1.value0), Nil.value));
                      };
                      if (v1 instanceof Cons && v1.value1 instanceof Nil) {
                          return new Cons(f(v1.value0), Nil.value);
                      };
                      return Nil.value;
                  };
                  var reverseUnrolledMap = function ($copy_v1) {
                      return function ($copy_acc) {
                          var $tco_var_v1 = $copy_v1;
                          var $tco_done1 = false;
                          var $tco_result;
                          function $tco_loop(v1, acc) {
                              if (v1 instanceof Cons && (v1.value0 instanceof Cons && (v1.value0.value1 instanceof Cons && v1.value0.value1.value1 instanceof Cons))) {
                                  $tco_var_v1 = v1.value1;
                                  $copy_acc = new Cons(f(v1.value0.value0), new Cons(f(v1.value0.value1.value0), new Cons(f(v1.value0.value1.value1.value0), acc)));
                                  return;
                              };
                              $tco_done1 = true;
                              return acc;
                          };
                          while (!$tco_done1) {
                              $tco_result = $tco_loop($tco_var_v1, $copy_acc);
                          };
                          return $tco_result;
                      };
                  };
                  $tco_done = true;
                  return reverseUnrolledMap(chunksAcc)(unrolledMap(v));
              };
              while (!$tco_done) {
                  $tco_result = $tco_loop($tco_var_chunksAcc, $copy_v);
              };
              return $tco_result;
          };
      };
      return chunkedRevMap(Nil.value);
  };
  var functorList = {
      map: listMap
  };                                                                   
  var foldableList = {
      foldr: function (f) {
          return function (b) {
              var rev = (function () {
                  var go = function ($copy_acc) {
                      return function ($copy_v) {
                          var $tco_var_acc = $copy_acc;
                          var $tco_done = false;
                          var $tco_result;
                          function $tco_loop(acc, v) {
                              if (v instanceof Nil) {
                                  $tco_done = true;
                                  return acc;
                              };
                              if (v instanceof Cons) {
                                  $tco_var_acc = new Cons(v.value0, acc);
                                  $copy_v = v.value1;
                                  return;
                              };
                              throw new Error("Failed pattern match at Data.List.Types (line 108, column 7 - line 108, column 23): " + [ acc.constructor.name, v.constructor.name ]);
                          };
                          while (!$tco_done) {
                              $tco_result = $tco_loop($tco_var_acc, $copy_v);
                          };
                          return $tco_result;
                      };
                  };
                  return go(Nil.value);
              })();
              var $205 = Data_Foldable.foldl(foldableList)(Data_Function.flip(f))(b);
              return function ($206) {
                  return $205(rev($206));
              };
          };
      },
      foldl: function (f) {
          var go = function ($copy_b) {
              return function ($copy_v) {
                  var $tco_var_b = $copy_b;
                  var $tco_done1 = false;
                  var $tco_result;
                  function $tco_loop(b, v) {
                      if (v instanceof Nil) {
                          $tco_done1 = true;
                          return b;
                      };
                      if (v instanceof Cons) {
                          $tco_var_b = f(b)(v.value0);
                          $copy_v = v.value1;
                          return;
                      };
                      throw new Error("Failed pattern match at Data.List.Types (line 112, column 12 - line 114, column 30): " + [ v.constructor.name ]);
                  };
                  while (!$tco_done1) {
                      $tco_result = $tco_loop($tco_var_b, $copy_v);
                  };
                  return $tco_result;
              };
          };
          return go;
      },
      foldMap: function (dictMonoid) {
          return function (f) {
              return Data_Foldable.foldl(foldableList)(function (acc) {
                  var $207 = Data_Semigroup.append(dictMonoid.Semigroup0())(acc);
                  return function ($208) {
                      return $207(f($208));
                  };
              })(Data_Monoid.mempty(dictMonoid));
          };
      }
  };
  var semigroupList = {
      append: function (xs) {
          return function (ys) {
              return Data_Foldable.foldr(foldableList)(Cons.create)(ys)(xs);
          };
      }
  };
  var unfoldable1List = {
      unfoldr1: function (f) {
          return function (b) {
              var go = function ($copy_source) {
                  return function ($copy_memo) {
                      var $tco_var_source = $copy_source;
                      var $tco_done = false;
                      var $tco_result;
                      function $tco_loop(source, memo) {
                          var v = f(source);
                          if (v.value1 instanceof Data_Maybe.Just) {
                              $tco_var_source = v.value1.value0;
                              $copy_memo = new Cons(v.value0, memo);
                              return;
                          };
                          if (v.value1 instanceof Data_Maybe.Nothing) {
                              $tco_done = true;
                              return Data_Foldable.foldl(foldableList)(Data_Function.flip(Cons.create))(Nil.value)(new Cons(v.value0, memo));
                          };
                          throw new Error("Failed pattern match at Data.List.Types (line 136, column 22 - line 138, column 61): " + [ v.constructor.name ]);
                      };
                      while (!$tco_done) {
                          $tco_result = $tco_loop($tco_var_source, $copy_memo);
                      };
                      return $tco_result;
                  };
              };
              return go(b)(Nil.value);
          };
      }
  };
  var unfoldableList = {
      unfoldr: function (f) {
          return function (b) {
              var go = function ($copy_source) {
                  return function ($copy_memo) {
                      var $tco_var_source = $copy_source;
                      var $tco_done = false;
                      var $tco_result;
                      function $tco_loop(source, memo) {
                          var v = f(source);
                          if (v instanceof Data_Maybe.Nothing) {
                              $tco_done = true;
                              return Data_Foldable.foldl(foldableList)(Data_Function.flip(Cons.create))(Nil.value)(memo);
                          };
                          if (v instanceof Data_Maybe.Just) {
                              $tco_var_source = v.value0.value1;
                              $copy_memo = new Cons(v.value0.value0, memo);
                              return;
                          };
                          throw new Error("Failed pattern match at Data.List.Types (line 143, column 22 - line 145, column 52): " + [ v.constructor.name ]);
                      };
                      while (!$tco_done) {
                          $tco_result = $tco_loop($tco_var_source, $copy_memo);
                      };
                      return $tco_result;
                  };
              };
              return go(b)(Nil.value);
          };
      },
      Unfoldable10: function () {
          return unfoldable1List;
      }
  };
  var applyList = {
      apply: function (v) {
          return function (v1) {
              if (v instanceof Nil) {
                  return Nil.value;
              };
              if (v instanceof Cons) {
                  return Data_Semigroup.append(semigroupList)(Data_Functor.map(functorList)(v.value0)(v1))(Control_Apply.apply(applyList)(v.value1)(v1));
              };
              throw new Error("Failed pattern match at Data.List.Types (line 158, column 1 - line 160, column 48): " + [ v.constructor.name, v1.constructor.name ]);
          };
      },
      Functor0: function () {
          return functorList;
      }
  };
  var applicativeList = {
      pure: function (a) {
          return new Cons(a, Nil.value);
      },
      Apply0: function () {
          return applyList;
      }
  };
  var altList = {
      alt: Data_Semigroup.append(semigroupList),
      Functor0: function () {
          return functorList;
      }
  };
  var plusList = {
      empty: Nil.value,
      Alt0: function () {
          return altList;
      }
  };
  exports["Nil"] = Nil;
  exports["Cons"] = Cons;
  exports["NonEmptyList"] = NonEmptyList;
  exports["semigroupList"] = semigroupList;
  exports["foldableList"] = foldableList;
  exports["unfoldableList"] = unfoldableList;
  exports["applicativeList"] = applicativeList;
  exports["plusList"] = plusList;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Traversable"] = $PS["Data.Traversable"] || {};
  var exports = $PS["Data.Traversable"];             
  var traverse = function (dict) {
      return dict.traverse;
  };
  exports["traverse"] = traverse;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Unfoldable"] = $PS["Data.Unfoldable"] || {};
  var exports = $PS["Data.Unfoldable"];            
  var unfoldr = function (dict) {
      return dict.unfoldr;
  };
  exports["unfoldr"] = unfoldr;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Map.Internal"] = $PS["Data.Map.Internal"] || {};
  var exports = $PS["Data.Map.Internal"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Category = $PS["Control.Category"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Monoid = $PS["Data.Monoid"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Ordering = $PS["Data.Ordering"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Data_Traversable = $PS["Data.Traversable"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Data_Unfoldable = $PS["Data.Unfoldable"];                
  var Leaf = (function () {
      function Leaf() {

      };
      Leaf.value = new Leaf();
      return Leaf;
  })();
  var Two = (function () {
      function Two(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      Two.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new Two(value0, value1, value2, value3);
                  };
              };
          };
      };
      return Two;
  })();
  var Three = (function () {
      function Three(value0, value1, value2, value3, value4, value5, value6) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
          this.value4 = value4;
          this.value5 = value5;
          this.value6 = value6;
      };
      Three.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return function (value4) {
                          return function (value5) {
                              return function (value6) {
                                  return new Three(value0, value1, value2, value3, value4, value5, value6);
                              };
                          };
                      };
                  };
              };
          };
      };
      return Three;
  })();
  var TwoLeft = (function () {
      function TwoLeft(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      TwoLeft.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new TwoLeft(value0, value1, value2);
              };
          };
      };
      return TwoLeft;
  })();
  var TwoRight = (function () {
      function TwoRight(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      TwoRight.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new TwoRight(value0, value1, value2);
              };
          };
      };
      return TwoRight;
  })();
  var ThreeLeft = (function () {
      function ThreeLeft(value0, value1, value2, value3, value4, value5) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
          this.value4 = value4;
          this.value5 = value5;
      };
      ThreeLeft.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return function (value4) {
                          return function (value5) {
                              return new ThreeLeft(value0, value1, value2, value3, value4, value5);
                          };
                      };
                  };
              };
          };
      };
      return ThreeLeft;
  })();
  var ThreeMiddle = (function () {
      function ThreeMiddle(value0, value1, value2, value3, value4, value5) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
          this.value4 = value4;
          this.value5 = value5;
      };
      ThreeMiddle.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return function (value4) {
                          return function (value5) {
                              return new ThreeMiddle(value0, value1, value2, value3, value4, value5);
                          };
                      };
                  };
              };
          };
      };
      return ThreeMiddle;
  })();
  var ThreeRight = (function () {
      function ThreeRight(value0, value1, value2, value3, value4, value5) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
          this.value4 = value4;
          this.value5 = value5;
      };
      ThreeRight.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return function (value4) {
                          return function (value5) {
                              return new ThreeRight(value0, value1, value2, value3, value4, value5);
                          };
                      };
                  };
              };
          };
      };
      return ThreeRight;
  })();
  var KickUp = (function () {
      function KickUp(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      KickUp.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new KickUp(value0, value1, value2, value3);
                  };
              };
          };
      };
      return KickUp;
  })();
  var values = function (v) {
      if (v instanceof Leaf) {
          return Data_List_Types.Nil.value;
      };
      if (v instanceof Two) {
          return Data_Semigroup.append(Data_List_Types.semigroupList)(values(v.value0))(Data_Semigroup.append(Data_List_Types.semigroupList)(Control_Applicative.pure(Data_List_Types.applicativeList)(v.value2))(values(v.value3)));
      };
      if (v instanceof Three) {
          return Data_Semigroup.append(Data_List_Types.semigroupList)(values(v.value0))(Data_Semigroup.append(Data_List_Types.semigroupList)(Control_Applicative.pure(Data_List_Types.applicativeList)(v.value2))(Data_Semigroup.append(Data_List_Types.semigroupList)(values(v.value3))(Data_Semigroup.append(Data_List_Types.semigroupList)(Control_Applicative.pure(Data_List_Types.applicativeList)(v.value5))(values(v.value6)))));
      };
      throw new Error("Failed pattern match at Data.Map.Internal (line 626, column 1 - line 626, column 40): " + [ v.constructor.name ]);
  };
  var singleton = function (k) {
      return function (v) {
          return new Two(Leaf.value, k, v, Leaf.value);
      };
  };
  var toUnfoldable = function (dictUnfoldable) {
      return function (m) {
          var go = function ($copy_v) {
              var $tco_done = false;
              var $tco_result;
              function $tco_loop(v) {
                  if (v instanceof Data_List_Types.Nil) {
                      $tco_done = true;
                      return Data_Maybe.Nothing.value;
                  };
                  if (v instanceof Data_List_Types.Cons) {
                      if (v.value0 instanceof Leaf) {
                          $copy_v = v.value1;
                          return;
                      };
                      if (v.value0 instanceof Two && (v.value0.value0 instanceof Leaf && v.value0.value3 instanceof Leaf)) {
                          $tco_done = true;
                          return new Data_Maybe.Just(new Data_Tuple.Tuple(new Data_Tuple.Tuple(v.value0.value1, v.value0.value2), v.value1));
                      };
                      if (v.value0 instanceof Two && v.value0.value0 instanceof Leaf) {
                          $tco_done = true;
                          return new Data_Maybe.Just(new Data_Tuple.Tuple(new Data_Tuple.Tuple(v.value0.value1, v.value0.value2), new Data_List_Types.Cons(v.value0.value3, v.value1)));
                      };
                      if (v.value0 instanceof Two) {
                          $copy_v = new Data_List_Types.Cons(v.value0.value0, new Data_List_Types.Cons(singleton(v.value0.value1)(v.value0.value2), new Data_List_Types.Cons(v.value0.value3, v.value1)));
                          return;
                      };
                      if (v.value0 instanceof Three) {
                          $copy_v = new Data_List_Types.Cons(v.value0.value0, new Data_List_Types.Cons(singleton(v.value0.value1)(v.value0.value2), new Data_List_Types.Cons(v.value0.value3, new Data_List_Types.Cons(singleton(v.value0.value4)(v.value0.value5), new Data_List_Types.Cons(v.value0.value6, v.value1)))));
                          return;
                      };
                      throw new Error("Failed pattern match at Data.Map.Internal (line 591, column 18 - line 600, column 71): " + [ v.value0.constructor.name ]);
                  };
                  throw new Error("Failed pattern match at Data.Map.Internal (line 590, column 3 - line 590, column 19): " + [ v.constructor.name ]);
              };
              while (!$tco_done) {
                  $tco_result = $tco_loop($copy_v);
              };
              return $tco_result;
          };
          return Data_Unfoldable.unfoldr(dictUnfoldable)(go)(new Data_List_Types.Cons(m, Data_List_Types.Nil.value));
      };
  };
  var lookup = function (dictOrd) {
      return function (k) {
          var comp = Data_Ord.compare(dictOrd);
          var go = function ($copy_v) {
              var $tco_done = false;
              var $tco_result;
              function $tco_loop(v) {
                  if (v instanceof Leaf) {
                      $tco_done = true;
                      return Data_Maybe.Nothing.value;
                  };
                  if (v instanceof Two) {
                      var v2 = comp(k)(v.value1);
                      if (v2 instanceof Data_Ordering.EQ) {
                          $tco_done = true;
                          return new Data_Maybe.Just(v.value2);
                      };
                      if (v2 instanceof Data_Ordering.LT) {
                          $copy_v = v.value0;
                          return;
                      };
                      $copy_v = v.value3;
                      return;
                  };
                  if (v instanceof Three) {
                      var v3 = comp(k)(v.value1);
                      if (v3 instanceof Data_Ordering.EQ) {
                          $tco_done = true;
                          return new Data_Maybe.Just(v.value2);
                      };
                      var v4 = comp(k)(v.value4);
                      if (v4 instanceof Data_Ordering.EQ) {
                          $tco_done = true;
                          return new Data_Maybe.Just(v.value5);
                      };
                      if (v3 instanceof Data_Ordering.LT) {
                          $copy_v = v.value0;
                          return;
                      };
                      if (v4 instanceof Data_Ordering.GT) {
                          $copy_v = v.value6;
                          return;
                      };
                      $copy_v = v.value3;
                      return;
                  };
                  throw new Error("Failed pattern match at Data.Map.Internal (line 211, column 5 - line 211, column 22): " + [ v.constructor.name ]);
              };
              while (!$tco_done) {
                  $tco_result = $tco_loop($copy_v);
              };
              return $tco_result;
          };
          return go;
      };
  };
  var functorMap = {
      map: function (v) {
          return function (v1) {
              if (v1 instanceof Leaf) {
                  return Leaf.value;
              };
              if (v1 instanceof Two) {
                  return new Two(Data_Functor.map(functorMap)(v)(v1.value0), v1.value1, v(v1.value2), Data_Functor.map(functorMap)(v)(v1.value3));
              };
              if (v1 instanceof Three) {
                  return new Three(Data_Functor.map(functorMap)(v)(v1.value0), v1.value1, v(v1.value2), Data_Functor.map(functorMap)(v)(v1.value3), v1.value4, v(v1.value5), Data_Functor.map(functorMap)(v)(v1.value6));
              };
              throw new Error("Failed pattern match at Data.Map.Internal (line 101, column 1 - line 104, column 110): " + [ v.constructor.name, v1.constructor.name ]);
          };
      }
  };
  var fromZipper = function ($copy_dictOrd) {
      return function ($copy_v) {
          return function ($copy_tree) {
              var $tco_var_dictOrd = $copy_dictOrd;
              var $tco_var_v = $copy_v;
              var $tco_done = false;
              var $tco_result;
              function $tco_loop(dictOrd, v, tree) {
                  if (v instanceof Data_List_Types.Nil) {
                      $tco_done = true;
                      return tree;
                  };
                  if (v instanceof Data_List_Types.Cons) {
                      if (v.value0 instanceof TwoLeft) {
                          $tco_var_dictOrd = dictOrd;
                          $tco_var_v = v.value1;
                          $copy_tree = new Two(tree, v.value0.value0, v.value0.value1, v.value0.value2);
                          return;
                      };
                      if (v.value0 instanceof TwoRight) {
                          $tco_var_dictOrd = dictOrd;
                          $tco_var_v = v.value1;
                          $copy_tree = new Two(v.value0.value0, v.value0.value1, v.value0.value2, tree);
                          return;
                      };
                      if (v.value0 instanceof ThreeLeft) {
                          $tco_var_dictOrd = dictOrd;
                          $tco_var_v = v.value1;
                          $copy_tree = new Three(tree, v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3, v.value0.value4, v.value0.value5);
                          return;
                      };
                      if (v.value0 instanceof ThreeMiddle) {
                          $tco_var_dictOrd = dictOrd;
                          $tco_var_v = v.value1;
                          $copy_tree = new Three(v.value0.value0, v.value0.value1, v.value0.value2, tree, v.value0.value3, v.value0.value4, v.value0.value5);
                          return;
                      };
                      if (v.value0 instanceof ThreeRight) {
                          $tco_var_dictOrd = dictOrd;
                          $tco_var_v = v.value1;
                          $copy_tree = new Three(v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3, v.value0.value4, v.value0.value5, tree);
                          return;
                      };
                      throw new Error("Failed pattern match at Data.Map.Internal (line 432, column 3 - line 437, column 88): " + [ v.value0.constructor.name ]);
                  };
                  throw new Error("Failed pattern match at Data.Map.Internal (line 429, column 1 - line 429, column 80): " + [ v.constructor.name, tree.constructor.name ]);
              };
              while (!$tco_done) {
                  $tco_result = $tco_loop($tco_var_dictOrd, $tco_var_v, $copy_tree);
              };
              return $tco_result;
          };
      };
  };
  var insert = function (dictOrd) {
      return function (k) {
          return function (v) {
              var up = function ($copy_v1) {
                  return function ($copy_v2) {
                      var $tco_var_v1 = $copy_v1;
                      var $tco_done = false;
                      var $tco_result;
                      function $tco_loop(v1, v2) {
                          if (v1 instanceof Data_List_Types.Nil) {
                              $tco_done = true;
                              return new Two(v2.value0, v2.value1, v2.value2, v2.value3);
                          };
                          if (v1 instanceof Data_List_Types.Cons) {
                              if (v1.value0 instanceof TwoLeft) {
                                  $tco_done = true;
                                  return fromZipper(dictOrd)(v1.value1)(new Three(v2.value0, v2.value1, v2.value2, v2.value3, v1.value0.value0, v1.value0.value1, v1.value0.value2));
                              };
                              if (v1.value0 instanceof TwoRight) {
                                  $tco_done = true;
                                  return fromZipper(dictOrd)(v1.value1)(new Three(v1.value0.value0, v1.value0.value1, v1.value0.value2, v2.value0, v2.value1, v2.value2, v2.value3));
                              };
                              if (v1.value0 instanceof ThreeLeft) {
                                  $tco_var_v1 = v1.value1;
                                  $copy_v2 = new KickUp(new Two(v2.value0, v2.value1, v2.value2, v2.value3), v1.value0.value0, v1.value0.value1, new Two(v1.value0.value2, v1.value0.value3, v1.value0.value4, v1.value0.value5));
                                  return;
                              };
                              if (v1.value0 instanceof ThreeMiddle) {
                                  $tco_var_v1 = v1.value1;
                                  $copy_v2 = new KickUp(new Two(v1.value0.value0, v1.value0.value1, v1.value0.value2, v2.value0), v2.value1, v2.value2, new Two(v2.value3, v1.value0.value3, v1.value0.value4, v1.value0.value5));
                                  return;
                              };
                              if (v1.value0 instanceof ThreeRight) {
                                  $tco_var_v1 = v1.value1;
                                  $copy_v2 = new KickUp(new Two(v1.value0.value0, v1.value0.value1, v1.value0.value2, v1.value0.value3), v1.value0.value4, v1.value0.value5, new Two(v2.value0, v2.value1, v2.value2, v2.value3));
                                  return;
                              };
                              throw new Error("Failed pattern match at Data.Map.Internal (line 468, column 5 - line 473, column 108): " + [ v1.value0.constructor.name, v2.constructor.name ]);
                          };
                          throw new Error("Failed pattern match at Data.Map.Internal (line 465, column 3 - line 465, column 56): " + [ v1.constructor.name, v2.constructor.name ]);
                      };
                      while (!$tco_done) {
                          $tco_result = $tco_loop($tco_var_v1, $copy_v2);
                      };
                      return $tco_result;
                  };
              };
              var comp = Data_Ord.compare(dictOrd);
              var down = function ($copy_ctx) {
                  return function ($copy_v1) {
                      var $tco_var_ctx = $copy_ctx;
                      var $tco_done1 = false;
                      var $tco_result;
                      function $tco_loop(ctx, v1) {
                          if (v1 instanceof Leaf) {
                              $tco_done1 = true;
                              return up(ctx)(new KickUp(Leaf.value, k, v, Leaf.value));
                          };
                          if (v1 instanceof Two) {
                              var v2 = comp(k)(v1.value1);
                              if (v2 instanceof Data_Ordering.EQ) {
                                  $tco_done1 = true;
                                  return fromZipper(dictOrd)(ctx)(new Two(v1.value0, k, v, v1.value3));
                              };
                              if (v2 instanceof Data_Ordering.LT) {
                                  $tco_var_ctx = new Data_List_Types.Cons(new TwoLeft(v1.value1, v1.value2, v1.value3), ctx);
                                  $copy_v1 = v1.value0;
                                  return;
                              };
                              $tco_var_ctx = new Data_List_Types.Cons(new TwoRight(v1.value0, v1.value1, v1.value2), ctx);
                              $copy_v1 = v1.value3;
                              return;
                          };
                          if (v1 instanceof Three) {
                              var v3 = comp(k)(v1.value1);
                              if (v3 instanceof Data_Ordering.EQ) {
                                  $tco_done1 = true;
                                  return fromZipper(dictOrd)(ctx)(new Three(v1.value0, k, v, v1.value3, v1.value4, v1.value5, v1.value6));
                              };
                              var v4 = comp(k)(v1.value4);
                              if (v4 instanceof Data_Ordering.EQ) {
                                  $tco_done1 = true;
                                  return fromZipper(dictOrd)(ctx)(new Three(v1.value0, v1.value1, v1.value2, v1.value3, k, v, v1.value6));
                              };
                              if (v3 instanceof Data_Ordering.LT) {
                                  $tco_var_ctx = new Data_List_Types.Cons(new ThreeLeft(v1.value1, v1.value2, v1.value3, v1.value4, v1.value5, v1.value6), ctx);
                                  $copy_v1 = v1.value0;
                                  return;
                              };
                              if (v3 instanceof Data_Ordering.GT && v4 instanceof Data_Ordering.LT) {
                                  $tco_var_ctx = new Data_List_Types.Cons(new ThreeMiddle(v1.value0, v1.value1, v1.value2, v1.value4, v1.value5, v1.value6), ctx);
                                  $copy_v1 = v1.value3;
                                  return;
                              };
                              $tco_var_ctx = new Data_List_Types.Cons(new ThreeRight(v1.value0, v1.value1, v1.value2, v1.value3, v1.value4, v1.value5), ctx);
                              $copy_v1 = v1.value6;
                              return;
                          };
                          throw new Error("Failed pattern match at Data.Map.Internal (line 448, column 3 - line 448, column 55): " + [ ctx.constructor.name, v1.constructor.name ]);
                      };
                      while (!$tco_done1) {
                          $tco_result = $tco_loop($tco_var_ctx, $copy_v1);
                      };
                      return $tco_result;
                  };
              };
              return down(Data_List_Types.Nil.value);
          };
      };
  };
  var pop = function (dictOrd) {
      return function (k) {
          var up = function ($copy_ctxs) {
              return function ($copy_tree) {
                  var $tco_var_ctxs = $copy_ctxs;
                  var $tco_done = false;
                  var $tco_result;
                  function $tco_loop(ctxs, tree) {
                      if (ctxs instanceof Data_List_Types.Nil) {
                          $tco_done = true;
                          return tree;
                      };
                      if (ctxs instanceof Data_List_Types.Cons) {
                          if (ctxs.value0 instanceof TwoLeft && (ctxs.value0.value2 instanceof Leaf && tree instanceof Leaf)) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(Leaf.value, ctxs.value0.value0, ctxs.value0.value1, Leaf.value));
                          };
                          if (ctxs.value0 instanceof TwoRight && (ctxs.value0.value0 instanceof Leaf && tree instanceof Leaf)) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(Leaf.value, ctxs.value0.value1, ctxs.value0.value2, Leaf.value));
                          };
                          if (ctxs.value0 instanceof TwoLeft && ctxs.value0.value2 instanceof Two) {
                              $tco_var_ctxs = ctxs.value1;
                              $copy_tree = new Three(tree, ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2.value0, ctxs.value0.value2.value1, ctxs.value0.value2.value2, ctxs.value0.value2.value3);
                              return;
                          };
                          if (ctxs.value0 instanceof TwoRight && ctxs.value0.value0 instanceof Two) {
                              $tco_var_ctxs = ctxs.value1;
                              $copy_tree = new Three(ctxs.value0.value0.value0, ctxs.value0.value0.value1, ctxs.value0.value0.value2, ctxs.value0.value0.value3, ctxs.value0.value1, ctxs.value0.value2, tree);
                              return;
                          };
                          if (ctxs.value0 instanceof TwoLeft && ctxs.value0.value2 instanceof Three) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(new Two(tree, ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2.value0), ctxs.value0.value2.value1, ctxs.value0.value2.value2, new Two(ctxs.value0.value2.value3, ctxs.value0.value2.value4, ctxs.value0.value2.value5, ctxs.value0.value2.value6)));
                          };
                          if (ctxs.value0 instanceof TwoRight && ctxs.value0.value0 instanceof Three) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(new Two(ctxs.value0.value0.value0, ctxs.value0.value0.value1, ctxs.value0.value0.value2, ctxs.value0.value0.value3), ctxs.value0.value0.value4, ctxs.value0.value0.value5, new Two(ctxs.value0.value0.value6, ctxs.value0.value1, ctxs.value0.value2, tree)));
                          };
                          if (ctxs.value0 instanceof ThreeLeft && (ctxs.value0.value2 instanceof Leaf && (ctxs.value0.value5 instanceof Leaf && tree instanceof Leaf))) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Three(Leaf.value, ctxs.value0.value0, ctxs.value0.value1, Leaf.value, ctxs.value0.value3, ctxs.value0.value4, Leaf.value));
                          };
                          if (ctxs.value0 instanceof ThreeMiddle && (ctxs.value0.value0 instanceof Leaf && (ctxs.value0.value5 instanceof Leaf && tree instanceof Leaf))) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Three(Leaf.value, ctxs.value0.value1, ctxs.value0.value2, Leaf.value, ctxs.value0.value3, ctxs.value0.value4, Leaf.value));
                          };
                          if (ctxs.value0 instanceof ThreeRight && (ctxs.value0.value0 instanceof Leaf && (ctxs.value0.value3 instanceof Leaf && tree instanceof Leaf))) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Three(Leaf.value, ctxs.value0.value1, ctxs.value0.value2, Leaf.value, ctxs.value0.value4, ctxs.value0.value5, Leaf.value));
                          };
                          if (ctxs.value0 instanceof ThreeLeft && ctxs.value0.value2 instanceof Two) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(new Three(tree, ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2.value0, ctxs.value0.value2.value1, ctxs.value0.value2.value2, ctxs.value0.value2.value3), ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5));
                          };
                          if (ctxs.value0 instanceof ThreeMiddle && ctxs.value0.value0 instanceof Two) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(new Three(ctxs.value0.value0.value0, ctxs.value0.value0.value1, ctxs.value0.value0.value2, ctxs.value0.value0.value3, ctxs.value0.value1, ctxs.value0.value2, tree), ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5));
                          };
                          if (ctxs.value0 instanceof ThreeMiddle && ctxs.value0.value5 instanceof Two) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2, new Three(tree, ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5.value0, ctxs.value0.value5.value1, ctxs.value0.value5.value2, ctxs.value0.value5.value3)));
                          };
                          if (ctxs.value0 instanceof ThreeRight && ctxs.value0.value3 instanceof Two) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Two(ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2, new Three(ctxs.value0.value3.value0, ctxs.value0.value3.value1, ctxs.value0.value3.value2, ctxs.value0.value3.value3, ctxs.value0.value4, ctxs.value0.value5, tree)));
                          };
                          if (ctxs.value0 instanceof ThreeLeft && ctxs.value0.value2 instanceof Three) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Three(new Two(tree, ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2.value0), ctxs.value0.value2.value1, ctxs.value0.value2.value2, new Two(ctxs.value0.value2.value3, ctxs.value0.value2.value4, ctxs.value0.value2.value5, ctxs.value0.value2.value6), ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5));
                          };
                          if (ctxs.value0 instanceof ThreeMiddle && ctxs.value0.value0 instanceof Three) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Three(new Two(ctxs.value0.value0.value0, ctxs.value0.value0.value1, ctxs.value0.value0.value2, ctxs.value0.value0.value3), ctxs.value0.value0.value4, ctxs.value0.value0.value5, new Two(ctxs.value0.value0.value6, ctxs.value0.value1, ctxs.value0.value2, tree), ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5));
                          };
                          if (ctxs.value0 instanceof ThreeMiddle && ctxs.value0.value5 instanceof Three) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Three(ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2, new Two(tree, ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5.value0), ctxs.value0.value5.value1, ctxs.value0.value5.value2, new Two(ctxs.value0.value5.value3, ctxs.value0.value5.value4, ctxs.value0.value5.value5, ctxs.value0.value5.value6)));
                          };
                          if (ctxs.value0 instanceof ThreeRight && ctxs.value0.value3 instanceof Three) {
                              $tco_done = true;
                              return fromZipper(dictOrd)(ctxs.value1)(new Three(ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2, new Two(ctxs.value0.value3.value0, ctxs.value0.value3.value1, ctxs.value0.value3.value2, ctxs.value0.value3.value3), ctxs.value0.value3.value4, ctxs.value0.value3.value5, new Two(ctxs.value0.value3.value6, ctxs.value0.value4, ctxs.value0.value5, tree)));
                          };
                          throw new Error("Failed pattern match at Data.Map.Internal (line 525, column 9 - line 542, column 136): " + [ ctxs.value0.constructor.name, tree.constructor.name ]);
                      };
                      throw new Error("Failed pattern match at Data.Map.Internal (line 522, column 5 - line 542, column 136): " + [ ctxs.constructor.name ]);
                  };
                  while (!$tco_done) {
                      $tco_result = $tco_loop($tco_var_ctxs, $copy_tree);
                  };
                  return $tco_result;
              };
          };
          var removeMaxNode = function ($copy_ctx) {
              return function ($copy_m) {
                  var $tco_var_ctx = $copy_ctx;
                  var $tco_done1 = false;
                  var $tco_result;
                  function $tco_loop(ctx, m) {
                      if (m instanceof Two && (m.value0 instanceof Leaf && m.value3 instanceof Leaf)) {
                          $tco_done1 = true;
                          return up(ctx)(Leaf.value);
                      };
                      if (m instanceof Two) {
                          $tco_var_ctx = new Data_List_Types.Cons(new TwoRight(m.value0, m.value1, m.value2), ctx);
                          $copy_m = m.value3;
                          return;
                      };
                      if (m instanceof Three && (m.value0 instanceof Leaf && (m.value3 instanceof Leaf && m.value6 instanceof Leaf))) {
                          $tco_done1 = true;
                          return up(new Data_List_Types.Cons(new TwoRight(Leaf.value, m.value1, m.value2), ctx))(Leaf.value);
                      };
                      if (m instanceof Three) {
                          $tco_var_ctx = new Data_List_Types.Cons(new ThreeRight(m.value0, m.value1, m.value2, m.value3, m.value4, m.value5), ctx);
                          $copy_m = m.value6;
                          return;
                      };
                      throw new Error("Failed pattern match at Data.Map.Internal (line 554, column 5 - line 558, column 107): " + [ m.constructor.name ]);
                  };
                  while (!$tco_done1) {
                      $tco_result = $tco_loop($tco_var_ctx, $copy_m);
                  };
                  return $tco_result;
              };
          };
          var maxNode = function ($copy_m) {
              var $tco_done2 = false;
              var $tco_result;
              function $tco_loop(m) {
                  if (m instanceof Two && m.value3 instanceof Leaf) {
                      $tco_done2 = true;
                      return {
                          key: m.value1,
                          value: m.value2
                      };
                  };
                  if (m instanceof Two) {
                      $copy_m = m.value3;
                      return;
                  };
                  if (m instanceof Three && m.value6 instanceof Leaf) {
                      $tco_done2 = true;
                      return {
                          key: m.value4,
                          value: m.value5
                      };
                  };
                  if (m instanceof Three) {
                      $copy_m = m.value6;
                      return;
                  };
                  throw new Error("Failed pattern match at Data.Map.Internal (line 545, column 33 - line 549, column 45): " + [ m.constructor.name ]);
              };
              while (!$tco_done2) {
                  $tco_result = $tco_loop($copy_m);
              };
              return $tco_result;
          };
          var comp = Data_Ord.compare(dictOrd);
          var down = function ($copy_ctx) {
              return function ($copy_m) {
                  var $tco_var_ctx = $copy_ctx;
                  var $tco_done3 = false;
                  var $tco_result;
                  function $tco_loop(ctx, m) {
                      if (m instanceof Leaf) {
                          $tco_done3 = true;
                          return Data_Maybe.Nothing.value;
                      };
                      if (m instanceof Two) {
                          var v = comp(k)(m.value1);
                          if (m.value3 instanceof Leaf && v instanceof Data_Ordering.EQ) {
                              $tco_done3 = true;
                              return new Data_Maybe.Just(new Data_Tuple.Tuple(m.value2, up(ctx)(Leaf.value)));
                          };
                          if (v instanceof Data_Ordering.EQ) {
                              var max = maxNode(m.value0);
                              $tco_done3 = true;
                              return new Data_Maybe.Just(new Data_Tuple.Tuple(m.value2, removeMaxNode(new Data_List_Types.Cons(new TwoLeft(max.key, max.value, m.value3), ctx))(m.value0)));
                          };
                          if (v instanceof Data_Ordering.LT) {
                              $tco_var_ctx = new Data_List_Types.Cons(new TwoLeft(m.value1, m.value2, m.value3), ctx);
                              $copy_m = m.value0;
                              return;
                          };
                          $tco_var_ctx = new Data_List_Types.Cons(new TwoRight(m.value0, m.value1, m.value2), ctx);
                          $copy_m = m.value3;
                          return;
                      };
                      if (m instanceof Three) {
                          var leaves = (function () {
                              if (m.value0 instanceof Leaf && (m.value3 instanceof Leaf && m.value6 instanceof Leaf)) {
                                  return true;
                              };
                              return false;
                          })();
                          var v = comp(k)(m.value4);
                          var v3 = comp(k)(m.value1);
                          if (leaves && v3 instanceof Data_Ordering.EQ) {
                              $tco_done3 = true;
                              return new Data_Maybe.Just(new Data_Tuple.Tuple(m.value2, fromZipper(dictOrd)(ctx)(new Two(Leaf.value, m.value4, m.value5, Leaf.value))));
                          };
                          if (leaves && v instanceof Data_Ordering.EQ) {
                              $tco_done3 = true;
                              return new Data_Maybe.Just(new Data_Tuple.Tuple(m.value5, fromZipper(dictOrd)(ctx)(new Two(Leaf.value, m.value1, m.value2, Leaf.value))));
                          };
                          if (v3 instanceof Data_Ordering.EQ) {
                              var max = maxNode(m.value0);
                              $tco_done3 = true;
                              return new Data_Maybe.Just(new Data_Tuple.Tuple(m.value2, removeMaxNode(new Data_List_Types.Cons(new ThreeLeft(max.key, max.value, m.value3, m.value4, m.value5, m.value6), ctx))(m.value0)));
                          };
                          if (v instanceof Data_Ordering.EQ) {
                              var max = maxNode(m.value3);
                              $tco_done3 = true;
                              return new Data_Maybe.Just(new Data_Tuple.Tuple(m.value5, removeMaxNode(new Data_List_Types.Cons(new ThreeMiddle(m.value0, m.value1, m.value2, max.key, max.value, m.value6), ctx))(m.value3)));
                          };
                          if (v3 instanceof Data_Ordering.LT) {
                              $tco_var_ctx = new Data_List_Types.Cons(new ThreeLeft(m.value1, m.value2, m.value3, m.value4, m.value5, m.value6), ctx);
                              $copy_m = m.value0;
                              return;
                          };
                          if (v3 instanceof Data_Ordering.GT && v instanceof Data_Ordering.LT) {
                              $tco_var_ctx = new Data_List_Types.Cons(new ThreeMiddle(m.value0, m.value1, m.value2, m.value4, m.value5, m.value6), ctx);
                              $copy_m = m.value3;
                              return;
                          };
                          $tco_var_ctx = new Data_List_Types.Cons(new ThreeRight(m.value0, m.value1, m.value2, m.value3, m.value4, m.value5), ctx);
                          $copy_m = m.value6;
                          return;
                      };
                      throw new Error("Failed pattern match at Data.Map.Internal (line 495, column 34 - line 518, column 80): " + [ m.constructor.name ]);
                  };
                  while (!$tco_done3) {
                      $tco_result = $tco_loop($tco_var_ctx, $copy_m);
                  };
                  return $tco_result;
              };
          };
          return down(Data_List_Types.Nil.value);
      };
  };
  var foldableMap = {
      foldl: function (f) {
          return function (z) {
              return function (m) {
                  return Data_Foldable.foldl(Data_List_Types.foldableList)(f)(z)(values(m));
              };
          };
      },
      foldr: function (f) {
          return function (z) {
              return function (m) {
                  return Data_Foldable.foldr(Data_List_Types.foldableList)(f)(z)(values(m));
              };
          };
      },
      foldMap: function (dictMonoid) {
          return function (f) {
              return function (m) {
                  return Data_Foldable.foldMap(Data_List_Types.foldableList)(dictMonoid)(f)(values(m));
              };
          };
      }
  };
  var traversableMap = {
      traverse: function (dictApplicative) {
          return function (v) {
              return function (v1) {
                  if (v1 instanceof Leaf) {
                      return Control_Applicative.pure(dictApplicative)(Leaf.value);
                  };
                  if (v1 instanceof Two) {
                      return Control_Apply.apply(dictApplicative.Apply0())(Control_Apply.apply(dictApplicative.Apply0())(Control_Apply.apply(dictApplicative.Apply0())(Data_Functor.map((dictApplicative.Apply0()).Functor0())(Two.create)(Data_Traversable.traverse(traversableMap)(dictApplicative)(v)(v1.value0)))(Control_Applicative.pure(dictApplicative)(v1.value1)))(v(v1.value2)))(Data_Traversable.traverse(traversableMap)(dictApplicative)(v)(v1.value3));
                  };
                  if (v1 instanceof Three) {
                      return Control_Apply.apply(dictApplicative.Apply0())(Control_Apply.apply(dictApplicative.Apply0())(Control_Apply.apply(dictApplicative.Apply0())(Control_Apply.apply(dictApplicative.Apply0())(Control_Apply.apply(dictApplicative.Apply0())(Control_Apply.apply(dictApplicative.Apply0())(Data_Functor.map((dictApplicative.Apply0()).Functor0())(Three.create)(Data_Traversable.traverse(traversableMap)(dictApplicative)(v)(v1.value0)))(Control_Applicative.pure(dictApplicative)(v1.value1)))(v(v1.value2)))(Data_Traversable.traverse(traversableMap)(dictApplicative)(v)(v1.value3)))(Control_Applicative.pure(dictApplicative)(v1.value4)))(v(v1.value5)))(Data_Traversable.traverse(traversableMap)(dictApplicative)(v)(v1.value6));
                  };
                  throw new Error("Failed pattern match at Data.Map.Internal (line 127, column 1 - line 142, column 31): " + [ v.constructor.name, v1.constructor.name ]);
              };
          };
      },
      sequence: function (dictApplicative) {
          return Data_Traversable.traverse(traversableMap)(dictApplicative)(Control_Category.identity(Control_Category.categoryFn));
      },
      Functor0: function () {
          return functorMap;
      },
      Foldable1: function () {
          return foldableMap;
      }
  };
  var foldSubmapBy = function (dictOrd) {
      return function (appendFn) {
          return function (memptyValue) {
              return function (kmin) {
                  return function (kmax) {
                      return function (f) {
                          var tooSmall = (function () {
                              if (kmin instanceof Data_Maybe.Just) {
                                  return function (k) {
                                      return Data_Ord.lessThan(dictOrd)(k)(kmin.value0);
                                  };
                              };
                              if (kmin instanceof Data_Maybe.Nothing) {
                                  return Data_Function["const"](false);
                              };
                              throw new Error("Failed pattern match at Data.Map.Internal (line 333, column 7 - line 337, column 22): " + [ kmin.constructor.name ]);
                          })();
                          var tooLarge = (function () {
                              if (kmax instanceof Data_Maybe.Just) {
                                  return function (k) {
                                      return Data_Ord.greaterThan(dictOrd)(k)(kmax.value0);
                                  };
                              };
                              if (kmax instanceof Data_Maybe.Nothing) {
                                  return Data_Function["const"](false);
                              };
                              throw new Error("Failed pattern match at Data.Map.Internal (line 340, column 7 - line 344, column 22): " + [ kmax.constructor.name ]);
                          })();
                          var inBounds = (function () {
                              if (kmin instanceof Data_Maybe.Just && kmax instanceof Data_Maybe.Just) {
                                  return function (k) {
                                      return Data_Ord.lessThanOrEq(dictOrd)(kmin.value0)(k) && Data_Ord.lessThanOrEq(dictOrd)(k)(kmax.value0);
                                  };
                              };
                              if (kmin instanceof Data_Maybe.Just && kmax instanceof Data_Maybe.Nothing) {
                                  return function (k) {
                                      return Data_Ord.lessThanOrEq(dictOrd)(kmin.value0)(k);
                                  };
                              };
                              if (kmin instanceof Data_Maybe.Nothing && kmax instanceof Data_Maybe.Just) {
                                  return function (k) {
                                      return Data_Ord.lessThanOrEq(dictOrd)(k)(kmax.value0);
                                  };
                              };
                              if (kmin instanceof Data_Maybe.Nothing && kmax instanceof Data_Maybe.Nothing) {
                                  return Data_Function["const"](true);
                              };
                              throw new Error("Failed pattern match at Data.Map.Internal (line 347, column 7 - line 355, column 21): " + [ kmin.constructor.name, kmax.constructor.name ]);
                          })();
                          var go = function (v) {
                              if (v instanceof Leaf) {
                                  return memptyValue;
                              };
                              if (v instanceof Two) {
                                  return appendFn(appendFn((function () {
                                      var $626 = tooSmall(v.value1);
                                      if ($626) {
                                          return memptyValue;
                                      };
                                      return go(v.value0);
                                  })())((function () {
                                      var $627 = inBounds(v.value1);
                                      if ($627) {
                                          return f(v.value1)(v.value2);
                                      };
                                      return memptyValue;
                                  })()))((function () {
                                      var $628 = tooLarge(v.value1);
                                      if ($628) {
                                          return memptyValue;
                                      };
                                      return go(v.value3);
                                  })());
                              };
                              if (v instanceof Three) {
                                  return appendFn(appendFn(appendFn(appendFn((function () {
                                      var $633 = tooSmall(v.value1);
                                      if ($633) {
                                          return memptyValue;
                                      };
                                      return go(v.value0);
                                  })())((function () {
                                      var $634 = inBounds(v.value1);
                                      if ($634) {
                                          return f(v.value1)(v.value2);
                                      };
                                      return memptyValue;
                                  })()))((function () {
                                      var $635 = tooSmall(v.value4) || tooLarge(v.value1);
                                      if ($635) {
                                          return memptyValue;
                                      };
                                      return go(v.value3);
                                  })()))((function () {
                                      var $636 = inBounds(v.value4);
                                      if ($636) {
                                          return f(v.value4)(v.value5);
                                      };
                                      return memptyValue;
                                  })()))((function () {
                                      var $637 = tooLarge(v.value4);
                                      if ($637) {
                                          return memptyValue;
                                      };
                                      return go(v.value6);
                                  })());
                              };
                              throw new Error("Failed pattern match at Data.Map.Internal (line 373, column 10 - line 385, column 67): " + [ v.constructor.name ]);
                          };
                          return go;
                      };
                  };
              };
          };
      };
  };
  var foldSubmap = function (dictOrd) {
      return function (dictMonoid) {
          return foldSubmapBy(dictOrd)(Data_Semigroup.append(dictMonoid.Semigroup0()))(Data_Monoid.mempty(dictMonoid));
      };
  };
  var empty = Leaf.value;
  var $$delete = function (dictOrd) {
      return function (k) {
          return function (m) {
              return Data_Maybe.maybe(m)(Data_Tuple.snd)(pop(dictOrd)(k)(m));
          };
      };
  };
  var asList = Control_Category.identity(Control_Category.categoryFn);
  var foldableWithIndexMap = {
      foldlWithIndex: function (f) {
          return function (z) {
              return function (m) {
                  return Data_Foldable.foldl(Data_List_Types.foldableList)((function () {
                      var $756 = Data_Function.flip(f);
                      return function ($757) {
                          return Data_Tuple.uncurry($756($757));
                      };
                  })())(z)(asList(toUnfoldable(Data_List_Types.unfoldableList)(m)));
              };
          };
      },
      foldrWithIndex: function (f) {
          return function (z) {
              return function (m) {
                  return Data_Foldable.foldr(Data_List_Types.foldableList)(Data_Tuple.uncurry(f))(z)(asList(toUnfoldable(Data_List_Types.unfoldableList)(m)));
              };
          };
      },
      foldMapWithIndex: function (dictMonoid) {
          return function (f) {
              return function (m) {
                  return Data_Foldable.foldMap(Data_List_Types.foldableList)(dictMonoid)(Data_Tuple.uncurry(f))(asList(toUnfoldable(Data_List_Types.unfoldableList)(m)));
              };
          };
      },
      Foldable0: function () {
          return foldableMap;
      }
  };
  var alter = function (dictOrd) {
      return function (f) {
          return function (k) {
              return function (m) {
                  var v = f(lookup(dictOrd)(k)(m));
                  if (v instanceof Data_Maybe.Nothing) {
                      return $$delete(dictOrd)(k)(m);
                  };
                  if (v instanceof Data_Maybe.Just) {
                      return insert(dictOrd)(k)(v.value0)(m);
                  };
                  throw new Error("Failed pattern match at Data.Map.Internal (line 563, column 15 - line 565, column 25): " + [ v.constructor.name ]);
              };
          };
      };
  };
  var unionWith = function (dictOrd) {
      return function (f) {
          return function (m1) {
              return function (m2) {
                  var go = function (m) {
                      return function (v) {
                          return alter(dictOrd)((function () {
                              var $764 = Data_Maybe.maybe(v.value1)(f(v.value1));
                              return function ($765) {
                                  return Data_Maybe.Just.create($764($765));
                              };
                          })())(v.value0)(m);
                      };
                  };
                  return Data_Foldable.foldl(Data_List_Types.foldableList)(go)(m2)(toUnfoldable(Data_List_Types.unfoldableList)(m1));
              };
          };
      };
  };
  var union = function (dictOrd) {
      return unionWith(dictOrd)(Data_Function["const"]);
  };
  var altMap = function (dictOrd) {
      return {
          alt: union(dictOrd),
          Functor0: function () {
              return functorMap;
          }
      };
  };
  var plusMap = function (dictOrd) {
      return {
          empty: empty,
          Alt0: function () {
              return altMap(dictOrd);
          }
      };
  };
  exports["empty"] = empty;
  exports["singleton"] = singleton;
  exports["insert"] = insert;
  exports["lookup"] = lookup;
  exports["foldSubmap"] = foldSubmap;
  exports["delete"] = $$delete;
  exports["pop"] = pop;
  exports["alter"] = alter;
  exports["values"] = values;
  exports["plusMap"] = plusMap;
  exports["foldableMap"] = foldableMap;
  exports["foldableWithIndexMap"] = foldableWithIndexMap;
  exports["traversableMap"] = traversableMap;
})(PS);
(function(exports) {
  "use strict";

  exports.showIntImpl = function (n) {
    return n.toString();
  };
})(PS["Data.Show"] = PS["Data.Show"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Show"] = $PS["Data.Show"] || {};
  var exports = $PS["Data.Show"];
  var $foreign = $PS["Data.Show"];
  var showInt = {
      show: $foreign.showIntImpl
  };
  var show = function (dict) {
      return dict.show;
  };
  exports["show"] = show;
  exports["showInt"] = showInt;
})(PS);
(function(exports) {
  "use strict";

  // module Unsafe.Coerce

  exports.unsafeCoerce = function (x) {
    return x;
  };
})(PS["Unsafe.Coerce"] = PS["Unsafe.Coerce"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Unsafe.Coerce"] = $PS["Unsafe.Coerce"] || {};
  var exports = $PS["Unsafe.Coerce"];
  var $foreign = $PS["Unsafe.Coerce"];
  exports["unsafeCoerce"] = $foreign.unsafeCoerce;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Exists"] = $PS["Data.Exists"] || {};
  var exports = $PS["Data.Exists"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                
  var runExists = Unsafe_Coerce.unsafeCoerce;
  var mkExists = Unsafe_Coerce.unsafeCoerce;
  exports["mkExists"] = mkExists;
  exports["runExists"] = runExists;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Coyoneda"] = $PS["Data.Coyoneda"] || {};
  var exports = $PS["Data.Coyoneda"];
  var Control_Category = $PS["Control.Category"];
  var Data_Exists = $PS["Data.Exists"];                          
  var CoyonedaF = (function () {
      function CoyonedaF(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      CoyonedaF.create = function (value0) {
          return function (value1) {
              return new CoyonedaF(value0, value1);
          };
      };
      return CoyonedaF;
  })();
  var unCoyoneda = function (f) {
      return function (v) {
          return Data_Exists.runExists(function (v1) {
              return f(v1.value0)(v1.value1);
          })(v);
      };
  };
  var coyoneda = function (k) {
      return function (fi) {
          return Data_Exists.mkExists(new CoyonedaF(k, fi));
      };
  };
  var functorCoyoneda = {
      map: function (f) {
          return function (v) {
              return Data_Exists.runExists(function (v1) {
                  return coyoneda(function ($84) {
                      return f(v1.value0($84));
                  })(v1.value1);
              })(v);
          };
      }
  };
  var liftCoyoneda = coyoneda(Control_Category.identity(Control_Category.categoryFn));
  exports["unCoyoneda"] = unCoyoneda;
  exports["liftCoyoneda"] = liftCoyoneda;
  exports["functorCoyoneda"] = functorCoyoneda;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Alt"] = $PS["Control.Alt"] || {};
  var exports = $PS["Control.Alt"];
  var alt = function (dict) {
      return dict.alt;
  };
  exports["alt"] = alt;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Plus"] = $PS["Control.Plus"] || {};
  var exports = $PS["Control.Plus"];
  var empty = function (dict) {
      return dict.empty;
  };
  exports["empty"] = empty;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Monoid.Alternate"] = $PS["Data.Monoid.Alternate"] || {};
  var exports = $PS["Data.Monoid.Alternate"];
  var Control_Alt = $PS["Control.Alt"];
  var Control_Plus = $PS["Control.Plus"];          
  var Alternate = function (x) {
      return x;
  };
  var semigroupAlternate = function (dictAlt) {
      return {
          append: function (v) {
              return function (v1) {
                  return Control_Alt.alt(dictAlt)(v)(v1);
              };
          }
      };
  };
  var monoidAlternate = function (dictPlus) {
      return {
          mempty: Control_Plus.empty(dictPlus),
          Semigroup0: function () {
              return semigroupAlternate(dictPlus.Alt0());
          }
      };
  };
  exports["Alternate"] = Alternate;
  exports["monoidAlternate"] = monoidAlternate;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Safe.Coerce"] = $PS["Safe.Coerce"] || {};
  var exports = $PS["Safe.Coerce"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                
  var coerce = function () {
      return Unsafe_Coerce.unsafeCoerce;
  };
  exports["coerce"] = coerce;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Newtype"] = $PS["Data.Newtype"] || {};
  var exports = $PS["Data.Newtype"];
  var Safe_Coerce = $PS["Safe.Coerce"];
  var unwrap = Safe_Coerce.coerce;
  var un = function () {
      return function (v) {
          return unwrap();
      };
  };
  exports["unwrap"] = unwrap;
  exports["un"] = un;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.Data.OrdBox"] = $PS["Halogen.Data.OrdBox"] || {};
  var exports = $PS["Halogen.Data.OrdBox"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Ord = $PS["Data.Ord"];                
  var OrdBox = (function () {
      function OrdBox(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      OrdBox.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new OrdBox(value0, value1, value2);
              };
          };
      };
      return OrdBox;
  })();
  var unOrdBox = function (v) {
      return v.value2;
  };
  var mkOrdBox = function (dictOrd) {
      return OrdBox.create(Data_Eq.eq(dictOrd.Eq0()))(Data_Ord.compare(dictOrd));
  };
  var eqOrdBox = {
      eq: function (v) {
          return function (v1) {
              return v.value0(v.value2)(v1.value2);
          };
      }
  };
  var ordOrdBox = {
      compare: function (v) {
          return function (v1) {
              return v.value1(v.value2)(v1.value2);
          };
      },
      Eq0: function () {
          return eqOrdBox;
      }
  };
  exports["mkOrdBox"] = mkOrdBox;
  exports["unOrdBox"] = unOrdBox;
  exports["ordOrdBox"] = ordOrdBox;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.Data.Slot"] = $PS["Halogen.Data.Slot"] || {};
  var exports = $PS["Halogen.Data.Slot"];
  var Data_Boolean = $PS["Data.Boolean"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Map_Internal = $PS["Data.Map.Internal"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Monoid_Alternate = $PS["Data.Monoid.Alternate"];
  var Data_Newtype = $PS["Data.Newtype"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Symbol = $PS["Data.Symbol"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Halogen_Data_OrdBox = $PS["Halogen.Data.OrdBox"];
  var slots = function () {
      return function (dictIsSymbol) {
          return function (dictOrd) {
              return function (sym) {
                  return function (v) {
                      var key = Data_Symbol.reflectSymbol(dictIsSymbol)(sym);
                      var go = function (v1) {
                          return function (val) {
                              if (key === v1.value0) {
                                  return Data_Map_Internal.singleton(Halogen_Data_OrdBox.unOrdBox(v1.value1))(val);
                              };
                              if (Data_Boolean.otherwise) {
                                  return Data_Map_Internal.empty;
                              };
                              throw new Error("Failed pattern match at Halogen.Data.Slot (line 121, column 3 - line 123, column 38): " + [ v1.constructor.name, val.constructor.name ]);
                          };
                      };
                      return Data_Newtype.un()(Data_Monoid_Alternate.Alternate)(Data_Map_Internal.foldSubmap(Data_Tuple.ordTuple(Data_Ord.ordString)(Halogen_Data_OrdBox.ordOrdBox))(Data_Monoid_Alternate.monoidAlternate(Data_Map_Internal.plusMap(dictOrd)))(Data_Maybe.Nothing.value)(Data_Maybe.Nothing.value)(go)(v));
                  };
              };
          };
      };
  };
  var pop = function () {
      return function (dictIsSymbol) {
          return function (dictOrd) {
              return function (sym) {
                  return function (key) {
                      return function (v) {
                          return Data_Map_Internal.pop(Data_Tuple.ordTuple(Data_Ord.ordString)(Halogen_Data_OrdBox.ordOrdBox))(new Data_Tuple.Tuple(Data_Symbol.reflectSymbol(dictIsSymbol)(sym), Halogen_Data_OrdBox.mkOrdBox(dictOrd)(key)))(v);
                      };
                  };
              };
          };
      };
  };
  var lookup = function () {
      return function (dictIsSymbol) {
          return function (dictOrd) {
              return function (sym) {
                  return function (key) {
                      return function (v) {
                          return Data_Map_Internal.lookup(Data_Tuple.ordTuple(Data_Ord.ordString)(Halogen_Data_OrdBox.ordOrdBox))(new Data_Tuple.Tuple(Data_Symbol.reflectSymbol(dictIsSymbol)(sym), Halogen_Data_OrdBox.mkOrdBox(dictOrd)(key)))(v);
                      };
                  };
              };
          };
      };
  };
  var insert = function () {
      return function (dictIsSymbol) {
          return function (dictOrd) {
              return function (sym) {
                  return function (key) {
                      return function (val) {
                          return function (v) {
                              return Data_Map_Internal.insert(Data_Tuple.ordTuple(Data_Ord.ordString)(Halogen_Data_OrdBox.ordOrdBox))(new Data_Tuple.Tuple(Data_Symbol.reflectSymbol(dictIsSymbol)(sym), Halogen_Data_OrdBox.mkOrdBox(dictOrd)(key)))(val)(v);
                          };
                      };
                  };
              };
          };
      };
  };
  var foreachSlot = function (dictApplicative) {
      return function (v) {
          return function (k) {
              return Data_Foldable.traverse_(dictApplicative)(Data_Map_Internal.foldableMap)(function ($33) {
                  return k($33);
              })(v);
          };
      };
  };
  var empty = Data_Map_Internal.empty;
  exports["empty"] = empty;
  exports["lookup"] = lookup;
  exports["insert"] = insert;
  exports["pop"] = pop;
  exports["slots"] = slots;
  exports["foreachSlot"] = foreachSlot;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Monad"] = $PS["Control.Monad"] || {};
  var exports = $PS["Control.Monad"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var unlessM = function (dictMonad) {
      return function (mb) {
          return function (m) {
              return Control_Bind.bind(dictMonad.Bind1())(mb)(function (b) {
                  return Control_Applicative.unless(dictMonad.Applicative0())(b)(m);
              });
          };
      };
  };
  var ap = function (dictMonad) {
      return function (f) {
          return function (a) {
              return Control_Bind.bind(dictMonad.Bind1())(f)(function (f$prime) {
                  return Control_Bind.bind(dictMonad.Bind1())(a)(function (a$prime) {
                      return Control_Applicative.pure(dictMonad.Applicative0())(f$prime(a$prime));
                  });
              });
          };
      };
  };
  exports["unlessM"] = unlessM;
  exports["ap"] = ap;
})(PS);
(function(exports) {
  "use strict";

  exports.pureE = function (a) {
    return function () {
      return a;
    };
  };

  exports.bindE = function (a) {
    return function (f) {
      return function () {
        return f(a())();
      };
    };
  };
})(PS["Effect"] = PS["Effect"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Effect"] = $PS["Effect"] || {};
  var exports = $PS["Effect"];
  var $foreign = $PS["Effect"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Monad = $PS["Control.Monad"];                  
  var monadEffect = {
      Applicative0: function () {
          return applicativeEffect;
      },
      Bind1: function () {
          return bindEffect;
      }
  };
  var bindEffect = {
      bind: $foreign.bindE,
      Apply0: function () {
          return applyEffect;
      }
  };
  var applyEffect = {
      apply: Control_Monad.ap(monadEffect),
      Functor0: function () {
          return functorEffect;
      }
  };
  var applicativeEffect = {
      pure: $foreign.pureE,
      Apply0: function () {
          return applyEffect;
      }
  };
  var functorEffect = {
      map: Control_Applicative.liftA1(applicativeEffect)
  };
  exports["functorEffect"] = functorEffect;
  exports["applicativeEffect"] = applicativeEffect;
  exports["bindEffect"] = bindEffect;
  exports["monadEffect"] = monadEffect;
})(PS);
(function(exports) {
  "use strict";

  exports.new = function (val) {
    return function () {
      return { value: val };
    };
  };

  exports.read = function (ref) {
    return function () {
      return ref.value;
    };
  };

  exports.modifyImpl = function (f) {
    return function (ref) {
      return function () {
        var t = f(ref.value);
        ref.value = t.state;
        return t.value;
      };
    };
  };

  exports.write = function (val) {
    return function (ref) {
      return function () {
        ref.value = val;
      };
    };
  };
})(PS["Effect.Ref"] = PS["Effect.Ref"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Effect.Ref"] = $PS["Effect.Ref"] || {};
  var exports = $PS["Effect.Ref"];
  var $foreign = $PS["Effect.Ref"];
  var Data_Functor = $PS["Data.Functor"];
  var Effect = $PS["Effect"];                
  var modify$prime = $foreign.modifyImpl;
  var modify = function (f) {
      return modify$prime(function (s) {
          var s$prime = f(s);
          return {
              state: s$prime,
              value: s$prime
          };
      });
  };
  var modify_ = function (f) {
      return function (s) {
          return Data_Functor["void"](Effect.functorEffect)(modify(f)(s));
      };
  };
  exports["modify'"] = modify$prime;
  exports["modify_"] = modify_;
  exports["new"] = $foreign["new"];
  exports["read"] = $foreign.read;
  exports["write"] = $foreign.write;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Monad.Rec.Class"] = $PS["Control.Monad.Rec.Class"] || {};
  var exports = $PS["Control.Monad.Rec.Class"];
  var Control_Bind = $PS["Control.Bind"];
  var Data_Functor = $PS["Data.Functor"];
  var Effect = $PS["Effect"];
  var Effect_Ref = $PS["Effect.Ref"];                
  var Loop = (function () {
      function Loop(value0) {
          this.value0 = value0;
      };
      Loop.create = function (value0) {
          return new Loop(value0);
      };
      return Loop;
  })();
  var Done = (function () {
      function Done(value0) {
          this.value0 = value0;
      };
      Done.create = function (value0) {
          return new Done(value0);
      };
      return Done;
  })();
  var tailRecM = function (dict) {
      return dict.tailRecM;
  };
  var monadRecEffect = {
      tailRecM: function (f) {
          return function (a) {
              var fromDone = function (v) {
                  if (v instanceof Done) {
                      return v.value0;
                  };
                  throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 113, column 30 - line 113, column 44): " + [ v.constructor.name ]);
              };
              return function __do() {
                  var r = Control_Bind.bindFlipped(Effect.bindEffect)(Effect_Ref["new"])(f(a))();
                  (function () {
                      while (!(function __do() {
                          var v = Effect_Ref.read(r)();
                          if (v instanceof Loop) {
                              var e = f(v.value0)();
                              Effect_Ref.write(e)(r)();
                              return false;
                          };
                          if (v instanceof Done) {
                              return true;
                          };
                          throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 104, column 22 - line 109, column 28): " + [ v.constructor.name ]);
                      })()) {

                      };
                      return {};
                  })();
                  return Data_Functor.map(Effect.functorEffect)(fromDone)(Effect_Ref.read(r))();
              };
          };
      },
      Monad0: function () {
          return Effect.monadEffect;
      }
  };
  exports["Loop"] = Loop;
  exports["Done"] = Done;
  exports["tailRecM"] = tailRecM;
  exports["monadRecEffect"] = monadRecEffect;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.List"] = $PS["Data.List"] || {};
  var exports = $PS["Data.List"];
  var Data_List_Types = $PS["Data.List.Types"];
  var reverse = (function () {
      var go = function ($copy_acc) {
          return function ($copy_v) {
              var $tco_var_acc = $copy_acc;
              var $tco_done = false;
              var $tco_result;
              function $tco_loop(acc, v) {
                  if (v instanceof Data_List_Types.Nil) {
                      $tco_done = true;
                      return acc;
                  };
                  if (v instanceof Data_List_Types.Cons) {
                      $tco_var_acc = new Data_List_Types.Cons(v.value0, acc);
                      $copy_v = v.value1;
                      return;
                  };
                  throw new Error("Failed pattern match at Data.List (line 372, column 3 - line 372, column 19): " + [ acc.constructor.name, v.constructor.name ]);
              };
              while (!$tco_done) {
                  $tco_result = $tco_loop($tco_var_acc, $copy_v);
              };
              return $tco_result;
          };
      };
      return go(Data_List_Types.Nil.value);
  })();
  var $$null = function (v) {
      if (v instanceof Data_List_Types.Nil) {
          return true;
      };
      return false;
  };
  exports["null"] = $$null;
  exports["reverse"] = reverse;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.CatQueue"] = $PS["Data.CatQueue"] || {};
  var exports = $PS["Data.CatQueue"];
  var Data_List = $PS["Data.List"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Tuple = $PS["Data.Tuple"];                
  var CatQueue = (function () {
      function CatQueue(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      CatQueue.create = function (value0) {
          return function (value1) {
              return new CatQueue(value0, value1);
          };
      };
      return CatQueue;
  })();
  var uncons = function ($copy_v) {
      var $tco_done = false;
      var $tco_result;
      function $tco_loop(v) {
          if (v.value0 instanceof Data_List_Types.Nil && v.value1 instanceof Data_List_Types.Nil) {
              $tco_done = true;
              return Data_Maybe.Nothing.value;
          };
          if (v.value0 instanceof Data_List_Types.Nil) {
              $copy_v = new CatQueue(Data_List.reverse(v.value1), Data_List_Types.Nil.value);
              return;
          };
          if (v.value0 instanceof Data_List_Types.Cons) {
              $tco_done = true;
              return new Data_Maybe.Just(new Data_Tuple.Tuple(v.value0.value0, new CatQueue(v.value0.value1, v.value1)));
          };
          throw new Error("Failed pattern match at Data.CatQueue (line 83, column 1 - line 83, column 63): " + [ v.constructor.name ]);
      };
      while (!$tco_done) {
          $tco_result = $tco_loop($copy_v);
      };
      return $tco_result;
  };
  var snoc = function (v) {
      return function (a) {
          return new CatQueue(v.value0, new Data_List_Types.Cons(a, v.value1));
      };
  };
  var $$null = function (v) {
      if (v.value0 instanceof Data_List_Types.Nil && v.value1 instanceof Data_List_Types.Nil) {
          return true;
      };
      return false;
  };
  var empty = new CatQueue(Data_List_Types.Nil.value, Data_List_Types.Nil.value);
  exports["empty"] = empty;
  exports["null"] = $$null;
  exports["snoc"] = snoc;
  exports["uncons"] = uncons;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.CatList"] = $PS["Data.CatList"] || {};
  var exports = $PS["Data.CatList"];
  var Data_CatQueue = $PS["Data.CatQueue"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Tuple = $PS["Data.Tuple"];                
  var CatNil = (function () {
      function CatNil() {

      };
      CatNil.value = new CatNil();
      return CatNil;
  })();
  var CatCons = (function () {
      function CatCons(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      CatCons.create = function (value0) {
          return function (value1) {
              return new CatCons(value0, value1);
          };
      };
      return CatCons;
  })();
  var link = function (v) {
      return function (v1) {
          if (v instanceof CatNil) {
              return v1;
          };
          if (v1 instanceof CatNil) {
              return v;
          };
          if (v instanceof CatCons) {
              return new CatCons(v.value0, Data_CatQueue.snoc(v.value1)(v1));
          };
          throw new Error("Failed pattern match at Data.CatList (line 109, column 1 - line 109, column 54): " + [ v.constructor.name, v1.constructor.name ]);
      };
  };
  var foldr = function (k) {
      return function (b) {
          return function (q) {
              var foldl = function ($copy_v) {
                  return function ($copy_c) {
                      return function ($copy_v1) {
                          var $tco_var_v = $copy_v;
                          var $tco_var_c = $copy_c;
                          var $tco_done = false;
                          var $tco_result;
                          function $tco_loop(v, c, v1) {
                              if (v1 instanceof Data_List_Types.Nil) {
                                  $tco_done = true;
                                  return c;
                              };
                              if (v1 instanceof Data_List_Types.Cons) {
                                  $tco_var_v = v;
                                  $tco_var_c = v(c)(v1.value0);
                                  $copy_v1 = v1.value1;
                                  return;
                              };
                              throw new Error("Failed pattern match at Data.CatList (line 125, column 3 - line 125, column 59): " + [ v.constructor.name, c.constructor.name, v1.constructor.name ]);
                          };
                          while (!$tco_done) {
                              $tco_result = $tco_loop($tco_var_v, $tco_var_c, $copy_v1);
                          };
                          return $tco_result;
                      };
                  };
              };
              var go = function ($copy_xs) {
                  return function ($copy_ys) {
                      var $tco_var_xs = $copy_xs;
                      var $tco_done1 = false;
                      var $tco_result;
                      function $tco_loop(xs, ys) {
                          var v = Data_CatQueue.uncons(xs);
                          if (v instanceof Data_Maybe.Nothing) {
                              $tco_done1 = true;
                              return foldl(function (x) {
                                  return function (i) {
                                      return i(x);
                                  };
                              })(b)(ys);
                          };
                          if (v instanceof Data_Maybe.Just) {
                              $tco_var_xs = v.value0.value1;
                              $copy_ys = new Data_List_Types.Cons(k(v.value0.value0), ys);
                              return;
                          };
                          throw new Error("Failed pattern match at Data.CatList (line 121, column 14 - line 123, column 67): " + [ v.constructor.name ]);
                      };
                      while (!$tco_done1) {
                          $tco_result = $tco_loop($tco_var_xs, $copy_ys);
                      };
                      return $tco_result;
                  };
              };
              return go(q)(Data_List_Types.Nil.value);
          };
      };
  };
  var uncons = function (v) {
      if (v instanceof CatNil) {
          return Data_Maybe.Nothing.value;
      };
      if (v instanceof CatCons) {
          return new Data_Maybe.Just(new Data_Tuple.Tuple(v.value0, (function () {
              var $45 = Data_CatQueue["null"](v.value1);
              if ($45) {
                  return CatNil.value;
              };
              return foldr(link)(CatNil.value)(v.value1);
          })()));
      };
      throw new Error("Failed pattern match at Data.CatList (line 100, column 1 - line 100, column 61): " + [ v.constructor.name ]);
  };
  var empty = CatNil.value;
  var append = link;
  var semigroupCatList = {
      append: append
  };
  var snoc = function (cat) {
      return function (a) {
          return append(cat)(new CatCons(a, Data_CatQueue.empty));
      };
  };
  exports["empty"] = empty;
  exports["snoc"] = snoc;
  exports["uncons"] = uncons;
  exports["semigroupCatList"] = semigroupCatList;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Monad.Free"] = $PS["Control.Monad.Free"] || {};
  var exports = $PS["Control.Monad.Free"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad = $PS["Control.Monad"];
  var Control_Monad_Rec_Class = $PS["Control.Monad.Rec.Class"];
  var Data_CatList = $PS["Data.CatList"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Free = (function () {
      function Free(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Free.create = function (value0) {
          return function (value1) {
              return new Free(value0, value1);
          };
      };
      return Free;
  })();
  var Return = (function () {
      function Return(value0) {
          this.value0 = value0;
      };
      Return.create = function (value0) {
          return new Return(value0);
      };
      return Return;
  })();
  var Bind = (function () {
      function Bind(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Bind.create = function (value0) {
          return function (value1) {
              return new Bind(value0, value1);
          };
      };
      return Bind;
  })();
  var toView = function ($copy_v) {
      var $tco_done = false;
      var $tco_result;
      function $tco_loop(v) {
          var runExpF = function (v2) {
              return v2;
          };
          var concatF = function (v2) {
              return function (r) {
                  return new Free(v2.value0, Data_Semigroup.append(Data_CatList.semigroupCatList)(v2.value1)(r));
              };
          };
          if (v.value0 instanceof Return) {
              var v2 = Data_CatList.uncons(v.value1);
              if (v2 instanceof Data_Maybe.Nothing) {
                  $tco_done = true;
                  return new Return(v.value0.value0);
              };
              if (v2 instanceof Data_Maybe.Just) {
                  $copy_v = concatF(runExpF(v2.value0.value0)(v.value0.value0))(v2.value0.value1);
                  return;
              };
              throw new Error("Failed pattern match at Control.Monad.Free (line 227, column 7 - line 231, column 64): " + [ v2.constructor.name ]);
          };
          if (v.value0 instanceof Bind) {
              $tco_done = true;
              return new Bind(v.value0.value0, function (a) {
                  return concatF(v.value0.value1(a))(v.value1);
              });
          };
          throw new Error("Failed pattern match at Control.Monad.Free (line 225, column 3 - line 233, column 56): " + [ v.value0.constructor.name ]);
      };
      while (!$tco_done) {
          $tco_result = $tco_loop($copy_v);
      };
      return $tco_result;
  };
  var fromView = function (f) {
      return new Free(f, Data_CatList.empty);
  };
  var freeMonad = {
      Applicative0: function () {
          return freeApplicative;
      },
      Bind1: function () {
          return freeBind;
      }
  };
  var freeFunctor = {
      map: function (k) {
          return function (f) {
              return Control_Bind.bindFlipped(freeBind)((function () {
                  var $119 = Control_Applicative.pure(freeApplicative);
                  return function ($120) {
                      return $119(k($120));
                  };
              })())(f);
          };
      }
  };
  var freeBind = {
      bind: function (v) {
          return function (k) {
              return new Free(v.value0, Data_CatList.snoc(v.value1)(k));
          };
      },
      Apply0: function () {
          return freeApply;
      }
  };
  var freeApply = {
      apply: Control_Monad.ap(freeMonad),
      Functor0: function () {
          return freeFunctor;
      }
  };
  var freeApplicative = {
      pure: function ($121) {
          return fromView(Return.create($121));
      },
      Apply0: function () {
          return freeApply;
      }
  };
  var liftF = function (f) {
      return fromView(new Bind(f, (function () {
          var $122 = Control_Applicative.pure(freeApplicative);
          return function ($123) {
              return $122($123);
          };
      })()));
  };
  var foldFree = function (dictMonadRec) {
      return function (k) {
          var go = function (f) {
              var v = toView(f);
              if (v instanceof Return) {
                  return Data_Functor.map((((dictMonadRec.Monad0()).Bind1()).Apply0()).Functor0())(Control_Monad_Rec_Class.Done.create)(Control_Applicative.pure((dictMonadRec.Monad0()).Applicative0())(v.value0));
              };
              if (v instanceof Bind) {
                  return Data_Functor.map((((dictMonadRec.Monad0()).Bind1()).Apply0()).Functor0())(function ($135) {
                      return Control_Monad_Rec_Class.Loop.create(v.value1($135));
                  })(k(v.value0));
              };
              throw new Error("Failed pattern match at Control.Monad.Free (line 158, column 10 - line 160, column 37): " + [ v.constructor.name ]);
          };
          return Control_Monad_Rec_Class.tailRecM(dictMonadRec)(go);
      };
  };
  exports["liftF"] = liftF;
  exports["foldFree"] = foldFree;
  exports["freeFunctor"] = freeFunctor;
  exports["freeBind"] = freeBind;
  exports["freeApplicative"] = freeApplicative;
  exports["freeMonad"] = freeMonad;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.FoldableWithIndex"] = $PS["Data.FoldableWithIndex"] || {};
  var exports = $PS["Data.FoldableWithIndex"];     
  var foldrWithIndex = function (dict) {
      return dict.foldrWithIndex;
  };
  exports["foldrWithIndex"] = foldrWithIndex;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.Query.ChildQuery"] = $PS["Halogen.Query.ChildQuery"] || {};
  var exports = $PS["Halogen.Query.ChildQuery"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                
  var ChildQuery = (function () {
      function ChildQuery(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      ChildQuery.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new ChildQuery(value0, value1, value2);
              };
          };
      };
      return ChildQuery;
  })();
  var unChildQueryBox = Unsafe_Coerce.unsafeCoerce;
  var mkChildQueryBox = Unsafe_Coerce.unsafeCoerce;
  exports["ChildQuery"] = ChildQuery;
  exports["mkChildQueryBox"] = mkChildQueryBox;
  exports["unChildQueryBox"] = unChildQueryBox;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.Query.HalogenM"] = $PS["Halogen.Query.HalogenM"] || {};
  var exports = $PS["Halogen.Query.HalogenM"];
  var Control_Category = $PS["Control.Category"];
  var Control_Monad_Free = $PS["Control.Monad.Free"];
  var Data_FoldableWithIndex = $PS["Data.FoldableWithIndex"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Map_Internal = $PS["Data.Map.Internal"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Traversable = $PS["Data.Traversable"];
  var Data_Unit = $PS["Data.Unit"];
  var Halogen_Data_Slot = $PS["Halogen.Data.Slot"];
  var Halogen_Query_ChildQuery = $PS["Halogen.Query.ChildQuery"];        
  var SubscriptionId = function (x) {
      return x;
  };
  var ForkId = function (x) {
      return x;
  };
  var State = (function () {
      function State(value0) {
          this.value0 = value0;
      };
      State.create = function (value0) {
          return new State(value0);
      };
      return State;
  })();
  var Subscribe = (function () {
      function Subscribe(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Subscribe.create = function (value0) {
          return function (value1) {
              return new Subscribe(value0, value1);
          };
      };
      return Subscribe;
  })();
  var Unsubscribe = (function () {
      function Unsubscribe(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Unsubscribe.create = function (value0) {
          return function (value1) {
              return new Unsubscribe(value0, value1);
          };
      };
      return Unsubscribe;
  })();
  var Lift = (function () {
      function Lift(value0) {
          this.value0 = value0;
      };
      Lift.create = function (value0) {
          return new Lift(value0);
      };
      return Lift;
  })();
  var ChildQuery = (function () {
      function ChildQuery(value0) {
          this.value0 = value0;
      };
      ChildQuery.create = function (value0) {
          return new ChildQuery(value0);
      };
      return ChildQuery;
  })();
  var Raise = (function () {
      function Raise(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Raise.create = function (value0) {
          return function (value1) {
              return new Raise(value0, value1);
          };
      };
      return Raise;
  })();
  var Par = (function () {
      function Par(value0) {
          this.value0 = value0;
      };
      Par.create = function (value0) {
          return new Par(value0);
      };
      return Par;
  })();
  var Fork = (function () {
      function Fork(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Fork.create = function (value0) {
          return function (value1) {
              return new Fork(value0, value1);
          };
      };
      return Fork;
  })();
  var Kill = (function () {
      function Kill(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Kill.create = function (value0) {
          return function (value1) {
              return new Kill(value0, value1);
          };
      };
      return Kill;
  })();
  var GetRef = (function () {
      function GetRef(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      GetRef.create = function (value0) {
          return function (value1) {
              return new GetRef(value0, value1);
          };
      };
      return GetRef;
  })();
  var HalogenM = function (x) {
      return x;
  };
  var raise = function (o) {
      return Control_Monad_Free.liftF(new Raise(o, Data_Unit.unit));
  };
  var queryAll = function () {
      return function (dictIsSymbol) {
          return function (dictOrd) {
              return function (label) {
                  return function (q) {
                      var catMapMaybes = function (dictOrd1) {
                          return Data_FoldableWithIndex.foldrWithIndex(Data_Map_Internal.foldableWithIndexMap)(function (k) {
                              return function (v) {
                                  return function (acc) {
                                      return Data_Maybe.maybe(acc)(Data_Function.flip(Data_Map_Internal.insert(dictOrd1)(k))(acc))(v);
                                  };
                              };
                          })(Data_Map_Internal.empty);
                      };
                      return Control_Monad_Free.liftF(new ChildQuery(Halogen_Query_ChildQuery.mkChildQueryBox(new Halogen_Query_ChildQuery.ChildQuery(function (dictApplicative) {
                          return function (k) {
                              var $126 = Data_Functor.map((dictApplicative.Apply0()).Functor0())(catMapMaybes(dictOrd));
                              var $127 = Data_Traversable.traverse(Data_Map_Internal.traversableMap)(dictApplicative)(k);
                              var $128 = Halogen_Data_Slot.slots()(dictIsSymbol)(dictOrd)(label);
                              return function ($129) {
                                  return $126($127($128($129)));
                              };
                          };
                      }, q, Control_Category.identity(Control_Category.categoryFn)))));
                  };
              };
          };
      };
  };
  var ordSubscriptionId = Data_Ord.ordInt;
  var ordForkId = Data_Ord.ordInt;
  var monadHalogenM = Control_Monad_Free.freeMonad;
  var monadStateHalogenM = {
      state: function ($134) {
          return HalogenM(Control_Monad_Free.liftF(State.create($134)));
      },
      Monad0: function () {
          return monadHalogenM;
      }
  };
  var functorHalogenM = Control_Monad_Free.freeFunctor;
  var bindHalogenM = Control_Monad_Free.freeBind;           
  var applicativeHalogenM = Control_Monad_Free.freeApplicative;
  exports["State"] = State;
  exports["Subscribe"] = Subscribe;
  exports["Unsubscribe"] = Unsubscribe;
  exports["Lift"] = Lift;
  exports["ChildQuery"] = ChildQuery;
  exports["Raise"] = Raise;
  exports["Par"] = Par;
  exports["Fork"] = Fork;
  exports["Kill"] = Kill;
  exports["GetRef"] = GetRef;
  exports["raise"] = raise;
  exports["queryAll"] = queryAll;
  exports["SubscriptionId"] = SubscriptionId;
  exports["ForkId"] = ForkId;
  exports["functorHalogenM"] = functorHalogenM;
  exports["applicativeHalogenM"] = applicativeHalogenM;
  exports["bindHalogenM"] = bindHalogenM;
  exports["monadStateHalogenM"] = monadStateHalogenM;
  exports["ordSubscriptionId"] = ordSubscriptionId;
  exports["ordForkId"] = ordForkId;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.Query.HalogenQ"] = $PS["Halogen.Query.HalogenQ"] || {};
  var exports = $PS["Halogen.Query.HalogenQ"];           
  var Initialize = (function () {
      function Initialize(value0) {
          this.value0 = value0;
      };
      Initialize.create = function (value0) {
          return new Initialize(value0);
      };
      return Initialize;
  })();
  var Finalize = (function () {
      function Finalize(value0) {
          this.value0 = value0;
      };
      Finalize.create = function (value0) {
          return new Finalize(value0);
      };
      return Finalize;
  })();
  var Receive = (function () {
      function Receive(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Receive.create = function (value0) {
          return function (value1) {
              return new Receive(value0, value1);
          };
      };
      return Receive;
  })();
  var Action = (function () {
      function Action(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Action.create = function (value0) {
          return function (value1) {
              return new Action(value0, value1);
          };
      };
      return Action;
  })();
  var Query = (function () {
      function Query(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Query.create = function (value0) {
          return function (value1) {
              return new Query(value0, value1);
          };
      };
      return Query;
  })();
  exports["Initialize"] = Initialize;
  exports["Finalize"] = Finalize;
  exports["Receive"] = Receive;
  exports["Action"] = Action;
  exports["Query"] = Query;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.Component"] = $PS["Halogen.Component"] || {};
  var exports = $PS["Halogen.Component"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Data_Coyoneda = $PS["Data.Coyoneda"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Unit = $PS["Data.Unit"];
  var Halogen_Data_Slot = $PS["Halogen.Data.Slot"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var Halogen_Query_HalogenQ = $PS["Halogen.Query.HalogenQ"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                
  var ComponentSlot = (function () {
      function ComponentSlot(value0) {
          this.value0 = value0;
      };
      ComponentSlot.create = function (value0) {
          return new ComponentSlot(value0);
      };
      return ComponentSlot;
  })();
  var ThunkSlot = (function () {
      function ThunkSlot(value0) {
          this.value0 = value0;
      };
      ThunkSlot.create = function (value0) {
          return new ThunkSlot(value0);
      };
      return ThunkSlot;
  })();
  var unComponentSlot = Unsafe_Coerce.unsafeCoerce;
  var unComponent = Unsafe_Coerce.unsafeCoerce;
  var mkEval = function (args) {
      return function (v) {
          if (v instanceof Halogen_Query_HalogenQ.Initialize) {
              return Data_Functor.voidLeft(Halogen_Query_HalogenM.functorHalogenM)(Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(args.handleAction)(args.initialize))(v.value0);
          };
          if (v instanceof Halogen_Query_HalogenQ.Finalize) {
              return Data_Functor.voidLeft(Halogen_Query_HalogenM.functorHalogenM)(Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(args.handleAction)(args.finalize))(v.value0);
          };
          if (v instanceof Halogen_Query_HalogenQ.Receive) {
              return Data_Functor.voidLeft(Halogen_Query_HalogenM.functorHalogenM)(Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(args.handleAction)(args.receive(v.value0)))(v.value1);
          };
          if (v instanceof Halogen_Query_HalogenQ.Action) {
              return Data_Functor.voidLeft(Halogen_Query_HalogenM.functorHalogenM)(args.handleAction(v.value0))(v.value1);
          };
          if (v instanceof Halogen_Query_HalogenQ.Query) {
              return Data_Coyoneda.unCoyoneda(function (g) {
                  var $24 = Data_Functor.map(Halogen_Query_HalogenM.functorHalogenM)(Data_Maybe.maybe(v.value1(Data_Unit.unit))(g));
                  return function ($25) {
                      return $24(args.handleQuery($25));
                  };
              })(v.value0);
          };
          throw new Error("Failed pattern match at Halogen.Component (line 182, column 15 - line 192, column 70): " + [ v.constructor.name ]);
      };
  };
  var mkComponentSlot = Unsafe_Coerce.unsafeCoerce;
  var mkComponent = Unsafe_Coerce.unsafeCoerce;
  var defaultEval = {
      handleAction: Data_Function["const"](Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit)),
      handleQuery: Data_Function["const"](Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Maybe.Nothing.value)),
      receive: Data_Function["const"](Data_Maybe.Nothing.value),
      initialize: Data_Maybe.Nothing.value,
      finalize: Data_Maybe.Nothing.value
  };
  var componentSlot = function () {
      return function (dictIsSymbol) {
          return function (dictOrd) {
              return function (label) {
                  return function (p) {
                      return function (comp) {
                          return function (input) {
                              return function (output) {
                                  return mkComponentSlot({
                                      get: Halogen_Data_Slot.lookup()(dictIsSymbol)(dictOrd)(label)(p),
                                      pop: Halogen_Data_Slot.pop()(dictIsSymbol)(dictOrd)(label)(p),
                                      set: Halogen_Data_Slot.insert()(dictIsSymbol)(dictOrd)(label)(p),
                                      component: comp,
                                      input: input,
                                      output: output
                                  });
                              };
                          };
                      };
                  };
              };
          };
      };
  };
  exports["mkComponent"] = mkComponent;
  exports["unComponent"] = unComponent;
  exports["mkEval"] = mkEval;
  exports["defaultEval"] = defaultEval;
  exports["ComponentSlot"] = ComponentSlot;
  exports["ThunkSlot"] = ThunkSlot;
  exports["componentSlot"] = componentSlot;
  exports["unComponentSlot"] = unComponentSlot;
})(PS);
(function(exports) {
  /* eslint-disable no-eq-null, eqeqeq */

  "use strict";

  exports["null"] = null;

  exports.nullable = function (a, r, f) {
    return a == null ? r : f(a);
  };

  exports.notNull = function (x) {
    return x;
  };
})(PS["Data.Nullable"] = PS["Data.Nullable"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Nullable"] = $PS["Data.Nullable"] || {};
  var exports = $PS["Data.Nullable"];
  var $foreign = $PS["Data.Nullable"];
  var Data_Maybe = $PS["Data.Maybe"];              
  var toNullable = Data_Maybe.maybe($foreign["null"])($foreign.notNull);
  var toMaybe = function (n) {
      return $foreign.nullable(n, Data_Maybe.Nothing.value, Data_Maybe.Just.create);
  };
  exports["toMaybe"] = toMaybe;
  exports["toNullable"] = toNullable;
  exports["null"] = $foreign["null"];
})(PS);
(function(exports) {
  "use strict";

  exports.typeOf = function (value) {
    return typeof value;
  };

  exports.tagOf = function (value) {
    return Object.prototype.toString.call(value).slice(8, -1);
  };
})(PS["Foreign"] = PS["Foreign"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Either"] = $PS["Data.Either"] || {};
  var exports = $PS["Data.Either"];                
  var Left = (function () {
      function Left(value0) {
          this.value0 = value0;
      };
      Left.create = function (value0) {
          return new Left(value0);
      };
      return Left;
  })();
  var Right = (function () {
      function Right(value0) {
          this.value0 = value0;
      };
      Right.create = function (value0) {
          return new Right(value0);
      };
      return Right;
  })();
  var functorEither = {
      map: function (f) {
          return function (m) {
              if (m instanceof Left) {
                  return new Left(m.value0);
              };
              if (m instanceof Right) {
                  return new Right(f(m.value0));
              };
              throw new Error("Failed pattern match at Data.Either (line 31, column 1 - line 31, column 52): " + [ m.constructor.name ]);
          };
      }
  };
  var either = function (v) {
      return function (v1) {
          return function (v2) {
              if (v2 instanceof Left) {
                  return v(v2.value0);
              };
              if (v2 instanceof Right) {
                  return v1(v2.value0);
              };
              throw new Error("Failed pattern match at Data.Either (line 208, column 1 - line 208, column 64): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
          };
      };
  };
  exports["Left"] = Left;
  exports["Right"] = Right;
  exports["either"] = either;
  exports["functorEither"] = functorEither;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Monad.Error.Class"] = $PS["Control.Monad.Error.Class"] || {};
  var exports = $PS["Control.Monad.Error.Class"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Data_Either = $PS["Data.Either"];
  var Data_Functor = $PS["Data.Functor"];                        
  var throwError = function (dict) {
      return dict.throwError;
  };
  var catchError = function (dict) {
      return dict.catchError;
  };
  var $$try = function (dictMonadError) {
      return function (a) {
          return catchError(dictMonadError)(Data_Functor.map(((((dictMonadError.MonadThrow0()).Monad0()).Bind1()).Apply0()).Functor0())(Data_Either.Right.create)(a))((function () {
              var $21 = Control_Applicative.pure(((dictMonadError.MonadThrow0()).Monad0()).Applicative0());
              return function ($22) {
                  return $21(Data_Either.Left.create($22));
              };
          })());
      };
  };
  exports["throwError"] = throwError;
  exports["try"] = $$try;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Monad.Except.Trans"] = $PS["Control.Monad.Except.Trans"] || {};
  var exports = $PS["Control.Monad.Except.Trans"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad = $PS["Control.Monad"];
  var Data_Either = $PS["Data.Either"];
  var Data_Functor = $PS["Data.Functor"];                
  var ExceptT = function (x) {
      return x;
  };
  var runExceptT = function (v) {
      return v;
  };
  var mapExceptT = function (f) {
      return function (v) {
          return f(v);
      };
  };
  var functorExceptT = function (dictFunctor) {
      return {
          map: function (f) {
              return mapExceptT(Data_Functor.map(dictFunctor)(Data_Functor.map(Data_Either.functorEither)(f)));
          }
      };
  };
  var monadExceptT = function (dictMonad) {
      return {
          Applicative0: function () {
              return applicativeExceptT(dictMonad);
          },
          Bind1: function () {
              return bindExceptT(dictMonad);
          }
      };
  };
  var bindExceptT = function (dictMonad) {
      return {
          bind: function (v) {
              return function (k) {
                  return Control_Bind.bind(dictMonad.Bind1())(v)(Data_Either.either((function () {
                      var $91 = Control_Applicative.pure(dictMonad.Applicative0());
                      return function ($92) {
                          return $91(Data_Either.Left.create($92));
                      };
                  })())(function (a) {
                      var v1 = k(a);
                      return v1;
                  }));
              };
          },
          Apply0: function () {
              return applyExceptT(dictMonad);
          }
      };
  };
  var applyExceptT = function (dictMonad) {
      return {
          apply: Control_Monad.ap(monadExceptT(dictMonad)),
          Functor0: function () {
              return functorExceptT(((dictMonad.Bind1()).Apply0()).Functor0());
          }
      };
  };
  var applicativeExceptT = function (dictMonad) {
      return {
          pure: (function () {
              var $93 = Control_Applicative.pure(dictMonad.Applicative0());
              return function ($94) {
                  return ExceptT($93(Data_Either.Right.create($94)));
              };
          })(),
          Apply0: function () {
              return applyExceptT(dictMonad);
          }
      };
  };
  var monadThrowExceptT = function (dictMonad) {
      return {
          throwError: (function () {
              var $103 = Control_Applicative.pure(dictMonad.Applicative0());
              return function ($104) {
                  return ExceptT($103(Data_Either.Left.create($104)));
              };
          })(),
          Monad0: function () {
              return monadExceptT(dictMonad);
          }
      };
  };
  exports["runExceptT"] = runExceptT;
  exports["applicativeExceptT"] = applicativeExceptT;
  exports["bindExceptT"] = bindExceptT;
  exports["monadThrowExceptT"] = monadThrowExceptT;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.NonEmpty"] = $PS["Data.NonEmpty"] || {};
  var exports = $PS["Data.NonEmpty"];
  var Control_Plus = $PS["Control.Plus"];                      
  var NonEmpty = (function () {
      function NonEmpty(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      NonEmpty.create = function (value0) {
          return function (value1) {
              return new NonEmpty(value0, value1);
          };
      };
      return NonEmpty;
  })();
  var singleton = function (dictPlus) {
      return function (a) {
          return new NonEmpty(a, Control_Plus.empty(dictPlus));
      };
  };
  exports["NonEmpty"] = NonEmpty;
  exports["singleton"] = singleton;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.List.NonEmpty"] = $PS["Data.List.NonEmpty"] || {};
  var exports = $PS["Data.List.NonEmpty"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_NonEmpty = $PS["Data.NonEmpty"];
  var singleton = (function () {
      var $171 = Data_NonEmpty.singleton(Data_List_Types.plusList);
      return function ($172) {
          return Data_List_Types.NonEmptyList($171($172));
      };
  })();
  var cons = function (y) {
      return function (v) {
          return new Data_NonEmpty.NonEmpty(y, new Data_List_Types.Cons(v.value0, v.value1));
      };
  };
  exports["singleton"] = singleton;
  exports["cons"] = cons;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Foreign"] = $PS["Foreign"] || {};
  var exports = $PS["Foreign"];
  var $foreign = $PS["Foreign"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Monad_Error_Class = $PS["Control.Monad.Error.Class"];
  var Control_Monad_Except_Trans = $PS["Control.Monad.Except.Trans"];
  var Data_Boolean = $PS["Data.Boolean"];
  var Data_List_NonEmpty = $PS["Data.List.NonEmpty"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var TypeMismatch = (function () {
      function TypeMismatch(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      TypeMismatch.create = function (value0) {
          return function (value1) {
              return new TypeMismatch(value0, value1);
          };
      };
      return TypeMismatch;
  })();
  var unsafeToForeign = Unsafe_Coerce.unsafeCoerce;
  var unsafeFromForeign = Unsafe_Coerce.unsafeCoerce;
  var fail = function (dictMonad) {
      var $118 = Control_Monad_Error_Class.throwError(Control_Monad_Except_Trans.monadThrowExceptT(dictMonad));
      return function ($119) {
          return $118(Data_List_NonEmpty.singleton($119));
      };
  };
  var unsafeReadTagged = function (dictMonad) {
      return function (tag) {
          return function (value) {
              if ($foreign.tagOf(value) === tag) {
                  return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(dictMonad))(unsafeFromForeign(value));
              };
              if (Data_Boolean.otherwise) {
                  return fail(dictMonad)(new TypeMismatch(tag, $foreign.tagOf(value)));
              };
              throw new Error("Failed pattern match at Foreign (line 110, column 1 - line 110, column 71): " + [ tag.constructor.name, value.constructor.name ]);
          };
      };
  };
  var readBoolean = function (dictMonad) {
      return unsafeReadTagged(dictMonad)("Boolean");
  };
  var readString = function (dictMonad) {
      return unsafeReadTagged(dictMonad)("String");
  };
  exports["TypeMismatch"] = TypeMismatch;
  exports["unsafeToForeign"] = unsafeToForeign;
  exports["readString"] = readString;
  exports["readBoolean"] = readBoolean;
  exports["fail"] = fail;
  exports["typeOf"] = $foreign.typeOf;
})(PS);
(function(exports) {
  "use strict";

  exports._lookup = function (no, yes, k, m) {
    return k in m ? yes(m[k]) : no;
  };
})(PS["Foreign.Object"] = PS["Foreign.Object"] || {});
(function(exports) {
  "use strict";

  exports.runFn4 = function (fn) {
    return function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return fn(a, b, c, d);
          };
        };
      };
    };
  };
})(PS["Data.Function.Uncurried"] = PS["Data.Function.Uncurried"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Function.Uncurried"] = $PS["Data.Function.Uncurried"] || {};
  var exports = $PS["Data.Function.Uncurried"];
  var $foreign = $PS["Data.Function.Uncurried"];
  exports["runFn4"] = $foreign.runFn4;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Foreign.Object"] = $PS["Foreign.Object"] || {};
  var exports = $PS["Foreign.Object"];
  var $foreign = $PS["Foreign.Object"];
  var Data_Function_Uncurried = $PS["Data.Function.Uncurried"];
  var Data_Maybe = $PS["Data.Maybe"];
  var lookup = Data_Function_Uncurried.runFn4($foreign["_lookup"])(Data_Maybe.Nothing.value)(Data_Maybe.Just.create);
  exports["lookup"] = lookup;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.VDom.Machine"] = $PS["Halogen.VDom.Machine"] || {};
  var exports = $PS["Halogen.VDom.Machine"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                
  var Step = (function () {
      function Step(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      Step.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new Step(value0, value1, value2, value3);
                  };
              };
          };
      };
      return Step;
  })();
  var unStep = Unsafe_Coerce.unsafeCoerce;
  var step = function (v, a) {
      return v.value2(v.value1, a);
  };
  var mkStep = Unsafe_Coerce.unsafeCoerce;
  var halt = function (v) {
      return v.value3(v.value1);
  };
  var extract = unStep(function (v) {
      return v.value0;
  });
  exports["Step"] = Step;
  exports["mkStep"] = mkStep;
  exports["unStep"] = unStep;
  exports["extract"] = extract;
  exports["step"] = step;
  exports["halt"] = halt;
})(PS);
(function(exports) {
  "use strict";

  exports.unsafeGetAny = function (key, obj) {
    return obj[key];
  };

  exports.unsafeHasAny = function (key, obj) {
    return obj.hasOwnProperty(key);
  };

  exports.unsafeSetAny = function (key, val, obj) {
      obj[key] = val;
  };

  exports.forE = function (a, f) {
    var b = [];
    for (var i = 0; i < a.length; i++) {
      b.push(f(i, a[i]));
    }
    return b;
  };

  exports.forEachE = function (a, f) {
    for (var i = 0; i < a.length; i++) {
      f(a[i]);
    }
  };

  exports.forInE = function (o, f) {
    var ks = Object.keys(o);
    for (var i = 0; i < ks.length; i++) {
      var k = ks[i];
      f(k, o[k]);
    }
  };

  exports.diffWithIxE = function (a1, a2, f1, f2, f3) {
    var a3 = [];
    var l1 = a1.length;
    var l2 = a2.length;
    var i  = 0;
    while (1) {
      if (i < l1) {
        if (i < l2) {
          a3.push(f1(i, a1[i], a2[i]));
        } else {
          f2(i, a1[i]);
        }
      } else if (i < l2) {
        a3.push(f3(i, a2[i]));
      } else {
        break;
      }
      i++;
    }
    return a3;
  };

  exports.strMapWithIxE = function (as, fk, f) {
    var o = {};
    for (var i = 0; i < as.length; i++) {
      var a = as[i];
      var k = fk(a);
      o[k] = f(k, i, a);
    }
    return o;
  };

  exports.diffWithKeyAndIxE = function (o1, as, fk, f1, f2, f3) {
    var o2 = {};
    for (var i = 0; i < as.length; i++) {
      var a = as[i];
      var k = fk(a);
      if (o1.hasOwnProperty(k)) {
        o2[k] = f1(k, i, o1[k], a);
      } else {
        o2[k] = f3(k, i, a);
      }
    }
    for (var k in o1) {
      if (k in o2) {
        continue;
      }
      f2(k, o1[k]);
    }
    return o2;
  };

  exports.refEq = function (a, b) {
    return a === b;
  };

  exports.createTextNode = function (s, doc) {
    return doc.createTextNode(s);
  };

  exports.setTextContent = function (s, n) {
    n.textContent = s;
  };

  exports.createElement = function (ns, name, doc) {
    if (ns != null) {
      return doc.createElementNS(ns, name);
    } else {
      return doc.createElement(name)
    }
  };

  exports.insertChildIx = function (i, a, b) {
    var n = b.childNodes.item(i) || null;
    if (n !== a) {
      b.insertBefore(a, n);
    }
  };

  exports.removeChild = function (a, b) {
    if (b && a.parentNode === b) {
      b.removeChild(a);
    }
  };

  exports.parentNode = function (a) {
    return a.parentNode;
  };

  exports.setAttribute = function (ns, attr, val, el) {
    if (ns != null) {
      el.setAttributeNS(ns, attr, val);
    } else {
      el.setAttribute(attr, val);
    }
  };

  exports.removeAttribute = function (ns, attr, el) {
    if (ns != null) {
      el.removeAttributeNS(ns, attr);
    } else {
      el.removeAttribute(attr);
    }
  };

  exports.hasAttribute = function (ns, attr, el) {
    if (ns != null) {
      return el.hasAttributeNS(ns, attr);
    } else {
      return el.hasAttribute(attr);
    }
  };

  exports.addEventListener = function (ev, listener, el) {
    el.addEventListener(ev, listener, false);
  };

  exports.removeEventListener = function (ev, listener, el) {
    el.removeEventListener(ev, listener, false);
  };

  exports.jsUndefined = void 0;
})(PS["Halogen.VDom.Util"] = PS["Halogen.VDom.Util"] || {});
(function(exports) {
  "use strict";

  exports["new"] = function () {
    return {};
  };
})(PS["Foreign.Object.ST"] = PS["Foreign.Object.ST"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Foreign.Object.ST"] = $PS["Foreign.Object.ST"] || {};
  var exports = $PS["Foreign.Object.ST"];
  var $foreign = $PS["Foreign.Object.ST"];
  exports["new"] = $foreign["new"];
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.VDom.Util"] = $PS["Halogen.VDom.Util"] || {};
  var exports = $PS["Halogen.VDom.Util"];
  var $foreign = $PS["Halogen.VDom.Util"];
  var Foreign_Object_ST = $PS["Foreign.Object.ST"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                
  var unsafeLookup = $foreign.unsafeGetAny;
  var unsafeFreeze = Unsafe_Coerce.unsafeCoerce;
  var pokeMutMap = $foreign.unsafeSetAny;
  var newMutMap = Foreign_Object_ST["new"];
  exports["newMutMap"] = newMutMap;
  exports["pokeMutMap"] = pokeMutMap;
  exports["unsafeFreeze"] = unsafeFreeze;
  exports["unsafeLookup"] = unsafeLookup;
  exports["unsafeGetAny"] = $foreign.unsafeGetAny;
  exports["unsafeHasAny"] = $foreign.unsafeHasAny;
  exports["unsafeSetAny"] = $foreign.unsafeSetAny;
  exports["forE"] = $foreign.forE;
  exports["forEachE"] = $foreign.forEachE;
  exports["forInE"] = $foreign.forInE;
  exports["diffWithIxE"] = $foreign.diffWithIxE;
  exports["diffWithKeyAndIxE"] = $foreign.diffWithKeyAndIxE;
  exports["strMapWithIxE"] = $foreign.strMapWithIxE;
  exports["refEq"] = $foreign.refEq;
  exports["createTextNode"] = $foreign.createTextNode;
  exports["setTextContent"] = $foreign.setTextContent;
  exports["createElement"] = $foreign.createElement;
  exports["insertChildIx"] = $foreign.insertChildIx;
  exports["removeChild"] = $foreign.removeChild;
  exports["parentNode"] = $foreign.parentNode;
  exports["setAttribute"] = $foreign.setAttribute;
  exports["removeAttribute"] = $foreign.removeAttribute;
  exports["hasAttribute"] = $foreign.hasAttribute;
  exports["addEventListener"] = $foreign.addEventListener;
  exports["removeEventListener"] = $foreign.removeEventListener;
  exports["jsUndefined"] = $foreign.jsUndefined;
})(PS);
(function(exports) {
  "use strict";

  exports.eventListener = function (fn) {
    return function () {
      return function (event) {
        return fn(event)();
      };
    };
  };

  exports.addEventListener = function (type) {
    return function (listener) {
      return function (useCapture) {
        return function (target) {
          return function () {
            return target.addEventListener(type, listener, useCapture);
          };
        };
      };
    };
  };

  exports.removeEventListener = function (type) {
    return function (listener) {
      return function (useCapture) {
        return function (target) {
          return function () {
            return target.removeEventListener(type, listener, useCapture);
          };
        };
      };
    };
  };
})(PS["Web.Event.EventTarget"] = PS["Web.Event.EventTarget"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Web.Event.EventTarget"] = $PS["Web.Event.EventTarget"] || {};
  var exports = $PS["Web.Event.EventTarget"];
  var $foreign = $PS["Web.Event.EventTarget"];
  exports["eventListener"] = $foreign.eventListener;
  exports["addEventListener"] = $foreign.addEventListener;
  exports["removeEventListener"] = $foreign.removeEventListener;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.VDom.DOM.Prop"] = $PS["Halogen.VDom.DOM.Prop"] || {};
  var exports = $PS["Halogen.VDom.DOM.Prop"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Nullable = $PS["Data.Nullable"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Data_Unit = $PS["Data.Unit"];
  var Effect_Ref = $PS["Effect.Ref"];
  var Foreign = $PS["Foreign"];
  var Foreign_Object = $PS["Foreign.Object"];
  var Halogen_VDom_Machine = $PS["Halogen.VDom.Machine"];
  var Halogen_VDom_Util = $PS["Halogen.VDom.Util"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var Web_Event_EventTarget = $PS["Web.Event.EventTarget"];                
  var Created = (function () {
      function Created(value0) {
          this.value0 = value0;
      };
      Created.create = function (value0) {
          return new Created(value0);
      };
      return Created;
  })();
  var Removed = (function () {
      function Removed(value0) {
          this.value0 = value0;
      };
      Removed.create = function (value0) {
          return new Removed(value0);
      };
      return Removed;
  })();
  var Attribute = (function () {
      function Attribute(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      Attribute.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new Attribute(value0, value1, value2);
              };
          };
      };
      return Attribute;
  })();
  var Property = (function () {
      function Property(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Property.create = function (value0) {
          return function (value1) {
              return new Property(value0, value1);
          };
      };
      return Property;
  })();
  var Handler = (function () {
      function Handler(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Handler.create = function (value0) {
          return function (value1) {
              return new Handler(value0, value1);
          };
      };
      return Handler;
  })();
  var Ref = (function () {
      function Ref(value0) {
          this.value0 = value0;
      };
      Ref.create = function (value0) {
          return new Ref(value0);
      };
      return Ref;
  })();
  var unsafeGetProperty = Halogen_VDom_Util.unsafeGetAny;
  var setProperty = Halogen_VDom_Util.unsafeSetAny;
  var removeProperty = function (key, el) {
      var v = Halogen_VDom_Util.hasAttribute(Data_Nullable["null"], key, el);
      if (v) {
          return Halogen_VDom_Util.removeAttribute(Data_Nullable["null"], key, el);
      };
      var v1 = Foreign.typeOf(Halogen_VDom_Util.unsafeGetAny(key, el));
      if (v1 === "string") {
          return Halogen_VDom_Util.unsafeSetAny(key, "", el);
      };
      if (key === "rowSpan") {
          return Halogen_VDom_Util.unsafeSetAny(key, 1, el);
      };
      if (key === "colSpan") {
          return Halogen_VDom_Util.unsafeSetAny(key, 1, el);
      };
      return Halogen_VDom_Util.unsafeSetAny(key, Halogen_VDom_Util.jsUndefined, el);
  };
  var propToStrKey = function (v) {
      if (v instanceof Attribute && v.value0 instanceof Data_Maybe.Just) {
          return "attr/" + (v.value0.value0 + (":" + v.value1));
      };
      if (v instanceof Attribute) {
          return "attr/:" + v.value1;
      };
      if (v instanceof Property) {
          return "prop/" + v.value0;
      };
      if (v instanceof Handler) {
          return "handler/" + v.value0;
      };
      if (v instanceof Ref) {
          return "ref";
      };
      throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 182, column 16 - line 187, column 16): " + [ v.constructor.name ]);
  };
  var propFromString = Unsafe_Coerce.unsafeCoerce;
  var propFromNumber = Unsafe_Coerce.unsafeCoerce;
  var propFromBoolean = Unsafe_Coerce.unsafeCoerce;
  var buildProp = function (emit) {
      return function (el) {
          var removeProp = function (prevEvents) {
              return function (v, v1) {
                  if (v1 instanceof Attribute) {
                      return Halogen_VDom_Util.removeAttribute(Data_Nullable.toNullable(v1.value0), v1.value1, el);
                  };
                  if (v1 instanceof Property) {
                      return removeProperty(v1.value0, el);
                  };
                  if (v1 instanceof Handler) {
                      var handler = Halogen_VDom_Util.unsafeLookup(v1.value0, prevEvents);
                      return Halogen_VDom_Util.removeEventListener(v1.value0, Data_Tuple.fst(handler), el);
                  };
                  if (v1 instanceof Ref) {
                      return Data_Unit.unit;
                  };
                  throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 169, column 5 - line 179, column 18): " + [ v1.constructor.name ]);
              };
          };
          var mbEmit = function (v) {
              if (v instanceof Data_Maybe.Just) {
                  return emit(v.value0)();
              };
              return Data_Unit.unit;
          };
          var haltProp = function (state) {
              var v = Foreign_Object.lookup("ref")(state.props);
              if (v instanceof Data_Maybe.Just && v.value0 instanceof Ref) {
                  return mbEmit(v.value0.value0(new Removed(el)));
              };
              return Data_Unit.unit;
          };
          var diffProp = function (prevEvents, events) {
              return function (v, v1, v11, v2) {
                  if (v11 instanceof Attribute && v2 instanceof Attribute) {
                      var $57 = v11.value2 === v2.value2;
                      if ($57) {
                          return v2;
                      };
                      Halogen_VDom_Util.setAttribute(Data_Nullable.toNullable(v2.value0), v2.value1, v2.value2, el);
                      return v2;
                  };
                  if (v11 instanceof Property && v2 instanceof Property) {
                      var v4 = Halogen_VDom_Util.refEq(v11.value1, v2.value1);
                      if (v4) {
                          return v2;
                      };
                      if (v2.value0 === "value") {
                          var elVal = unsafeGetProperty("value", el);
                          var $66 = Halogen_VDom_Util.refEq(elVal, v2.value1);
                          if ($66) {
                              return v2;
                          };
                          setProperty(v2.value0, v2.value1, el);
                          return v2;
                      };
                      setProperty(v2.value0, v2.value1, el);
                      return v2;
                  };
                  if (v11 instanceof Handler && v2 instanceof Handler) {
                      var handler = Halogen_VDom_Util.unsafeLookup(v2.value0, prevEvents);
                      Effect_Ref.write(v2.value1)(Data_Tuple.snd(handler))();
                      Halogen_VDom_Util.pokeMutMap(v2.value0, handler, events);
                      return v2;
                  };
                  return v2;
              };
          };
          var applyProp = function (events) {
              return function (v, v1, v2) {
                  if (v2 instanceof Attribute) {
                      Halogen_VDom_Util.setAttribute(Data_Nullable.toNullable(v2.value0), v2.value1, v2.value2, el);
                      return v2;
                  };
                  if (v2 instanceof Property) {
                      setProperty(v2.value0, v2.value1, el);
                      return v2;
                  };
                  if (v2 instanceof Handler) {
                      var v3 = Halogen_VDom_Util.unsafeGetAny(v2.value0, events);
                      if (Halogen_VDom_Util.unsafeHasAny(v2.value0, events)) {
                          Effect_Ref.write(v2.value1)(Data_Tuple.snd(v3))();
                          return v2;
                      };
                      var ref = Effect_Ref["new"](v2.value1)();
                      var listener = Web_Event_EventTarget.eventListener(function (ev) {
                          return function __do() {
                              var f$prime = Effect_Ref.read(ref)();
                              return mbEmit(f$prime(ev));
                          };
                      })();
                      Halogen_VDom_Util.pokeMutMap(v2.value0, new Data_Tuple.Tuple(listener, ref), events);
                      Halogen_VDom_Util.addEventListener(v2.value0, listener, el);
                      return v2;
                  };
                  if (v2 instanceof Ref) {
                      mbEmit(v2.value0(new Created(el)));
                      return v2;
                  };
                  throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 113, column 5 - line 135, column 15): " + [ v2.constructor.name ]);
              };
          };
          var patchProp = function (state, ps2) {
              var events = Halogen_VDom_Util.newMutMap();
              var onThis = removeProp(state.events);
              var onThese = diffProp(state.events, events);
              var onThat = applyProp(events);
              var props = Halogen_VDom_Util.diffWithKeyAndIxE(state.props, ps2, propToStrKey, onThese, onThis, onThat);
              var nextState = {
                  events: Halogen_VDom_Util.unsafeFreeze(events),
                  props: props
              };
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(Data_Unit.unit, nextState, patchProp, haltProp));
          };
          var renderProp = function (ps1) {
              var events = Halogen_VDom_Util.newMutMap();
              var ps1$prime = Halogen_VDom_Util.strMapWithIxE(ps1, propToStrKey, applyProp(events));
              var state = {
                  events: Halogen_VDom_Util.unsafeFreeze(events),
                  props: ps1$prime
              };
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(Data_Unit.unit, state, patchProp, haltProp));
          };
          return renderProp;
      };
  };
  exports["Attribute"] = Attribute;
  exports["Property"] = Property;
  exports["Handler"] = Handler;
  exports["propFromString"] = propFromString;
  exports["propFromBoolean"] = propFromBoolean;
  exports["propFromNumber"] = propFromNumber;
  exports["buildProp"] = buildProp;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Bifunctor"] = $PS["Data.Bifunctor"] || {};
  var exports = $PS["Data.Bifunctor"];               
  var bimap = function (dict) {
      return dict.bimap;
  };
  exports["bimap"] = bimap;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.VDom.Types"] = $PS["Halogen.VDom.Types"] || {};
  var exports = $PS["Halogen.VDom.Types"];
  var Data_Bifunctor = $PS["Data.Bifunctor"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var Text = (function () {
      function Text(value0) {
          this.value0 = value0;
      };
      Text.create = function (value0) {
          return new Text(value0);
      };
      return Text;
  })();
  var Elem = (function () {
      function Elem(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      Elem.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new Elem(value0, value1, value2, value3);
                  };
              };
          };
      };
      return Elem;
  })();
  var Keyed = (function () {
      function Keyed(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      Keyed.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new Keyed(value0, value1, value2, value3);
                  };
              };
          };
      };
      return Keyed;
  })();
  var Widget = (function () {
      function Widget(value0) {
          this.value0 = value0;
      };
      Widget.create = function (value0) {
          return new Widget(value0);
      };
      return Widget;
  })();
  var Grafted = (function () {
      function Grafted(value0) {
          this.value0 = value0;
      };
      Grafted.create = function (value0) {
          return new Grafted(value0);
      };
      return Grafted;
  })();
  var Graft = (function () {
      function Graft(value0, value1, value2) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
      };
      Graft.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return new Graft(value0, value1, value2);
              };
          };
      };
      return Graft;
  })();
  var unGraft = function (f) {
      return function ($55) {
          return f($55);
      };
  };
  var graft = Unsafe_Coerce.unsafeCoerce;
  var bifunctorGraft = {
      bimap: function (f) {
          return function (g) {
              return unGraft(function (v) {
                  return graft(new Graft(function ($57) {
                      return f(v.value0($57));
                  }, function ($58) {
                      return g(v.value1($58));
                  }, v.value2));
              });
          };
      }
  };
  var runGraft = unGraft(function (v) {
      var go = function (v2) {
          if (v2 instanceof Text) {
              return new Text(v2.value0);
          };
          if (v2 instanceof Elem) {
              return new Elem(v2.value0, v2.value1, v.value0(v2.value2), Data_Functor.map(Data_Functor.functorArray)(go)(v2.value3));
          };
          if (v2 instanceof Keyed) {
              return new Keyed(v2.value0, v2.value1, v.value0(v2.value2), Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Data_Tuple.functorTuple)(go))(v2.value3));
          };
          if (v2 instanceof Widget) {
              return new Widget(v.value1(v2.value0));
          };
          if (v2 instanceof Grafted) {
              return new Grafted(Data_Bifunctor.bimap(bifunctorGraft)(v.value0)(v.value1)(v2.value0));
          };
          throw new Error("Failed pattern match at Halogen.VDom.Types (line 86, column 7 - line 86, column 27): " + [ v2.constructor.name ]);
      };
      return go(v.value2);
  });
  exports["Text"] = Text;
  exports["Elem"] = Elem;
  exports["Keyed"] = Keyed;
  exports["Widget"] = Widget;
  exports["Grafted"] = Grafted;
  exports["runGraft"] = runGraft;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.HTML.Core"] = $PS["Halogen.HTML.Core"] || {};
  var exports = $PS["Halogen.HTML.Core"];
  var DOM_HTML_Indexed_InputType = $PS["DOM.HTML.Indexed.InputType"];
  var Halogen_VDom_DOM_Prop = $PS["Halogen.VDom.DOM.Prop"];
  var Halogen_VDom_Types = $PS["Halogen.VDom.Types"];          
  var HTML = function (x) {
      return x;
  };
  var widget = function ($19) {
      return HTML(Halogen_VDom_Types.Widget.create($19));
  };
  var toPropValue = function (dict) {
      return dict.toPropValue;
  };
  var text = function ($20) {
      return HTML(Halogen_VDom_Types.Text.create($20));
  };
  var prop = function (dictIsProp) {
      return function (v) {
          var $22 = Halogen_VDom_DOM_Prop.Property.create(v);
          var $23 = toPropValue(dictIsProp);
          return function ($24) {
              return $22($23($24));
          };
      };
  };
  var isPropString = {
      toPropValue: Halogen_VDom_DOM_Prop.propFromString
  };
  var isPropNumber = {
      toPropValue: Halogen_VDom_DOM_Prop.propFromNumber
  };
  var isPropInputType = {
      toPropValue: function ($38) {
          return Halogen_VDom_DOM_Prop.propFromString(DOM_HTML_Indexed_InputType.renderInputType($38));
      }
  };
  var isPropBoolean = {
      toPropValue: Halogen_VDom_DOM_Prop.propFromBoolean
  };
  var handler = Halogen_VDom_DOM_Prop.Handler.create;
  var element = function (ns) {
      return function (name) {
          return function (props) {
              return function (children) {
                  return new Halogen_VDom_Types.Elem(ns, name, props, children);
              };
          };
      };
  };
  var attr = function (ns) {
      return function (v) {
          return Halogen_VDom_DOM_Prop.Attribute.create(ns)(v);
      };
  };
  exports["widget"] = widget;
  exports["text"] = text;
  exports["element"] = element;
  exports["prop"] = prop;
  exports["attr"] = attr;
  exports["handler"] = handler;
  exports["isPropString"] = isPropString;
  exports["isPropNumber"] = isPropNumber;
  exports["isPropBoolean"] = isPropBoolean;
  exports["isPropInputType"] = isPropInputType;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.HTML"] = $PS["Halogen.HTML"] || {};
  var exports = $PS["Halogen.HTML"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var slot = function () {
      return function (dictIsSymbol) {
          return function (dictOrd) {
              return function (label) {
                  return function (p) {
                      return function (component) {
                          return function (input) {
                              return function (outputQuery) {
                                  return Halogen_HTML_Core.widget(new Halogen_Component.ComponentSlot(Halogen_Component.componentSlot()(dictIsSymbol)(dictOrd)(label)(p)(component)(input)(function ($4) {
                                      return Data_Maybe.Just.create(outputQuery($4));
                                  })));
                              };
                          };
                      };
                  };
              };
          };
      };
  };
  exports["slot"] = slot;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.HTML.Elements"] = $PS["Halogen.HTML.Elements"] || {};
  var exports = $PS["Halogen.HTML.Elements"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var element = Halogen_HTML_Core.element(Data_Maybe.Nothing.value);
  var h2 = element("h2");
  var h2_ = h2([  ]);
  var h3 = element("h3");
  var h3_ = h3([  ]);
  var input = function (props) {
      return element("input")(props)([  ]);
  };                   
  var label = element("label");
  var li = element("li");
  var li_ = li([  ]);            
  var option = element("option");
  var p = element("p");
  var p_ = p([  ]);            
  var select = element("select");
  var ul = element("ul");
  var ul_ = ul([  ]);
  var div = element("div");
  var div_ = div([  ]);
  var button = element("button");
  exports["button"] = button;
  exports["div"] = div;
  exports["div_"] = div_;
  exports["h2_"] = h2_;
  exports["h3_"] = h3_;
  exports["input"] = input;
  exports["label"] = label;
  exports["li_"] = li_;
  exports["option"] = option;
  exports["p_"] = p_;
  exports["select"] = select;
  exports["ul_"] = ul_;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.Query"] = $PS["Halogen.Query"] || {};
  var exports = $PS["Halogen.Query"];
  var Control_Category = $PS["Control.Category"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var requestAll = function () {
      return function (dictIsSymbol) {
          return function (dictOrd) {
              return function (label) {
                  return function (req) {
                      return Halogen_Query_HalogenM.queryAll()(dictIsSymbol)(dictOrd)(label)(req(Control_Category.identity(Control_Category.categoryFn)));
                  };
              };
          };
      };
  };
  exports["requestAll"] = requestAll;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Monad.Except"] = $PS["Control.Monad.Except"] || {};
  var exports = $PS["Control.Monad.Except"];
  var Control_Monad_Except_Trans = $PS["Control.Monad.Except.Trans"];
  var Data_Newtype = $PS["Data.Newtype"];                                                
  var runExcept = (function () {
      var $0 = Data_Newtype.unwrap();
      return function ($1) {
          return $0(Control_Monad_Except_Trans.runExceptT($1));
      };
  })();
  exports["runExcept"] = runExcept;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.Identity"] = $PS["Data.Identity"] || {};
  var exports = $PS["Data.Identity"];              
  var Identity = function (x) {
      return x;
  };
  var functorIdentity = {
      map: function (f) {
          return function (m) {
              return f(m);
          };
      }
  };
  var applyIdentity = {
      apply: function (v) {
          return function (v1) {
              return v(v1);
          };
      },
      Functor0: function () {
          return functorIdentity;
      }
  };
  var bindIdentity = {
      bind: function (v) {
          return function (f) {
              return f(v);
          };
      },
      Apply0: function () {
          return applyIdentity;
      }
  };
  var applicativeIdentity = {
      pure: Identity,
      Apply0: function () {
          return applyIdentity;
      }
  };
  var monadIdentity = {
      Applicative0: function () {
          return applicativeIdentity;
      },
      Bind1: function () {
          return bindIdentity;
      }
  };
  exports["monadIdentity"] = monadIdentity;
})(PS);
(function(exports) {
  "use strict";

  exports.unsafeReadPropImpl = function (f, s, key, value) {
    return value == null ? f : s(value[key]);
  };
})(PS["Foreign.Index"] = PS["Foreign.Index"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Foreign.Index"] = $PS["Foreign.Index"] || {};
  var exports = $PS["Foreign.Index"];
  var $foreign = $PS["Foreign.Index"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Monad_Except_Trans = $PS["Control.Monad.Except.Trans"];
  var Foreign = $PS["Foreign"];                
  var unsafeReadProp = function (dictMonad) {
      return function (k) {
          return function (value) {
              return $foreign.unsafeReadPropImpl(Foreign.fail(dictMonad)(new Foreign.TypeMismatch("object", Foreign.typeOf(value))), Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(dictMonad)), k, value);
          };
      };
  };
  var readProp = function (dictMonad) {
      return unsafeReadProp(dictMonad);
  };
  exports["readProp"] = readProp;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.Query.Input"] = $PS["Halogen.Query.Input"] || {};
  var exports = $PS["Halogen.Query.Input"];
  var RefUpdate = (function () {
      function RefUpdate(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      RefUpdate.create = function (value0) {
          return function (value1) {
              return new RefUpdate(value0, value1);
          };
      };
      return RefUpdate;
  })();
  var Action = (function () {
      function Action(value0) {
          this.value0 = value0;
      };
      Action.create = function (value0) {
          return new Action(value0);
      };
      return Action;
  })();
  exports["RefUpdate"] = RefUpdate;
  exports["Action"] = Action;
})(PS);
(function(exports) {
  "use strict";

  exports._currentTarget = function (e) {
    return e.currentTarget;
  };
})(PS["Web.Event.Event"] = PS["Web.Event.Event"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Web.Event.Event"] = $PS["Web.Event.Event"] || {};
  var exports = $PS["Web.Event.Event"];
  var $foreign = $PS["Web.Event.Event"];
  var Data_Nullable = $PS["Data.Nullable"];
  var currentTarget = function ($4) {
      return Data_Nullable.toMaybe($foreign["_currentTarget"]($4));
  };
  exports["currentTarget"] = currentTarget;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Web.HTML.Event.EventTypes"] = $PS["Web.HTML.Event.EventTypes"] || {};
  var exports = $PS["Web.HTML.Event.EventTypes"];
  var input = "input";
  var domcontentloaded = "DOMContentLoaded";
  var change = "change";
  exports["change"] = change;
  exports["domcontentloaded"] = domcontentloaded;
  exports["input"] = input;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Web.UIEvent.MouseEvent.EventTypes"] = $PS["Web.UIEvent.MouseEvent.EventTypes"] || {};
  var exports = $PS["Web.UIEvent.MouseEvent.EventTypes"];
  var click = "click";
  exports["click"] = click;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.HTML.Events"] = $PS["Halogen.HTML.Events"] || {};
  var exports = $PS["Halogen.HTML.Events"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_Except = $PS["Control.Monad.Except"];
  var Control_Monad_Except_Trans = $PS["Control.Monad.Except.Trans"];
  var Data_Either = $PS["Data.Either"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Identity = $PS["Data.Identity"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Foreign = $PS["Foreign"];
  var Foreign_Index = $PS["Foreign.Index"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_Query_Input = $PS["Halogen.Query.Input"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var Web_Event_Event = $PS["Web.Event.Event"];
  var Web_HTML_Event_EventTypes = $PS["Web.HTML.Event.EventTypes"];
  var Web_UIEvent_MouseEvent_EventTypes = $PS["Web.UIEvent.MouseEvent.EventTypes"];
  var mouseHandler = Unsafe_Coerce.unsafeCoerce;
  var handler$prime = function (et) {
      return function (f) {
          return Halogen_HTML_Core.handler(et)(function (ev) {
              return Data_Functor.map(Data_Maybe.functorMaybe)(Halogen_Query_Input.Action.create)(f(ev));
          });
      };
  };
  var handler = function (et) {
      return function (f) {
          return Halogen_HTML_Core.handler(et)(function (ev) {
              return new Data_Maybe.Just(new Halogen_Query_Input.Action(f(ev)));
          });
      };
  };                                                       
  var onClick = (function () {
      var $1 = handler(Web_UIEvent_MouseEvent_EventTypes.click);
      return function ($2) {
          return $1(mouseHandler($2));
      };
  })();
  var addForeignPropHandler = function (key) {
      return function (prop) {
          return function (reader) {
              return function (f) {
                  var go = function (a) {
                      return Control_Bind.composeKleisliFlipped(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(reader)(Foreign_Index.readProp(Data_Identity.monadIdentity)(prop))(Foreign.unsafeToForeign(a));
                  };
                  return handler$prime(key)(Control_Bind.composeKleisli(Data_Maybe.bindMaybe)(Web_Event_Event.currentTarget)(function (e) {
                      return Data_Either.either(Data_Function["const"](Data_Maybe.Nothing.value))(function ($71) {
                          return Data_Maybe.Just.create(f($71));
                      })(Control_Monad_Except.runExcept(go(e)));
                  }));
              };
          };
      };
  };
  var onChecked = addForeignPropHandler(Web_HTML_Event_EventTypes.change)("checked")(Foreign.readBoolean(Data_Identity.monadIdentity));              
  var onValueChange = addForeignPropHandler(Web_HTML_Event_EventTypes.change)("value")(Foreign.readString(Data_Identity.monadIdentity));
  var onValueInput = addForeignPropHandler(Web_HTML_Event_EventTypes.input)("value")(Foreign.readString(Data_Identity.monadIdentity));
  exports["onClick"] = onClick;
  exports["onValueChange"] = onValueChange;
  exports["onValueInput"] = onValueInput;
  exports["onChecked"] = onChecked;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.HTML.Properties"] = $PS["Halogen.HTML.Properties"] || {};
  var exports = $PS["Halogen.HTML.Properties"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var prop = function (dictIsProp) {
      return Halogen_HTML_Core.prop(dictIsProp);
  };                                                          
  var title = prop(Halogen_HTML_Core.isPropString)("title");
  var type_ = function (dictIsProp) {
      return prop(dictIsProp)("type");
  };
  var value = prop(Halogen_HTML_Core.isPropString)("value");
  var name = prop(Halogen_HTML_Core.isPropString)("name");         
  var min = prop(Halogen_HTML_Core.isPropNumber)("min");   
  var id = prop(Halogen_HTML_Core.isPropString)("id");
  var $$for = prop(Halogen_HTML_Core.isPropString)("htmlFor");
  var checked = prop(Halogen_HTML_Core.isPropBoolean)("checked");
  var attr = Halogen_HTML_Core.attr(Data_Maybe.Nothing.value);
  var style = attr("style");
  exports["for"] = $$for;
  exports["id"] = id;
  exports["name"] = name;
  exports["style"] = style;
  exports["title"] = title;
  exports["type_"] = type_;
  exports["value"] = value;
  exports["min"] = min;
  exports["checked"] = checked;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Trainable"] = $PS["Trainable"] || {};
  var exports = $PS["Trainable"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Category = $PS["Control.Category"];
  var Control_Monad_State_Class = $PS["Control.Monad.State.Class"];
  var Data_Array = $PS["Data.Array"];
  var Data_BigInt = $PS["Data.BigInt"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_EuclideanRing = $PS["Data.EuclideanRing"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Int = $PS["Data.Int"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Show = $PS["Data.Show"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Events = $PS["Halogen.HTML.Events"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];                
  var HandleSpellInput = (function () {
      function HandleSpellInput(value0) {
          this.value0 = value0;
      };
      HandleSpellInput.create = function (value0) {
          return new HandleSpellInput(value0);
      };
      return HandleSpellInput;
  })();
  var SetSpell = (function () {
      function SetSpell(value0) {
          this.value0 = value0;
      };
      SetSpell.create = function (value0) {
          return new SetSpell(value0);
      };
      return SetSpell;
  })();
  var SetSpellMin = (function () {
      function SetSpellMin() {

      };
      SetSpellMin.value = new SetSpellMin();
      return SetSpellMin;
  })();
  var SetSpell100 = (function () {
      function SetSpell100() {

      };
      SetSpell100.value = new SetSpell100();
      return SetSpell100;
  })();
  var SetSpellMax = (function () {
      function SetSpellMax() {

      };
      SetSpellMax.value = new SetSpellMax();
      return SetSpellMax;
  })();
  var Changed = (function () {
      function Changed() {

      };
      Changed.value = new Changed();
      return Changed;
  })();
  var SpellChanged = (function () {
      function SpellChanged() {

      };
      SpellChanged.value = new SpellChanged();
      return SpellChanged;
  })();
  var GetSkillExps = (function () {
      function GetSkillExps(value0) {
          this.value0 = value0;
      };
      GetSkillExps.create = function (value0) {
          return new GetSkillExps(value0);
      };
      return GetSkillExps;
  })();
  var HandleInput = (function () {
      function HandleInput(value0) {
          this.value0 = value0;
      };
      HandleInput.create = function (value0) {
          return new HandleInput(value0);
      };
      return HandleInput;
  })();
  var SetSkill = (function () {
      function SetSkill(value0) {
          this.value0 = value0;
      };
      SetSkill.create = function (value0) {
          return new SetSkill(value0);
      };
      return SetSkill;
  })();
  var SetMin = (function () {
      function SetMin() {

      };
      SetMin.value = new SetMin();
      return SetMin;
  })();
  var Set100 = (function () {
      function Set100() {

      };
      Set100.value = new Set100();
      return Set100;
  })();
  var SetMax = (function () {
      function SetMax() {

      };
      SetMax.value = new SetMax();
      return SetMax;
  })();
  var spellRender = function (state) {
      return Halogen_HTML_Elements.li_([ Halogen_HTML_Elements.label([  ])([ Halogen_HTML_Core.text(state.name + ": ") ]), Halogen_HTML_Elements.select([ Halogen_HTML_Properties.value(Data_Show.show(Data_Show.showInt)(state.value)), Halogen_HTML_Events.onValueChange(function (str) {
          return new SetSpell(str);
      }) ])(Data_Array.mapWithIndex(function (i) {
          return function (txt) {
              return Halogen_HTML_Elements.option([ Halogen_HTML_Properties.value(Data_Show.show(Data_Show.showInt)(i)) ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(txt)) ]);
          };
      })(Data_Functor.map(Data_Functor.functorArray)(function (x) {
          return x * 5 | 0;
      })(Data_Array.range(1)(Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(state.spellMax + state.spellWishes | 0)(5))))), Halogen_HTML_Elements.button([ Halogen_HTML_Properties.title("min"), Halogen_HTML_Properties.style("margin-left: 5px"), Halogen_HTML_Events.onClick(function (v) {
          return SetSpellMin.value;
      }) ])([ Halogen_HTML_Core.text("min") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Properties.title("100"), Halogen_HTML_Properties.style("margin-left: 5px"), Halogen_HTML_Events.onClick(function (v) {
          return SetSpell100.value;
      }) ])([ Halogen_HTML_Core.text("100") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Properties.title("max"), Halogen_HTML_Properties.style("margin-left: 5px"), Halogen_HTML_Events.onClick(function (v) {
          return SetSpellMax.value;
      }) ])([ Halogen_HTML_Core.text("max") ]) ]);
  };
  var render = function (state) {
      return Halogen_HTML_Elements.li_([ Halogen_HTML_Elements.label([  ])([ Halogen_HTML_Core.text(state.name + ": ") ]), Halogen_HTML_Elements.select([ Halogen_HTML_Properties.value(Data_Show.show(Data_Show.showInt)(state.value)), Halogen_HTML_Events.onValueChange(function (str) {
          return new SetSkill(str);
      }) ])(Data_Array.mapWithIndex(function (i) {
          return function (txt) {
              return Halogen_HTML_Elements.option([ Halogen_HTML_Properties.value(Data_Show.show(Data_Show.showInt)(i)) ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(txt)) ]);
          };
      })(Data_Functor.map(Data_Functor.functorArray)(function (x) {
          return x * 5 | 0;
      })(Data_Array.range(1)(Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(state.skillMax + state.skillWishes | 0)(5))))), Halogen_HTML_Elements.button([ Halogen_HTML_Properties.title("min"), Halogen_HTML_Properties.style("margin-left: 5px"), Halogen_HTML_Events.onClick(function (v) {
          return SetMin.value;
      }) ])([ Halogen_HTML_Core.text("min") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Properties.title("100"), Halogen_HTML_Properties.style("margin-left: 5px"), Halogen_HTML_Events.onClick(function (v) {
          return Set100.value;
      }) ])([ Halogen_HTML_Core.text("100") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Properties.title("max"), Halogen_HTML_Properties.style("margin-left: 5px"), Halogen_HTML_Events.onClick(function (v) {
          return SetMax.value;
      }) ])([ Halogen_HTML_Core.text("max") ]) ]);
  };
  var handleSpellAction = function (v) {
      if (v instanceof HandleSpellInput) {
          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (oldN) {
              return Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Eq.notEq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
                  reflectSymbol: function () {
                      return "value";
                  }
              })(Data_Eq.eqInt))()({
                  reflectSymbol: function () {
                      return "spellWishes";
                  }
              })(Data_Eq.eqInt))()({
                  reflectSymbol: function () {
                      return "spellMax";
                  }
              })(Data_Eq.eqInt))()({
                  reflectSymbol: function () {
                      return "name";
                  }
              })(Data_Eq.eqString))()({
                  reflectSymbol: function () {
                      return "baseCost";
                  }
              })(Data_Eq.eqInt)))(oldN)(v.value0))(Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)(v.value0));
          });
      };
      if (v instanceof SetSpell) {
          var v1 = Data_Int.fromString(v.value0);
          if (v1 instanceof Data_Maybe.Nothing) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                  var $30 = {};
                  for (var $31 in v2) {
                      if ({}.hasOwnProperty.call(v2, $31)) {
                          $30[$31] = v2[$31];
                      };
                  };
                  $30.value = 0;
                  return $30;
              });
          };
          if (v1 instanceof Data_Maybe.Just) {
              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                  var $33 = {};
                  for (var $34 in v2) {
                      if ({}.hasOwnProperty.call(v2, $34)) {
                          $33[$34] = v2[$34];
                      };
                  };
                  $33.value = v1.value0;
                  return $33;
              }))(function () {
                  return Halogen_Query_HalogenM.raise(SpellChanged.value);
              });
          };
          throw new Error("Failed pattern match at Trainable (line 161, column 19 - line 165, column 27): " + [ v1.constructor.name ]);
      };
      if (v instanceof SetSpellMin) {
          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
              var $38 = {};
              for (var $39 in st) {
                  if ({}.hasOwnProperty.call(st, $39)) {
                      $38[$39] = st[$39];
                  };
              };
              $38.value = 0;
              return $38;
          }))(function () {
              return Halogen_Query_HalogenM.raise(SpellChanged.value);
          });
      };
      if (v instanceof SetSpell100) {
          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
              var max = Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(st.spellMax + st.spellWishes | 0)(5) - 1 | 0;
              var $42 = {};
              for (var $43 in st) {
                  if ({}.hasOwnProperty.call(st, $43)) {
                      $42[$43] = st[$43];
                  };
              };
              $42.value = (function () {
                  var $41 = 19 < max;
                  if ($41) {
                      return 19;
                  };
                  return max;
              })();
              return $42;
          }))(function () {
              return Halogen_Query_HalogenM.raise(SpellChanged.value);
          });
      };
      if (v instanceof SetSpellMax) {
          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
              var $45 = {};
              for (var $46 in st) {
                  if ({}.hasOwnProperty.call(st, $46)) {
                      $45[$46] = st[$46];
                  };
              };
              $45.value = Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(st.spellMax + st.spellWishes | 0)(5) - 1 | 0;
              return $45;
          }))(function () {
              return Halogen_Query_HalogenM.raise(SpellChanged.value);
          });
      };
      throw new Error("Failed pattern match at Trainable (line 157, column 21 - line 177, column 25): " + [ v.constructor.name ]);
  };
  var handleAction = function (v) {
      if (v instanceof HandleInput) {
          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (oldN) {
              return Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Eq.notEq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
                  reflectSymbol: function () {
                      return "value";
                  }
              })(Data_Eq.eqInt))()({
                  reflectSymbol: function () {
                      return "skillWishes";
                  }
              })(Data_Eq.eqInt))()({
                  reflectSymbol: function () {
                      return "skillMax";
                  }
              })(Data_Eq.eqInt))()({
                  reflectSymbol: function () {
                      return "name";
                  }
              })(Data_Eq.eqString))()({
                  reflectSymbol: function () {
                      return "baseCost";
                  }
              })(Data_Eq.eqInt)))(oldN)(v.value0))(Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)(v.value0));
          });
      };
      if (v instanceof SetSkill) {
          var v1 = Data_Int.fromString(v.value0);
          if (v1 instanceof Data_Maybe.Nothing) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                  var $51 = {};
                  for (var $52 in v2) {
                      if ({}.hasOwnProperty.call(v2, $52)) {
                          $51[$52] = v2[$52];
                      };
                  };
                  $51.value = 0;
                  return $51;
              });
          };
          if (v1 instanceof Data_Maybe.Just) {
              return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                  var $54 = {};
                  for (var $55 in v2) {
                      if ({}.hasOwnProperty.call(v2, $55)) {
                          $54[$55] = v2[$55];
                      };
                  };
                  $54.value = v1.value0;
                  return $54;
              }))(function () {
                  return Halogen_Query_HalogenM.raise(Changed.value);
              });
          };
          throw new Error("Failed pattern match at Trainable (line 83, column 19 - line 87, column 22): " + [ v1.constructor.name ]);
      };
      if (v instanceof SetMin) {
          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
              var $59 = {};
              for (var $60 in st) {
                  if ({}.hasOwnProperty.call(st, $60)) {
                      $59[$60] = st[$60];
                  };
              };
              $59.value = 0;
              return $59;
          }))(function () {
              return Halogen_Query_HalogenM.raise(Changed.value);
          });
      };
      if (v instanceof Set100) {
          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
              var max = Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(st.skillMax + st.skillWishes | 0)(5) - 1 | 0;
              var $63 = {};
              for (var $64 in st) {
                  if ({}.hasOwnProperty.call(st, $64)) {
                      $63[$64] = st[$64];
                  };
              };
              $63.value = (function () {
                  var $62 = 19 < max;
                  if ($62) {
                      return 19;
                  };
                  return max;
              })();
              return $63;
          }))(function () {
              return Halogen_Query_HalogenM.raise(Changed.value);
          });
      };
      if (v instanceof SetMax) {
          return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
              var $66 = {};
              for (var $67 in st) {
                  if ({}.hasOwnProperty.call(st, $67)) {
                      $66[$67] = st[$67];
                  };
              };
              $66.value = Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(st.skillMax + st.skillWishes | 0)(5) - 1 | 0;
              return $66;
          }))(function () {
              return Halogen_Query_HalogenM.raise(Changed.value);
          });
      };
      throw new Error("Failed pattern match at Trainable (line 79, column 16 - line 99, column 20): " + [ v.constructor.name ]);
  };
  var costMultipliers = [ 0, 1, 3, 7, 14, 27, 51, 93, 163, 277, 457, 734, 1150, 1760, 2637, 3874, 5590, 7934, 11091, 15289, 20804, 27970, 37188, 46406 ];
  var getMultiplier = function (i) {
      var v = Data_Array.index(costMultipliers)(i);
      if (v instanceof Data_Maybe.Just) {
          return v.value0;
      };
      if (v instanceof Data_Maybe.Nothing) {
          return 0;
      };
      throw new Error("Failed pattern match at Trainable (line 16, column 19 - line 18, column 15): " + [ v.constructor.name ]);
  };
  var handleQuery = function (v) {
      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
          return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0(Data_BigInt.fromInt(v1.baseCost * getMultiplier(v1.value) | 0))));
      });
  };
  var skill = Halogen_Component.mkComponent({
      initialState: Control_Category.identity(Control_Category.categoryFn),
      render: render,
      "eval": Halogen_Component.mkEval({
          handleAction: handleAction,
          handleQuery: handleQuery,
          receive: function ($81) {
              return Data_Maybe.Just.create(HandleInput.create($81));
          },
          initialize: Halogen_Component.defaultEval.initialize,
          finalize: Halogen_Component.defaultEval.finalize
      })
  });
  var handleSpellQuery = function (v) {
      return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
          return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0(Data_BigInt.fromInt(v1.baseCost * getMultiplier(v1.value) | 0))));
      });
  };
  var spell = Halogen_Component.mkComponent({
      initialState: Control_Category.identity(Control_Category.categoryFn),
      render: spellRender,
      "eval": Halogen_Component.mkEval({
          handleAction: handleSpellAction,
          handleQuery: handleSpellQuery,
          receive: function ($82) {
              return Data_Maybe.Just.create(HandleSpellInput.create($82));
          },
          initialize: Halogen_Component.defaultEval.initialize,
          finalize: Halogen_Component.defaultEval.finalize
      })
  });
  exports["GetSkillExps"] = GetSkillExps;
  exports["Changed"] = Changed;
  exports["SpellChanged"] = SpellChanged;
  exports["skill"] = skill;
  exports["spell"] = spell;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["GuildComponent"] = $PS["GuildComponent"] || {};
  var exports = $PS["GuildComponent"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Category = $PS["Control.Category"];
  var Control_Monad_State_Class = $PS["Control.Monad.State.Class"];
  var Data_Array = $PS["Data.Array"];
  var Data_Eq = $PS["Data.Eq"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Show = $PS["Data.Show"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_HTML = $PS["Halogen.HTML"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_Query = $PS["Halogen.Query"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var Trainable = $PS["Trainable"];
  var Type_Proxy = $PS["Type.Proxy"];                
  var GetSkillExp = (function () {
      function GetSkillExp(value0) {
          this.value0 = value0;
      };
      GetSkillExp.create = function (value0) {
          return new GetSkillExp(value0);
      };
      return GetSkillExp;
  })();
  var GetSpellExp = (function () {
      function GetSpellExp(value0) {
          this.value0 = value0;
      };
      GetSpellExp.create = function (value0) {
          return new GetSpellExp(value0);
      };
      return GetSpellExp;
  })();
  var HandleInput = (function () {
      function HandleInput(value0) {
          this.value0 = value0;
      };
      HandleInput.create = function (value0) {
          return new HandleInput(value0);
      };
      return HandleInput;
  })();
  var HandleNotification = (function () {
      function HandleNotification(value0) {
          this.value0 = value0;
      };
      HandleNotification.create = function (value0) {
          return new HandleNotification(value0);
      };
      return HandleNotification;
  })();
  var handleAction = function (v) {
      if (v instanceof HandleInput) {
          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (oldN) {
              return Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Eq.notEq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
                  reflectSymbol: function () {
                      return "spellWishes";
                  }
              })(Data_Eq.eqInt))()({
                  reflectSymbol: function () {
                      return "spellMax";
                  }
              })(Data_Eq.eqInt))()({
                  reflectSymbol: function () {
                      return "skillWishes";
                  }
              })(Data_Eq.eqInt))()({
                  reflectSymbol: function () {
                      return "skillMax";
                  }
              })(Data_Eq.eqInt))()({
                  reflectSymbol: function () {
                      return "guild";
                  }
              })(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
                  reflectSymbol: function () {
                      return "spells";
                  }
              })(Data_Eq.eqArray(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
                  reflectSymbol: function () {
                      return "name";
                  }
              })(Data_Eq.eqString))()({
                  reflectSymbol: function () {
                      return "baseCost";
                  }
              })(Data_Eq.eqInt)))))()({
                  reflectSymbol: function () {
                      return "skills";
                  }
              })(Data_Eq.eqArray(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
                  reflectSymbol: function () {
                      return "name";
                  }
              })(Data_Eq.eqString))()({
                  reflectSymbol: function () {
                      return "baseCost";
                  }
              })(Data_Eq.eqInt)))))()({
                  reflectSymbol: function () {
                      return "name";
                  }
              })(Data_Eq.eqString)))))(oldN)(v.value0))(Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)(v.value0));
          });
      };
      if (v instanceof HandleNotification) {
          if (v.value0 instanceof Trainable.Changed) {
              return Halogen_Query_HalogenM.raise(Trainable.Changed.value);
          };
          if (v.value0 instanceof Trainable.SpellChanged) {
              return Halogen_Query_HalogenM.raise(Trainable.SpellChanged.value);
          };
          throw new Error("Failed pattern match at GuildComponent (line 73, column 5 - line 75, column 63): " + [ v.value0.constructor.name ]);
      };
      throw new Error("Failed pattern match at GuildComponent (line 68, column 16 - line 75, column 63): " + [ v.constructor.name ]);
  };
  var _spell = Type_Proxy["Proxy"].value;
  var _skill = Type_Proxy["Proxy"].value;
  var handleQuery = function (v) {
      if (v instanceof GetSkillExp) {
          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query.requestAll()({
              reflectSymbol: function () {
                  return "skill";
              }
          })(Data_Ord.ordString)(_skill)(Trainable.GetSkillExps.create))(function (exps) {
              return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0(exps)));
          });
      };
      if (v instanceof GetSpellExp) {
          return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query.requestAll()({
              reflectSymbol: function () {
                  return "spell";
              }
          })(Data_Ord.ordString)(_spell)(Trainable.GetSkillExps.create))(function (exps) {
              return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0(exps)));
          });
      };
      throw new Error("Failed pattern match at GuildComponent (line 78, column 16 - line 84, column 29): " + [ v.constructor.name ]);
  };
  var render = function (state) {
      return Halogen_HTML_Elements.div_([ Halogen_HTML_Elements.h2_([ Halogen_HTML_Core.text(state.guild.name) ]), (function () {
          var $13 = Data_Array["null"](state.guild.skills);
          if ($13) {
              return Halogen_HTML_Core.text("");
          };
          return Halogen_HTML_Elements.h3_([ Halogen_HTML_Core.text("Skills") ]);
      })(), Halogen_HTML_Elements.ul_(Data_Array.mapWithIndex(function (i) {
          return function (s) {
              return Halogen_HTML.slot()({
                  reflectSymbol: function () {
                      return "skill";
                  }
              })(Data_Ord.ordString)(_skill)(s.name + Data_Show.show(Data_Show.showInt)(i))(Trainable.skill)({
                  name: s.name,
                  baseCost: s.baseCost,
                  value: 0,
                  skillMax: state.skillMax,
                  skillWishes: state.skillWishes
              })(HandleNotification.create);
          };
      })(state.guild.skills)), (function () {
          var $14 = Data_Array["null"](state.guild.spells);
          if ($14) {
              return Halogen_HTML_Core.text("");
          };
          return Halogen_HTML_Elements.h3_([ Halogen_HTML_Core.text("Spells") ]);
      })(), Halogen_HTML_Elements.ul_(Data_Array.mapWithIndex(function (i) {
          return function (s) {
              return Halogen_HTML.slot()({
                  reflectSymbol: function () {
                      return "spell";
                  }
              })(Data_Ord.ordString)(_spell)(s.name + ("_" + Data_Show.show(Data_Show.showInt)(i)))(Trainable.spell)({
                  name: s.name,
                  baseCost: s.baseCost,
                  value: 0,
                  spellMax: state.spellMax,
                  spellWishes: state.spellWishes
              })(HandleNotification.create);
          };
      })(state.guild.spells)) ]);
  };
  var guildComponent = Halogen_Component.mkComponent({
      initialState: Control_Category.identity(Control_Category.categoryFn),
      render: render,
      "eval": Halogen_Component.mkEval({
          handleAction: handleAction,
          handleQuery: handleQuery,
          receive: function ($15) {
              return Data_Maybe.Just.create(HandleInput.create($15));
          },
          initialize: Halogen_Component.defaultEval.initialize,
          finalize: Halogen_Component.defaultEval.finalize
      })
  });
  exports["GetSkillExp"] = GetSkillExp;
  exports["GetSpellExp"] = GetSpellExp;
  exports["guildComponent"] = guildComponent;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Common.Skills"] = $PS["Common.Skills"] || {};
  var exports = $PS["Common.Skills"];
  var willpower = {
      name: "willpower",
      baseCost: 1598
  };
  var whirlwind_attack = {
      name: "whirlwind attack",
      baseCost: 940
  };
  var weaponmaster = {
      name: "weaponmaster",
      baseCost: 1176
  };
  var weapon_skill_slashing = {
      name: "weapon skill slashing",
      baseCost: 504
  };
  var weapon_skill_shield = {
      name: "weapon skill shield",
      baseCost: 940
  };
  var weapon_skill_piercing = {
      name: "weapon skill piercing",
      baseCost: 504
  };
  var weapon_skill_blunt = {
      name: "weapon skill blunt",
      baseCost: 504
  };
  var tanking = {
      name: "tanking",
      baseCost: 557
  };
  var style_preference = {
      name: "style preference",
      baseCost: 720
  };
  var stun = {
      name: "stun",
      baseCost: 940
  };
  var strike = {
      name: "strike",
      baseCost: 960
  };
  var spiritual_transfer = {
      name: "spiritual transfer",
      baseCost: 2694
  };
  var spirit_blessing = {
      name: "spirit blessing",
      baseCost: 1033
  };
  var slashing_weapons_mastery = {
      name: "slashing weapons mastery",
      baseCost: 1345
  };
  var shield_parry = {
      name: "shield parry",
      baseCost: 1316
  };
  var shield_deflection = {
      name: "shield deflection",
      baseCost: 1457
  };
  var sharpen_weapon = {
      name: "sharpen weapon",
      baseCost: 1345
  };
  var scavenge_wood = {
      name: "scavenge wood",
      baseCost: 571
  };
  var ritual_circle_lore = {
      name: "ritual circle lore",
      baseCost: 3037
  };
  var quick_chant = {
      name: "quick chant",
      baseCost: 1655
  };
  var punch = {
      name: "punch",
      baseCost: 426
  };
  var piercing_weapons_mastery = {
      name: "piercing weapons mastery",
      baseCost: 1345
  };
  var philosophy = {
      name: "philosophy",
      baseCost: 1718
  };
  var natures_rage = {
      name: "natures rage",
      baseCost: 1370
  };
  var natural_weapon_lore = {
      name: "natural weapon lore",
      baseCost: 1827
  };
  var multiweapons = {
      name: "multiweapons",
      baseCost: 940
  };
  var motion_control = {
      name: "motion control",
      baseCost: 1428
  };
  var minion_control = {
      name: "minion control",
      baseCost: 1142
  };
  var mind_power = {
      name: "mind power",
      baseCost: 5717
  };
  var mastery_of_mummification = {
      name: "mastery of mummification",
      baseCost: 5717
  };
  var maintain_healing_energy = {
      name: "maintain healing energy",
      baseCost: 1878
  };
  var magical_economy = {
      name: "magical economy",
      baseCost: 557
  };
  var hunting = {
      name: "hunting",
      baseCost: 705
  };
  var honor_of_the_gods = {
      name: "honor of the gods",
      baseCost: 557
  };
  var high_energy_focus = {
      name: "high energy focus",
      baseCost: 1541
  };
  var herb_preservation = {
      name: "herb preservation",
      baseCost: 501
  };
  var herb_gathering = {
      name: "herb gathering",
      baseCost: 873
  };
  var flesh_of_stone = {
      name: "flesh of stone",
      baseCost: 708
  };
  var fire_building = {
      name: "fire building",
      baseCost: 604
  };
  var exorcism = {
      name: "exorcism",
      baseCost: 2123
  };
  var essence_eye = {
      name: "essence eye",
      baseCost: 557
  };
  var enhance_striking = {
      name: "enhance striking",
      baseCost: 1084
  };
  var endowment_of_the_gods = {
      name: "endowment of the gods",
      baseCost: 1633
  };
  var draw_ritual_circle = {
      name: "draw ritual circle",
      baseCost: 1375
  };
  var doublehit = {
      name: "doublehit",
      baseCost: 940
  };
  var dodge = {
      name: "dodge",
      baseCost: 1316
  };
  var devastating_attack = {
      name: "devastating attack",
      baseCost: 1748
  };
  var determine_effectiveness = {
      name: "determine effectiveness",
      baseCost: 1142
  };
  var dedication = {
      name: "dedication",
      baseCost: 2041
  };
  var cry_of_the_berserker = {
      name: "cry of the berserker",
      baseCost: 1201
  };
  var counter_dodge = {
      name: "counter dodge",
      baseCost: 940
  };
  var ceremony = {
      name: "ceremony",
      baseCost: 328
  };
  var casting = {
      name: "casting",
      baseCost: 1428
  };
  var camping = {
      name: "camping",
      baseCost: 705
  };
  var blunt_weapons_mastery = {
      name: "blunt weapons mastery",
      baseCost: 1345
  };
  var biofeedback = {
      name: "biofeedback",
      baseCost: 739
  };
  var benediction = {
      name: "benediction",
      baseCost: 1960
  };
  var attack = {
      name: "attack",
      baseCost: 459
  };
  var animal_friendship = {
      name: "animal friendship",
      baseCost: 3505
  };
  var anatomy = {
      name: "anatomy",
      baseCost: 5717
  };
  var advanced_whirlwind_attack = {
      name: "advanced whirlwind attack",
      baseCost: 1479
  };
  exports["ceremony"] = ceremony;
  exports["essence_eye"] = essence_eye;
  exports["magical_economy"] = magical_economy;
  exports["honor_of_the_gods"] = honor_of_the_gods;
  exports["casting"] = casting;
  exports["quick_chant"] = quick_chant;
  exports["high_energy_focus"] = high_energy_focus;
  exports["determine_effectiveness"] = determine_effectiveness;
  exports["attack"] = attack;
  exports["weapon_skill_blunt"] = weapon_skill_blunt;
  exports["scavenge_wood"] = scavenge_wood;
  exports["weapon_skill_piercing"] = weapon_skill_piercing;
  exports["punch"] = punch;
  exports["doublehit"] = doublehit;
  exports["tanking"] = tanking;
  exports["fire_building"] = fire_building;
  exports["dodge"] = dodge;
  exports["spirit_blessing"] = spirit_blessing;
  exports["herb_gathering"] = herb_gathering;
  exports["endowment_of_the_gods"] = endowment_of_the_gods;
  exports["whirlwind_attack"] = whirlwind_attack;
  exports["motion_control"] = motion_control;
  exports["herb_preservation"] = herb_preservation;
  exports["stun"] = stun;
  exports["weapon_skill_slashing"] = weapon_skill_slashing;
  exports["flesh_of_stone"] = flesh_of_stone;
  exports["style_preference"] = style_preference;
  exports["minion_control"] = minion_control;
  exports["mind_power"] = mind_power;
  exports["anatomy"] = anatomy;
  exports["mastery_of_mummification"] = mastery_of_mummification;
  exports["ritual_circle_lore"] = ritual_circle_lore;
  exports["philosophy"] = philosophy;
  exports["draw_ritual_circle"] = draw_ritual_circle;
  exports["multiweapons"] = multiweapons;
  exports["weaponmaster"] = weaponmaster;
  exports["advanced_whirlwind_attack"] = advanced_whirlwind_attack;
  exports["piercing_weapons_mastery"] = piercing_weapons_mastery;
  exports["biofeedback"] = biofeedback;
  exports["strike"] = strike;
  exports["counter_dodge"] = counter_dodge;
  exports["enhance_striking"] = enhance_striking;
  exports["cry_of_the_berserker"] = cry_of_the_berserker;
  exports["willpower"] = willpower;
  exports["devastating_attack"] = devastating_attack;
  exports["sharpen_weapon"] = sharpen_weapon;
  exports["shield_parry"] = shield_parry;
  exports["maintain_healing_energy"] = maintain_healing_energy;
  exports["benediction"] = benediction;
  exports["exorcism"] = exorcism;
  exports["dedication"] = dedication;
  exports["hunting"] = hunting;
  exports["weapon_skill_shield"] = weapon_skill_shield;
  exports["natural_weapon_lore"] = natural_weapon_lore;
  exports["natures_rage"] = natures_rage;
  exports["slashing_weapons_mastery"] = slashing_weapons_mastery;
  exports["blunt_weapons_mastery"] = blunt_weapons_mastery;
  exports["shield_deflection"] = shield_deflection;
  exports["animal_friendship"] = animal_friendship;
  exports["spiritual_transfer"] = spiritual_transfer;
  exports["camping"] = camping;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Common.Spells"] = $PS["Common.Spells"] || {};
  var exports = $PS["Common.Spells"];
  var will_of_the_gods = {
      name: "will of the gods",
      baseCost: 1656
  };
  var spirit_wind = {
      name: "spirit wind",
      baseCost: 308
  };
  var spectral_push = {
      name: "spectral push",
      baseCost: 369
  };
  var rock_rain = {
      name: "rock rain",
      baseCost: 350
  };
  var ritual_of_torture = {
      name: "ritual of torture",
      baseCost: 1656
  };
  var ritual_of_protection = {
      name: "ritual of protection",
      baseCost: 1656
  };
  var ritual_of_incarnation = {
      name: "ritual of incarnation",
      baseCost: 1537
  };
  var ritual_of_draining = {
      name: "ritual of draining",
      baseCost: 1656
  };
  var ritual_of_death = {
      name: "ritual of death",
      baseCost: 2366
  };
  var ritual_of_binding = {
      name: "ritual of binding",
      baseCost: 1656
  };
  var minor_cleric_staff = {
      name: "minor cleric staff",
      baseCost: 308
  };
  var mind_sponge = {
      name: "mind sponge",
      baseCost: 614
  };
  var magical_growth = {
      name: "magical growth",
      baseCost: 292
  };
  var magic_dart = {
      name: "magic dart",
      baseCost: 308
  };
  var magic_blast = {
      name: "magic blast",
      baseCost: 462
  };
  var light = {
      name: "light",
      baseCost: 277
  };
  var know_alignment = {
      name: "know alignment",
      baseCost: 261
  };
  var identify = {
      name: "identify",
      baseCost: 474
  };
  var hypnotic_gaze = {
      name: "hypnotic gaze",
      baseCost: 1550
  };
  var hand_of_balance = {
      name: "hand of balance",
      baseCost: 308
  };
  var floating_disc = {
      name: "floating disc",
      baseCost: 603
  };
  var darkness = {
      name: "darkness",
      baseCost: 261
  };
  var create_food = {
      name: "create food",
      baseCost: 431
  };
  var coming_of_age = {
      name: "coming of age",
      baseCost: 2011
  };
  var circle_of_protection = {
      name: "circle of protection",
      baseCost: 603
  };
  exports["light"] = light;
  exports["darkness"] = darkness;
  exports["magic_dart"] = magic_dart;
  exports["mind_sponge"] = mind_sponge;
  exports["spectral_push"] = spectral_push;
  exports["magic_blast"] = magic_blast;
  exports["identify"] = identify;
  exports["spirit_wind"] = spirit_wind;
  exports["magical_growth"] = magical_growth;
  exports["rock_rain"] = rock_rain;
  exports["floating_disc"] = floating_disc;
  exports["circle_of_protection"] = circle_of_protection;
  exports["hypnotic_gaze"] = hypnotic_gaze;
  exports["ritual_of_protection"] = ritual_of_protection;
  exports["ritual_of_death"] = ritual_of_death;
  exports["ritual_of_torture"] = ritual_of_torture;
  exports["ritual_of_draining"] = ritual_of_draining;
  exports["ritual_of_binding"] = ritual_of_binding;
  exports["ritual_of_incarnation"] = ritual_of_incarnation;
  exports["will_of_the_gods"] = will_of_the_gods;
  exports["coming_of_age"] = coming_of_age;
  exports["know_alignment"] = know_alignment;
  exports["minor_cleric_staff"] = minor_cleric_staff;
  exports["hand_of_balance"] = hand_of_balance;
  exports["create_food"] = create_food;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Guilds"] = $PS["Guilds"] || {};
  var exports = $PS["Guilds"];
  var Common_Skills = $PS["Common.Skills"];
  var Common_Spells = $PS["Common.Spells"];
  var Data_Array = $PS["Data.Array"];
  var Data_Maybe = $PS["Data.Maybe"];                
  var traveler = {
      name: "Traveler",
      skills: [ {
          name: "tinning",
          baseCost: 705
      }, {
          name: "torch making",
          baseCost: 571
      }, Common_Skills.scavenge_wood, Common_Skills.fire_building, {
          name: "skinning",
          baseCost: 638
      }, Common_Skills.hunting, {
          name: "fishing",
          baseCost: 1541
      }, Common_Skills.camping, Common_Skills.herb_gathering, Common_Skills.herb_preservation, {
          name: "awareness",
          baseCost: 1633
      } ],
      spells: [  ]
  };
  var street_brawler = {
      name: "Street Brawler",
      skills: [ Common_Skills.tanking, Common_Skills.doublehit, Common_Skills.dodge, {
          name: "dirty kick",
          baseCost: 1108
      }, {
          name: "mighty blow",
          baseCost: 1256
      }, {
          name: "tackle",
          baseCost: 672
      }, {
          name: "street brawling",
          baseCost: 1312
      } ],
      spells: [  ]
  };
  var navigator = {
      name: "Navigator",
      skills: [ {
          name: "mastery of navigation",
          baseCost: 1142
      } ],
      spells: [ {
          name: "heavy weight",
          baseCost: 633
      }, {
          name: "create navigation stone",
          baseCost: 904
      }, {
          name: "guild portal",
          baseCost: 603
      }, {
          name: "word of recall",
          baseCost: 603
      }, {
          name: "whisper's recall",
          baseCost: 603
      }, {
          name: "relocate",
          baseCost: 603
      }, {
          name: "summon",
          baseCost: 603
      } ]
  };
  var master_navigators = {
      name: "Master Navigators",
      skills: [  ],
      spells: [ {
          name: "party heavy weight",
          baseCost: 760
      }, {
          name: "mordnoch's recall",
          baseCost: 845
      }, {
          name: "call beacon",
          baseCost: 1056
      }, {
          name: "mordnoch's spatial connection",
          baseCost: 845
      }, {
          name: "create shimmering portal",
          baseCost: 1267
      }, {
          name: "portal preferences",
          baseCost: 845
      }, {
          name: "create portal of summoning",
          baseCost: 802
      }, {
          name: "party summon",
          baseCost: 971
      } ]
  };
  var herbalist = {
      name: "Herbalist",
      skills: [ {
          name: "find herbs",
          baseCost: 571
      }, {
          name: "herb lore",
          baseCost: 1198
      }, {
          name: "mixing lore",
          baseCost: 1198
      } ],
      spells: [ {
          name: "mix healing balm",
          baseCost: 572
      }, {
          name: "mix antidote",
          baseCost: 693
      }, {
          name: "mix potion of the warrior",
          baseCost: 482
      }, {
          name: "mix waking salts",
          baseCost: 572
      }, {
          name: "mix potion of the priest",
          baseCost: 512
      }, {
          name: "mix potion of the rogue",
          baseCost: 482
      }, {
          name: "mix potion of the mage",
          baseCost: 512
      }, {
          name: "mix balm of protection",
          baseCost: 572
      } ]
  };
  var enchanter = {
      name: "Enchanter",
      skills: [ {
          name: "weapon enchanting",
          baseCost: 1633
      }, {
          name: "armor enchanting",
          baseCost: 1633
      } ],
      spells: [ Common_Spells.identify, {
          name: "shrink weapon",
          baseCost: 802
      }, {
          name: "enlarge weapon",
          baseCost: 802
      }, {
          name: "flame coating",
          baseCost: 887
      }, {
          name: "mystifying levitation",
          baseCost: 1056
      }, {
          name: "freezing touch",
          baseCost: 1242
      }, {
          name: "remove enchantment",
          baseCost: 887
      }, {
          name: "strengthen armor",
          baseCost: 3104
      }, {
          name: "empower weapon",
          baseCost: 1943
      }, {
          name: "enchant armor",
          baseCost: 2040
      }, {
          name: "protect armor",
          baseCost: 2040
      } ]
  };
  var blacksmith = {
      name: "Blacksmith",
      skills: [ {
          name: "appraise item",
          baseCost: 672
      }, {
          name: "material gathering",
          baseCost: 1370
      }, {
          name: "merge materials",
          baseCost: 672
      }, {
          name: "hammer blow",
          baseCost: 1344
      }, {
          name: "repair armor",
          baseCost: 772
      }, {
          name: "repair weapon",
          baseCost: 772
      }, {
          name: "ground pound",
          baseCost: 873
      }, {
          name: "weapon repairing",
          baseCost: 1428
      }, {
          name: "armor repairing",
          baseCost: 1428
      }, {
          name: "mastery of the hammer",
          baseCost: 1198
      }, {
          name: "art of blacksmithing",
          baseCost: 1484
      } ],
      spells: [  ]
  };
  var druid = [ {
      name: "Druid",
      skills: [ Common_Skills.attack, Common_Skills.weapon_skill_blunt, Common_Skills.honor_of_the_gods, Common_Skills.scavenge_wood, Common_Skills.fire_building, Common_Skills.spirit_blessing, Common_Skills.herb_gathering, Common_Skills.herb_preservation, Common_Skills.essence_eye, Common_Skills.magical_economy, Common_Skills.determine_effectiveness, Common_Skills.casting, {
          name: "commune with nature",
          baseCost: 1142
      } ],
      spells: [ Common_Spells.spirit_wind, Common_Spells.magical_growth, Common_Spells.rock_rain, {
          name: "gaian touch",
          baseCost: 366
      }, {
          name: "poison dart",
          baseCost: 431
      }, {
          name: "harmony of nature",
          baseCost: 689
      }, {
          name: "thorn cloud",
          baseCost: 431
      }, {
          name: "call for dryad",
          baseCost: 431
      }, {
          name: "embrace of gaia",
          baseCost: 768
      } ]
  }, {
      name: "Weather Watcher",
      skills: [ Common_Skills.quick_chant, Common_Skills.high_energy_focus, {
          name: "weather sense",
          baseCost: 1256
      } ],
      spells: [ {
          name: "call clouds",
          baseCost: 572
      }, {
          name: "call lightning",
          baseCost: 822
      }, {
          name: "living lightningrod",
          baseCost: 976
      }, {
          name: "purifying drizzle",
          baseCost: 572
      }, {
          name: "clear clouds",
          baseCost: 482
      }, {
          name: "sunbeam",
          baseCost: 928
      }, {
          name: "moonray",
          baseCost: 861
      }, {
          name: "wind call",
          baseCost: 904
      } ]
  }, {
      name: "Animal Tamer",
      skills: [ {
          name: "harmony with falcon spirits",
          baseCost: 1256
      }, {
          name: "animal empathy",
          baseCost: 1142
      }, {
          name: "harmony with wolf spirits",
          baseCost: 1312
      }, {
          name: "recall animal",
          baseCost: 638
      }, {
          name: "harmony with eagle spirits",
          baseCost: 1370
      }, {
          name: "harmony with bear spirits",
          baseCost: 1428
      } ],
      spells: [ {
          name: "call for falcon",
          baseCost: 603
      }, {
          name: "call for wolf",
          baseCost: 603
      }, {
          name: "call for eagle",
          baseCost: 603
      }, {
          name: "call for bear",
          baseCost: 603
      } ]
  }, herbalist, {
      name: "Adept Of The Stones",
      skills: [ {
          name: "crystal binding",
          baseCost: 2286
      }, {
          name: "focus crystal energy",
          baseCost: 2612
      }, {
          name: "crystal efficiency",
          baseCost: 2857
      } ],
      spells: [ {
          name: "create power crystal",
          baseCost: 1352
      }, {
          name: "merge power crystals",
          baseCost: 1605
      }, {
          name: "drain power crystal",
          baseCost: 1605
      }, {
          name: "gem blast",
          baseCost: 2163
      }, {
          name: "gem flash",
          baseCost: 1756
      } ]
  }, {
      name: "Shaman Of Soil",
      skills: [ {
          name: "drain soil energy",
          baseCost: 1537
      }, {
          name: "lore of the soil shamans",
          baseCost: 2286
      }, {
          name: "soil staff bash",
          baseCost: 2334
      }, Common_Skills.motion_control ],
      spells: [ {
          name: "root rise",
          baseCost: 1014
      }, {
          name: "hurl rock",
          baseCost: 1056
      }, {
          name: "root transit",
          baseCost: 971
      }, {
          name: "soil shield",
          baseCost: 929
      }, {
          name: "regrowth",
          baseCost: 1140
      }, {
          name: "grow personal tree",
          baseCost: 1183
      }, {
          name: "homecoming",
          baseCost: 845
      }, {
          name: "root travel",
          baseCost: 1098
      }, {
          name: "soil storm",
          baseCost: 1318
      } ]
  }, {
      name: "Chanter Of Deep Earth",
      skills: [ {
          name: "fire attunement",
          baseCost: 2453
      }, {
          name: "ritual of creation",
          baseCost: 3855
      }, {
          name: "crystal efficiency",
          baseCost: 2857
      }, {
          name: "focus crystal energy",
          baseCost: 2612
      }, {
          name: "cold attunement",
          baseCost: 2453
      }, {
          name: "asphyxiation attunement",
          baseCost: 2570
      }, {
          name: "physical attunement",
          baseCost: 2570
      }, {
          name: "magical attunement",
          baseCost: 2687
      }, {
          name: "mastery of attunement",
          baseCost: 3505
      }, {
          name: "acid attunement",
          baseCost: 2805
      }, {
          name: "poison attunement",
          baseCost: 2687
      }, {
          name: "electric attunement",
          baseCost: 2920
      } ],
      spells: [ {
          name: "crystal attunement",
          baseCost: 1656
      }, {
          name: "womb of gaia",
          baseCost: 1242
      } ]
  }, enchanter, traveler, blacksmith ];
  var elemental = [ {
      name: "Elemental",
      skills: [ Common_Skills.ceremony, Common_Skills.essence_eye, Common_Skills.magical_economy, Common_Skills.honor_of_the_gods, Common_Skills.determine_effectiveness, Common_Skills.casting ],
      spells: [ Common_Spells.darkness, Common_Spells.light, Common_Spells.magic_dart, Common_Spells.mind_sponge, Common_Spells.spectral_push, Common_Spells.magic_blast, {
          name: "stone fist",
          baseCost: 431
      }, {
          name: "flame tongue",
          baseCost: 431
      }, Common_Spells.floating_disc, {
          name: "cold flesh",
          baseCost: 521
      }, {
          name: "stone rain",
          baseCost: 474
      }, {
          name: "stun shield",
          baseCost: 1326
      } ]
  }, {
      name: "Fire Mage",
      skills: [ Common_Skills.quick_chant, Common_Skills.high_energy_focus, {
          name: "mastery of fire",
          baseCost: 1713
      } ],
      spells: [ {
          name: "armor of flame",
          baseCost: 1097
      }, {
          name: "fireball",
          baseCost: 603
      }, {
          name: "flame blade",
          baseCost: 603
      }, {
          name: "immunity of fire",
          baseCost: 723
      }, {
          name: "body of fire",
          baseCost: 1688
      }, {
          name: "incinerate",
          baseCost: 904
      }, {
          name: "revert form",
          baseCost: 542
      } ]
  }, {
      name: "Earth Mage",
      skills: [ Common_Skills.quick_chant, Common_Skills.high_energy_focus, {
          name: "mastery of earth",
          baseCost: 1713
      } ],
      spells: [ {
          name: "stoneskin",
          baseCost: 693
      }, {
          name: "sand storm",
          baseCost: 603
      }, {
          name: "earthstaff",
          baseCost: 603
      }, {
          name: "earth quake",
          baseCost: 603
      }, {
          name: "body of stone",
          baseCost: 1688
      }, {
          name: "petrify",
          baseCost: 1025
      }, {
          name: "revert form",
          baseCost: 542
      } ]
  }, {
      name: "Air Mage",
      skills: [ Common_Skills.quick_chant, Common_Skills.high_energy_focus, {
          name: "mastery of air",
          baseCost: 1713
      } ],
      spells: [ {
          name: "aura of air",
          baseCost: 723
      }, {
          name: "tornado",
          baseCost: 723
      }, {
          name: "air shield",
          baseCost: 603
      }, {
          name: "asphyxiate",
          baseCost: 844
      }, {
          name: "body of air",
          baseCost: 1688
      }, {
          name: "revert form",
          baseCost: 542
      } ]
  }, {
      name: "Water Mage",
      skills: [ Common_Skills.quick_chant, Common_Skills.high_energy_focus, {
          name: "mastery of water",
          baseCost: 1713
      } ],
      spells: [ {
          name: "wild flood",
          baseCost: 844
      }, {
          name: "lightning bolt",
          baseCost: 603
      }, {
          name: "ice pick",
          baseCost: 603
      }, {
          name: "body of water",
          baseCost: 1688
      }, {
          name: "revert form",
          baseCost: 542
      }, {
          name: "wall of water",
          baseCost: 723
      }, {
          name: "freeze",
          baseCost: 603
      }, {
          name: "call for storm",
          baseCost: 783
      } ]
  }, {
      name: "Lava Mage",
      skills: [ {
          name: "mold lava",
          baseCost: 1153
      }, {
          name: "mastery of molding",
          baseCost: 1633
      } ],
      spells: [ {
          name: "summon molding gloves",
          baseCost: 845
      }, {
          name: "magma boulder",
          baseCost: 1098
      }, {
          name: "create raw lava",
          baseCost: 845
      }, {
          name: "eruption",
          baseCost: 1478
      }, {
          name: "wall of lava",
          baseCost: 1225
      }, {
          name: "body of lava",
          baseCost: 2163
      } ]
  }, {
      name: "Mist Mage",
      skills: [ {
          name: "mist lore",
          baseCost: 2449
      } ],
      spells: [ {
          name: "yellow mist",
          baseCost: 1056
      }, {
          name: "blue mist",
          baseCost: 1056
      }, {
          name: "black mist",
          baseCost: 1056
      }, {
          name: "green mist",
          baseCost: 1317
      }, {
          name: "wall of mist",
          baseCost: 1098
      }, {
          name: "mist form",
          baseCost: 1900
      }, {
          name: "solidify",
          baseCost: 760
      } ]
  }, {
      name: "Nether Mage",
      skills: [ {
          name: "estimate elemental abundance",
          baseCost: 1375
      }, {
          name: "elemental strand weaving",
          baseCost: 3037
      }, {
          name: "mastery of elements",
          baseCost: 3388
      } ],
      spells: [ {
          name: "control elemental energy ",
          baseCost: 2040
      }, {
          name: "project energy blast",
          baseCost: 2614
      }, {
          name: "body of nether",
          baseCost: 3075
      }, {
          name: "dispel nether energy",
          baseCost: 1360
      }, {
          name: "summon elemental matter",
          baseCost: 1419
      }, {
          name: "wall of elemental energy",
          baseCost: 1537
      }, {
          name: "elemental wave blast",
          baseCost: 1886
      }, {
          name: "elemental attunement",
          baseCost: 1419
      }, {
          name: "absorb elemental energy",
          baseCost: 1360
      }, {
          name: "nether body harmony",
          baseCost: 1419
      }, {
          name: "chain elemental bolts",
          baseCost: 2483
      } ]
  }, enchanter, navigator, master_navigators, traveler, blacksmith ];
  var evoker = [ {
      name: "Evoker",
      skills: [ Common_Skills.ceremony, Common_Skills.essence_eye, Common_Skills.magical_economy, Common_Skills.honor_of_the_gods, Common_Skills.determine_effectiveness, Common_Skills.casting, {
          name: "evocation",
          baseCost: 1142
      }, {
          name: "channel energy",
          baseCost: 672
      } ],
      spells: [ Common_Spells.light, Common_Spells.darkness, Common_Spells.magic_dart, Common_Spells.mind_sponge, Common_Spells.spectral_push, Common_Spells.magic_blast, {
          name: "fire dart",
          baseCost: 474
      }, {
          name: "ice dart",
          baseCost: 588
      }, Common_Spells.floating_disc, {
          name: "magic wind",
          baseCost: 517
      } ]
  }, {
      name: "Evoker Of Elements",
      skills: [ Common_Skills.quick_chant, {
          name: "regeneration stance",
          baseCost: 940
      }, Common_Skills.high_energy_focus ],
      spells: [ {
          name: "fire bolt",
          baseCost: 783
      }, {
          name: "ice bolt",
          baseCost: 814
      }, {
          name: "power bolt",
          baseCost: 844
      }, {
          name: "vacuum bolt",
          baseCost: 874
      } ]
  }, {
      name: "Evoker Of Ether",
      skills: [ Common_Skills.quick_chant, {
          name: "focused mind",
          baseCost: 1310
      }, Common_Skills.high_energy_focus ],
      spells: [ {
          name: "acid arrow",
          baseCost: 783
      }, {
          name: "lightning arrow",
          baseCost: 814
      }, {
          name: "poison arrow",
          baseCost: 844
      }, {
          name: "magical arrow",
          baseCost: 874
      }, {
          name: "dispel magic",
          baseCost: 603
      } ]
  }, {
      name: "Evoker Of Magic",
      skills: [ {
          name: "magic evocation",
          baseCost: 2286
      }, {
          name: "magical focus",
          baseCost: 1729
      } ],
      spells: [ {
          name: "breath of magic",
          baseCost: 2112
      }, {
          name: "mana storm",
          baseCost: 1470
      }, {
          name: "magical fury",
          baseCost: 2788
      } ]
  }, {
      name: "Evoker Of Vacuum",
      skills: [ {
          name: "vacuum evocation",
          baseCost: 2286
      }, {
          name: "asphyxiation focus",
          baseCost: 1729
      } ],
      spells: [ {
          name: "suffocating force",
          baseCost: 2112
      }, {
          name: "void vortex",
          baseCost: 1470
      }, {
          name: "choking strike",
          baseCost: 2788
      } ]
  }, {
      name: "Evoker Of Flames",
      skills: [ {
          name: "fire evocation",
          baseCost: 2286
      }, {
          name: "fire focus",
          baseCost: 1729
      } ],
      spells: [ {
          name: "flame strike",
          baseCost: 2112
      }, {
          name: "fire wave",
          baseCost: 1470
      }, {
          name: "immolate",
          baseCost: 2788
      } ]
  }, {
      name: "Evoker Of Force",
      skills: [ {
          name: "force evocation",
          baseCost: 2286
      }, {
          name: "physical focus",
          baseCost: 1729
      } ],
      spells: [ {
          name: "hammering blow",
          baseCost: 2112
      }, {
          name: "hail of stones",
          baseCost: 1470
      }, {
          name: "concussive force",
          baseCost: 2788
      } ]
  }, {
      name: "Evoker Of Poison",
      skills: [ {
          name: "poison evocation",
          baseCost: 2286
      }, {
          name: "poison focus",
          baseCost: 1729
      } ],
      spells: [ {
          name: "venomous bite",
          baseCost: 2112
      }, {
          name: "killing plague",
          baseCost: 1470
      }, {
          name: "virulent strike",
          baseCost: 2788
      } ]
  }, {
      name: "Evoker Of Acid",
      skills: [ {
          name: "acid evocation",
          baseCost: 2286
      }, {
          name: "acid focus",
          baseCost: 1729
      } ],
      spells: [ {
          name: "acidic ray",
          baseCost: 2112
      }, {
          name: "corrosive cloud",
          baseCost: 1470
      }, {
          name: "dissolving spray",
          baseCost: 2788
      } ]
  }, {
      name: "Evoker Of Lightning",
      skills: [ {
          name: "lightning evocation",
          baseCost: 2286
      }, {
          name: "electric focus",
          baseCost: 1729
      } ],
      spells: [ {
          name: "electrocution",
          baseCost: 2112
      }, {
          name: "chain lightning",
          baseCost: 1470
      }, {
          name: "static discharge",
          baseCost: 2788
      } ]
  }, {
      name: "Evoker Of Ice",
      skills: [ {
          name: "cold evocation",
          baseCost: 2286
      }, {
          name: "cold focus",
          baseCost: 1729
      } ],
      spells: [ {
          name: "hypothermia",
          baseCost: 2112
      }, {
          name: "cone of cold",
          baseCost: 1470
      }, {
          name: "freezing sphere",
          baseCost: 2788
      } ]
  }, {
      name: "Sorcerer",
      skills: [ {
          name: "mastery of evocation",
          baseCost: 3740
      }, {
          name: "casting efficiency",
          baseCost: 4090
      }, {
          name: "estimate efficiency",
          baseCost: 3505
      }, {
          name: "mind peace",
          baseCost: 3272
      } ],
      spells: [ {
          name: "condition orbit",
          baseCost: 1014
      }, {
          name: "prismatic spray",
          baseCost: 1537
      }, {
          name: "dampen magic",
          baseCost: 1774
      }, {
          name: "amplify magic",
          baseCost: 1774
      }, {
          name: "store spell",
          baseCost: 1242
      } ]
  }, navigator, master_navigators, enchanter, traveler, blacksmith ];
  var lurker = [ {
      name: "Lurker",
      skills: [ Common_Skills.attack, Common_Skills.weapon_skill_piercing, Common_Skills.weapon_skill_slashing, Common_Skills.punch, {
          name: "stab",
          baseCost: 1505
      }, Common_Skills.honor_of_the_gods, {
          name: "flight",
          baseCost: 1034
      }, {
          name: "kick",
          baseCost: 940
      }, {
          name: "stealth",
          baseCost: 974
      }, Common_Skills.essence_eye, {
          name: "limber up",
          baseCost: 1339
      }, {
          name: "acrobat stance",
          baseCost: 1773
      }, {
          name: "tumbling",
          baseCost: 1222
      }, {
          name: "sleight of hand",
          baseCost: 328
      }, {
          name: "double stab",
          baseCost: 1370
      } ],
      spells: [ Common_Spells.light, Common_Spells.darkness ]
  }, street_brawler, {
      name: "Assassin",
      skills: [ {
          name: "backstab",
          baseCost: 1786
      }, {
          name: "armor piercing",
          baseCost: 940
      }, Common_Skills.counter_dodge, {
          name: "track",
          baseCost: 1105
      }, {
          name: "stun",
          baseCost: 940
      }, Common_Skills.multiweapons, {
          name: "knowledge of pressure points",
          baseCost: 1484
      }, {
          name: "motion control",
          baseCost: 1428
      }, {
          name: "bleed",
          baseCost: 2204
      }, {
          name: "triple stab",
          baseCost: 1655
      } ],
      spells: [  ]
  }, {
      name: "Poison Brewer",
      skills: [ {
          name: "brew confusing poison",
          baseCost: 672
      }, {
          name: "apply poison",
          baseCost: 873
      }, {
          name: "mastery of poisons",
          baseCost: 1142
      }, {
          name: "brew numbing poison",
          baseCost: 672
      }, {
          name: "brew paralyzing potion",
          baseCost: 672
      }, {
          name: "brew lethal poison",
          baseCost: 672
      }, {
          name: "brew stunning poison",
          baseCost: 672
      } ],
      spells: [  ]
  }, {
      name: "Trickster",
      skills: [ {
          name: "art of deception",
          baseCost: 1084
      }, {
          name: "confuse opponent",
          baseCost: 672
      }, {
          name: "anger opponent",
          baseCost: 739
      }, {
          name: "intimidate opponent",
          baseCost: 672
      }, {
          name: "fast talk",
          baseCost: 672
      }, {
          name: "conceal skill",
          baseCost: 2041
      }, {
          name: "pickpocket",
          baseCost: 705
      }, {
          name: "hide",
          baseCost: 772
      }, {
          name: "false alliance",
          baseCost: 638
      }, {
          name: "disarm",
          baseCost: 961
      } ],
      spells: [  ]
  }, {
      name: "Bartender",
      skills: [ {
          name: "appraisal",
          baseCost: 768
      }, Common_Skills.tanking, {
          name: "drink of inspiration",
          baseCost: 1009
      }, {
          name: "hearty feast",
          baseCost: 961
      }, {
          name: "putrid drink",
          baseCost: 1057
      }, {
          name: "drink of motivation",
          baseCost: 1009
      }, {
          name: "foul drink",
          baseCost: 1057
      }, {
          name: "bartering",
          baseCost: 1468
      }, {
          name: "bartending",
          baseCost: 1633
      } ],
      spells: [  ]
  }, {
      name: "Master Assassin",
      skills: [ {
          name: "art of concealment",
          baseCost: 2570
      }, {
          name: "piercing weapons mastery",
          baseCost: 1345
      }, {
          name: "psychotic stabbing",
          baseCost: 2041
      }, Common_Skills.whirlwind_attack, Common_Skills.sharpen_weapon, Common_Skills.endowment_of_the_gods, {
          name: "fatal strike",
          baseCost: 2041
      }, {
          name: "strangle",
          baseCost: 1345
      } ],
      spells: [  ]
  }, {
      name: "Disciple Of Shadow",
      skills: [ {
          name: "shadow lore",
          baseCost: 1084
      }, {
          name: "shadow control",
          baseCost: 1142
      }, {
          name: "stretch shadow",
          baseCost: 806
      }, {
          name: "shadow manipulation",
          baseCost: 2449
      }, {
          name: "shape shadow",
          baseCost: 912
      } ],
      spells: [ {
          name: "awaken shadow",
          baseCost: 603
      }, {
          name: "touch of darkness",
          baseCost: 845
      }, {
          name: "dark arrow",
          baseCost: 819
      }, {
          name: "fluttering wall",
          baseCost: 572
      }, {
          name: "impaling shadow",
          baseCost: 1085
      }, {
          name: "shaded ally",
          baseCost: 693
      }, {
          name: "split shadow",
          baseCost: 603
      }, {
          name: "tendrils of darkness",
          baseCost: 844
      } ]
  }, {
      name: "Silent Hand",
      skills: [ {
          name: "uncanny stabbling",
          baseCost: 3155
      }, Common_Skills.advanced_whirlwind_attack, {
          name: "honed perception",
          baseCost: 1306
      }, {
          name: "unbelievable stealth",
          baseCost: 3175
      }, {
          name: "inflict pain",
          baseCost: 1925
      }, {
          name: "uncanny dodge",
          baseCost: 3368
      }, {
          name: "art of assassination",
          baseCost: 2920
      }, {
          name: "manipulate aura",
          baseCost: 4812
      } ],
      spells: [  ]
  }, traveler, blacksmith ];
  var martial_artist = [ {
      name: "Martial Artist",
      skills: [ Common_Skills.attack, Common_Skills.tanking, Common_Skills.flesh_of_stone, Common_Skills.honor_of_the_gods, Common_Skills.punch, {
          name: "martial arts",
          baseCost: 940
      }, Common_Skills.essence_eye, {
          name: "meditation",
          baseCost: 739
      }, {
          name: "defensive maneuvers",
          baseCost: 940
      }, {
          name: "power kick",
          baseCost: 1142
      }, {
          name: "off hand attack",
          baseCost: 940
      }, Common_Skills.stun, {
          name: "fists of fury",
          baseCost: 940
      } ],
      spells: [  ]
  }, {
      name: "Dragonfist Fighter",
      skills: [ {
          name: "deliver criticals",
          baseCost: 940
      }, {
          name: "focus chi",
          baseCost: 986
      }, {
          name: "defensive prowess`",
          baseCost: 940
      }, {
          name: "resist pain",
          baseCost: 739
      }, Common_Skills.counter_dodge, {
          name: "empower will",
          baseCost: 1008
      }, {
          name: "dragonfist",
          baseCost: 940
      } ],
      spells: [  ]
  }, {
      name: "Mystic Warriors",
      skills: [ {
          name: "inner peace",
          baseCost: 1075
      }, Common_Skills.motion_control, {
          name: "restore self",
          baseCost: 1176
      }, {
          name: "mastery of chi",
          baseCost: 1713
      }, {
          name: "force of will",
          baseCost: 775
      }, {
          name: "split essence",
          baseCost: 672
      }, {
          name: "fists of legend",
          baseCost: 940
      } ],
      spells: [ {
          name: "chi bolt",
          baseCost: 603
      } ]
  }, {
      name: "Toad Master",
      skills: [ {
          name: "flying kick",
          baseCost: 1479
      }, Common_Skills.style_preference, {
          name: "soul of the toad",
          baseCost: 1633
      }, {
          name: "toad armor",
          baseCost: 1057
      }, {
          name: "bouncing toad",
          baseCost: 961
      }, Common_Skills.endowment_of_the_gods, {
          name: "toad leg power",
          baseCost: 912
      }, {
          name: "mind over body",
          baseCost: 1550
      }, {
          name: "forged ego",
          baseCost: 1057
      } ],
      spells: [  ]
  }, {
      name: "Tiger Master",
      skills: [ {
          name: "pounce attack",
          baseCost: 1479
      }, {
          name: "soul of the tiger",
          baseCost: 1633
      }, Common_Skills.style_preference, {
          name: "tiger claw",
          baseCost: 1057
      }, Common_Skills.endowment_of_the_gods, {
          name: "double claw attack",
          baseCost: 1796
      }, {
          name: "tiger aggression",
          baseCost: 1412
      }, {
          name: "focus tiger claw",
          baseCost: 1633
      } ],
      spells: [  ]
  }, {
      name: "Crane Master",
      skills: [ {
          name: "nerve strike",
          baseCost: 1479
      }, Common_Skills.style_preference, {
          name: "soul of the crane",
          baseCost: 1633
      }, {
          name: "pluck the thorn",
          baseCost: 961
      }, {
          name: "cranes gait",
          baseCost: 1412
      }, Common_Skills.endowment_of_the_gods, {
          name: "chi of yin",
          baseCost: 1009
      }, {
          name: "martial parry",
          baseCost: 1412
      }, {
          name: "chi of yang",
          baseCost: 1305
      } ],
      spells: [  ]
  }, {
      name: "Snake Master",
      skills: [ {
          name: "viper strike",
          baseCost: 1479
      }, Common_Skills.style_preference, {
          name: "soul of the snake",
          baseCost: 1633
      }, {
          name: "enhance criticals",
          baseCost: 1479
      }, {
          name: "armor piercing",
          baseCost: 940
      }, Common_Skills.endowment_of_the_gods, {
          name: "fury of the snake",
          baseCost: 1547
      }, {
          name: "lightning strike",
          baseCost: 1084
      }, {
          name: "snake gaze",
          baseCost: 1153
      } ],
      spells: [  ]
  }, {
      name: "Order Of The Crescent Moon",
      skills: [ {
          name: "neutralize fists",
          baseCost: 961
      }, {
          name: "chi polarity",
          baseCost: 1796
      }, {
          name: "fists of elements",
          baseCost: 961
      }, {
          name: "fire fists",
          baseCost: 1550
      }, {
          name: "freezing fists",
          baseCost: 1550
      }, {
          name: "lightning fists",
          baseCost: 1550
      } ],
      spells: [  ]
  }, {
      name: "Dragon Master",
      skills: [ {
          name: "dragon strength",
          baseCost: 2501
      }, {
          name: "soul of the dragon",
          baseCost: 2337
      }, {
          name: "sharpen claw",
          baseCost: 2570
      }, {
          name: "dragon tail sweep",
          baseCost: 2116
      }, {
          name: "nature of the beast",
          baseCost: 2268
      }, {
          name: "dragon reflexes",
          baseCost: 2213
      }, {
          name: "poison claw",
          baseCost: 2102
      }, {
          name: "scaled hide",
          baseCost: 2570
      }, {
          name: "dragon possession",
          baseCost: 3093
      } ],
      spells: [  ]
  }, traveler, blacksmith ];
  var necromancer = [ {
      name: "Necromancer",
      skills: [ Common_Skills.ceremony, Common_Skills.essence_eye, Common_Skills.magical_economy, Common_Skills.honor_of_the_gods, Common_Skills.weapon_skill_blunt, {
          name: "death rites",
          baseCost: 672
      }, Common_Skills.determine_effectiveness, Common_Skills.casting, Common_Skills.minion_control ],
      spells: [ Common_Spells.light, Common_Spells.darkness, {
          name: "animate dead",
          baseCost: 431
      }, Common_Spells.magic_dart, {
          name: "blister skin",
          baseCost: 474
      }, Common_Spells.mind_sponge, {
          name: "corpse explosion",
          baseCost: 862
      }, Common_Spells.spectral_push, {
          name: "release undead",
          baseCost: 431
      }, Common_Spells.magic_blast ]
  }, {
      name: "Necroscope",
      skills: [ {
          name: "dead speak",
          baseCost: 2284
      } ],
      spells: [ {
          name: "speak with rogue",
          baseCost: 1582
      }, {
          name: "speak with warrior",
          baseCost: 1582
      }, {
          name: "recall minion",
          baseCost: 603
      }, {
          name: "lethargy of shirija",
          baseCost: 603
      }, {
          name: "return to limbo",
          baseCost: 693
      }, {
          name: "speak with priest",
          baseCost: 1582
      }, {
          name: "speak with magi",
          baseCost: 1582
      }, {
          name: "hands of the dead",
          baseCost: 663
      } ]
  }, {
      name: "Voodooist",
      skills: [ Common_Skills.minion_control, {
          name: "voodooism",
          baseCost: 2284
      } ],
      spells: [ Common_Spells.circle_of_protection, {
          name: "mind surge",
          baseCost: 603
      }, {
          name: "summon carrion crawlers",
          baseCost: 693
      }, {
          name: "rotting limbs",
          baseCost: 693
      }, {
          name: "minion information",
          baseCost: 603
      }, {
          name: "combine corpses",
          baseCost: 603
      }, {
          name: "voodoo curse",
          baseCost: 814
      }, {
          name: "strenghten immunity",
          baseCost: 2321
      }, {
          name: "vampiric touch",
          baseCost: 603
      }, {
          name: "animate zombie",
          baseCost: 603
      } ]
  }, {
      name: "Bone Mage",
      skills: [ {
          name: "osteology",
          baseCost: 1142
      }, Common_Skills.minion_control, Common_Skills.quick_chant ],
      spells: [ Common_Spells.circle_of_protection, {
          name: "animate skeletal warrior",
          baseCost: 603
      }, {
          name: "animate skeletal mage",
          baseCost: 603
      }, {
          name: "summon vultures",
          baseCost: 603
      }, {
          name: "regeneration pile",
          baseCost: 603
      }, {
          name: "disjoint bones",
          baseCost: 693
      } ]
  }, {
      name: "Stygian Sorcerer",
      skills: [ Common_Skills.mind_power, Common_Skills.high_energy_focus ],
      spells: [ {
          name: "energy field",
          baseCost: 3380
      }, {
          name: "animate wraith",
          baseCost: 1690
      }, {
          name: "mind blast",
          baseCost: 1098
      } ]
  }, {
      name: "Embalmer`",
      skills: [ Common_Skills.mastery_of_mummification ],
      spells: [ {
          name: "animate mummy",
          baseCost: 1690
      } ]
  }, {
      name: "Dreadlord",
      skills: [ Common_Skills.anatomy ],
      spells: [ {
          name: "animate abomination",
          baseCost: 1690
      } ]
  }, {
      name: "Scourge",
      skills: [ {
          name: "repair undead",
          baseCost: 961
      }, {
          name: "mould body",
          baseCost: 961
      }, {
          name: "bond preference",
          baseCost: 961
      } ],
      spells: [ {
          name: "torokaha",
          baseCost: 845
      }, {
          name: "parenga",
          baseCost: 845
      }, {
          name: "ethereal bonding",
          baseCost: 971
      }, {
          name: "pupuhi",
          baseCost: 845
      }, {
          name: "tauoranga",
          baseCost: 2661
      }, {
          name: "kaha o tinana",
          baseCost: 2661
      }, {
          name: "roro",
          baseCost: 845
      }, {
          name: "tumatarau",
          baseCost: 2661
      } ]
  }, {
      name: "Lords Of Undeath",
      skills: [ Common_Skills.anatomy, Common_Skills.mastery_of_mummification, Common_Skills.mind_power, {
          name: "lich status",
          baseCost: 2406
      } ],
      spells: [ {
          name: "bone fusion",
          baseCost: 2070
      }, {
          name: "consume brain",
          baseCost: 2070
      }, {
          name: "consume flesh",
          baseCost: 2070
      }, {
          name: "consume muscle tissue",
          baseCost: 2070
      }, {
          name: "mind fusion",
          baseCost: 2070
      }, {
          name: "lich transformation",
          baseCost: 2366
      } ]
  }, {
      name: "Blood Brother",
      skills: [ {
          name: "hematology",
          baseCost: 8180
      } ],
      spells: [ {
          name: "animate vampire",
          baseCost: 2366
      } ]
  }, navigator, master_navigators, enchanter, traveler, blacksmith ];
  var psychics = [ {
      name: "Psychics",
      skills: [ Common_Skills.ceremony, Common_Skills.essence_eye, Common_Skills.magical_economy, Common_Skills.honor_of_the_gods, Common_Skills.casting, Common_Skills.determine_effectiveness ],
      spells: [ Common_Spells.light, Common_Spells.darkness, Common_Spells.magic_dart, Common_Spells.mind_sponge, Common_Spells.spectral_push, Common_Spells.magic_blast, {
          name: "psychic fury",
          baseCost: 431
      }, {
          name: "create psychic container",
          baseCost: 431
      }, {
          name: "transfer object",
          baseCost: 474
      }, {
          name: "meditate",
          baseCost: 930
      }, Common_Spells.identify, Common_Spells.floating_disc, {
          name: "psychic transfer",
          baseCost: 929
      }, {
          name: "distant sell",
          baseCost: 409
      } ]
  }, {
      name: "Mystics",
      skills: [ {
          name: "mastery of the realm",
          baseCost: 1370
      }, Common_Skills.quick_chant ],
      spells: [ {
          name: "mind lash",
          baseCost: 814
      }, {
          name: "diffuse magic",
          baseCost: 783
      }, {
          name: "astral walk",
          baseCost: 603
      }, {
          name: "deflect",
          baseCost: 1259
      }, {
          name: "psychic manipulation",
          baseCost: 783
      } ]
  }, {
      name: "Witch",
      skills: [ Common_Skills.quick_chant, {
          name: "lore of the elders",
          baseCost: 1142
      }, Common_Skills.high_energy_focus ],
      spells: [ {
          name: "evil eye",
          baseCost: 795
      }, {
          name: "charge broom",
          baseCost: 603
      }, {
          name: "wrath of the covenant",
          baseCost: 1206
      }, {
          name: "nerves of fire",
          baseCost: 1012
      }, {
          name: "recall to covenant",
          baseCost: 603
      }, {
          name: "remove curse",
          baseCost: 663
      } ]
  }, {
      name: "Telekinetics",
      skills: [ Common_Skills.quick_chant, {
          name: "mastery of the mind",
          baseCost: 1370
      } ],
      spells: [ {
          name: "psychic gaze",
          baseCost: 603
      }, {
          name: "clairvoyance",
          baseCost: 971
      }, {
          name: "assess person",
          baseCost: 452
      }, {
          name: "mental eye",
          baseCost: 603
      }, {
          name: "levitate",
          baseCost: 1206
      } ]
  }, {
      name: "Cauldron Magic",
      skills: [ {
          name: "brewing lore",
          baseCost: 1878
      } ],
      spells: [ {
          name: "summon cauldron",
          baseCost: 845
      }, {
          name: "fill cauldron",
          baseCost: 845
      }, {
          name: "stir mixture of tremors",
          baseCost: 789
      }, {
          name: "stir explosive mixture",
          baseCost: 882
      }, {
          name: "stir poisonous mixture",
          baseCost: 933
      }, {
          name: "stir magical mixture",
          baseCost: 1123
      }, {
          name: "stir corrosive mixture",
          baseCost: 1183
      } ]
  }, {
      name: "Oneiromancers",
      skills: [ {
          name: "dreamweaving lore",
          baseCost: 1960
      }, {
          name: "sleep trance",
          baseCost: 1960
      }, {
          name: "dream of anticipation",
          baseCost: 845
      }, {
          name: "dream of delaeus",
          baseCost: 845
      }, {
          name: "dream of faeries",
          baseCost: 845
      } ],
      spells: [ {
          name: "dream of titans",
          baseCost: 845
      }, {
          name: "dream of wellsprings",
          baseCost: 845
      } ]
  }, {
      name: "Watchers Of The Night",
      skills: [ {
          name: "lore of the watchers",
          baseCost: 1960
      } ],
      spells: [ {
          name: "nightmare of medusa",
          baseCost: 929
      }, {
          name: "nightmare of hemophilia",
          baseCost: 971
      }, {
          name: "nightmare of vertigo",
          baseCost: 760
      }, {
          name: "nightmare of lucifer",
          baseCost: 760
      }, {
          name: "nightmare of oedipus",
          baseCost: 971
      }, {
          name: "recurring nightmare",
          baseCost: 971
      } ]
  }, {
      name: "Psionists",
      skills: [ {
          name: "mental tide",
          baseCost: 1960
      }, {
          name: "mind orbit",
          baseCost: 1960
      }, {
          name: "memory lapse",
          baseCost: 1387
      } ],
      spells: [ {
          name: "pierce thought",
          baseCost: 929
      }, {
          name: "shock",
          baseCost: 1014
      }, Common_Spells.hypnotic_gaze, {
          name: "power leak",
          baseCost: 971
      }, {
          name: "arc impulse",
          baseCost: 1318
      }, {
          name: "cytokinesis",
          baseCost: 1014
      }, {
          name: "mind shout",
          baseCost: 1318
      } ]
  }, {
      name: "Talisman Magic",
      skills: [ Common_Spells.hypnotic_gaze, {
          name: "charge talisman",
          baseCost: 1718
      }, {
          name: "talisman ceremonies",
          baseCost: 2805
      } ],
      spells: [ {
          name: "create etheral talisman",
          baseCost: 1183
      }, {
          name: "synergy",
          baseCost: 1301
      }, {
          name: "astral projection",
          baseCost: 1183
      }, {
          name: "spontaneous combustion",
          baseCost: 1715
      }, {
          name: "etheral shield",
          baseCost: 1631
      }, {
          name: "augment",
          baseCost: 1987
      }, {
          name: "mind vortex",
          baseCost: 1183
      }, {
          name: "soul steal",
          baseCost: 1951
      } ]
  }, navigator, master_navigators, enchanter, traveler, blacksmith ];
  var shapeshifter = [ {
      name: "shapeshifter",
      skills: [ Common_Skills.attack, Common_Skills.tanking, Common_Skills.weapon_skill_blunt, Common_Skills.honor_of_the_gods, Common_Skills.scavenge_wood, Common_Skills.fire_building, Common_Skills.spirit_blessing, Common_Skills.herb_gathering, Common_Skills.essence_eye, Common_Skills.herb_preservation, {
          name: "avian lore",
          baseCost: 1428
      }, {
          name: "ursine lore",
          baseCost: 1428
      }, {
          name: "form preference",
          baseCost: 336
      }, {
          name: "shapeshifting lore",
          baseCost: 1256
      }, {
          name: "canine lore",
          baseCost: 1428
      }, {
          name: "feline lore",
          baseCost: 1428
      }, {
          name: "claw attack",
          baseCost: 829
      }, Common_Skills.doublehit, {
          name: "tooth and nail",
          baseCost: 1080
      }, Common_Skills.dodge, {
          name: "natural coordination",
          baseCost: 845
      } ],
      spells: [ Common_Spells.spirit_wind, Common_Spells.magical_growth, Common_Spells.rock_rain, {
          name: "shape shift",
          baseCost: 754
      } ]
  }, {
      name: "bestial seccedaneum",
      skills: [ {
          name: "call of nature",
          baseCost: 1312
      }, {
          name: "avian lore",
          baseCost: 1428
      }, {
          name: "canine lore",
          baseCost: 1428
      }, {
          name: "ursine lore",
          baseCost: 1428
      }, {
          name: "feline lore",
          baseCost: 1428
      }, {
          name: "bite attack",
          baseCost: 1269
      }, Common_Skills.stun, {
          name: "fang and claw",
          baseCost: 1128
      }, {
          name: "hug attack",
          baseCost: 886
      } ],
      spells: [ {
          name: "reverse transformation",
          baseCost: 663
      } ]
  }, {
      name: "savager",
      skills: [ Common_Skills.whirlwind_attack, {
          name: "natural toughness",
          baseCost: 1142
      }, Common_Skills.motion_control, {
          name: "natural agility",
          baseCost: 912
      }, Common_Skills.counter_dodge, {
          name: "natural brutality",
          baseCost: 1034
      }, {
          name: "natural instincts",
          baseCost: 1370
      }, {
          name: "contest of wills",
          baseCost: 672
      }, {
          name: "natural calm",
          baseCost: 1198
      }, {
          name: "calm beasts",
          baseCost: 912
      } ],
      spells: [  ]
  }, {
      name: "Animal Tamer",
      skills: [ {
          name: "harmony with falcon spirits",
          baseCost: 1256
      }, {
          name: "animal empathy",
          baseCost: 1142
      }, {
          name: "harmony with wolf spirits",
          baseCost: 1312
      }, {
          name: "recall animal",
          baseCost: 638
      }, {
          name: "harmony with eagle spirits",
          baseCost: 1370
      }, {
          name: "harmony with bear spirits",
          baseCost: 1428
      } ],
      spells: [ {
          name: "call for falcon",
          baseCost: 603
      }, {
          name: "call for wolf",
          baseCost: 603
      }, {
          name: "call for eagle",
          baseCost: 603
      }, {
          name: "call for bear",
          baseCost: 603
      } ]
  }, {
      name: "animal healer",
      skills: [ {
          name: "animal anatomy",
          baseCost: 1796
      }, Common_Skills.endowment_of_the_gods, {
          name: "unnatural agility",
          baseCost: 1305
      }, {
          name: "unnatural instincts",
          baseCost: 1960
      }, {
          name: "unnatural calm",
          baseCost: 1715
      }, {
          name: "groom",
          baseCost: 961
      }, {
          name: "diagnose  animal",
          baseCost: 961
      }, {
          name: "animal magnetism",
          baseCost: 816
      } ],
      spells: [ {
          name: "mend beast",
          baseCost: 1267
      }, {
          name: "balsamic bestial bath",
          baseCost: 1478
      } ]
  }, {
      name: "animal trainer",
      skills: [ Common_Skills.animal_friendship, {
          name: "animal training",
          baseCost: 1715
      }, {
          name: "teach forestry",
          baseCost: 961
      }, {
          name: "teach horticulture",
          baseCost: 1057
      }, {
          name: "teach hunting",
          baseCost: 1009
      }, {
          name: "teach gleaning",
          baseCost: 1153
      }, {
          name: "teach herbology",
          baseCost: 1249
      }, {
          name: "animal husbandry",
          baseCost: 1715
      }, {
          name: "teach bravery",
          baseCost: 961
      } ],
      spells: [  ]
  }, {
      name: "beast lord",
      skills: [ {
          name: "avian lore",
          baseCost: 1428
      }, {
          name: "canine lore",
          baseCost: 1428
      }, {
          name: "ursine lore",
          baseCost: 1428
      }, {
          name: "feline lore",
          baseCost: 1428
      }, {
          name: "unnatural toughness",
          baseCost: 1633
      }, {
          name: "batter attack",
          baseCost: 1201
      }, {
          name: "unnatural coordination",
          baseCost: 1209
      }, {
          name: "bestial speed",
          baseCost: 1345
      }, {
          name: "call of the wild",
          baseCost: 1960
      }, {
          name: "unnatural brutality",
          baseCost: 1479
      } ],
      spells: [  ]
  }, {
      name: "dragon lord",
      skills: [ {
          name: "dragon hide",
          baseCost: 2453
      }, {
          name: "draconian lore",
          baseCost: 2805
      }, {
          name: "dragon weapons",
          baseCost: 2570
      }, {
          name: "legendary prowess",
          baseCost: 5258
      }, {
          name: "migrate",
          baseCost: 1512
      }, {
          name: "dragon breath",
          baseCost: 2687
      }, {
          name: "animal harmony",
          baseCost: 3505
      } ],
      spells: [ {
          name: "niveous puff",
          baseCost: 5441
      }, {
          name: "incandescent issue",
          baseCost: 5441
      }, {
          name: "draconian halitosis",
          baseCost: 5441
      }, {
          name: "caustic cyclone",
          baseCost: 5441
      }, {
          name: "voltaic venting",
          baseCost: 5441
      } ]
  }, traveler, blacksmith ];
  var unraveller = [ {
      name: "Unraveller",
      skills: [ Common_Skills.attack, Common_Skills.essence_eye, Common_Skills.weapon_skill_blunt, Common_Skills.honor_of_the_gods, Common_Skills.ceremony, Common_Skills.magical_economy, Common_Skills.determine_effectiveness, Common_Skills.casting, {
          name: "unholy essence",
          baseCost: 1142
      } ],
      spells: [ Common_Spells.darkness, Common_Spells.light, Common_Spells.know_alignment, Common_Spells.hand_of_balance, {
          name: "cause light wounds",
          baseCost: 308
      }, Common_Spells.minor_cleric_staff, {
          name: "arrow of darkness",
          baseCost: 338
      }, {
          name: "armor of scorn",
          baseCost: 847
      }, Common_Spells.create_food, {
          name: "diagnose",
          baseCost: 344
      }, {
          name: "burning aura",
          baseCost: 387
      }, {
          name: "scar",
          baseCost: 431
      }, {
          name: "darkflame",
          baseCost: 560
      } ]
  }, {
      name: "Harmer",
      skills: [ {
          name: "inflict harm",
          baseCost: 1142
      }, Common_Skills.quick_chant, Common_Skills.high_energy_focus ],
      spells: [ {
          name: "unholy prayer",
          baseCost: 1097
      }, {
          name: "harm body",
          baseCost: 603
      }, {
          name: "protection from good",
          baseCost: 1084
      }, {
          name: "unholy shield",
          baseCost: 1166
      }, {
          name: "mana drain",
          baseCost: 603
      }, {
          name: "harm good",
          baseCost: 723
      } ]
  }, {
      name: "Sacrificer",
      skills: [ {
          name: "offer blood",
          baseCost: 772
      }, Common_Skills.quick_chant, {
          name: "dark ritual",
          baseCost: 1256
      }, {
          name: "bloodletting",
          baseCost: 604
      } ],
      spells: [ {
          name: "summon ritual dagger",
          baseCost: 482
      }, {
          name: "summon vessel",
          baseCost: 603
      }, {
          name: "life drain",
          baseCost: 603
      }, {
          name: "blood brotherhood",
          baseCost: 663
      }, {
          name: "blood healing",
          baseCost: 1039
      }, {
          name: "energy drain",
          baseCost: 603
      } ]
  }, {
      name: "Magical Torturer",
      skills: [ Common_Skills.quick_chant, {
          name: "thumb screws",
          baseCost: 672
      }, {
          name: "rack",
          baseCost: 1622
      }, {
          name: "interrogation",
          baseCost: 1142
      } ],
      spells: [ {
          name: "magical brand",
          baseCost: 663
      }, {
          name: "create magical rack",
          baseCost: 603
      }, {
          name: "peel flesh",
          baseCost: 603
      }, {
          name: "images of torture",
          baseCost: 603
      } ]
  }, {
      name: "Servant Of Mordulak",
      skills: [ {
          name: "worship of mordulak",
          baseCost: 1878
      }, {
          name: "intimidation",
          baseCost: 1633
      } ],
      spells: [ {
          name: "summon leech",
          baseCost: 845
      }, {
          name: "sacrifice to mordulak",
          baseCost: 1056
      }, {
          name: "blood fire",
          baseCost: 845
      }, {
          name: "massive scab",
          baseCost: 1710
      }, {
          name: "cloud of blood",
          baseCost: 845
      }, {
          name: "appoint acolyte of mordulak",
          baseCost: 1014
      }, {
          name: "willing convert",
          baseCost: 845
      }, {
          name: "avatar of mordulak",
          baseCost: 1267
      } ]
  }, {
      name: "Servant Of Shirija",
      skills: [ {
          name: "worship of shirija",
          baseCost: 1878
      } ],
      spells: [ {
          name: "summon undead",
          baseCost: 845
      }, {
          name: "imprison soul",
          baseCost: 845
      }, {
          name: "soul drain",
          baseCost: 845
      }, {
          name: "sacrifice to shirija",
          baseCost: 718
      }, {
          name: "stench of death",
          baseCost: 845
      }, {
          name: "exchange soul",
          baseCost: 1056
      }, {
          name: "appoint acolyte of shirija",
          baseCost: 1014
      }, {
          name: "corpse speech",
          baseCost: 802
      }, {
          name: "avatar of shirija",
          baseCost: 1267
      } ]
  }, {
      name: "Servant Of Talakh",
      skills: [ {
          name: "worship of talakh",
          baseCost: 1796
      }, {
          name: "taunt",
          baseCost: 1009
      }, {
          name: "berserk",
          baseCost: 1009
      }, Common_Skills.attack, {
          name: "sacrifice to talakh",
          baseCost: 1153
      }, Common_Skills.weapon_skill_blunt, Common_Skills.blunt_weapons_mastery, Common_Skills.weaponmaster ],
      spells: [ {
          name: "summon lizard",
          baseCost: 845
      }, {
          name: "plague of stones",
          baseCost: 845
      }, {
          name: "fist of talakh",
          baseCost: 887
      }, {
          name: "appoint acolyte of talakh",
          baseCost: 1014
      }, {
          name: "avatar of talakh",
          baseCost: 1267
      } ]
  }, {
      name: "Servant Of Lloth",
      skills: [ {
          name: "worship of lloth",
          baseCost: 1960
      } ],
      spells: [ {
          name: "talk to varya",
          baseCost: 591
      }, {
          name: "summon spiders",
          baseCost: 845
      }, {
          name: "evil heart",
          baseCost: 845
      }, {
          name: "spin web",
          baseCost: 971
      }, {
          name: "silken parachute",
          baseCost: 1056
      }, {
          name: "spider bite",
          baseCost: 845
      }, {
          name: "sacrifice to lloth",
          baseCost: 718
      }, {
          name: "appoint acolyte of lloth",
          baseCost: 1014
      }, {
          name: "feel web",
          baseCost: 676
      }, {
          name: "avatar of lloth",
          baseCost: 1267
      } ]
  }, {
      name: "Elder Of Mordulak",
      skills: [ {
          name: "true belief in mordulak",
          baseCost: 3037
      }, Common_Skills.ritual_circle_lore, Common_Skills.philosophy, Common_Skills.draw_ritual_circle ],
      spells: [ Common_Spells.ritual_of_protection, Common_Spells.ritual_of_death, Common_Spells.ritual_of_torture, Common_Spells.coming_of_age, Common_Spells.ritual_of_draining, Common_Spells.ritual_of_binding, Common_Spells.ritual_of_incarnation, Common_Spells.will_of_the_gods ]
  }, {
      name: "Patriarch Of Shirija",
      skills: [ {
          name: "true belief in shirija",
          baseCost: 2920
      }, Common_Skills.ritual_circle_lore, Common_Skills.philosophy, Common_Skills.draw_ritual_circle ],
      spells: [ Common_Spells.ritual_of_protection, Common_Spells.ritual_of_death, Common_Spells.ritual_of_torture, Common_Spells.coming_of_age, Common_Spells.ritual_of_draining, Common_Spells.ritual_of_binding, Common_Spells.ritual_of_incarnation ]
  }, {
      name: "Sword Of Talakh",
      skills: [ {
          name: "true belief in talakh",
          baseCost: 2570
      }, Common_Skills.ritual_circle_lore, Common_Skills.philosophy, Common_Skills.draw_ritual_circle ],
      spells: [ Common_Spells.ritual_of_protection, Common_Spells.ritual_of_death, Common_Spells.ritual_of_torture, Common_Spells.coming_of_age, Common_Spells.ritual_of_draining, Common_Spells.ritual_of_binding, Common_Spells.ritual_of_incarnation, Common_Spells.will_of_the_gods ]
  }, {
      name: "Primate of Lloth",
      skills: [ {
          name: "true belief in lloth",
          baseCost: 3037
      }, Common_Skills.ritual_circle_lore, Common_Skills.philosophy, Common_Skills.draw_ritual_circle ],
      spells: [ Common_Spells.ritual_of_protection, Common_Spells.ritual_of_death, Common_Spells.ritual_of_torture, Common_Spells.coming_of_age, Common_Spells.ritual_of_draining, Common_Spells.ritual_of_binding, Common_Spells.ritual_of_incarnation, Common_Spells.will_of_the_gods ]
  }, navigator, master_navigators, enchanter, {
      name: "Master Enchanter",
      skills: [ {
          name: "mastery of enchanting",
          baseCost: 2337
      } ],
      spells: [ {
          name: "create enchantment stone",
          baseCost: 1183
      }, {
          name: "disenchant armor",
          baseCost: 1360
      }, {
          name: "disenchant weapon",
          baseCost: 1360
      } ]
  }, traveler, blacksmith ];
  var warrior = [ {
      name: "Warrior",
      skills: [ Common_Skills.tanking, Common_Skills.attack, Common_Skills.weapon_skill_blunt, Common_Skills.flesh_of_stone, Common_Skills.honor_of_the_gods, Common_Skills.weapon_skill_piercing, Common_Skills.punch, Common_Skills.weapon_skill_slashing, {
          name: "weapon skill whipping",
          baseCost: 504
      }, Common_Skills.essence_eye, {
          name: "forearm bash",
          baseCost: 739
      }, Common_Skills.doublehit, {
          name: "kick",
          baseCost: 940
      }, Common_Skills.dodge, Common_Skills.stun, {
          name: "unarmed combat",
          baseCost: 1370
      } ],
      spells: [  ]
  }, {
      name: "Knight",
      skills: [ Common_Skills.biofeedback, Common_Skills.strike, Common_Skills.multiweapons, Common_Skills.whirlwind_attack, Common_Skills.counter_dodge, Common_Skills.enhance_striking, Common_Skills.weaponmaster ],
      spells: [  ]
  }, {
      name: "Defender Of The Crown",
      skills: [ Common_Skills.weapon_skill_shield, {
          name: "unbalancing blow",
          baseCost: 974
      }, Common_Skills.shield_parry, Common_Skills.motion_control, {
          name: "riposte",
          baseCost: 1176
      }, Common_Skills.willpower, Common_Skills.shield_deflection, {
          name: "defensive stance",
          baseCost: 739
      } ],
      spells: [  ]
  }, {
      name: "Berserker",
      skills: [ {
          name: "resist pain",
          baseCost: 739
      }, Common_Skills.biofeedback, Common_Skills.strike, {
          name: "body control",
          baseCost: 1312
      }, {
          name: "fevered strength",
          baseCost: 772
      }, {
          name: "ignore pain",
          baseCost: 940
      }, Common_Skills.enhance_striking, {
          name: "berserker rage",
          baseCost: 1034
      }, {
          name: "berserker stance",
          baseCost: 739
      } ],
      spells: [  ]
  }, {
      name: "Blade Dancer",
      skills: [ {
          name: "bladed fury",
          baseCost: 1561
      }, Common_Skills.devastating_attack, Common_Skills.endowment_of_the_gods, Common_Skills.advanced_whirlwind_attack, {
          name: "blade dance",
          baseCost: 1057
      }, {
          name: "master of the dance",
          baseCost: 1715
      }, {
          name: "singing blade",
          baseCost: 1657
      }, Common_Skills.slashing_weapons_mastery, Common_Skills.cry_of_the_berserker ],
      spells: [  ]
  }, {
      name: "Barbarian",
      skills: [ {
          name: "deathblow",
          baseCost: 1498
      }, Common_Skills.endowment_of_the_gods, Common_Skills.devastating_attack, Common_Skills.advanced_whirlwind_attack, {
          name: "stunning blow",
          baseCost: 2084
      }, {
          name: "bloodlust",
          baseCost: 1960
      }, {
          name: "whirlwind strike",
          baseCost: 1249
      }, {
          name: "blunt weapons mastery",
          baseCost: 1345
      }, Common_Skills.cry_of_the_berserker ],
      spells: [  ]
  }, {
      name: "Shield Master",
      skills: [ Common_Skills.willpower, {
          name: "fighting instinct",
          baseCost: 1878
      }, Common_Skills.endowment_of_the_gods, {
          name: "weapon parry",
          baseCost: 1412
      }, {
          name: "advanced parry",
          baseCost: 1748
      }, {
          name: "enhanced deflection",
          baseCost: 1815
      }, {
          name: "double bash",
          baseCost: 1547
      }, {
          name: "shield fighting",
          baseCost: 1345
      }, {
          name: "defenders warcry",
          baseCost: 1201
      } ],
      spells: [  ]
  }, {
      name: "Flogger",
      skills: [ {
          name: "lacerate",
          baseCost: 1441
      }, {
          name: "immobilize",
          baseCost: 1153
      }, Common_Skills.devastating_attack, Common_Skills.endowment_of_the_gods, {
          name: "whipping weapons mastery attack",
          baseCost: 1950
      }, Common_Skills.advanced_whirlwind_attack, {
          name: "lightning whip",
          baseCost: 1345
      }, Common_Skills.cry_of_the_berserker, {
          name: "entangle",
          baseCost: 1297
      } ],
      spells: [  ]
  }, {
      name: "Thruster",
      skills: [ {
          name: "impale",
          baseCost: 1441
      }, Common_Skills.devastating_attack, Common_Skills.endowment_of_the_gods, Common_Skills.sharpen_weapon, Common_Skills.advanced_whirlwind_attack, Common_Skills.piercing_weapons_mastery, {
          name: "spot weak point",
          baseCost: 1878
      }, Common_Skills.cry_of_the_berserker, {
          name: "wrist flick",
          baseCost: 2286
      } ],
      spells: [  ]
  }, {
      name: "champion of the crown",
      skills: [ {
          name: "crippling blow",
          baseCost: 2405
      }, {
          name: "strike weakness",
          baseCost: 2213
      }, {
          name: "weapon maneuvers",
          baseCost: 3740
      }, {
          name: "stun resistance",
          baseCost: 2501
      }, {
          name: "champion lore",
          baseCost: 2570
      }, {
          name: "charge",
          baseCost: 3656
      }, {
          name: "champion trance",
          baseCost: 2640
      } ],
      spells: [  ]
  }, traveler, blacksmith ];
  var weaver = [ {
      name: "Weaver",
      skills: [ Common_Skills.attack, Common_Skills.essence_eye, Common_Skills.weapon_skill_blunt, Common_Skills.honor_of_the_gods, Common_Skills.ceremony, Common_Skills.magical_economy, {
          name: "holy essence",
          baseCost: 1198
      }, Common_Skills.determine_effectiveness, Common_Skills.casting ],
      spells: [ Common_Spells.darkness, Common_Spells.light, Common_Spells.know_alignment, Common_Spells.hand_of_balance, {
          name: "cure light wounds",
          baseCost: 308
      }, Common_Spells.minor_cleric_staff, {
          name: "arrow of light",
          baseCost: 338
      }, {
          name: "armor of faith",
          baseCost: 847
      }, {
          name: "remove scar",
          baseCost: 431
      }, {
          name: "cure serious wounds",
          baseCost: 431
      }, {
          name: "minor refresh",
          baseCost: 431
      }, Common_Spells.create_food, {
          name: "infravision",
          baseCost: 777
      }, {
          name: "cure critical wounds",
          baseCost: 646
      } ]
  }, {
      name: "Healer",
      skills: [ {
          name: "mastery of healing",
          baseCost: 1598
      }, {
          name: "enhance healing",
          baseCost: 1827
      } ],
      spells: [ {
          name: "heal",
          baseCost: 844
      }, {
          name: "remove poison",
          baseCost: 603
      }, {
          name: "resurrect",
          baseCost: 753
      }, {
          name: "body restoration",
          baseCost: 723
      }, {
          name: "cure disease",
          baseCost: 603
      }, {
          name: "refresh",
          baseCost: 844
      }, {
          name: "restore",
          baseCost: 663
      }, {
          name: "renew",
          baseCost: 663
      }, {
          name: "estimate worth",
          baseCost: 542
      }, {
          name: "reincarnate",
          baseCost: 723
      }, {
          name: "cure memory",
          baseCost: 693
      } ]
  }, {
      name: "Martyr",
      skills: [ {
          name: "holy cause",
          baseCost: 1598
      } ],
      spells: [ {
          name: "heal companions",
          baseCost: 663
      }, {
          name: "refresh companions",
          baseCost: 663
      }, {
          name: "sacrifice health",
          baseCost: 693
      }, {
          name: "martyric presence",
          baseCost: 753
      }, {
          name: "sacrifice energy",
          baseCost: 693
      }, {
          name: "life link",
          baseCost: 783
      }, {
          name: "restore companions",
          baseCost: 795
      }, {
          name: "share suffering",
          baseCost: 693
      }, {
          name: "invigorate companions",
          baseCost: 828
      }, {
          name: "sacrifice mana",
          baseCost: 693
      } ]
  }, {
      name: "Confessor",
      skills: [ {
          name: "pious words",
          baseCost: 1598
      } ],
      spells: [ {
          name: "prayer for healing",
          baseCost: 603
      }, {
          name: "prayer for refreshment",
          baseCost: 723
      }, {
          name: "prayer for protection",
          baseCost: 693
      }, {
          name: "prayer for sanctuary",
          baseCost: 603
      }, {
          name: "prayer for mankind",
          baseCost: 814
      }, {
          name: "prayer for replenishment",
          baseCost: 783
      }, {
          name: "prayer for the crusader",
          baseCost: 1247
      }, {
          name: "prayer for the enlightened",
          baseCost: 1247
      } ]
  }, {
      name: "Avatar",
      skills: [ Common_Skills.maintain_healing_energy, Common_Skills.quick_chant, {
          name: "soul of the avatar",
          baseCost: 2123
      } ],
      spells: [ {
          name: "cleanse soul",
          baseCost: 845
      }, {
          name: "redemption",
          baseCost: 845
      }, {
          name: "feed companions",
          baseCost: 845
      }, {
          name: "heal body",
          baseCost: 971
      }, {
          name: "major refresh",
          baseCost: 971
      }, {
          name: "encourage regeneration",
          baseCost: 2129
      }, {
          name: "resurrect companions",
          baseCost: 1056
      }, {
          name: "aura of healing",
          baseCost: 2031
      }, {
          name: "revive dead",
          baseCost: 1098
      }, {
          name: "avatar regeneration",
          baseCost: 2331
      } ]
  }, {
      name: "Exorcist",
      skills: [ Common_Skills.exorcism, Common_Skills.quick_chant, Common_Skills.high_energy_focus ],
      spells: [ {
          name: "white flame",
          baseCost: 1056
      }, {
          name: "wrath of the righteous",
          baseCost: 1056
      }, {
          name: "holy prayer",
          baseCost: 1216
      }, {
          name: "turn undead",
          baseCost: 1521
      }, {
          name: "banish demon",
          baseCost: 1690
      }, {
          name: "hand of god",
          baseCost: 1773
      } ]
  }, {
      name: "Templar",
      skills: [ Common_Skills.weapon_skill_blunt, Common_Skills.tanking, Common_Skills.attack, Common_Skills.weapon_skill_slashing, {
          name: "lay hands",
          baseCost: 1201
      }, Common_Skills.doublehit, {
          name: "consecrate weapon",
          baseCost: 1546
      }, Common_Skills.shield_parry, {
          name: "templar rituals",
          baseCost: 2286
      }, {
          name: "consecrate shield",
          baseCost: 1801
      }, {
          name: "faith of the crusader",
          baseCost: 1690
      } ],
      spells: [  ]
  }, {
      name: "Shields Of Faith",
      skills: [ Common_Skills.benediction, Common_Skills.dedication ],
      spells: [ {
          name: "pilgrims protection",
          baseCost: 887
      }, {
          name: "prayer of the martyr",
          baseCost: 1427
      }, {
          name: "firm belief",
          baseCost: 1622
      }, {
          name: "holy shield",
          baseCost: 1166
      }, {
          name: "armor of life",
          baseCost: 887
      }, {
          name: "protection from evil",
          baseCost: 1098
      }, {
          name: "sacrifice spirit",
          baseCost: 929
      } ]
  }, {
      name: "High Priest",
      skills: [ Common_Skills.maintain_healing_energy, {
          name: "sincerity of prayers",
          baseCost: 1870
      }, {
          name: "martyr strength",
          baseCost: 2570
      }, {
          name: "healing efficiency",
          baseCost: 3037
      }, Common_Skills.benediction, Common_Skills.exorcism, Common_Skills.dedication, {
          name: "consecrate ground",
          baseCost: 1375
      }, {
          name: "high priest rites",
          baseCost: 2687
      } ],
      spells: [ {
          name: "return to sanctuary",
          baseCost: 1360
      }, {
          name: "summon holy bottle",
          baseCost: 1183
      }, {
          name: "create holy water",
          baseCost: 1478
      }, {
          name: "death ritual",
          baseCost: 3382
      }, {
          name: "chant of the high priest",
          baseCost: 1183
      }, {
          name: "spray holy water",
          baseCost: 1986
      }, {
          name: "revive companions",
          baseCost: 1892
      } ]
  }, navigator, master_navigators, enchanter, traveler, blacksmith ];
  var woodsman = [ {
      name: "Woodsman",
      skills: [ Common_Skills.tanking, Common_Skills.attack, Common_Skills.weapon_skill_blunt, Common_Skills.honor_of_the_gods, Common_Skills.scavenge_wood, Common_Skills.fire_building, Common_Skills.spirit_blessing, Common_Skills.herb_gathering, Common_Skills.essence_eye, Common_Skills.herb_preservation, Common_Skills.weapon_skill_slashing, Common_Skills.hunting, Common_Skills.doublehit, {
          name: "build campfire",
          baseCost: 705
      }, {
          name: "prepare nourishing soup",
          baseCost: 739
      }, Common_Skills.whirlwind_attack, Common_Skills.dodge, {
          name: "prepare healing poultice",
          baseCost: 739
      }, Common_Skills.camping ],
      spells: [ Common_Spells.spirit_wind, Common_Spells.magical_growth, Common_Spells.rock_rain ]
  }, {
      name: "Sylvan Guard",
      skills: [ {
          name: "whittle rootstaff",
          baseCost: 940
      }, {
          name: "carve leafblade",
          baseCost: 907
      }, Common_Skills.whirlwind_attack, {
          name: "whirling branches",
          baseCost: 1075
      }, {
          name: "drumming limbs",
          baseCost: 1075
      }, Common_Skills.natures_rage, Common_Skills.natural_weapon_lore, {
          name: "spiritual power",
          baseCost: 2612
      }, Common_Skills.multiweapons, {
          name: "wrath of mother earth",
          baseCost: 1478
      } ],
      spells: [ {
          name: "infuse fire power",
          baseCost: 1048
      }, {
          name: "infuse strength",
          baseCost: 1012
      } ]
  }, {
      name: "Sylwan Ward",
      skills: [ {
          name: "weave twigshield",
          baseCost: 806
      }, {
          name: "inner walls",
          baseCost: 1175
      }, {
          name: "survival reflexes",
          baseCost: 1428
      }, {
          name: "intuitive awareness",
          baseCost: 907
      }, Common_Skills.weapon_skill_shield, Common_Skills.natural_weapon_lore, Common_Skills.spiritual_transfer ],
      spells: [ {
          name: "fire warding",
          baseCost: 1084
      }, {
          name: "power warding",
          baseCost: 1048
      } ]
  }, {
      name: "Animal Tamer",
      skills: [ {
          name: "harmony with falcon spirits",
          baseCost: 1256
      }, {
          name: "animal empathy",
          baseCost: 1142
      }, {
          name: "harmony with wolf spirits",
          baseCost: 1312
      }, {
          name: "recall animal",
          baseCost: 638
      }, {
          name: "harmony with eagle spirits",
          baseCost: 1370
      }, {
          name: "harmony with bear spirits",
          baseCost: 1428
      } ],
      spells: [ {
          name: "call for falcon",
          baseCost: 603
      }, {
          name: "call for wolf",
          baseCost: 603
      }, {
          name: "call for eagle",
          baseCost: 603
      }, {
          name: "call for bear",
          baseCost: 603
      } ]
  }, herbalist, {
      name: "Sylvan Scout",
      skills: [ {
          name: "gauge opponent",
          baseCost: 1249
      }, {
          name: "spiritual power",
          baseCost: 2612
      }, Common_Skills.multiweapons, Common_Skills.natures_rage, {
          name: "search tracks",
          baseCost: 1009
      }, Common_Skills.slashing_weapons_mastery, {
          name: "track",
          baseCost: 1105
      }, {
          name: "survival lore",
          baseCost: 1878
      }, Common_Skills.blunt_weapons_mastery, Common_Skills.stun, {
          name: "avenging fury",
          baseCost: 1249
      }, Common_Skills.endowment_of_the_gods, Common_Skills.weaponmaster, {
          name: "furious bashing",
          baseCost: 1153
      } ],
      spells: [ {
          name: "nightvision",
          baseCost: 1352
      }, {
          name: "infuse acid power",
          baseCost: 1161
      }, {
          name: "infuse poison power",
          baseCost: 1254
      }, {
          name: "infuse lightning power",
          baseCost: 1470
      } ]
  }, {
      name: "Sylvan Protector",
      skills: [ {
          name: "memorize location",
          baseCost: 1009
      }, {
          name: "willow roots",
          baseCost: 1945
      }, Common_Skills.spiritual_transfer, {
          name: "pathfinding",
          baseCost: 1201
      }, Common_Skills.weapon_skill_shield, Common_Skills.shield_deflection, {
          name: "hide tracks",
          baseCost: 1201
      }, Common_Skills.motion_control, Common_Skills.shield_parry, Common_Skills.endowment_of_the_gods ],
      spells: [ {
          name: "release spirits",
          baseCost: 929
      }, {
          name: "acid warding",
          baseCost: 1207
      }, {
          name: "poison warding",
          baseCost: 1300
      }, {
          name: "lightning warding",
          baseCost: 1393
      } ]
  }, {
      name: "Sylvan Woodlord",
      skills: [ Common_Skills.weapon_skill_blunt, Common_Skills.slashing_weapons_mastery, Common_Skills.animal_friendship, Common_Skills.spiritual_transfer, {
          name: "observe opponent",
          baseCost: 1306
      }, Common_Skills.stun, {
          name: "fast mixing",
          baseCost: 1167
      }, Common_Skills.weaponmaster, {
          name: "prepare shield",
          baseCost: 1718
      }, {
          name: "prepare weapon",
          baseCost: 1718
      }, {
          name: "harmony with nature",
          baseCost: 3505
      }, {
          name: "neutralize weapon",
          baseCost: 687
      }, Common_Skills.shield_deflection, Common_Skills.shield_parry, {
          name: "deadly preparations",
          baseCost: 2020
      } ],
      spells: [ {
          name: "vengeance of gaia",
          baseCost: 1419
      }, {
          name: "womb of gaia",
          baseCost: 1242
      } ]
  }, traveler, blacksmith ];
  var acrobat = [ {
      name: "Acrobat",
      skills: [ Common_Skills.attack, {
          name: "sleight of hand",
          baseCost: 328
      }, Common_Skills.punch, Common_Skills.weapon_skill_piercing, Common_Skills.honor_of_the_gods, Common_Skills.essence_eye, {
          name: "leaping attack",
          baseCost: 1075
      }, {
          name: "acrobat stance",
          baseCost: 1773
      }, {
          name: "stealth",
          baseCost: 974
      }, {
          name: "limber up",
          baseCost: 1339
      }, {
          name: "trick punch",
          baseCost: 1313
      }, {
          name: "tumbling",
          baseCost: 1222
      } ],
      spells: [ Common_Spells.light, Common_Spells.darkness ]
  }, street_brawler, {
      name: "Juggler",
      skills: [ {
          name: "throw knife",
          baseCost: 1075
      }, {
          name: "armor piercing",
          baseCost: 940
      }, {
          name: "target preference",
          baseCost: 1008
      }, {
          name: "throwing art",
          baseCost: 1428
      }, {
          name: "lower body anatomy",
          baseCost: 1084
      }, {
          name: "upper body anatomy",
          baseCost: 1198
      }, {
          name: "head throw",
          baseCost: 1370
      }, Common_Skills.motion_control, {
          name: "heart throw",
          baseCost: 1541
      } ],
      spells: [  ]
  }, {
      name: "Bard",
      skills: [ {
          name: "disillusionment",
          baseCost: 1176
      }, {
          name: "storytelling",
          baseCost: 1142
      }, {
          name: "eye of the beholder",
          baseCost: 604
      }, {
          name: "song of the streets",
          baseCost: 604
      }, {
          name: "legend of arabidopsis",
          baseCost: 604
      }, {
          name: "demoralize",
          baseCost: 1176
      }, {
          name: "grithmals chant",
          baseCost: 604
      }, {
          name: "hymn to mitra",
          baseCost: 604
      }, {
          name: "song of sinbad",
          baseCost: 604
      }, {
          name: "mithrens warsong",
          baseCost: 604
      }, {
          name: "epic of endowment",
          baseCost: 604
      }, {
          name: "song of spirit",
          baseCost: 604
      }, {
          name: "recent performances",
          baseCost: 604
      }, {
          name: "hymn of honor",
          baseCost: 604
      }, {
          name: "history",
          baseCost: 739
      } ],
      spells: [  ]
  }, {
      name: "Minstrel",
      skills: [ {
          name: "trip",
          baseCost: 961
      }, {
          name: "please audience",
          baseCost: 1633
      }, {
          name: "allegory  of athol",
          baseCost: 1105
      }, {
          name: "tale of achman",
          baseCost: 1201
      }, {
          name: "psalm of protection",
          baseCost: 1681
      } ],
      spells: [  ]
  }, {
      name: "Bartender",
      skills: [ {
          name: "appraisal",
          baseCost: 768
      }, Common_Skills.tanking, {
          name: "drink of inspiration",
          baseCost: 1009
      }, {
          name: "hearty feast",
          baseCost: 961
      }, {
          name: "putrid drink",
          baseCost: 1057
      }, {
          name: "drink of motivation",
          baseCost: 1009
      }, {
          name: "foul drink",
          baseCost: 1057
      }, {
          name: "bartering",
          baseCost: 1468
      }, {
          name: "bartending",
          baseCost: 1633
      } ],
      spells: [  ]
  }, {
      name: "Bannerman",
      skills: [ {
          name: "hymn of rawknrhol",
          baseCost: 864
      }, {
          name: "hymn of enlightenment",
          baseCost: 1009
      }, Common_Skills.whirlwind_attack, {
          name: "ode to ona",
          baseCost: 1551
      }, Common_Skills.endowment_of_the_gods, {
          name: "battle singing",
          baseCost: 1633
      }, {
          name: "legend of secs",
          baseCost: 1551
      }, Common_Skills.piercing_weapons_mastery, {
          name: "glory of kreativ",
          baseCost: 1633
      }, {
          name: "epic of aurvex",
          baseCost: 1124
      }, {
          name: "legend of sear",
          baseCost: 1124
      } ],
      spells: [  ]
  }, {
      name: "Gleeman",
      skills: [ {
          name: "deadly accuracy",
          baseCost: 3272
      }, {
          name: "peripatetic entertainment",
          baseCost: 1635
      }, {
          name: "funeral march",
          baseCost: 1306
      }, {
          name: "speed throwing",
          baseCost: 2805
      }, {
          name: "lasting memory",
          baseCost: 3272
      }, {
          name: "knowledge of pressure points",
          baseCost: 1484
      }, {
          name: "soothing melodies",
          baseCost: 1512
      }, {
          name: "song of destruction",
          baseCost: 1306
      }, {
          name: "voice of strength",
          baseCost: 3037
      }, {
          name: "fast as the wind",
          baseCost: 1650
      }, {
          name: "song of resilience",
          baseCost: 1443
      } ],
      spells: [  ]
  }, {
      name: "Troubadour",
      skills: [ {
          name: "voice control",
          baseCost: 3972
      }, {
          name: "chant of smaug",
          baseCost: 2337
      }, {
          name: "rondel",
          baseCost: 2612
      }, {
          name: "power singing",
          baseCost: 2920
      }, {
          name: "bannerman hymn",
          baseCost: 3437
      }, {
          name: "minstrel rhythms",
          baseCost: 3437
      } ],
      spells: [  ]
  }, traveler, blacksmith ];
  var abjurer = [ {
      name: "Abjurer",
      skills: [ Common_Skills.ceremony, Common_Skills.essence_eye, Common_Skills.magical_economy, Common_Skills.honor_of_the_gods, Common_Skills.casting, {
          name: "protection ritual",
          baseCost: 1142
      } ],
      spells: [ Common_Spells.light, Common_Spells.darkness, Common_Spells.magic_dart, Common_Spells.mind_sponge, Common_Spells.spectral_push, Common_Spells.magic_blast, {
          name: "aura of force",
          baseCost: 757
      }, {
          name: "lesser magical shield",
          baseCost: 431
      }, {
          name: "lesser fire shield",
          baseCost: 431
      }, {
          name: "lesser poison shield",
          baseCost: 431
      }, {
          name: "lesser cold shield",
          baseCost: 431
      }, {
          name: "iron will",
          baseCost: 1185
      }, {
          name: "lesser psionic shield",
          baseCost: 431
      }, {
          name: "lesser acid shield",
          baseCost: 431
      }, {
          name: "lesser asphyxiation shield",
          baseCost: 431
      }, {
          name: "lesser electric shield",
          baseCost: 431
      }, {
          name: "lesser physical shield",
          baseCost: 431
      } ]
  }, {
      name: "Protector Of The Earth",
      skills: [ Common_Skills.quick_chant ],
      spells: [ {
          name: "greater fire shield",
          baseCost: 603
      }, {
          name: "remove shields",
          baseCost: 663
      }, {
          name: "aura detection",
          baseCost: 633
      }, {
          name: "greater cold shield",
          baseCost: 603
      }, {
          name: "acid spray",
          baseCost: 603
      }, {
          name: "greater acid shield",
          baseCost: 603
      }, {
          name: "greater physical shield",
          baseCost: 603
      }, {
          name: "shelter",
          baseCost: 814
      } ]
  }, {
      name: "Masters of Energy",
      skills: [ Common_Skills.quick_chant ],
      spells: [ {
          name: "greater magical shield",
          baseCost: 603
      }, {
          name: "greater poison shield",
          baseCost: 603
      }, {
          name: "magical drain",
          baseCost: 603
      }, {
          name: "feather weight",
          baseCost: 753
      }, {
          name: "greater psionic shield",
          baseCost: 603
      }, {
          name: "greater asphyxiation shield",
          baseCost: 603
      }, Common_Spells.identify, {
          name: "greater electric shield",
          baseCost: 603
      } ]
  }, {
      name: "Irrifletta",
      skills: [ {
          name: "quccata",
          baseCost: 1713
      } ],
      spells: [ {
          name: "hsieb",
          baseCost: 603
      }, {
          name: "berqa",
          baseCost: 603
      }, {
          name: "nohexeqekor",
          baseCost: 663
      }, {
          name: "xeraq",
          baseCost: 603
      }, {
          name: "velenu",
          baseCost: 603
      }, {
          name: "qares",
          baseCost: 603
      }, {
          name: "seher",
          baseCost: 603
      }, {
          name: "kiesah",
          baseCost: 603
      }, {
          name: "loghob",
          baseCost: 603
      }, {
          name: "orpo",
          baseCost: 783
      } ]
  }, {
      name: "Master Abjurer",
      skills: [ {
          name: "find weakness",
          baseCost: 1537
      }, {
          name: "mastery of reflection",
          baseCost: 2123
      }, Common_Skills.determine_effectiveness, {
          name: "enhance abjuration",
          baseCost: 2368
      }, {
          name: "lengthen abjuration",
          baseCost: 2286
      }, {
          name: "strenghten abjuration",
          baseCost: 2123
      } ],
      spells: [ {
          name: "chameleon energy blast",
          baseCost: 1183
      }, {
          name: "lesser holy shield",
          baseCost: 1352
      }, {
          name: "lesser unholy shield",
          baseCost: 1352
      } ]
  }, {
      name: "Harbinger Of Anguish",
      skills: [ Common_Skills.high_energy_focus, {
          name: "master of vulnerability",
          baseCost: 1633
      } ],
      spells: [ {
          name: "lungs of lead",
          baseCost: 1056
      }, {
          name: "brain warp",
          baseCost: 1056
      }, {
          name: "collapsed synapses",
          baseCost: 1056
      }, {
          name: "dulled senses",
          baseCost: 1056
      }, {
          name: "poisoned heart",
          baseCost: 1056
      }, {
          name: "epidermal peel",
          baseCost: 1056
      }, {
          name: "soul of the saint",
          baseCost: 1056
      }, {
          name: "soul of the sinner",
          baseCost: 1056
      }, {
          name: "boiling blood",
          baseCost: 1056
      }, {
          name: "veins of ice",
          baseCost: 1056
      }, {
          name: "weakened body",
          baseCost: 1056
      } ]
  }, {
      name: "Master Of Disruption",
      skills: [ Common_Skills.high_energy_focus, {
          name: "disruption lore",
          baseCost: 3388
      } ],
      spells: [ {
          name: "constricted throat",
          baseCost: 1419
      }, {
          name: "crushed brains",
          baseCost: 1419
      }, {
          name: "metallic skin",
          baseCost: 1419
      }, {
          name: "magical weakness",
          baseCost: 1419
      }, {
          name: "emaciated blood",
          baseCost: 1419
      }, {
          name: "weaken willpower",
          baseCost: 1656
      }, {
          name: "corroded body",
          baseCost: 1419
      }, {
          name: "unholy spirit",
          baseCost: 1419
      }, {
          name: "holy mind",
          baseCost: 1419
      }, {
          name: "burning skin",
          baseCost: 1419
      }, {
          name: "freezing blood",
          baseCost: 1419
      }, {
          name: "brittle limbs",
          baseCost: 1419
      } ]
  }, {
      name: "Guardians",
      skills: [  ],
      spells: [ {
          name: "greater holy shield",
          baseCost: 1774
      }, {
          name: "greater unholy shield",
          baseCost: 1774
      }, {
          name: "party remove shields",
          baseCost: 1360
      }, {
          name: "wall of force",
          baseCost: 1301
      }, {
          name: "party shield",
          baseCost: 1360
      }, {
          name: "party lesser shield",
          baseCost: 2661
      }, {
          name: "party greater shield",
          baseCost: 3253
      }, {
          name: "remove vulnerabilities",
          baseCost: 1301
      } ]
  }, navigator, master_navigators, traveler, enchanter, blacksmith ];
  var guilds = [ abjurer, acrobat, druid, elemental, evoker, lurker, martial_artist, necromancer, psychics, shapeshifter, unraveller, warrior, weaver, woodsman ];
  var getGuild = function (i) {
      var v = Data_Array.index(guilds)(i);
      if (v instanceof Data_Maybe.Just) {
          return v.value0;
      };
      if (v instanceof Data_Maybe.Nothing) {
          return abjurer;
      };
      throw new Error("Failed pattern match at Guilds (line 1632, column 14 - line 1634, column 21): " + [ v.constructor.name ]);
  };
  var getGuildName = function (i) {
      var v = Data_Array.index(guilds)(i);
      if (v instanceof Data_Maybe.Just) {
          var v1 = Data_Array.index(v.value0)(0);
          if (v1 instanceof Data_Maybe.Just) {
              return v1.value0.name;
          };
          if (v1 instanceof Data_Maybe.Nothing) {
              return "abjurer";
          };
          throw new Error("Failed pattern match at Guilds (line 1626, column 13 - line 1628, column 25): " + [ v1.constructor.name ]);
      };
      if (v instanceof Data_Maybe.Nothing) {
          return "abjurer";
      };
      throw new Error("Failed pattern match at Guilds (line 1625, column 18 - line 1629, column 23): " + [ v.constructor.name ]);
  };
  exports["guilds"] = guilds;
  exports["getGuildName"] = getGuildName;
  exports["getGuild"] = getGuild;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Level"] = $PS["Level"] || {};
  var exports = $PS["Level"];
  var Data_Array = $PS["Data.Array"];
  var Data_BigInt = $PS["Data.BigInt"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Semiring = $PS["Data.Semiring"];                
  var levels = Data_Functor.map(Data_Functor.functorArray)(Data_BigInt.fromInt)([ 9, 54, 206, 578, 1290, 2464, 4236, 6746, 10142, 14570, 20188, 27156, 35632, 45784, 57780, 71792, 87990, 106552, 127656, 151482, 178212, 208030, 241124, 277678, 317882, 361928, 410008, 462316, 519048, 580398, 646566, 717750, 794152, 875970, 963410, 1056676, 1155970, 1261500, 1373472, 1492096, 1617578, 1750130, 1889962, 2037286, 2192312, 2355258, 2526336, 2705760, 2893748, 3090516, 3296280, 3511262, 3735676, 3969746, 4213688, 4496768, 4793802, 5105254, 5431598, 5773318, 6130908, 6504868, 6895714, 7303968, 7730164, 8174850, 8638576, 9121908, 9625426, 10149716, 10695380, 11263024, 11853274, 12466762, 13104134, 13766052, 14453180, 15166210, 15905826, 16672746, 17467690, 18291386, 19144590, 20028060, 20942572, 21888908, 22864886, 23880316, 24927026, 26008868, 27126706, 28281410, 29473878, 30705018, 31975754, 33287018, 34639772, 36034996, 37473664, 38956792, 41028436, 43196408, 45464680, 47837344, 50318652, 52913024, 55624992, 58459324, 61420904, 64514828, 67746360, 71120936, 74644232, 78322096, 82160592, 86165992, 90344808, 94703760, 99249832, 103990248, 106796544, 109654184, 112563720, 115525616, 118540392, 121608536, 124730568, 127906984, 131138272, 134424960, 137767536, 141166528, 144622400, 148135728, 151706944, 155336576, 159025184, 162773232, 166581216, 170449680, 174379136, 178370064, 182422992, 186538448, 190716896, 194958928, 199264960 ]);
  var sumLevels = function (x) {
      var $0 = x > 147;
      if ($0) {
          return Data_Semiring.add(Data_BigInt.semiringBigInt)(Data_Semiring.mul(Data_BigInt.semiringBigInt)(Data_BigInt.fromInt(x - 147 | 0))(Data_BigInt.fromInt(200000000)))(Data_Array.foldl(Data_Semiring.add(Data_BigInt.semiringBigInt))(Data_BigInt.fromInt(0))(Data_Array.take(x)(levels)));
      };
      return Data_Array.foldl(Data_Semiring.add(Data_BigInt.semiringBigInt))(Data_BigInt.fromInt(0))(Data_Array.take(x)(levels));
  };
  exports["sumLevels"] = sumLevels;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Races"] = $PS["Races"] || {};
  var exports = $PS["Races"];
  var Data_Array = $PS["Data.Array"];
  var Data_BigInt = $PS["Data.BigInt"];
  var Data_Maybe = $PS["Data.Maybe"];                
  var races = [ {
      name: "celestial mage",
      skill: 100,
      spell: 100,
      skillMax: 100,
      spellMax: 100
  }, {
      name: "cromagnon",
      skill: 68,
      spell: 84,
      skillMax: 90,
      spellMax: 70
  }, {
      name: "drow",
      skill: 84,
      spell: 80,
      skillMax: 95,
      spellMax: 100
  }, {
      name: "dwarf",
      skill: 72,
      spell: 92,
      skillMax: 100,
      spellMax: 85
  }, {
      name: "elf",
      skill: 96,
      spell: 80,
      skillMax: 95,
      spellMax: 95
  }, {
      name: "ent",
      skill: 104,
      spell: 80,
      skillMax: 90,
      spellMax: 95
  }, {
      name: "faerie",
      skill: 88,
      spell: 72,
      skillMax: 95,
      spellMax: 100
  }, {
      name: "gargoyle",
      skill: 80,
      spell: 72,
      skillMax: 90,
      spellMax: 95
  }, {
      name: "giant",
      skill: 100,
      spell: 160,
      skillMax: 95,
      spellMax: 20
  }, {
      name: "gnoll",
      skill: 92,
      spell: 108,
      skillMax: 100,
      spellMax: 90
  }, {
      name: "gnome",
      skill: 84,
      spell: 80,
      skillMax: 85,
      spellMax: 95
  }, {
      name: "goblin",
      skill: 80,
      spell: 128,
      skillMax: 95,
      spellMax: 60
  }, {
      name: "grorrark",
      skill: 76,
      spell: 128,
      skillMax: 100,
      spellMax: 80
  }, {
      name: "halfelf",
      skill: 84,
      spell: 76,
      skillMax: 95,
      spellMax: 95
  }, {
      name: "hobbit",
      skill: 76,
      spell: 96,
      skillMax: 100,
      spellMax: 75
  }, {
      name: "human",
      skill: 80,
      spell: 80,
      skillMax: 95,
      spellMax: 95
  }, {
      name: "kobold",
      skill: 80,
      spell: 84,
      skillMax: 90,
      spellMax: 75
  }, {
      name: "leprechaun",
      skill: 84,
      spell: 72,
      skillMax: 80,
      spellMax: 90
  }, {
      name: "lizardman",
      skill: 88,
      spell: 96,
      skillMax: 95,
      spellMax: 90
  }, {
      name: "mindflayer",
      skill: 112,
      spell: 72,
      skillMax: 90,
      spellMax: 100
  }, {
      name: "minotaur",
      skill: 80,
      spell: 120,
      skillMax: 100,
      spellMax: 50
  }, {
      name: "ogier",
      skill: 92,
      spell: 112,
      skillMax: 95,
      spellMax: 60
  }, {
      name: "phoenix",
      skill: 92,
      spell: 76,
      skillMax: 90,
      spellMax: 95
  }, {
      name: "snakeman",
      skill: 96,
      spell: 72,
      skillMax: 95,
      spellMax: 100
  }, {
      name: "thrikhren",
      skill: 88,
      spell: 80,
      skillMax: 95,
      spellMax: 95
  }, {
      name: "troll",
      skill: 104,
      spell: 160,
      skillMax: 90,
      spellMax: 10
  }, {
      name: "vampire",
      skill: 88,
      spell: 80,
      skillMax: 95,
      spellMax: 100
  }, {
      name: "vinnipier",
      skill: 80,
      spell: 80,
      skillMax: 100,
      spellMax: 80
  }, {
      name: "xorn",
      skill: 88,
      spell: 160,
      skillMax: 90,
      spellMax: 25
  } ];
  var getSpellMultiplier = function (i) {
      var v = Data_Array.index(races)(i);
      if (v instanceof Data_Maybe.Just) {
          return Data_BigInt.fromInt(v.value0.spell);
      };
      if (v instanceof Data_Maybe.Nothing) {
          return Data_BigInt.fromInt(0);
      };
      throw new Error("Failed pattern match at Races (line 51, column 24 - line 53, column 23): " + [ v.constructor.name ]);
  };
  var getSpellMax = function (i) {
      var v = Data_Array.index(races)(i);
      if (v instanceof Data_Maybe.Just) {
          return v.value0.spellMax;
      };
      if (v instanceof Data_Maybe.Nothing) {
          return 0;
      };
      throw new Error("Failed pattern match at Races (line 61, column 17 - line 63, column 15): " + [ v.constructor.name ]);
  };
  var getSkillMultiplier = function (i) {
      var v = Data_Array.index(races)(i);
      if (v instanceof Data_Maybe.Just) {
          return Data_BigInt.fromInt(v.value0.skill);
      };
      if (v instanceof Data_Maybe.Nothing) {
          return Data_BigInt.fromInt(0);
      };
      throw new Error("Failed pattern match at Races (line 46, column 24 - line 48, column 23): " + [ v.constructor.name ]);
  };
  var getSkillMax = function (i) {
      var v = Data_Array.index(races)(i);
      if (v instanceof Data_Maybe.Just) {
          return v.value0.skillMax;
      };
      if (v instanceof Data_Maybe.Nothing) {
          return 0;
      };
      throw new Error("Failed pattern match at Races (line 56, column 17 - line 58, column 15): " + [ v.constructor.name ]);
  };
  exports["races"] = races;
  exports["getSkillMultiplier"] = getSkillMultiplier;
  exports["getSpellMultiplier"] = getSpellMultiplier;
  exports["getSkillMax"] = getSkillMax;
  exports["getSpellMax"] = getSpellMax;
})(PS);
(function(exports) {
  'use strict'

  exports.formatNumber = function (str) {
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
})(PS["Util"] = PS["Util"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Util"] = $PS["Util"] || {};
  var exports = $PS["Util"];
  var $foreign = $PS["Util"];
  exports["formatNumber"] = $foreign.formatNumber;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["App.Estimator"] = $PS["App.Estimator"] || {};
  var exports = $PS["App.Estimator"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_State_Class = $PS["Control.Monad.State.Class"];
  var DOM_HTML_Indexed_InputType = $PS["DOM.HTML.Indexed.InputType"];
  var Data_Array = $PS["Data.Array"];
  var Data_BigInt = $PS["Data.BigInt"];
  var Data_EuclideanRing = $PS["Data.EuclideanRing"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Int = $PS["Data.Int"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_Map_Internal = $PS["Data.Map.Internal"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Semiring = $PS["Data.Semiring"];
  var Data_Show = $PS["Data.Show"];
  var GuildComponent = $PS["GuildComponent"];
  var Guilds = $PS["Guilds"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_HTML = $PS["Halogen.HTML"];
  var Halogen_HTML_Core = $PS["Halogen.HTML.Core"];
  var Halogen_HTML_Elements = $PS["Halogen.HTML.Elements"];
  var Halogen_HTML_Events = $PS["Halogen.HTML.Events"];
  var Halogen_HTML_Properties = $PS["Halogen.HTML.Properties"];
  var Halogen_Query = $PS["Halogen.Query"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var Level = $PS["Level"];
  var Races = $PS["Races"];
  var Trainable = $PS["Trainable"];
  var Type_Proxy = $PS["Type.Proxy"];
  var Util = $PS["Util"];                
  var SetLevel = (function () {
      function SetLevel(value0) {
          this.value0 = value0;
      };
      SetLevel.create = function (value0) {
          return new SetLevel(value0);
      };
      return SetLevel;
  })();
  var SetRace = (function () {
      function SetRace(value0) {
          this.value0 = value0;
      };
      SetRace.create = function (value0) {
          return new SetRace(value0);
      };
      return SetRace;
  })();
  var SetGuild = (function () {
      function SetGuild(value0) {
          this.value0 = value0;
      };
      SetGuild.create = function (value0) {
          return new SetGuild(value0);
      };
      return SetGuild;
  })();
  var SetGSM = (function () {
      function SetGSM(value0) {
          this.value0 = value0;
      };
      SetGSM.create = function (value0) {
          return new SetGSM(value0);
      };
      return SetGSM;
  })();
  var SetLSM = (function () {
      function SetLSM(value0) {
          this.value0 = value0;
      };
      SetLSM.create = function (value0) {
          return new SetLSM(value0);
      };
      return SetLSM;
  })();
  var SetGSpM = (function () {
      function SetGSpM(value0) {
          this.value0 = value0;
      };
      SetGSpM.create = function (value0) {
          return new SetGSpM(value0);
      };
      return SetGSpM;
  })();
  var SetLSpM = (function () {
      function SetLSpM(value0) {
          this.value0 = value0;
      };
      SetLSpM.create = function (value0) {
          return new SetLSpM(value0);
      };
      return SetLSpM;
  })();
  var HandleNotification = (function () {
      function HandleNotification(value0) {
          this.value0 = value0;
      };
      HandleNotification.create = function (value0) {
          return new HandleNotification(value0);
      };
      return HandleNotification;
  })();
  var sumTrainables = function (arr) {
      return Data_Array.foldl(Data_Semiring.add(Data_BigInt.semiringBigInt))(Data_BigInt.fromInt(0))(arr);
  };
  var sumAll = function (arr) {
      return Data_Array.foldl(Data_Semiring.add(Data_BigInt.semiringBigInt))(Data_BigInt.fromInt(0))(Data_Functor.map(Data_Functor.functorArray)(function (nums) {
          return sumTrainables(Data_Array.fromFoldable(Data_List_Types.foldableList)(Data_Map_Internal.values(nums)));
      })(arr));
  };
  var indexToString = function (index) {
      var v = Data_Int.radix(10);
      if (v instanceof Data_Maybe.Just) {
          return Data_Int.toStringAs(v.value0)(index);
      };
      if (v instanceof Data_Maybe.Nothing) {
          return "0";
      };
      throw new Error("Failed pattern match at App.Estimator (line 26, column 23 - line 28, column 17): " + [ v.constructor.name ]);
  };
  var _guildComponent = Type_Proxy["Proxy"].value;
  var handleAction = function (v) {
      if (v instanceof SetLevel) {
          var v1 = Data_Int.fromString(v.value0);
          if (v1 instanceof Data_Maybe.Nothing) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
                  var $28 = {};
                  for (var $29 in st) {
                      if ({}.hasOwnProperty.call(st, $29)) {
                          $28[$29] = st[$29];
                      };
                  };
                  $28.level = st.level;
                  return $28;
              });
          };
          if (v1 instanceof Data_Maybe.Just) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                  var $31 = {};
                  for (var $32 in v2) {
                      if ({}.hasOwnProperty.call(v2, $32)) {
                          $31[$32] = v2[$32];
                      };
                  };
                  $31.level = v1.value0;
                  return $31;
              });
          };
          throw new Error("Failed pattern match at App.Estimator (line 137, column 21 - line 139, column 40): " + [ v1.constructor.name ]);
      };
      if (v instanceof SetRace) {
          var v1 = Data_Int.fromString(v.value0);
          if (v1 instanceof Data_Maybe.Nothing) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
                  var $37 = {};
                  for (var $38 in st) {
                      if ({}.hasOwnProperty.call(st, $38)) {
                          $37[$38] = st[$38];
                      };
                  };
                  $37.race = st.race;
                  return $37;
              });
          };
          if (v1 instanceof Data_Maybe.Just) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                  var $40 = {};
                  for (var $41 in v2) {
                      if ({}.hasOwnProperty.call(v2, $41)) {
                          $40[$41] = v2[$41];
                      };
                  };
                  $40.race = v1.value0;
                  return $40;
              });
          };
          throw new Error("Failed pattern match at App.Estimator (line 140, column 25 - line 142, column 39): " + [ v1.constructor.name ]);
      };
      if (v instanceof SetGuild) {
          var v1 = Data_Int.fromString(v.value0);
          if (v1 instanceof Data_Maybe.Nothing) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
                  var $46 = {};
                  for (var $47 in st) {
                      if ({}.hasOwnProperty.call(st, $47)) {
                          $46[$47] = st[$47];
                      };
                  };
                  $46.guild = st.guild;
                  return $46;
              });
          };
          if (v1 instanceof Data_Maybe.Just) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                  var $49 = {};
                  for (var $50 in v2) {
                      if ({}.hasOwnProperty.call(v2, $50)) {
                          $49[$50] = v2[$50];
                      };
                  };
                  $49.guild = v1.value0;
                  return $49;
              });
          };
          throw new Error("Failed pattern match at App.Estimator (line 143, column 27 - line 145, column 40): " + [ v1.constructor.name ]);
      };
      if (v instanceof SetGSM) {
          if (v.value0) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
                  var $55 = {};
                  for (var $56 in st) {
                      if ({}.hasOwnProperty.call(st, $56)) {
                          $55[$56] = st[$56];
                      };
                  };
                  $55.skillWishes = st.skillWishes + 10 | 0;
                  return $55;
              });
          };
          if (!v.value0) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
                  var $58 = {};
                  for (var $59 in st) {
                      if ({}.hasOwnProperty.call(st, $59)) {
                          $58[$59] = st[$59];
                      };
                  };
                  $58.skillWishes = st.skillWishes - 10 | 0;
                  return $58;
              });
          };
          throw new Error("Failed pattern match at App.Estimator (line 146, column 19 - line 148, column 70): " + [ v.value0.constructor.name ]);
      };
      if (v instanceof SetLSM) {
          if (v.value0) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
                  var $63 = {};
                  for (var $64 in st) {
                      if ({}.hasOwnProperty.call(st, $64)) {
                          $63[$64] = st[$64];
                      };
                  };
                  $63.skillWishes = st.skillWishes + 5 | 0;
                  return $63;
              });
          };
          if (!v.value0) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
                  var $66 = {};
                  for (var $67 in st) {
                      if ({}.hasOwnProperty.call(st, $67)) {
                          $66[$67] = st[$67];
                      };
                  };
                  $66.skillWishes = st.skillWishes - 5 | 0;
                  return $66;
              });
          };
          throw new Error("Failed pattern match at App.Estimator (line 149, column 19 - line 151, column 69): " + [ v.value0.constructor.name ]);
      };
      if (v instanceof SetGSpM) {
          if (v.value0) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
                  var $71 = {};
                  for (var $72 in st) {
                      if ({}.hasOwnProperty.call(st, $72)) {
                          $71[$72] = st[$72];
                      };
                  };
                  $71.spellWishes = st.spellWishes + 10 | 0;
                  return $71;
              });
          };
          if (!v.value0) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
                  var $74 = {};
                  for (var $75 in st) {
                      if ({}.hasOwnProperty.call(st, $75)) {
                          $74[$75] = st[$75];
                      };
                  };
                  $74.spellWishes = st.spellWishes - 10 | 0;
                  return $74;
              });
          };
          throw new Error("Failed pattern match at App.Estimator (line 152, column 20 - line 154, column 70): " + [ v.value0.constructor.name ]);
      };
      if (v instanceof SetLSpM) {
          if (v.value0) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
                  var $79 = {};
                  for (var $80 in st) {
                      if ({}.hasOwnProperty.call(st, $80)) {
                          $79[$80] = st[$80];
                      };
                  };
                  $79.spellWishes = st.spellWishes + 5 | 0;
                  return $79;
              });
          };
          if (!v.value0) {
              return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
                  var $82 = {};
                  for (var $83 in st) {
                      if ({}.hasOwnProperty.call(st, $83)) {
                          $82[$83] = st[$83];
                      };
                  };
                  $82.spellWishes = st.spellWishes - 5 | 0;
                  return $82;
              });
          };
          throw new Error("Failed pattern match at App.Estimator (line 155, column 20 - line 157, column 69): " + [ v.value0.constructor.name ]);
      };
      if (v instanceof HandleNotification) {
          if (v.value0 instanceof Trainable.Changed) {
              return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query.requestAll()({
                  reflectSymbol: function () {
                      return "guildComponent";
                  }
              })(Data_Ord.ordString)(_guildComponent)(GuildComponent.GetSkillExp.create))(function (exp) {
                  return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                      var $87 = {};
                      for (var $88 in v1) {
                          if ({}.hasOwnProperty.call(v1, $88)) {
                              $87[$88] = v1[$88];
                          };
                      };
                      $87.skillExp = sumAll(Data_Array.fromFoldable(Data_List_Types.foldableList)(Data_Map_Internal.values(exp)));
                      return $87;
                  });
              });
          };
          if (v.value0 instanceof Trainable.SpellChanged) {
              return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query.requestAll()({
                  reflectSymbol: function () {
                      return "guildComponent";
                  }
              })(Data_Ord.ordString)(_guildComponent)(GuildComponent.GetSpellExp.create))(function (exp) {
                  return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                      var $90 = {};
                      for (var $91 in v1) {
                          if ({}.hasOwnProperty.call(v1, $91)) {
                              $90[$91] = v1[$91];
                          };
                      };
                      $90.spellExp = sumAll(Data_Array.fromFoldable(Data_List_Types.foldableList)(Data_Map_Internal.values(exp)));
                      return $90;
                  });
              });
          };
          throw new Error("Failed pattern match at App.Estimator (line 159, column 5 - line 165, column 72): " + [ v.value0.constructor.name ]);
      };
      throw new Error("Failed pattern match at App.Estimator (line 136, column 16 - line 165, column 72): " + [ v.constructor.name ]);
  };
  var render = function (state) {
      return Halogen_HTML_Elements.div_([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.style("position: sticky; top: 0; border-bottom: 1px solid; width: 100%; background-color: white") ])([ Halogen_HTML_Elements.h2_([ Halogen_HTML_Core.text("Reinc Helper <alpha> by Nomz") ]), Halogen_HTML_Elements.p_([ Halogen_HTML_Core.text("Total exp required: " + Util.formatNumber(Data_BigInt.toString(Data_Semiring.add(Data_BigInt.semiringBigInt)(Data_Semiring.add(Data_BigInt.semiringBigInt)(Level.sumLevels(state.level))(Data_EuclideanRing.div(Data_BigInt.euclideanRingBigInt)(Data_Semiring.mul(Data_BigInt.semiringBigInt)(state.skillExp)(Races.getSkillMultiplier(state.race)))(Data_BigInt.fromInt(100))))(Data_EuclideanRing.div(Data_BigInt.euclideanRingBigInt)(Data_Semiring.mul(Data_BigInt.semiringBigInt)(state.spellExp)(Races.getSpellMultiplier(state.race)))(Data_BigInt.fromInt(100)))))) ]) ]), Halogen_HTML_Elements.label([ Halogen_HTML_Properties["for"]("lvl") ])([ Halogen_HTML_Core.text("Level: ") ]), Halogen_HTML_Elements.input([ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputNumber.value), Halogen_HTML_Properties.min(1.0), Halogen_HTML_Properties.id("lvl"), Halogen_HTML_Properties.name("lvl"), Halogen_HTML_Events.onValueInput(function (str) {
          return new SetLevel(str);
      }) ]), Halogen_HTML_Elements.label([ Halogen_HTML_Properties["for"]("race") ])([ Halogen_HTML_Core.text(" Race: ") ]), Halogen_HTML_Elements.select([ Halogen_HTML_Properties.id("race"), Halogen_HTML_Events.onValueChange(function (str) {
          return new SetRace(str);
      }) ])(Data_Array.mapWithIndex(function (index) {
          return function (race) {
              return Halogen_HTML_Elements.option([ Halogen_HTML_Properties.value(indexToString(index)) ])([ Halogen_HTML_Core.text(race.name) ]);
          };
      })(Races.races)), Halogen_HTML_Elements.label([ Halogen_HTML_Properties["for"]("guild") ])([ Halogen_HTML_Core.text(" Guild: ") ]), Halogen_HTML_Elements.select([ Halogen_HTML_Properties.id("guild"), Halogen_HTML_Events.onValueChange(function (str) {
          return new SetGuild(str);
      }) ])(Data_Array.mapWithIndex(function (index) {
          return function (v) {
              return Halogen_HTML_Elements.option([ Halogen_HTML_Properties.value(indexToString(index)) ])([ Halogen_HTML_Core.text(Guilds.getGuildName(index)) ]);
          };
      })(Guilds.guilds)), Halogen_HTML_Elements.p_([ Halogen_HTML_Core.text("") ]), Halogen_HTML_Elements.input([ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputCheckbox.value), Halogen_HTML_Properties.name("gsm"), Halogen_HTML_Properties.checked(true), Halogen_HTML_Events.onChecked(function (e) {
          return new SetGSM(e);
      }) ]), Halogen_HTML_Elements.label([ Halogen_HTML_Properties["for"]("gsm") ])([ Halogen_HTML_Core.text("Greater skill max") ]), Halogen_HTML_Elements.input([ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputCheckbox.value), Halogen_HTML_Properties.name("lsm"), Halogen_HTML_Properties.checked(true), Halogen_HTML_Events.onChecked(function (e) {
          return new SetLSM(e);
      }) ]), Halogen_HTML_Elements.label([ Halogen_HTML_Properties["for"]("lsm") ])([ Halogen_HTML_Core.text("Lesser skill max") ]), Halogen_HTML_Elements.input([ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputCheckbox.value), Halogen_HTML_Properties.name("gspm"), Halogen_HTML_Properties.checked(true), Halogen_HTML_Events.onChecked(function (e) {
          return new SetGSpM(e);
      }) ]), Halogen_HTML_Elements.label([ Halogen_HTML_Properties["for"]("gspm") ])([ Halogen_HTML_Core.text("Greater spell max") ]), Halogen_HTML_Elements.input([ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputCheckbox.value), Halogen_HTML_Properties.name("lspm"), Halogen_HTML_Properties.checked(true), Halogen_HTML_Events.onChecked(function (e) {
          return new SetLSpM(e);
      }) ]), Halogen_HTML_Elements.label([ Halogen_HTML_Properties["for"]("lspm") ])([ Halogen_HTML_Core.text("Lesser spell max") ]), Halogen_HTML_Elements.div_(Data_Array.mapWithIndex(function (i) {
          return function (g) {
              return Halogen_HTML.slot()({
                  reflectSymbol: function () {
                      return "guildComponent";
                  }
              })(Data_Ord.ordString)(_guildComponent)(Data_Show.show(Data_Show.showInt)(i))(GuildComponent.guildComponent)({
                  skillMax: Races.getSkillMax(state.race),
                  spellMax: Races.getSpellMax(state.race),
                  skillWishes: state.skillWishes,
                  spellWishes: state.spellWishes,
                  guild: g
              })(HandleNotification.create);
          };
      })(Guilds.getGuild(state.guild))) ]);
  };
  var component = Halogen_Component.mkComponent({
      initialState: function (v) {
          return {
              level: 1,
              race: 0,
              guild: 0,
              skillWishes: 15,
              spellWishes: 15,
              skillExp: Data_BigInt.fromInt(0),
              spellExp: Data_BigInt.fromInt(0)
          };
      },
      render: render,
      "eval": Halogen_Component.mkEval({
          handleAction: handleAction,
          handleQuery: Halogen_Component.defaultEval.handleQuery,
          receive: Halogen_Component.defaultEval.receive,
          initialize: Halogen_Component.defaultEval.initialize,
          finalize: Halogen_Component.defaultEval.finalize
      })
  });
  exports["component"] = component;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Applicative.Free"] = $PS["Control.Applicative.Free"] || {};
  var exports = $PS["Control.Applicative.Free"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Apply = $PS["Control.Apply"];
  var Control_Category = $PS["Control.Category"];
  var Data_Either = $PS["Data.Either"];
  var Data_List_NonEmpty = $PS["Data.List.NonEmpty"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_NonEmpty = $PS["Data.NonEmpty"];
  var Data_Tuple = $PS["Data.Tuple"];                
  var Pure = (function () {
      function Pure(value0) {
          this.value0 = value0;
      };
      Pure.create = function (value0) {
          return new Pure(value0);
      };
      return Pure;
  })();
  var Lift = (function () {
      function Lift(value0) {
          this.value0 = value0;
      };
      Lift.create = function (value0) {
          return new Lift(value0);
      };
      return Lift;
  })();
  var Ap = (function () {
      function Ap(value0, value1) {
          this.value0 = value0;
          this.value1 = value1;
      };
      Ap.create = function (value0) {
          return function (value1) {
              return new Ap(value0, value1);
          };
      };
      return Ap;
  })();
  var mkAp = function (fba) {
      return function (fb) {
          return new Ap(fba, fb);
      };
  };
  var liftFreeAp = Lift.create;
  var goLeft = function ($copy_dictApplicative) {
      return function ($copy_fStack) {
          return function ($copy_valStack) {
              return function ($copy_nat) {
                  return function ($copy_func) {
                      return function ($copy_count) {
                          var $tco_var_dictApplicative = $copy_dictApplicative;
                          var $tco_var_fStack = $copy_fStack;
                          var $tco_var_valStack = $copy_valStack;
                          var $tco_var_nat = $copy_nat;
                          var $tco_var_func = $copy_func;
                          var $tco_done = false;
                          var $tco_result;
                          function $tco_loop(dictApplicative, fStack, valStack, nat, func, count) {
                              if (func instanceof Pure) {
                                  $tco_done = true;
                                  return new Data_Tuple.Tuple(new Data_List_Types.Cons({
                                      func: Control_Applicative.pure(dictApplicative)(func.value0),
                                      count: count
                                  }, fStack), valStack);
                              };
                              if (func instanceof Lift) {
                                  $tco_done = true;
                                  return new Data_Tuple.Tuple(new Data_List_Types.Cons({
                                      func: nat(func.value0),
                                      count: count
                                  }, fStack), valStack);
                              };
                              if (func instanceof Ap) {
                                  $tco_var_dictApplicative = dictApplicative;
                                  $tco_var_fStack = fStack;
                                  $tco_var_valStack = Data_List_NonEmpty.cons(func.value1)(valStack);
                                  $tco_var_nat = nat;
                                  $tco_var_func = func.value0;
                                  $copy_count = count + 1 | 0;
                                  return;
                              };
                              throw new Error("Failed pattern match at Control.Applicative.Free (line 102, column 41 - line 105, column 81): " + [ func.constructor.name ]);
                          };
                          while (!$tco_done) {
                              $tco_result = $tco_loop($tco_var_dictApplicative, $tco_var_fStack, $tco_var_valStack, $tco_var_nat, $tco_var_func, $copy_count);
                          };
                          return $tco_result;
                      };
                  };
              };
          };
      };
  };
  var goApply = function ($copy_dictApplicative) {
      return function ($copy_fStack) {
          return function ($copy_vals) {
              return function ($copy_gVal) {
                  var $tco_var_dictApplicative = $copy_dictApplicative;
                  var $tco_var_fStack = $copy_fStack;
                  var $tco_var_vals = $copy_vals;
                  var $tco_done = false;
                  var $tco_result;
                  function $tco_loop(dictApplicative, fStack, vals, gVal) {
                      if (fStack instanceof Data_List_Types.Nil) {
                          $tco_done = true;
                          return new Data_Either.Left(gVal);
                      };
                      if (fStack instanceof Data_List_Types.Cons) {
                          var gRes = Control_Apply.apply(dictApplicative.Apply0())(fStack.value0.func)(gVal);
                          var $14 = fStack.value0.count === 1;
                          if ($14) {
                              if (fStack.value1 instanceof Data_List_Types.Nil) {
                                  $tco_done = true;
                                  return new Data_Either.Left(gRes);
                              };
                              $tco_var_dictApplicative = dictApplicative;
                              $tco_var_fStack = fStack.value1;
                              $tco_var_vals = vals;
                              $copy_gVal = gRes;
                              return;
                          };
                          if (vals instanceof Data_List_Types.Nil) {
                              $tco_done = true;
                              return new Data_Either.Left(gRes);
                          };
                          if (vals instanceof Data_List_Types.Cons) {
                              $tco_done = true;
                              return new Data_Either.Right(new Data_Tuple.Tuple(new Data_List_Types.Cons({
                                  func: gRes,
                                  count: fStack.value0.count - 1 | 0
                              }, fStack.value1), new Data_NonEmpty.NonEmpty(vals.value0, vals.value1)));
                          };
                          throw new Error("Failed pattern match at Control.Applicative.Free (line 83, column 11 - line 88, column 50): " + [ vals.constructor.name ]);
                      };
                      throw new Error("Failed pattern match at Control.Applicative.Free (line 72, column 3 - line 88, column 50): " + [ fStack.constructor.name ]);
                  };
                  while (!$tco_done) {
                      $tco_result = $tco_loop($tco_var_dictApplicative, $tco_var_fStack, $tco_var_vals, $copy_gVal);
                  };
                  return $tco_result;
              };
          };
      };
  };
  var functorFreeAp = {
      map: function (f) {
          return function (x) {
              return mkAp(new Pure(f))(x);
          };
      }
  };
  var foldFreeAp = function (dictApplicative) {
      return function (nat) {
          return function (z) {
              var go = function ($copy_v) {
                  var $tco_done = false;
                  var $tco_result;
                  function $tco_loop(v) {
                      if (v.value1.value0 instanceof Pure) {
                          var v1 = goApply(dictApplicative)(v.value0)(v.value1.value1)(Control_Applicative.pure(dictApplicative)(v.value1.value0.value0));
                          if (v1 instanceof Data_Either.Left) {
                              $tco_done = true;
                              return v1.value0;
                          };
                          if (v1 instanceof Data_Either.Right) {
                              $copy_v = v1.value0;
                              return;
                          };
                          throw new Error("Failed pattern match at Control.Applicative.Free (line 54, column 17 - line 56, column 24): " + [ v1.constructor.name ]);
                      };
                      if (v.value1.value0 instanceof Lift) {
                          var v1 = goApply(dictApplicative)(v.value0)(v.value1.value1)(nat(v.value1.value0.value0));
                          if (v1 instanceof Data_Either.Left) {
                              $tco_done = true;
                              return v1.value0;
                          };
                          if (v1 instanceof Data_Either.Right) {
                              $copy_v = v1.value0;
                              return;
                          };
                          throw new Error("Failed pattern match at Control.Applicative.Free (line 57, column 17 - line 59, column 24): " + [ v1.constructor.name ]);
                      };
                      if (v.value1.value0 instanceof Ap) {
                          var nextVals = new Data_NonEmpty.NonEmpty(v.value1.value0.value1, v.value1.value1);
                          $copy_v = goLeft(dictApplicative)(v.value0)(nextVals)(nat)(v.value1.value0.value0)(1);
                          return;
                      };
                      throw new Error("Failed pattern match at Control.Applicative.Free (line 53, column 5 - line 62, column 47): " + [ v.value1.value0.constructor.name ]);
                  };
                  while (!$tco_done) {
                      $tco_result = $tco_loop($copy_v);
                  };
                  return $tco_result;
              };
              return go(new Data_Tuple.Tuple(Data_List_Types.Nil.value, Data_List_NonEmpty.singleton(z)));
          };
      };
  };
  var retractFreeAp = function (dictApplicative) {
      return foldFreeAp(dictApplicative)(Control_Category.identity(Control_Category.categoryFn));
  };
  var applyFreeAp = {
      apply: function (fba) {
          return function (fb) {
              return mkAp(fba)(fb);
          };
      },
      Functor0: function () {
          return functorFreeAp;
      }
  };
  var applicativeFreeAp = {
      pure: Pure.create,
      Apply0: function () {
          return applyFreeAp;
      }
  };
  var hoistFreeAp = function (f) {
      return foldFreeAp(applicativeFreeAp)(function ($37) {
          return liftFreeAp(f($37));
      });
  };
  exports["retractFreeAp"] = retractFreeAp;
  exports["hoistFreeAp"] = hoistFreeAp;
})(PS);
(function(exports) {
  /* globals setImmediate, clearImmediate, setTimeout, clearTimeout */
  /* eslint-disable no-unused-vars, no-prototype-builtins, no-use-before-define, no-unused-labels, no-param-reassign */
  "use strict";

  var Aff = function () {
    // A unique value for empty.
    var EMPTY = {};

    /*

  An awkward approximation. We elide evidence we would otherwise need in PS for
  efficiency sake.

  data Aff eff a
    = Pure a
    | Throw Error
    | Catch (Aff eff a) (Error -> Aff eff a)
    | Sync (Eff eff a)
    | Async ((Either Error a -> Eff eff Unit) -> Eff eff (Canceler eff))
    | forall b. Bind (Aff eff b) (b -> Aff eff a)
    | forall b. Bracket (Aff eff b) (BracketConditions eff b) (b -> Aff eff a)
    | forall b. Fork Boolean (Aff eff b) ?(Fiber eff b -> a)
    | Sequential (ParAff aff a)

  */  
    var PURE    = "Pure";
    var THROW   = "Throw";
    var CATCH   = "Catch";
    var SYNC    = "Sync";
    var ASYNC   = "Async";
    var BIND    = "Bind";
    var BRACKET = "Bracket";
    var FORK    = "Fork";
    var SEQ     = "Sequential";

    /*

  data ParAff eff a
    = forall b. Map (b -> a) (ParAff eff b)
    | forall b. Apply (ParAff eff (b -> a)) (ParAff eff b)
    | Alt (ParAff eff a) (ParAff eff a)
    | ?Par (Aff eff a)

  */  
    var MAP   = "Map";
    var APPLY = "Apply";
    var ALT   = "Alt";

    // Various constructors used in interpretation
    var CONS      = "Cons";      // Cons-list, for stacks
    var RESUME    = "Resume";    // Continue indiscriminately
    var RELEASE   = "Release";   // Continue with bracket finalizers
    var FINALIZER = "Finalizer"; // A non-interruptible effect
    var FINALIZED = "Finalized"; // Marker for finalization
    var FORKED    = "Forked";    // Reference to a forked fiber, with resumption stack
    var FIBER     = "Fiber";     // Actual fiber reference
    var THUNK     = "Thunk";     // Primed effect, ready to invoke

    function Aff(tag, _1, _2, _3) {
      this.tag = tag;
      this._1  = _1;
      this._2  = _2;
      this._3  = _3;
    }

    function AffCtr(tag) {
      var fn = function (_1, _2, _3) {
        return new Aff(tag, _1, _2, _3);
      };
      fn.tag = tag;
      return fn;
    }

    function nonCanceler(error) {
      return new Aff(PURE, void 0);
    }

    function runEff(eff) {
      try {
        eff();
      } catch (error) {
        setTimeout(function () {
          throw error;
        }, 0);
      }
    }

    function runSync(left, right, eff) {
      try {
        return right(eff());
      } catch (error) {
        return left(error);
      }
    }

    function runAsync(left, eff, k) {
      try {
        return eff(k)();
      } catch (error) {
        k(left(error))();
        return nonCanceler;
      }
    }

    var Scheduler = function () {
      var limit    = 1024;
      var size     = 0;
      var ix       = 0;
      var queue    = new Array(limit);
      var draining = false;

      function drain() {
        var thunk;
        draining = true;
        while (size !== 0) {
          size--;
          thunk     = queue[ix];
          queue[ix] = void 0;
          ix        = (ix + 1) % limit;
          thunk();
        }
        draining = false;
      }

      return {
        isDraining: function () {
          return draining;
        },
        enqueue: function (cb) {
          var i, tmp;
          if (size === limit) {
            tmp = draining;
            drain();
            draining = tmp;
          }

          queue[(ix + size) % limit] = cb;
          size++;

          if (!draining) {
            drain();
          }
        }
      };
    }();

    function Supervisor(util) {
      var fibers  = {};
      var fiberId = 0;
      var count   = 0;

      return {
        register: function (fiber) {
          var fid = fiberId++;
          fiber.onComplete({
            rethrow: true,
            handler: function (result) {
              return function () {
                count--;
                delete fibers[fid];
              };
            }
          })();
          fibers[fid] = fiber;
          count++;
        },
        isEmpty: function () {
          return count === 0;
        },
        killAll: function (killError, cb) {
          return function () {
            if (count === 0) {
              return cb();
            }

            var killCount = 0;
            var kills     = {};

            function kill(fid) {
              kills[fid] = fibers[fid].kill(killError, function (result) {
                return function () {
                  delete kills[fid];
                  killCount--;
                  if (util.isLeft(result) && util.fromLeft(result)) {
                    setTimeout(function () {
                      throw util.fromLeft(result);
                    }, 0);
                  }
                  if (killCount === 0) {
                    cb();
                  }
                };
              })();
            }

            for (var k in fibers) {
              if (fibers.hasOwnProperty(k)) {
                killCount++;
                kill(k);
              }
            }

            fibers  = {};
            fiberId = 0;
            count   = 0;

            return function (error) {
              return new Aff(SYNC, function () {
                for (var k in kills) {
                  if (kills.hasOwnProperty(k)) {
                    kills[k]();
                  }
                }
              });
            };
          };
        }
      };
    }

    // Fiber state machine
    var SUSPENDED   = 0; // Suspended, pending a join.
    var CONTINUE    = 1; // Interpret the next instruction.
    var STEP_BIND   = 2; // Apply the next bind.
    var STEP_RESULT = 3; // Handle potential failure from a result.
    var PENDING     = 4; // An async effect is running.
    var RETURN      = 5; // The current stack has returned.
    var COMPLETED   = 6; // The entire fiber has completed.

    function Fiber(util, supervisor, aff) {
      // Monotonically increasing tick, increased on each asynchronous turn.
      var runTick = 0;

      // The current branch of the state machine.
      var status = SUSPENDED;

      // The current point of interest for the state machine branch.
      var step      = aff;  // Successful step
      var fail      = null; // Failure step
      var interrupt = null; // Asynchronous interrupt

      // Stack of continuations for the current fiber.
      var bhead = null;
      var btail = null;

      // Stack of attempts and finalizers for error recovery. Every `Cons` is also
      // tagged with current `interrupt` state. We use this to track which items
      // should be ignored or evaluated as a result of a kill.
      var attempts = null;

      // A special state is needed for Bracket, because it cannot be killed. When
      // we enter a bracket acquisition or finalizer, we increment the counter,
      // and then decrement once complete.
      var bracketCount = 0;

      // Each join gets a new id so they can be revoked.
      var joinId  = 0;
      var joins   = null;
      var rethrow = true;

      // Each invocation of `run` requires a tick. When an asynchronous effect is
      // resolved, we must check that the local tick coincides with the fiber
      // tick before resuming. This prevents multiple async continuations from
      // accidentally resuming the same fiber. A common example may be invoking
      // the provided callback in `makeAff` more than once, but it may also be an
      // async effect resuming after the fiber was already cancelled.
      function run(localRunTick) {
        var tmp, result, attempt;
        while (true) {
          tmp       = null;
          result    = null;
          attempt   = null;

          switch (status) {
          case STEP_BIND:
            status = CONTINUE;
            try {
              step   = bhead(step);
              if (btail === null) {
                bhead = null;
              } else {
                bhead = btail._1;
                btail = btail._2;
              }
            } catch (e) {
              status = RETURN;
              fail   = util.left(e);
              step   = null;
            }
            break;

          case STEP_RESULT:
            if (util.isLeft(step)) {
              status = RETURN;
              fail   = step;
              step   = null;
            } else if (bhead === null) {
              status = RETURN;
            } else {
              status = STEP_BIND;
              step   = util.fromRight(step);
            }
            break;

          case CONTINUE:
            switch (step.tag) {
            case BIND:
              if (bhead) {
                btail = new Aff(CONS, bhead, btail);
              }
              bhead  = step._2;
              status = CONTINUE;
              step   = step._1;
              break;

            case PURE:
              if (bhead === null) {
                status = RETURN;
                step   = util.right(step._1);
              } else {
                status = STEP_BIND;
                step   = step._1;
              }
              break;

            case SYNC:
              status = STEP_RESULT;
              step   = runSync(util.left, util.right, step._1);
              break;

            case ASYNC:
              status = PENDING;
              step   = runAsync(util.left, step._1, function (result) {
                return function () {
                  if (runTick !== localRunTick) {
                    return;
                  }
                  runTick++;
                  Scheduler.enqueue(function () {
                    // It's possible to interrupt the fiber between enqueuing and
                    // resuming, so we need to check that the runTick is still
                    // valid.
                    if (runTick !== localRunTick + 1) {
                      return;
                    }
                    status = STEP_RESULT;
                    step   = result;
                    run(runTick);
                  });
                };
              });
              return;

            case THROW:
              status = RETURN;
              fail   = util.left(step._1);
              step   = null;
              break;

            // Enqueue the Catch so that we can call the error handler later on
            // in case of an exception.
            case CATCH:
              if (bhead === null) {
                attempts = new Aff(CONS, step, attempts, interrupt);
              } else {
                attempts = new Aff(CONS, step, new Aff(CONS, new Aff(RESUME, bhead, btail), attempts, interrupt), interrupt);
              }
              bhead    = null;
              btail    = null;
              status   = CONTINUE;
              step     = step._1;
              break;

            // Enqueue the Bracket so that we can call the appropriate handlers
            // after resource acquisition.
            case BRACKET:
              bracketCount++;
              if (bhead === null) {
                attempts = new Aff(CONS, step, attempts, interrupt);
              } else {
                attempts = new Aff(CONS, step, new Aff(CONS, new Aff(RESUME, bhead, btail), attempts, interrupt), interrupt);
              }
              bhead  = null;
              btail  = null;
              status = CONTINUE;
              step   = step._1;
              break;

            case FORK:
              status = STEP_RESULT;
              tmp    = Fiber(util, supervisor, step._2);
              if (supervisor) {
                supervisor.register(tmp);
              }
              if (step._1) {
                tmp.run();
              }
              step = util.right(tmp);
              break;

            case SEQ:
              status = CONTINUE;
              step   = sequential(util, supervisor, step._1);
              break;
            }
            break;

          case RETURN:
            bhead = null;
            btail = null;
            // If the current stack has returned, and we have no other stacks to
            // resume or finalizers to run, the fiber has halted and we can
            // invoke all join callbacks. Otherwise we need to resume.
            if (attempts === null) {
              status = COMPLETED;
              step   = interrupt || fail || step;
            } else {
              // The interrupt status for the enqueued item.
              tmp      = attempts._3;
              attempt  = attempts._1;
              attempts = attempts._2;

              switch (attempt.tag) {
              // We cannot recover from an unmasked interrupt. Otherwise we should
              // continue stepping, or run the exception handler if an exception
              // was raised.
              case CATCH:
                // We should compare the interrupt status as well because we
                // only want it to apply if there has been an interrupt since
                // enqueuing the catch.
                if (interrupt && interrupt !== tmp && bracketCount === 0) {
                  status = RETURN;
                } else if (fail) {
                  status = CONTINUE;
                  step   = attempt._2(util.fromLeft(fail));
                  fail   = null;
                }
                break;

              // We cannot resume from an unmasked interrupt or exception.
              case RESUME:
                // As with Catch, we only want to ignore in the case of an
                // interrupt since enqueing the item.
                if (interrupt && interrupt !== tmp && bracketCount === 0 || fail) {
                  status = RETURN;
                } else {
                  bhead  = attempt._1;
                  btail  = attempt._2;
                  status = STEP_BIND;
                  step   = util.fromRight(step);
                }
                break;

              // If we have a bracket, we should enqueue the handlers,
              // and continue with the success branch only if the fiber has
              // not been interrupted. If the bracket acquisition failed, we
              // should not run either.
              case BRACKET:
                bracketCount--;
                if (fail === null) {
                  result   = util.fromRight(step);
                  // We need to enqueue the Release with the same interrupt
                  // status as the Bracket that is initiating it.
                  attempts = new Aff(CONS, new Aff(RELEASE, attempt._2, result), attempts, tmp);
                  // We should only coninue as long as the interrupt status has not changed or
                  // we are currently within a non-interruptable finalizer.
                  if (interrupt === tmp || bracketCount > 0) {
                    status = CONTINUE;
                    step   = attempt._3(result);
                  }
                }
                break;

              // Enqueue the appropriate handler. We increase the bracket count
              // because it should not be cancelled.
              case RELEASE:
                attempts = new Aff(CONS, new Aff(FINALIZED, step, fail), attempts, interrupt);
                status   = CONTINUE;
                // It has only been killed if the interrupt status has changed
                // since we enqueued the item, and the bracket count is 0. If the
                // bracket count is non-zero then we are in a masked state so it's
                // impossible to be killed.
                if (interrupt && interrupt !== tmp && bracketCount === 0) {
                  step = attempt._1.killed(util.fromLeft(interrupt))(attempt._2);
                } else if (fail) {
                  step = attempt._1.failed(util.fromLeft(fail))(attempt._2);
                } else {
                  step = attempt._1.completed(util.fromRight(step))(attempt._2);
                }
                fail = null;
                bracketCount++;
                break;

              case FINALIZER:
                bracketCount++;
                attempts = new Aff(CONS, new Aff(FINALIZED, step, fail), attempts, interrupt);
                status   = CONTINUE;
                step     = attempt._1;
                break;

              case FINALIZED:
                bracketCount--;
                status = RETURN;
                step   = attempt._1;
                fail   = attempt._2;
                break;
              }
            }
            break;

          case COMPLETED:
            for (var k in joins) {
              if (joins.hasOwnProperty(k)) {
                rethrow = rethrow && joins[k].rethrow;
                runEff(joins[k].handler(step));
              }
            }
            joins = null;
            // If we have an interrupt and a fail, then the thread threw while
            // running finalizers. This should always rethrow in a fresh stack.
            if (interrupt && fail) {
              setTimeout(function () {
                throw util.fromLeft(fail);
              }, 0);
            // If we have an unhandled exception, and no other fiber has joined
            // then we need to throw the exception in a fresh stack.
            } else if (util.isLeft(step) && rethrow) {
              setTimeout(function () {
                // Guard on reathrow because a completely synchronous fiber can
                // still have an observer which was added after-the-fact.
                if (rethrow) {
                  throw util.fromLeft(step);
                }
              }, 0);
            }
            return;
          case SUSPENDED:
            status = CONTINUE;
            break;
          case PENDING: return;
          }
        }
      }

      function onComplete(join) {
        return function () {
          if (status === COMPLETED) {
            rethrow = rethrow && join.rethrow;
            join.handler(step)();
            return function () {};
          }

          var jid    = joinId++;
          joins      = joins || {};
          joins[jid] = join;

          return function() {
            if (joins !== null) {
              delete joins[jid];
            }
          };
        };
      }

      function kill(error, cb) {
        return function () {
          if (status === COMPLETED) {
            cb(util.right(void 0))();
            return function () {};
          }

          var canceler = onComplete({
            rethrow: false,
            handler: function (/* unused */) {
              return cb(util.right(void 0));
            }
          })();

          switch (status) {
          case SUSPENDED:
            interrupt = util.left(error);
            status    = COMPLETED;
            step      = interrupt;
            run(runTick);
            break;
          case PENDING:
            if (interrupt === null) {
              interrupt = util.left(error);
            }
            if (bracketCount === 0) {
              if (status === PENDING) {
                attempts = new Aff(CONS, new Aff(FINALIZER, step(error)), attempts, interrupt);
              }
              status   = RETURN;
              step     = null;
              fail     = null;
              run(++runTick);
            }
            break;
          default:
            if (interrupt === null) {
              interrupt = util.left(error);
            }
            if (bracketCount === 0) {
              status = RETURN;
              step   = null;
              fail   = null;
            }
          }

          return canceler;
        };
      }

      function join(cb) {
        return function () {
          var canceler = onComplete({
            rethrow: false,
            handler: cb
          })();
          if (status === SUSPENDED) {
            run(runTick);
          }
          return canceler;
        };
      }

      return {
        kill: kill,
        join: join,
        onComplete: onComplete,
        isSuspended: function () {
          return status === SUSPENDED;
        },
        run: function () {
          if (status === SUSPENDED) {
            if (!Scheduler.isDraining()) {
              Scheduler.enqueue(function () {
                run(runTick);
              });
            } else {
              run(runTick);
            }
          }
        }
      };
    }

    function runPar(util, supervisor, par, cb) {
      // Table of all forked fibers.
      var fiberId   = 0;
      var fibers    = {};

      // Table of currently running cancelers, as a product of `Alt` behavior.
      var killId    = 0;
      var kills     = {};

      // Error used for early cancelation on Alt branches.
      var early     = new Error("[ParAff] Early exit");

      // Error used to kill the entire tree.
      var interrupt = null;

      // The root pointer of the tree.
      var root      = EMPTY;

      // Walks a tree, invoking all the cancelers. Returns the table of pending
      // cancellation fibers.
      function kill(error, par, cb) {
        var step  = par;
        var head  = null;
        var tail  = null;
        var count = 0;
        var kills = {};
        var tmp, kid;

        loop: while (true) {
          tmp = null;

          switch (step.tag) {
          case FORKED:
            if (step._3 === EMPTY) {
              tmp = fibers[step._1];
              kills[count++] = tmp.kill(error, function (result) {
                return function () {
                  count--;
                  if (count === 0) {
                    cb(result)();
                  }
                };
              });
            }
            // Terminal case.
            if (head === null) {
              break loop;
            }
            // Go down the right side of the tree.
            step = head._2;
            if (tail === null) {
              head = null;
            } else {
              head = tail._1;
              tail = tail._2;
            }
            break;
          case MAP:
            step = step._2;
            break;
          case APPLY:
          case ALT:
            if (head) {
              tail = new Aff(CONS, head, tail);
            }
            head = step;
            step = step._1;
            break;
          }
        }

        if (count === 0) {
          cb(util.right(void 0))();
        } else {
          // Run the cancelation effects. We alias `count` because it's mutable.
          kid = 0;
          tmp = count;
          for (; kid < tmp; kid++) {
            kills[kid] = kills[kid]();
          }
        }

        return kills;
      }

      // When a fiber resolves, we need to bubble back up the tree with the
      // result, computing the applicative nodes.
      function join(result, head, tail) {
        var fail, step, lhs, rhs, tmp, kid;

        if (util.isLeft(result)) {
          fail = result;
          step = null;
        } else {
          step = result;
          fail = null;
        }

        loop: while (true) {
          lhs = null;
          rhs = null;
          tmp = null;
          kid = null;

          // We should never continue if the entire tree has been interrupted.
          if (interrupt !== null) {
            return;
          }

          // We've made it all the way to the root of the tree, which means
          // the tree has fully evaluated.
          if (head === null) {
            cb(fail || step)();
            return;
          }

          // The tree has already been computed, so we shouldn't try to do it
          // again. This should never happen.
          // TODO: Remove this?
          if (head._3 !== EMPTY) {
            return;
          }

          switch (head.tag) {
          case MAP:
            if (fail === null) {
              head._3 = util.right(head._1(util.fromRight(step)));
              step    = head._3;
            } else {
              head._3 = fail;
            }
            break;
          case APPLY:
            lhs = head._1._3;
            rhs = head._2._3;
            // If we have a failure we should kill the other side because we
            // can't possible yield a result anymore.
            if (fail) {
              head._3 = fail;
              tmp     = true;
              kid     = killId++;

              kills[kid] = kill(early, fail === lhs ? head._2 : head._1, function (/* unused */) {
                return function () {
                  delete kills[kid];
                  if (tmp) {
                    tmp = false;
                  } else if (tail === null) {
                    join(fail, null, null);
                  } else {
                    join(fail, tail._1, tail._2);
                  }
                };
              });

              if (tmp) {
                tmp = false;
                return;
              }
            } else if (lhs === EMPTY || rhs === EMPTY) {
              // We can only proceed if both sides have resolved.
              return;
            } else {
              step    = util.right(util.fromRight(lhs)(util.fromRight(rhs)));
              head._3 = step;
            }
            break;
          case ALT:
            lhs = head._1._3;
            rhs = head._2._3;
            // We can only proceed if both have resolved or we have a success
            if (lhs === EMPTY && util.isLeft(rhs) || rhs === EMPTY && util.isLeft(lhs)) {
              return;
            }
            // If both sides resolve with an error, we should continue with the
            // first error
            if (lhs !== EMPTY && util.isLeft(lhs) && rhs !== EMPTY && util.isLeft(rhs)) {
              fail    = step === lhs ? rhs : lhs;
              step    = null;
              head._3 = fail;
            } else {
              head._3 = step;
              tmp     = true;
              kid     = killId++;
              // Once a side has resolved, we need to cancel the side that is still
              // pending before we can continue.
              kills[kid] = kill(early, step === lhs ? head._2 : head._1, function (/* unused */) {
                return function () {
                  delete kills[kid];
                  if (tmp) {
                    tmp = false;
                  } else if (tail === null) {
                    join(step, null, null);
                  } else {
                    join(step, tail._1, tail._2);
                  }
                };
              });

              if (tmp) {
                tmp = false;
                return;
              }
            }
            break;
          }

          if (tail === null) {
            head = null;
          } else {
            head = tail._1;
            tail = tail._2;
          }
        }
      }

      function resolve(fiber) {
        return function (result) {
          return function () {
            delete fibers[fiber._1];
            fiber._3 = result;
            join(result, fiber._2._1, fiber._2._2);
          };
        };
      }

      // Walks the applicative tree, substituting non-applicative nodes with
      // `FORKED` nodes. In this tree, all applicative nodes use the `_3` slot
      // as a mutable slot for memoization. In an unresolved state, the `_3`
      // slot is `EMPTY`. In the cases of `ALT` and `APPLY`, we always walk
      // the left side first, because both operations are left-associative. As
      // we `RETURN` from those branches, we then walk the right side.
      function run() {
        var status = CONTINUE;
        var step   = par;
        var head   = null;
        var tail   = null;
        var tmp, fid;

        loop: while (true) {
          tmp = null;
          fid = null;

          switch (status) {
          case CONTINUE:
            switch (step.tag) {
            case MAP:
              if (head) {
                tail = new Aff(CONS, head, tail);
              }
              head = new Aff(MAP, step._1, EMPTY, EMPTY);
              step = step._2;
              break;
            case APPLY:
              if (head) {
                tail = new Aff(CONS, head, tail);
              }
              head = new Aff(APPLY, EMPTY, step._2, EMPTY);
              step = step._1;
              break;
            case ALT:
              if (head) {
                tail = new Aff(CONS, head, tail);
              }
              head = new Aff(ALT, EMPTY, step._2, EMPTY);
              step = step._1;
              break;
            default:
              // When we hit a leaf value, we suspend the stack in the `FORKED`.
              // When the fiber resolves, it can bubble back up the tree.
              fid    = fiberId++;
              status = RETURN;
              tmp    = step;
              step   = new Aff(FORKED, fid, new Aff(CONS, head, tail), EMPTY);
              tmp    = Fiber(util, supervisor, tmp);
              tmp.onComplete({
                rethrow: false,
                handler: resolve(step)
              })();
              fibers[fid] = tmp;
              if (supervisor) {
                supervisor.register(tmp);
              }
            }
            break;
          case RETURN:
            // Terminal case, we are back at the root.
            if (head === null) {
              break loop;
            }
            // If we are done with the right side, we need to continue down the
            // left. Otherwise we should continue up the stack.
            if (head._1 === EMPTY) {
              head._1 = step;
              status  = CONTINUE;
              step    = head._2;
              head._2 = EMPTY;
            } else {
              head._2 = step;
              step    = head;
              if (tail === null) {
                head  = null;
              } else {
                head  = tail._1;
                tail  = tail._2;
              }
            }
          }
        }

        // Keep a reference to the tree root so it can be cancelled.
        root = step;

        for (fid = 0; fid < fiberId; fid++) {
          fibers[fid].run();
        }
      }

      // Cancels the entire tree. If there are already subtrees being canceled,
      // we need to first cancel those joins. We will then add fresh joins for
      // all pending branches including those that were in the process of being
      // canceled.
      function cancel(error, cb) {
        interrupt = util.left(error);
        var innerKills;
        for (var kid in kills) {
          if (kills.hasOwnProperty(kid)) {
            innerKills = kills[kid];
            for (kid in innerKills) {
              if (innerKills.hasOwnProperty(kid)) {
                innerKills[kid]();
              }
            }
          }
        }

        kills = null;
        var newKills = kill(error, root, cb);

        return function (killError) {
          return new Aff(ASYNC, function (killCb) {
            return function () {
              for (var kid in newKills) {
                if (newKills.hasOwnProperty(kid)) {
                  newKills[kid]();
                }
              }
              return nonCanceler;
            };
          });
        };
      }

      run();

      return function (killError) {
        return new Aff(ASYNC, function (killCb) {
          return function () {
            return cancel(killError, killCb);
          };
        });
      };
    }

    function sequential(util, supervisor, par) {
      return new Aff(ASYNC, function (cb) {
        return function () {
          return runPar(util, supervisor, par, cb);
        };
      });
    }

    Aff.EMPTY       = EMPTY;
    Aff.Pure        = AffCtr(PURE);
    Aff.Throw       = AffCtr(THROW);
    Aff.Catch       = AffCtr(CATCH);
    Aff.Sync        = AffCtr(SYNC);
    Aff.Async       = AffCtr(ASYNC);
    Aff.Bind        = AffCtr(BIND);
    Aff.Bracket     = AffCtr(BRACKET);
    Aff.Fork        = AffCtr(FORK);
    Aff.Seq         = AffCtr(SEQ);
    Aff.ParMap      = AffCtr(MAP);
    Aff.ParApply    = AffCtr(APPLY);
    Aff.ParAlt      = AffCtr(ALT);
    Aff.Fiber       = Fiber;
    Aff.Supervisor  = Supervisor;
    Aff.Scheduler   = Scheduler;
    Aff.nonCanceler = nonCanceler;

    return Aff;
  }();

  exports._pure = Aff.Pure;

  exports._throwError = Aff.Throw;

  exports._catchError = function (aff) {
    return function (k) {
      return Aff.Catch(aff, k);
    };
  };

  exports._map = function (f) {
    return function (aff) {
      if (aff.tag === Aff.Pure.tag) {
        return Aff.Pure(f(aff._1));
      } else {
        return Aff.Bind(aff, function (value) {
          return Aff.Pure(f(value));
        });
      }
    };
  };

  exports._bind = function (aff) {
    return function (k) {
      return Aff.Bind(aff, k);
    };
  };

  exports._fork = function (immediate) {
    return function (aff) {
      return Aff.Fork(immediate, aff);
    };
  };

  exports._liftEffect = Aff.Sync;

  exports._parAffMap = function (f) {
    return function (aff) {
      return Aff.ParMap(f, aff);
    };
  };

  exports._parAffApply = function (aff1) {
    return function (aff2) {
      return Aff.ParApply(aff1, aff2);
    };
  };

  exports.makeAff = Aff.Async;

  exports.generalBracket = function (acquire) {
    return function (options) {
      return function (k) {
        return Aff.Bracket(acquire, options, k);
      };
    };
  };

  exports._makeFiber = function (util, aff) {
    return function () {
      return Aff.Fiber(util, null, aff);
    };
  };  

  exports._sequential = Aff.Seq;
})(PS["Effect.Aff"] = PS["Effect.Aff"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Parallel.Class"] = $PS["Control.Parallel.Class"] || {};
  var exports = $PS["Control.Parallel.Class"];
  var sequential = function (dict) {
      return dict.sequential;
  };
  var parallel = function (dict) {
      return dict.parallel;
  };
  exports["parallel"] = parallel;
  exports["sequential"] = sequential;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Effect.Class"] = $PS["Effect.Class"] || {};
  var exports = $PS["Effect.Class"];
  var Control_Category = $PS["Control.Category"];
  var Effect = $PS["Effect"];                
  var monadEffectEffect = {
      liftEffect: Control_Category.identity(Control_Category.categoryFn),
      Monad0: function () {
          return Effect.monadEffect;
      }
  };
  var liftEffect = function (dict) {
      return dict.liftEffect;
  };
  exports["liftEffect"] = liftEffect;
  exports["monadEffectEffect"] = monadEffectEffect;
})(PS);
(function(exports) {
  "use strict";

  exports.unsafePerformEffect = function (f) {
    return f();
  };
})(PS["Effect.Unsafe"] = PS["Effect.Unsafe"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Effect.Unsafe"] = $PS["Effect.Unsafe"] || {};
  var exports = $PS["Effect.Unsafe"];
  var $foreign = $PS["Effect.Unsafe"];
  exports["unsafePerformEffect"] = $foreign.unsafePerformEffect;
})(PS);
(function(exports) {
  "use strict";

  // module Partial.Unsafe

  exports._unsafePartial = function (f) {
    return f();
  };
})(PS["Partial.Unsafe"] = PS["Partial.Unsafe"] || {});
(function(exports) {
  "use strict";

  // module Partial

  exports._crashWith = function (msg) {
    throw new Error(msg);
  };
})(PS["Partial"] = PS["Partial"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Partial"] = $PS["Partial"] || {};
  var exports = $PS["Partial"];
  var $foreign = $PS["Partial"];         
  var crashWith = function () {
      return $foreign["_crashWith"];
  };
  exports["crashWith"] = crashWith;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Partial.Unsafe"] = $PS["Partial.Unsafe"] || {};
  var exports = $PS["Partial.Unsafe"];
  var $foreign = $PS["Partial.Unsafe"];
  var Partial = $PS["Partial"];                
  var unsafePartial = $foreign["_unsafePartial"];
  var unsafeCrashWith = function (msg) {
      return unsafePartial(function () {
          return Partial.crashWith()(msg);
      });
  };
  exports["unsafeCrashWith"] = unsafeCrashWith;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Effect.Aff"] = $PS["Effect.Aff"] || {};
  var exports = $PS["Effect.Aff"];
  var $foreign = $PS["Effect.Aff"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad = $PS["Control.Monad"];
  var Control_Monad_Error_Class = $PS["Control.Monad.Error.Class"];
  var Control_Monad_Rec_Class = $PS["Control.Monad.Rec.Class"];
  var Control_Parallel_Class = $PS["Control.Parallel.Class"];
  var Data_Either = $PS["Data.Either"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Unit = $PS["Data.Unit"];
  var Effect = $PS["Effect"];
  var Effect_Class = $PS["Effect.Class"];
  var Effect_Unsafe = $PS["Effect.Unsafe"];
  var Partial_Unsafe = $PS["Partial.Unsafe"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var Canceler = function (x) {
      return x;
  };
  var suspendAff = $foreign["_fork"](false);
  var functorParAff = {
      map: $foreign["_parAffMap"]
  };
  var functorAff = {
      map: $foreign["_map"]
  };
  var forkAff = $foreign["_fork"](true);
  var ffiUtil = (function () {
      var unsafeFromRight = function (v) {
          if (v instanceof Data_Either.Right) {
              return v.value0;
          };
          if (v instanceof Data_Either.Left) {
              return Partial_Unsafe.unsafeCrashWith("unsafeFromRight: Left");
          };
          throw new Error("Failed pattern match at Effect.Aff (line 404, column 21 - line 406, column 54): " + [ v.constructor.name ]);
      };
      var unsafeFromLeft = function (v) {
          if (v instanceof Data_Either.Left) {
              return v.value0;
          };
          if (v instanceof Data_Either.Right) {
              return Partial_Unsafe.unsafeCrashWith("unsafeFromLeft: Right");
          };
          throw new Error("Failed pattern match at Effect.Aff (line 399, column 20 - line 401, column 54): " + [ v.constructor.name ]);
      };
      var isLeft = function (v) {
          if (v instanceof Data_Either.Left) {
              return true;
          };
          if (v instanceof Data_Either.Right) {
              return false;
          };
          throw new Error("Failed pattern match at Effect.Aff (line 394, column 12 - line 396, column 20): " + [ v.constructor.name ]);
      };
      return {
          isLeft: isLeft,
          fromLeft: unsafeFromLeft,
          fromRight: unsafeFromRight,
          left: Data_Either.Left.create,
          right: Data_Either.Right.create
      };
  })();
  var makeFiber = function (aff) {
      return $foreign["_makeFiber"](ffiUtil, aff);
  };
  var launchAff = function (aff) {
      return function __do() {
          var fiber = makeFiber(aff)();
          fiber.run();
          return fiber;
      };
  };
  var bracket = function (acquire) {
      return function (completed) {
          return $foreign.generalBracket(acquire)({
              killed: Data_Function["const"](completed),
              failed: Data_Function["const"](completed),
              completed: Data_Function["const"](completed)
          });
      };
  };
  var applyParAff = {
      apply: $foreign["_parAffApply"],
      Functor0: function () {
          return functorParAff;
      }
  };
  var monadAff = {
      Applicative0: function () {
          return applicativeAff;
      },
      Bind1: function () {
          return bindAff;
      }
  };
  var bindAff = {
      bind: $foreign["_bind"],
      Apply0: function () {
          return applyAff;
      }
  };
  var applyAff = {
      apply: Control_Monad.ap(monadAff),
      Functor0: function () {
          return functorAff;
      }
  };
  var applicativeAff = {
      pure: $foreign["_pure"],
      Apply0: function () {
          return applyAff;
      }
  };
  var $$finally = function (fin) {
      return function (a) {
          return bracket(Control_Applicative.pure(applicativeAff)(Data_Unit.unit))(Data_Function["const"](fin))(Data_Function["const"](a));
      };
  };
  var monadEffectAff = {
      liftEffect: $foreign["_liftEffect"],
      Monad0: function () {
          return monadAff;
      }
  };
  var effectCanceler = (function () {
      var $42 = Effect_Class.liftEffect(monadEffectAff);
      return function ($43) {
          return Canceler(Data_Function["const"]($42($43)));
      };
  })();
  var joinFiber = function (v) {
      return $foreign.makeAff(function (k) {
          return Data_Functor.map(Effect.functorEffect)(effectCanceler)(v.join(k));
      });
  };
  var functorFiber = {
      map: function (f) {
          return function (t) {
              return Effect_Unsafe.unsafePerformEffect(makeFiber(Data_Functor.map(functorAff)(f)(joinFiber(t))));
          };
      }
  };
  var killFiber = function (e) {
      return function (v) {
          return Control_Bind.bind(bindAff)(Effect_Class.liftEffect(monadEffectAff)(v.isSuspended))(function (v1) {
              if (v1) {
                  return Effect_Class.liftEffect(monadEffectAff)(Data_Functor["void"](Effect.functorEffect)(v.kill(e, Data_Function["const"](Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit)))));
              };
              return $foreign.makeAff(function (k) {
                  return Data_Functor.map(Effect.functorEffect)(effectCanceler)(v.kill(e, k));
              });
          });
      };
  };   
  var monadThrowAff = {
      throwError: $foreign["_throwError"],
      Monad0: function () {
          return monadAff;
      }
  };
  var monadErrorAff = {
      catchError: $foreign["_catchError"],
      MonadThrow0: function () {
          return monadThrowAff;
      }
  };                                                            
  var runAff = function (k) {
      return function (aff) {
          return launchAff(Control_Bind.bindFlipped(bindAff)((function () {
              var $46 = Effect_Class.liftEffect(monadEffectAff);
              return function ($47) {
                  return $46(k($47));
              };
          })())(Control_Monad_Error_Class["try"](monadErrorAff)(aff)));
      };
  };
  var runAff_ = function (k) {
      return function (aff) {
          return Data_Functor["void"](Effect.functorEffect)(runAff(k)(aff));
      };
  };
  var parallelAff = {
      parallel: Unsafe_Coerce.unsafeCoerce,
      sequential: $foreign["_sequential"],
      Monad0: function () {
          return monadAff;
      },
      Applicative1: function () {
          return applicativeParAff;
      }
  };
  var applicativeParAff = {
      pure: (function () {
          var $50 = Control_Parallel_Class.parallel(parallelAff);
          var $51 = Control_Applicative.pure(applicativeAff);
          return function ($52) {
              return $50($51($52));
          };
      })(),
      Apply0: function () {
          return applyParAff;
      }
  };
  var monadRecAff = {
      tailRecM: function (k) {
          var go = function (a) {
              return Control_Bind.bind(bindAff)(k(a))(function (res) {
                  if (res instanceof Control_Monad_Rec_Class.Done) {
                      return Control_Applicative.pure(applicativeAff)(res.value0);
                  };
                  if (res instanceof Control_Monad_Rec_Class.Loop) {
                      return go(res.value0);
                  };
                  throw new Error("Failed pattern match at Effect.Aff (line 102, column 7 - line 104, column 22): " + [ res.constructor.name ]);
              });
          };
          return go;
      },
      Monad0: function () {
          return monadAff;
      }
  };
  var nonCanceler = Data_Function["const"](Control_Applicative.pure(applicativeAff)(Data_Unit.unit));
  exports["runAff_"] = runAff_;
  exports["forkAff"] = forkAff;
  exports["suspendAff"] = suspendAff;
  exports["finally"] = $$finally;
  exports["killFiber"] = killFiber;
  exports["joinFiber"] = joinFiber;
  exports["nonCanceler"] = nonCanceler;
  exports["effectCanceler"] = effectCanceler;
  exports["functorAff"] = functorAff;
  exports["applicativeAff"] = applicativeAff;
  exports["bindAff"] = bindAff;
  exports["monadAff"] = monadAff;
  exports["monadRecAff"] = monadRecAff;
  exports["monadThrowAff"] = monadThrowAff;
  exports["monadEffectAff"] = monadEffectAff;
  exports["applicativeParAff"] = applicativeParAff;
  exports["parallelAff"] = parallelAff;
  exports["functorFiber"] = functorFiber;
  exports["makeAff"] = $foreign.makeAff;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Monad.Fork.Class"] = $PS["Control.Monad.Fork.Class"] || {};
  var exports = $PS["Control.Monad.Fork.Class"];
  var Effect_Aff = $PS["Effect.Aff"];
  var monadForkAff = {
      suspend: Effect_Aff.suspendAff,
      fork: Effect_Aff.forkAff,
      join: Effect_Aff.joinFiber,
      Monad0: function () {
          return Effect_Aff.monadAff;
      },
      Functor1: function () {
          return Effect_Aff.functorFiber;
      }
  };
  var fork = function (dict) {
      return dict.fork;
  };
  exports["fork"] = fork;
  exports["monadForkAff"] = monadForkAff;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Control.Parallel"] = $PS["Control.Parallel"] || {};
  var exports = $PS["Control.Parallel"];
  var Control_Category = $PS["Control.Category"];
  var Control_Parallel_Class = $PS["Control.Parallel.Class"];
  var Data_Foldable = $PS["Data.Foldable"];                      
  var parTraverse_ = function (dictParallel) {
      return function (dictFoldable) {
          return function (f) {
              var $17 = Control_Parallel_Class.sequential(dictParallel);
              var $18 = Data_Foldable.traverse_(dictParallel.Applicative1())(dictFoldable)((function () {
                  var $20 = Control_Parallel_Class.parallel(dictParallel);
                  return function ($21) {
                      return $20(f($21));
                  };
              })());
              return function ($19) {
                  return $17($18($19));
              };
          };
      };
  };
  var parSequence_ = function (dictParallel) {
      return function (dictFoldable) {
          return parTraverse_(dictParallel)(dictFoldable)(Control_Category.identity(Control_Category.categoryFn));
      };
  };
  exports["parSequence_"] = parSequence_;
})(PS);
(function(exports) {
  "use strict";

  exports.boolConj = function (b1) {
    return function (b2) {
      return b1 && b2;
    };
  };

  exports.boolDisj = function (b1) {
    return function (b2) {
      return b1 || b2;
    };
  };

  exports.boolNot = function (b) {
    return !b;
  };
})(PS["Data.HeytingAlgebra"] = PS["Data.HeytingAlgebra"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Data.HeytingAlgebra"] = $PS["Data.HeytingAlgebra"] || {};
  var exports = $PS["Data.HeytingAlgebra"];
  var $foreign = $PS["Data.HeytingAlgebra"];
  var tt = function (dict) {
      return dict.tt;
  };
  var not = function (dict) {
      return dict.not;
  };
  var implies = function (dict) {
      return dict.implies;
  };
  var ff = function (dict) {
      return dict.ff;
  };
  var disj = function (dict) {
      return dict.disj;
  };
  var heytingAlgebraBoolean = {
      ff: false,
      tt: true,
      implies: function (a) {
          return function (b) {
              return disj(heytingAlgebraBoolean)(not(heytingAlgebraBoolean)(a))(b);
          };
      },
      conj: $foreign.boolConj,
      disj: $foreign.boolDisj,
      not: $foreign.boolNot
  };
  var conj = function (dict) {
      return dict.conj;
  };
  var heytingAlgebraFunction = function (dictHeytingAlgebra) {
      return {
          ff: function (v) {
              return ff(dictHeytingAlgebra);
          },
          tt: function (v) {
              return tt(dictHeytingAlgebra);
          },
          implies: function (f) {
              return function (g) {
                  return function (a) {
                      return implies(dictHeytingAlgebra)(f(a))(g(a));
                  };
              };
          },
          conj: function (f) {
              return function (g) {
                  return function (a) {
                      return conj(dictHeytingAlgebra)(f(a))(g(a));
                  };
              };
          },
          disj: function (f) {
              return function (g) {
                  return function (a) {
                      return disj(dictHeytingAlgebra)(f(a))(g(a));
                  };
              };
          },
          not: function (f) {
              return function (a) {
                  return not(dictHeytingAlgebra)(f(a));
              };
          }
      };
  };
  exports["not"] = not;
  exports["heytingAlgebraBoolean"] = heytingAlgebraBoolean;
  exports["heytingAlgebraFunction"] = heytingAlgebraFunction;
})(PS);
(function(exports) {
  "use strict";

  exports.warn = function (s) {
    return function () {
      console.warn(s);
    };
  };
})(PS["Effect.Console"] = PS["Effect.Console"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Effect.Console"] = $PS["Effect.Console"] || {};
  var exports = $PS["Effect.Console"];
  var $foreign = $PS["Effect.Console"];
  exports["warn"] = $foreign.warn;
})(PS);
(function(exports) {
  "use strict";

  exports.error = function (msg) {
    return new Error(msg);
  };

  exports.throwException = function (e) {
    return function () {
      throw e;
    };
  };
})(PS["Effect.Exception"] = PS["Effect.Exception"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Effect.Exception"] = $PS["Effect.Exception"] || {};
  var exports = $PS["Effect.Exception"];
  var $foreign = $PS["Effect.Exception"];
  var $$throw = function ($2) {
      return $foreign.throwException($foreign.error($2));
  };
  exports["throw"] = $$throw;
  exports["error"] = $foreign.error;
  exports["throwException"] = $foreign.throwException;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.Aff.Driver.State"] = $PS["Halogen.Aff.Driver.State"] || {};
  var exports = $PS["Halogen.Aff.Driver.State"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_Map_Internal = $PS["Data.Map.Internal"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Effect_Ref = $PS["Effect.Ref"];
  var Halogen_Data_Slot = $PS["Halogen.Data.Slot"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var unRenderStateX = Unsafe_Coerce.unsafeCoerce;
  var unDriverStateX = Unsafe_Coerce.unsafeCoerce;
  var renderStateX_ = function (dictApplicative) {
      return function (f) {
          return unDriverStateX(function (st) {
              return Data_Foldable.traverse_(dictApplicative)(Data_Foldable.foldableMaybe)(f)(st.rendering);
          });
      };
  };
  var mkRenderStateX = Unsafe_Coerce.unsafeCoerce;
  var renderStateX = function (dictFunctor) {
      return function (f) {
          return unDriverStateX(function (st) {
              return mkRenderStateX(f(st.rendering));
          });
      };
  };
  var mkDriverStateXRef = Unsafe_Coerce.unsafeCoerce;
  var mapDriverState = function (f) {
      return function (v) {
          return f(v);
      };
  };
  var initDriverState = function (component) {
      return function (input) {
          return function (handler) {
              return function (lchs) {
                  return function __do() {
                      var selfRef = Effect_Ref["new"]({})();
                      var childrenIn = Effect_Ref["new"](Halogen_Data_Slot.empty)();
                      var childrenOut = Effect_Ref["new"](Halogen_Data_Slot.empty)();
                      var handlerRef = Effect_Ref["new"](handler)();
                      var pendingQueries = Effect_Ref["new"](new Data_Maybe.Just(Data_List_Types.Nil.value))();
                      var pendingOuts = Effect_Ref["new"](new Data_Maybe.Just(Data_List_Types.Nil.value))();
                      var pendingHandlers = Effect_Ref["new"](Data_Maybe.Nothing.value)();
                      var fresh = Effect_Ref["new"](1)();
                      var subscriptions = Effect_Ref["new"](new Data_Maybe.Just(Data_Map_Internal.empty))();
                      var forks = Effect_Ref["new"](Data_Map_Internal.empty)();
                      var ds = {
                          component: component,
                          state: component.initialState(input),
                          refs: Data_Map_Internal.empty,
                          children: Halogen_Data_Slot.empty,
                          childrenIn: childrenIn,
                          childrenOut: childrenOut,
                          selfRef: selfRef,
                          handlerRef: handlerRef,
                          pendingQueries: pendingQueries,
                          pendingOuts: pendingOuts,
                          pendingHandlers: pendingHandlers,
                          rendering: Data_Maybe.Nothing.value,
                          fresh: fresh,
                          subscriptions: subscriptions,
                          forks: forks,
                          lifecycleHandlers: lchs
                      };
                      Effect_Ref.write(ds)(selfRef)();
                      return mkDriverStateXRef(selfRef);
                  };
              };
          };
      };
  };
  exports["mapDriverState"] = mapDriverState;
  exports["unDriverStateX"] = unDriverStateX;
  exports["renderStateX"] = renderStateX;
  exports["renderStateX_"] = renderStateX_;
  exports["unRenderStateX"] = unRenderStateX;
  exports["initDriverState"] = initDriverState;
})(PS);
(function(exports) {
  "use strict";

  exports.reallyUnsafeRefEq = function (a) {
    return function (b) {
      return a === b;
    };
  };
})(PS["Unsafe.Reference"] = PS["Unsafe.Reference"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Unsafe.Reference"] = $PS["Unsafe.Reference"] || {};
  var exports = $PS["Unsafe.Reference"];
  var $foreign = $PS["Unsafe.Reference"];
  var unsafeRefEq = $foreign.reallyUnsafeRefEq;
  exports["unsafeRefEq"] = unsafeRefEq;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.Subscription"] = $PS["Halogen.Subscription"] || {};
  var exports = $PS["Halogen.Subscription"];
  var Control_Bind = $PS["Control.Bind"];
  var Data_Array = $PS["Data.Array"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Semigroup = $PS["Data.Semigroup"];
  var Effect = $PS["Effect"];
  var Effect_Ref = $PS["Effect.Ref"];
  var Unsafe_Reference = $PS["Unsafe.Reference"];
  var unsubscribe = function (v) {
      return v;
  };
  var subscribe = function (v) {
      return function (k) {
          return v((function () {
              var $55 = Data_Functor["void"](Effect.functorEffect);
              return function ($56) {
                  return $55(k($56));
              };
          })());
      };
  };                                                                               
  var notify = function (v) {
      return function (a) {
          return v(a);
      };
  };
  var create = function __do() {
      var subscribers = Effect_Ref["new"]([  ])();
      return {
          emitter: function (k) {
              return function __do() {
                  Effect_Ref.modify_(function (v) {
                      return Data_Semigroup.append(Data_Semigroup.semigroupArray)(v)([ k ]);
                  })(subscribers)();
                  return Effect_Ref.modify_(Data_Array.deleteBy(Unsafe_Reference.unsafeRefEq)(k))(subscribers);
              };
          },
          listener: function (a) {
              return Control_Bind.bind(Effect.bindEffect)(Effect_Ref.read(subscribers))(Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(function (k) {
                  return k(a);
              }));
          }
      };
  };
  exports["create"] = create;
  exports["notify"] = notify;
  exports["subscribe"] = subscribe;
  exports["unsubscribe"] = unsubscribe;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.Aff.Driver.Eval"] = $PS["Halogen.Aff.Driver.Eval"] || {};
  var exports = $PS["Halogen.Aff.Driver.Eval"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Applicative_Free = $PS["Control.Applicative.Free"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad = $PS["Control.Monad"];
  var Control_Monad_Fork_Class = $PS["Control.Monad.Fork.Class"];
  var Control_Monad_Free = $PS["Control.Monad.Free"];
  var Control_Parallel = $PS["Control.Parallel"];
  var Control_Parallel_Class = $PS["Control.Parallel.Class"];
  var Data_Boolean = $PS["Data.Boolean"];
  var Data_Coyoneda = $PS["Data.Coyoneda"];
  var Data_Either = $PS["Data.Either"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_Map_Internal = $PS["Data.Map.Internal"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Ord = $PS["Data.Ord"];
  var Data_Unit = $PS["Data.Unit"];
  var Effect = $PS["Effect"];
  var Effect_Aff = $PS["Effect.Aff"];
  var Effect_Class = $PS["Effect.Class"];
  var Effect_Exception = $PS["Effect.Exception"];
  var Effect_Ref = $PS["Effect.Ref"];
  var Halogen_Aff_Driver_State = $PS["Halogen.Aff.Driver.State"];
  var Halogen_Query_ChildQuery = $PS["Halogen.Query.ChildQuery"];
  var Halogen_Query_HalogenM = $PS["Halogen.Query.HalogenM"];
  var Halogen_Query_HalogenQ = $PS["Halogen.Query.HalogenQ"];
  var Halogen_Query_Input = $PS["Halogen.Query.Input"];
  var Halogen_Subscription = $PS["Halogen.Subscription"];
  var Unsafe_Reference = $PS["Unsafe.Reference"];                
  var unsubscribe = function (sid) {
      return function (ref) {
          return function __do() {
              var v = Effect_Ref.read(ref)();
              var subs = Effect_Ref.read(v.subscriptions)();
              return Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(Halogen_Subscription.unsubscribe)(Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(Data_Map_Internal.lookup(Halogen_Query_HalogenM.ordSubscriptionId)(sid))(subs))();
          };
      };
  };
  var queueOrRun = function (ref) {
      return function (au) {
          return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v) {
              if (v instanceof Data_Maybe.Nothing) {
                  return au;
              };
              if (v instanceof Data_Maybe.Just) {
                  return Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.write(new Data_Maybe.Just(new Data_List_Types.Cons(au, v.value0)))(ref));
              };
              throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 182, column 33 - line 184, column 57): " + [ v.constructor.name ]);
          });
      };
  };
  var handleLifecycle = function (lchs) {
      return function (f) {
          return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.write({
              initializers: Data_List_Types.Nil.value,
              finalizers: Data_List_Types.Nil.value
          })(lchs)))(function () {
              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(f))(function (result) {
                  return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(lchs)))(function (v) {
                      return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Data_Foldable.traverse_(Effect_Aff.applicativeAff)(Data_List_Types.foldableList)(Control_Monad_Fork_Class.fork(Control_Monad_Fork_Class.monadForkAff))(v.finalizers))(function () {
                          return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Control_Parallel.parSequence_(Effect_Aff.parallelAff)(Data_List_Types.foldableList)(v.initializers))(function () {
                              return Control_Applicative.pure(Effect_Aff.applicativeAff)(result);
                          });
                      });
                  });
              });
          });
      };
  };
  var handleAff = Effect_Aff.runAff_(Data_Either.either(Effect_Exception.throwException)(Data_Function["const"](Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit))));
  var fresh = function (f) {
      return function (ref) {
          return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v) {
              return Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref["modify'"](function (i) {
                  return {
                      state: i + 1 | 0,
                      value: f(i)
                  };
              })(v.fresh));
          });
      };
  };
  var evalQ = function (render) {
      return function (ref) {
          return function (q) {
              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v) {
                  return evalM(render)(ref)(v["component"]["eval"](new Halogen_Query_HalogenQ.Query(Data_Functor.map(Data_Coyoneda.functorCoyoneda)(Data_Maybe.Just.create)(Data_Coyoneda.liftCoyoneda(q)), Data_Function["const"](Data_Maybe.Nothing.value))));
              });
          };
      };
  };
  var evalM = function (render) {
      return function (initRef) {
          return function (v) {
              var evalChildQuery = function (ref) {
                  return function (cqb) {
                      return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v1) {
                          return Halogen_Query_ChildQuery.unChildQueryBox(function (v2) {
                              var evalChild = function (v3) {
                                  return Control_Parallel_Class.parallel(Effect_Aff.parallelAff)(Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(v3)))(function (dsx) {
                                      return Halogen_Aff_Driver_State.unDriverStateX(function (ds) {
                                          return evalQ(render)(ds.selfRef)(v2.value1);
                                      })(dsx);
                                  }));
                              };
                              return Data_Functor.map(Effect_Aff.functorAff)(v2.value2)(Control_Parallel_Class.sequential(Effect_Aff.parallelAff)(v2.value0(Effect_Aff.applicativeParAff)(evalChild)(v1.children)));
                          })(cqb);
                      });
                  };
              };
              var go = function (ref) {
                  return function (v1) {
                      if (v1 instanceof Halogen_Query_HalogenM.State) {
                          return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v2) {
                              var v3 = v1.value0(v2.state);
                              if (Unsafe_Reference.unsafeRefEq(v2.state)(v3.value1)) {
                                  return Control_Applicative.pure(Effect_Aff.applicativeAff)(v3.value0);
                              };
                              if (Data_Boolean.otherwise) {
                                  return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.write({
                                      component: v2.component,
                                      state: v3.value1,
                                      refs: v2.refs,
                                      children: v2.children,
                                      childrenIn: v2.childrenIn,
                                      childrenOut: v2.childrenOut,
                                      selfRef: v2.selfRef,
                                      handlerRef: v2.handlerRef,
                                      pendingQueries: v2.pendingQueries,
                                      pendingOuts: v2.pendingOuts,
                                      pendingHandlers: v2.pendingHandlers,
                                      rendering: v2.rendering,
                                      fresh: v2.fresh,
                                      subscriptions: v2.subscriptions,
                                      forks: v2.forks,
                                      lifecycleHandlers: v2.lifecycleHandlers
                                  })(ref)))(function () {
                                      return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(handleLifecycle(v2.lifecycleHandlers)(render(v2.lifecycleHandlers)(ref)))(function () {
                                          return Control_Applicative.pure(Effect_Aff.applicativeAff)(v3.value0);
                                      });
                                  });
                              };
                              throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 86, column 7 - line 92, column 21): " + [ v3.constructor.name ]);
                          });
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.Subscribe) {
                          return Control_Bind.bind(Effect_Aff.bindAff)(fresh(Halogen_Query_HalogenM.SubscriptionId)(ref))(function (sid) {
                              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Halogen_Subscription.subscribe(v1.value0(sid))(function (act) {
                                  return handleAff(evalF(render)(ref)(new Halogen_Query_Input.Action(act)));
                              })))(function (finalize) {
                                  return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v2) {
                                      return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.modify_(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Map_Internal.insert(Halogen_Query_HalogenM.ordSubscriptionId)(sid)(finalize)))(v2.subscriptions)))(function () {
                                          return Control_Applicative.pure(Effect_Aff.applicativeAff)(v1.value1(sid));
                                      });
                                  });
                              });
                          });
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.Unsubscribe) {
                          return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(unsubscribe(v1.value0)(ref)))(function () {
                              return Control_Applicative.pure(Effect_Aff.applicativeAff)(v1.value1);
                          });
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.Lift) {
                          return v1.value0;
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.ChildQuery) {
                          return evalChildQuery(ref)(v1.value0);
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.Raise) {
                          return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v2) {
                              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(v2.handlerRef)))(function (handler) {
                                  return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(queueOrRun(v2.pendingOuts)(handler(v1.value0)))(function () {
                                      return Control_Applicative.pure(Effect_Aff.applicativeAff)(v1.value1);
                                  });
                              });
                          });
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.Par) {
                          return Control_Parallel_Class.sequential(Effect_Aff.parallelAff)(Control_Applicative_Free.retractFreeAp(Effect_Aff.applicativeParAff)(Control_Applicative_Free.hoistFreeAp((function () {
                              var $78 = Control_Parallel_Class.parallel(Effect_Aff.parallelAff);
                              var $79 = evalM(render)(ref);
                              return function ($80) {
                                  return $78($79($80));
                              };
                          })())(v1.value0)));
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.Fork) {
                          return Control_Bind.bind(Effect_Aff.bindAff)(fresh(Halogen_Query_HalogenM.ForkId)(ref))(function (fid) {
                              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v2) {
                                  return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref["new"](false)))(function (doneRef) {
                                      return Control_Bind.bind(Effect_Aff.bindAff)(Control_Monad_Fork_Class.fork(Control_Monad_Fork_Class.monadForkAff)(Effect_Aff["finally"](Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(function __do() {
                                          Effect_Ref.modify_(Data_Map_Internal["delete"](Halogen_Query_HalogenM.ordForkId)(fid))(v2.forks)();
                                          return Effect_Ref.write(true)(doneRef)();
                                      }))(evalM(render)(ref)(v1.value0))))(function (fiber) {
                                          return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Control_Monad.unlessM(Effect.monadEffect)(Effect_Ref.read(doneRef))(Effect_Ref.modify_(Data_Map_Internal.insert(Halogen_Query_HalogenM.ordForkId)(fid)(fiber))(v2.forks))))(function () {
                                              return Control_Applicative.pure(Effect_Aff.applicativeAff)(v1.value1(fid));
                                          });
                                      });
                                  });
                              });
                          });
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.Kill) {
                          return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v2) {
                              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(v2.forks)))(function (forkMap) {
                                  return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Data_Foldable.traverse_(Effect_Aff.applicativeAff)(Data_Foldable.foldableMaybe)(Effect_Aff.killFiber(Effect_Exception.error("Cancelled")))(Data_Map_Internal.lookup(Halogen_Query_HalogenM.ordForkId)(v1.value0)(forkMap)))(function () {
                                      return Control_Applicative.pure(Effect_Aff.applicativeAff)(v1.value1);
                                  });
                              });
                          });
                      };
                      if (v1 instanceof Halogen_Query_HalogenM.GetRef) {
                          return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v2) {
                              return Control_Applicative.pure(Effect_Aff.applicativeAff)(v1.value1(Data_Map_Internal.lookup(Data_Ord.ordString)(v1.value0)(v2.refs)));
                          });
                      };
                      throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 83, column 12 - line 133, column 33): " + [ v1.constructor.name ]);
                  };
              };
              return Control_Monad_Free.foldFree(Effect_Aff.monadRecAff)(go(initRef))(v);
          };
      };
  };
  var evalF = function (render) {
      return function (ref) {
          return function (v) {
              if (v instanceof Halogen_Query_Input.RefUpdate) {
                  return Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Data_Function.flip(Effect_Ref.modify_)(ref)(Halogen_Aff_Driver_State.mapDriverState(function (st) {
                      return {
                          component: st.component,
                          state: st.state,
                          refs: Data_Map_Internal.alter(Data_Ord.ordString)(Data_Function["const"](v.value1))(v.value0)(st.refs),
                          children: st.children,
                          childrenIn: st.childrenIn,
                          childrenOut: st.childrenOut,
                          selfRef: st.selfRef,
                          handlerRef: st.handlerRef,
                          pendingQueries: st.pendingQueries,
                          pendingOuts: st.pendingOuts,
                          pendingHandlers: st.pendingHandlers,
                          rendering: st.rendering,
                          fresh: st.fresh,
                          subscriptions: st.subscriptions,
                          forks: st.forks,
                          lifecycleHandlers: st.lifecycleHandlers
                      };
                  })));
              };
              if (v instanceof Halogen_Query_Input.Action) {
                  return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(ref)))(function (v1) {
                      return evalM(render)(ref)(v1["component"]["eval"](new Halogen_Query_HalogenQ.Action(v.value0, Data_Unit.unit)));
                  });
              };
              throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 52, column 20 - line 58, column 62): " + [ v.constructor.name ]);
          };
      };
  };
  exports["evalF"] = evalF;
  exports["evalQ"] = evalQ;
  exports["evalM"] = evalM;
  exports["handleLifecycle"] = handleLifecycle;
  exports["queueOrRun"] = queueOrRun;
  exports["handleAff"] = handleAff;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.Aff.Driver"] = $PS["Halogen.Aff.Driver"] || {};
  var exports = $PS["Halogen.Aff.Driver"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Category = $PS["Control.Category"];
  var Control_Monad_Fork_Class = $PS["Control.Monad.Fork.Class"];
  var Control_Monad_Rec_Class = $PS["Control.Monad.Rec.Class"];
  var Control_Parallel = $PS["Control.Parallel"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_List = $PS["Data.List"];
  var Data_List_Types = $PS["Data.List.Types"];
  var Data_Map_Internal = $PS["Data.Map.Internal"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Unit = $PS["Data.Unit"];
  var Effect = $PS["Effect"];
  var Effect_Aff = $PS["Effect.Aff"];
  var Effect_Class = $PS["Effect.Class"];
  var Effect_Console = $PS["Effect.Console"];
  var Effect_Exception = $PS["Effect.Exception"];
  var Effect_Ref = $PS["Effect.Ref"];
  var Halogen_Aff_Driver_Eval = $PS["Halogen.Aff.Driver.Eval"];
  var Halogen_Aff_Driver_State = $PS["Halogen.Aff.Driver.State"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_Data_Slot = $PS["Halogen.Data.Slot"];
  var Halogen_Query_HalogenQ = $PS["Halogen.Query.HalogenQ"];
  var Halogen_Query_Input = $PS["Halogen.Query.Input"];
  var Halogen_Subscription = $PS["Halogen.Subscription"];                
  var newLifecycleHandlers = Effect_Ref["new"]({
      initializers: Data_List_Types.Nil.value,
      finalizers: Data_List_Types.Nil.value
  });
  var handlePending = function (ref) {
      return function __do() {
          var queue = Effect_Ref.read(ref)();
          Effect_Ref.write(Data_Maybe.Nothing.value)(ref)();
          return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(queue)((function () {
              var $28 = Data_Foldable.traverse_(Effect_Aff.applicativeAff)(Data_List_Types.foldableList)(Control_Monad_Fork_Class.fork(Control_Monad_Fork_Class.monadForkAff));
              return function ($29) {
                  return Halogen_Aff_Driver_Eval.handleAff($28(Data_List.reverse($29)));
              };
          })())();
      };
  };
  var cleanupSubscriptionsAndForks = function (v) {
      return function __do() {
          Control_Bind.bindFlipped(Effect.bindEffect)(Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Map_Internal.foldableMap)(Halogen_Subscription.unsubscribe)))(Effect_Ref.read(v.subscriptions))();
          Effect_Ref.write(Data_Maybe.Nothing.value)(v.subscriptions)();
          Control_Bind.bindFlipped(Effect.bindEffect)(Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Map_Internal.foldableMap)((function () {
              var $30 = Effect_Aff.killFiber(Effect_Exception.error("finalized"));
              return function ($31) {
                  return Halogen_Aff_Driver_Eval.handleAff($30($31));
              };
          })()))(Effect_Ref.read(v.forks))();
          return Effect_Ref.write(Data_Map_Internal.empty)(v.forks)();
      };
  };
  var runUI = function (renderSpec) {
      return function (component) {
          return function (i) {
              var squashChildInitializers = function (lchs) {
                  return function (preInits) {
                      return Halogen_Aff_Driver_State.unDriverStateX(function (st) {
                          var parentInitializer = Halogen_Aff_Driver_Eval.evalM(render)(st.selfRef)(st["component"]["eval"](new Halogen_Query_HalogenQ.Initialize(Data_Unit.unit)));
                          return Effect_Ref.modify_(function (handlers) {
                              return {
                                  initializers: new Data_List_Types.Cons(Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Control_Parallel.parSequence_(Effect_Aff.parallelAff)(Data_List_Types.foldableList)(Data_List.reverse(handlers.initializers)))(function () {
                                      return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(parentInitializer)(function () {
                                          return Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(function __do() {
                                              handlePending(st.pendingQueries)();
                                              return handlePending(st.pendingOuts)();
                                          });
                                      });
                                  }), preInits),
                                  finalizers: handlers.finalizers
                              };
                          })(lchs);
                      });
                  };
              };
              var runComponent = function (lchs) {
                  return function (handler) {
                      return function (j) {
                          return Halogen_Component.unComponent(function (c) {
                              return function __do() {
                                  var lchs$prime = newLifecycleHandlers();
                                  var $$var = Halogen_Aff_Driver_State.initDriverState(c)(j)(handler)(lchs$prime)();
                                  var pre = Effect_Ref.read(lchs)();
                                  Effect_Ref.write({
                                      initializers: Data_List_Types.Nil.value,
                                      finalizers: pre.finalizers
                                  })(lchs)();
                                  Control_Bind.bindFlipped(Effect.bindEffect)(Halogen_Aff_Driver_State.unDriverStateX((function () {
                                      var $32 = render(lchs);
                                      return function ($33) {
                                          return $32((function (v) {
                                              return v.selfRef;
                                          })($33));
                                      };
                                  })()))(Effect_Ref.read($$var))();
                                  Control_Bind.bindFlipped(Effect.bindEffect)(squashChildInitializers(lchs)(pre.initializers))(Effect_Ref.read($$var))();
                                  return $$var;
                              };
                          });
                      };
                  };
              };
              var renderChild = function (lchs) {
                  return function (handler) {
                      return function (childrenInRef) {
                          return function (childrenOutRef) {
                              return Halogen_Component.unComponentSlot(function (slot) {
                                  return function __do() {
                                      var childrenIn = Data_Functor.map(Effect.functorEffect)(slot.pop)(Effect_Ref.read(childrenInRef))();
                                      var $$var = (function () {
                                          if (childrenIn instanceof Data_Maybe.Just) {
                                              Effect_Ref.write(childrenIn.value0.value1)(childrenInRef)();
                                              var dsx = Effect_Ref.read(childrenIn.value0.value0)();
                                              Halogen_Aff_Driver_State.unDriverStateX(function (st) {
                                                  return function __do() {
                                                      Data_Function.flip(Effect_Ref.write)(st.handlerRef)((function () {
                                                          var $34 = Data_Maybe.maybe(Control_Applicative.pure(Effect_Aff.applicativeAff)(Data_Unit.unit))(handler);
                                                          return function ($35) {
                                                              return $34(slot.output($35));
                                                          };
                                                      })())();
                                                      return Halogen_Aff_Driver_Eval.handleAff(Halogen_Aff_Driver_Eval.evalM(render)(st.selfRef)(st["component"]["eval"](new Halogen_Query_HalogenQ.Receive(slot.input, Data_Unit.unit))))();
                                                  };
                                              })(dsx)();
                                              return childrenIn.value0.value0;
                                          };
                                          if (childrenIn instanceof Data_Maybe.Nothing) {
                                              return runComponent(lchs)((function () {
                                                  var $36 = Data_Maybe.maybe(Control_Applicative.pure(Effect_Aff.applicativeAff)(Data_Unit.unit))(handler);
                                                  return function ($37) {
                                                      return $36(slot.output($37));
                                                  };
                                              })())(slot.input)(slot.component)();
                                          };
                                          throw new Error("Failed pattern match at Halogen.Aff.Driver (line 210, column 14 - line 219, column 98): " + [ childrenIn.constructor.name ]);
                                      })();
                                      var isDuplicate = Data_Functor.map(Effect.functorEffect)(function ($38) {
                                          return Data_Maybe.isJust(slot.get($38));
                                      })(Effect_Ref.read(childrenOutRef))();
                                      Control_Applicative.when(Effect.applicativeEffect)(isDuplicate)(Effect_Console.warn("Halogen: Duplicate slot address was detected during rendering, unexpected results may occur"))();
                                      Effect_Ref.modify_(slot.set($$var))(childrenOutRef)();
                                      return Control_Bind.bind(Effect.bindEffect)(Effect_Ref.read($$var))(Halogen_Aff_Driver_State.renderStateX(Effect.functorEffect)(function (v) {
                                          if (v instanceof Data_Maybe.Nothing) {
                                              return Effect_Exception["throw"]("Halogen internal error: child was not initialized in renderChild");
                                          };
                                          if (v instanceof Data_Maybe.Just) {
                                              return Control_Applicative.pure(Effect.applicativeEffect)(renderSpec.renderChild(v.value0));
                                          };
                                          throw new Error("Failed pattern match at Halogen.Aff.Driver (line 224, column 37 - line 226, column 50): " + [ v.constructor.name ]);
                                      }))();
                                  };
                              });
                          };
                      };
                  };
              };
              var render = function (lchs) {
                  return function ($$var) {
                      return function __do() {
                          var v = Effect_Ref.read($$var)();
                          var shouldProcessHandlers = Data_Functor.map(Effect.functorEffect)(Data_Maybe.isNothing)(Effect_Ref.read(v.pendingHandlers))();
                          Control_Applicative.when(Effect.applicativeEffect)(shouldProcessHandlers)(Effect_Ref.write(new Data_Maybe.Just(Data_List_Types.Nil.value))(v.pendingHandlers))();
                          Effect_Ref.write(Halogen_Data_Slot.empty)(v.childrenOut)();
                          Effect_Ref.write(v.children)(v.childrenIn)();
                          var selfRef = Control_Category.identity(Control_Category.categoryFn)(v.selfRef);
                          var pendingQueries = Control_Category.identity(Control_Category.categoryFn)(v.pendingQueries);
                          var pendingHandlers = Control_Category.identity(Control_Category.categoryFn)(v.pendingHandlers);
                          var handler = (function () {
                              var $39 = Halogen_Aff_Driver_Eval.queueOrRun(pendingHandlers);
                              var $40 = Data_Functor["void"](Effect_Aff.functorAff);
                              var $41 = Halogen_Aff_Driver_Eval.evalF(render)(selfRef);
                              return function ($42) {
                                  return $39($40($41($42)));
                              };
                          })();
                          var childHandler = (function () {
                              var $43 = Halogen_Aff_Driver_Eval.queueOrRun(pendingQueries);
                              return function ($44) {
                                  return $43(handler(Halogen_Query_Input.Action.create($44)));
                              };
                          })();
                          var rendering = renderSpec.render(function ($45) {
                              return Halogen_Aff_Driver_Eval.handleAff(handler($45));
                          })(renderChild(lchs)(childHandler)(v.childrenIn)(v.childrenOut))(v.component.render(v.state))(v.rendering)();
                          var children = Effect_Ref.read(v.childrenOut)();
                          var childrenIn = Effect_Ref.read(v.childrenIn)();
                          Halogen_Data_Slot.foreachSlot(Effect.applicativeEffect)(childrenIn)(function (v1) {
                              return function __do() {
                                  var childDS = Effect_Ref.read(v1)();
                                  Halogen_Aff_Driver_State.renderStateX_(Effect.applicativeEffect)(renderSpec.removeChild)(childDS)();
                                  return finalize(lchs)(childDS)();
                              };
                          })();
                          Data_Function.flip(Effect_Ref.modify_)(v.selfRef)(Halogen_Aff_Driver_State.mapDriverState(function (ds$prime) {
                              return {
                                  component: ds$prime.component,
                                  state: ds$prime.state,
                                  refs: ds$prime.refs,
                                  children: children,
                                  childrenIn: ds$prime.childrenIn,
                                  childrenOut: ds$prime.childrenOut,
                                  selfRef: ds$prime.selfRef,
                                  handlerRef: ds$prime.handlerRef,
                                  pendingQueries: ds$prime.pendingQueries,
                                  pendingOuts: ds$prime.pendingOuts,
                                  pendingHandlers: ds$prime.pendingHandlers,
                                  rendering: new Data_Maybe.Just(rendering),
                                  fresh: ds$prime.fresh,
                                  subscriptions: ds$prime.subscriptions,
                                  forks: ds$prime.forks,
                                  lifecycleHandlers: ds$prime.lifecycleHandlers
                              };
                          }))();
                          return Control_Applicative.when(Effect.applicativeEffect)(shouldProcessHandlers)(Data_Function.flip(Control_Monad_Rec_Class.tailRecM(Control_Monad_Rec_Class.monadRecEffect))(Data_Unit.unit)(function (v1) {
                              return function __do() {
                                  var handlers = Effect_Ref.read(pendingHandlers)();
                                  Effect_Ref.write(new Data_Maybe.Just(Data_List_Types.Nil.value))(pendingHandlers)();
                                  Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)((function () {
                                      var $46 = Data_Foldable.traverse_(Effect_Aff.applicativeAff)(Data_List_Types.foldableList)(Control_Monad_Fork_Class.fork(Control_Monad_Fork_Class.monadForkAff));
                                      return function ($47) {
                                          return Halogen_Aff_Driver_Eval.handleAff($46(Data_List.reverse($47)));
                                      };
                                  })())(handlers)();
                                  var mmore = Effect_Ref.read(pendingHandlers)();
                                  var $21 = Data_Maybe.maybe(false)(Data_List["null"])(mmore);
                                  if ($21) {
                                      return Data_Functor.voidLeft(Effect.functorEffect)(Effect_Ref.write(Data_Maybe.Nothing.value)(pendingHandlers))(new Control_Monad_Rec_Class.Done(Data_Unit.unit))();
                                  };
                                  return new Control_Monad_Rec_Class.Loop(Data_Unit.unit);
                              };
                          }))();
                      };
                  };
              };
              var finalize = function (lchs) {
                  return Halogen_Aff_Driver_State.unDriverStateX(function (st) {
                      return function __do() {
                          cleanupSubscriptionsAndForks(st)();
                          var f = Halogen_Aff_Driver_Eval.evalM(render)(st.selfRef)(st["component"]["eval"](new Halogen_Query_HalogenQ.Finalize(Data_Unit.unit)));
                          Effect_Ref.modify_(function (handlers) {
                              return {
                                  initializers: handlers.initializers,
                                  finalizers: new Data_List_Types.Cons(f, handlers.finalizers)
                              };
                          })(lchs)();
                          return Halogen_Data_Slot.foreachSlot(Effect.applicativeEffect)(st.children)(function (v) {
                              return function __do() {
                                  var dsx = Effect_Ref.read(v)();
                                  return finalize(lchs)(dsx)();
                              };
                          })();
                      };
                  });
              };
              var evalDriver = function (disposed) {
                  return function (ref) {
                      return function (q) {
                          return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.read(disposed)))(function (v) {
                              if (v) {
                                  return Control_Applicative.pure(Effect_Aff.applicativeAff)(Data_Maybe.Nothing.value);
                              };
                              return Halogen_Aff_Driver_Eval.evalQ(render)(ref)(q);
                          });
                      };
                  };
              };
              var dispose = function (disposed) {
                  return function (lchs) {
                      return function (dsx) {
                          return Halogen_Aff_Driver_Eval.handleLifecycle(lchs)(function __do() {
                              var v = Effect_Ref.read(disposed)();
                              if (v) {
                                  return Data_Unit.unit;
                              };
                              Effect_Ref.write(true)(disposed)();
                              finalize(lchs)(dsx)();
                              return Halogen_Aff_Driver_State.unDriverStateX(function (v1) {
                                  return function __do() {
                                      var v2 = Effect_Class.liftEffect(Effect_Class.monadEffectEffect)(Effect_Ref.read(v1.selfRef))();
                                      return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(v2.rendering)(renderSpec.dispose)();
                                  };
                              })(dsx)();
                          });
                      };
                  };
              };
              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(newLifecycleHandlers))(function (lchs) {
                  return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref["new"](false)))(function (disposed) {
                      return Halogen_Aff_Driver_Eval.handleLifecycle(lchs)(function __do() {
                          var sio = Halogen_Subscription.create();
                          var dsx = Control_Bind.bindFlipped(Effect.bindEffect)(Effect_Ref.read)(runComponent(lchs)((function () {
                              var $48 = Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
                              var $49 = Halogen_Subscription.notify(sio.listener);
                              return function ($50) {
                                  return $48($49($50));
                              };
                          })())(i)(component))();
                          return Halogen_Aff_Driver_State.unDriverStateX(function (st) {
                              return Control_Applicative.pure(Effect.applicativeEffect)({
                                  query: evalDriver(disposed)(st.selfRef),
                                  messages: sio.emitter,
                                  dispose: dispose(disposed)(lchs)(dsx)
                              });
                          })(dsx)();
                      });
                  });
              });
          };
      };
  };
  exports["runUI"] = runUI;
})(PS);
(function(exports) {
  "use strict";                                               

  exports._querySelector = function (selector) {
    return function (node) {
      return function () {
        return node.querySelector(selector);
      };
    };
  };
})(PS["Web.DOM.ParentNode"] = PS["Web.DOM.ParentNode"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Web.DOM.ParentNode"] = $PS["Web.DOM.ParentNode"] || {};
  var exports = $PS["Web.DOM.ParentNode"];
  var $foreign = $PS["Web.DOM.ParentNode"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Nullable = $PS["Data.Nullable"];
  var Effect = $PS["Effect"];
  var querySelector = function (qs) {
      var $0 = Data_Functor.map(Effect.functorEffect)(Data_Nullable.toMaybe);
      var $1 = $foreign["_querySelector"](qs);
      return function ($2) {
          return $0($1($2));
      };
  };
  exports["querySelector"] = querySelector;
})(PS);
(function(exports) {
  "use strict";

  exports.window = function () {
    return window;
  };
})(PS["Web.HTML"] = PS["Web.HTML"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Web.HTML"] = $PS["Web.HTML"] || {};
  var exports = $PS["Web.HTML"];
  var $foreign = $PS["Web.HTML"];
  exports["window"] = $foreign.window;
})(PS);
(function(exports) {
  "use strict";

  exports._readyState = function (doc) {
    return function () {
      return doc.readyState;
    };
  };
})(PS["Web.HTML.HTMLDocument"] = PS["Web.HTML.HTMLDocument"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Web.HTML.HTMLDocument.ReadyState"] = $PS["Web.HTML.HTMLDocument.ReadyState"] || {};
  var exports = $PS["Web.HTML.HTMLDocument.ReadyState"];
  var Data_Maybe = $PS["Data.Maybe"];                      
  var Loading = (function () {
      function Loading() {

      };
      Loading.value = new Loading();
      return Loading;
  })();
  var Interactive = (function () {
      function Interactive() {

      };
      Interactive.value = new Interactive();
      return Interactive;
  })();
  var Complete = (function () {
      function Complete() {

      };
      Complete.value = new Complete();
      return Complete;
  })();
  var parse = function (v) {
      if (v === "loading") {
          return new Data_Maybe.Just(Loading.value);
      };
      if (v === "interactive") {
          return new Data_Maybe.Just(Interactive.value);
      };
      if (v === "complete") {
          return new Data_Maybe.Just(Complete.value);
      };
      return Data_Maybe.Nothing.value;
  };
  exports["Loading"] = Loading;
  exports["parse"] = parse;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Web.HTML.HTMLDocument"] = $PS["Web.HTML.HTMLDocument"] || {};
  var exports = $PS["Web.HTML.HTMLDocument"];
  var $foreign = $PS["Web.HTML.HTMLDocument"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Effect = $PS["Effect"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var Web_HTML_HTMLDocument_ReadyState = $PS["Web.HTML.HTMLDocument.ReadyState"];
  var toParentNode = Unsafe_Coerce.unsafeCoerce; 
  var toDocument = Unsafe_Coerce.unsafeCoerce;
  var readyState = (function () {
      var $0 = Data_Functor.map(Effect.functorEffect)((function () {
          var $2 = Data_Maybe.fromMaybe(Web_HTML_HTMLDocument_ReadyState.Loading.value);
          return function ($3) {
              return $2(Web_HTML_HTMLDocument_ReadyState.parse($3));
          };
      })());
      return function ($1) {
          return $0($foreign["_readyState"]($1));
      };
  })();
  exports["toDocument"] = toDocument;
  exports["toParentNode"] = toParentNode;
  exports["readyState"] = readyState;
})(PS);
(function(exports) {
  "use strict";

  exports._read = function (nothing, just, value) {
    var tag = Object.prototype.toString.call(value);
    if (tag.indexOf("[object HTML") === 0 && tag.indexOf("Element]") === tag.length - 8) {
      return just(value);
    } else {
      return nothing;
    }
  };
})(PS["Web.HTML.HTMLElement"] = PS["Web.HTML.HTMLElement"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Web.HTML.HTMLElement"] = $PS["Web.HTML.HTMLElement"] || {};
  var exports = $PS["Web.HTML.HTMLElement"];
  var $foreign = $PS["Web.HTML.HTMLElement"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                   
  var toNode = Unsafe_Coerce.unsafeCoerce;
  var fromElement = function (x) {
      return $foreign["_read"](Data_Maybe.Nothing.value, Data_Maybe.Just.create, x);
  };
  exports["fromElement"] = fromElement;
  exports["toNode"] = toNode;
})(PS);
(function(exports) {
  "use strict";

  exports.document = function (window) {
    return function () {
      return window.document;
    };
  };
})(PS["Web.HTML.Window"] = PS["Web.HTML.Window"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Web.HTML.Window"] = $PS["Web.HTML.Window"] || {};
  var exports = $PS["Web.HTML.Window"];
  var $foreign = $PS["Web.HTML.Window"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];
  var toEventTarget = Unsafe_Coerce.unsafeCoerce;
  exports["toEventTarget"] = toEventTarget;
  exports["document"] = $foreign.document;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.Aff.Util"] = $PS["Halogen.Aff.Util"] || {};
  var exports = $PS["Halogen.Aff.Util"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Monad_Error_Class = $PS["Control.Monad.Error.Class"];
  var Data_Either = $PS["Data.Either"];
  var Data_Function = $PS["Data.Function"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Unit = $PS["Data.Unit"];
  var Effect = $PS["Effect"];
  var Effect_Aff = $PS["Effect.Aff"];
  var Effect_Class = $PS["Effect.Class"];
  var Effect_Exception = $PS["Effect.Exception"];
  var Web_DOM_ParentNode = $PS["Web.DOM.ParentNode"];
  var Web_Event_EventTarget = $PS["Web.Event.EventTarget"];
  var Web_HTML = $PS["Web.HTML"];
  var Web_HTML_Event_EventTypes = $PS["Web.HTML.Event.EventTypes"];
  var Web_HTML_HTMLDocument = $PS["Web.HTML.HTMLDocument"];
  var Web_HTML_HTMLDocument_ReadyState = $PS["Web.HTML.HTMLDocument.ReadyState"];
  var Web_HTML_HTMLElement = $PS["Web.HTML.HTMLElement"];
  var Web_HTML_Window = $PS["Web.HTML.Window"];                
  var selectElement = function (query) {
      return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Control_Bind.bindFlipped(Effect.bindEffect)(Control_Bind.composeKleisliFlipped(Effect.bindEffect)((function () {
          var $2 = Web_DOM_ParentNode.querySelector(query);
          return function ($3) {
              return $2(Web_HTML_HTMLDocument.toParentNode($3));
          };
      })())(Web_HTML_Window.document))(Web_HTML.window)))(function (mel) {
          return Control_Applicative.pure(Effect_Aff.applicativeAff)(Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(Web_HTML_HTMLElement.fromElement)(mel));
      });
  };
  var runHalogenAff = Effect_Aff.runAff_(Data_Either.either(Effect_Exception.throwException)(Data_Function["const"](Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit))));
  var awaitLoad = Effect_Aff.makeAff(function (callback) {
      return function __do() {
          var rs = Control_Bind.bindFlipped(Effect.bindEffect)(Web_HTML_HTMLDocument.readyState)(Control_Bind.bindFlipped(Effect.bindEffect)(Web_HTML_Window.document)(Web_HTML.window))();
          if (rs instanceof Web_HTML_HTMLDocument_ReadyState.Loading) {
              var et = Data_Functor.map(Effect.functorEffect)(Web_HTML_Window.toEventTarget)(Web_HTML.window)();
              var listener = Web_Event_EventTarget.eventListener(function (v) {
                  return callback(new Data_Either.Right(Data_Unit.unit));
              })();
              Web_Event_EventTarget.addEventListener(Web_HTML_Event_EventTypes.domcontentloaded)(listener)(false)(et)();
              return Effect_Aff.effectCanceler(Web_Event_EventTarget.removeEventListener(Web_HTML_Event_EventTypes.domcontentloaded)(listener)(false)(et));
          };
          callback(new Data_Either.Right(Data_Unit.unit))();
          return Effect_Aff.nonCanceler;
      };
  });
  var awaitBody = Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(awaitLoad)(function () {
      return Control_Bind.bind(Effect_Aff.bindAff)(selectElement("body"))(function (body) {
          return Data_Maybe.maybe(Control_Monad_Error_Class.throwError(Effect_Aff.monadThrowAff)(Effect_Exception.error("Could not find body")))(Control_Applicative.pure(Effect_Aff.applicativeAff))(body);
      });
  });
  exports["awaitBody"] = awaitBody;
  exports["runHalogenAff"] = runHalogenAff;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Web.DOM.Element"] = $PS["Web.DOM.Element"] || {};
  var exports = $PS["Web.DOM.Element"];
  var Unsafe_Coerce = $PS["Unsafe.Coerce"];                   
  var toNode = Unsafe_Coerce.unsafeCoerce;
  exports["toNode"] = toNode;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.VDom.DOM"] = $PS["Halogen.VDom.DOM"] || {};
  var exports = $PS["Halogen.VDom.DOM"];
  var Data_Array = $PS["Data.Array"];
  var Data_Boolean = $PS["Data.Boolean"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Nullable = $PS["Data.Nullable"];
  var Data_Tuple = $PS["Data.Tuple"];
  var Halogen_VDom_Machine = $PS["Halogen.VDom.Machine"];
  var Halogen_VDom_Types = $PS["Halogen.VDom.Types"];
  var Halogen_VDom_Util = $PS["Halogen.VDom.Util"];
  var Web_DOM_Element = $PS["Web.DOM.Element"];
  var haltWidget = function (v) {
      return Halogen_VDom_Machine.halt(v.widget);
  };
  var patchWidget = function (state, vdom) {
      if (vdom instanceof Halogen_VDom_Types.Grafted) {
          return patchWidget(state, Halogen_VDom_Types.runGraft(vdom.value0));
      };
      if (vdom instanceof Halogen_VDom_Types.Widget) {
          var res = Halogen_VDom_Machine.step(state.widget, vdom.value0);
          var res$prime = Halogen_VDom_Machine.unStep(function (v) {
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(v.value0, {
                  build: state.build,
                  widget: res
              }, patchWidget, haltWidget));
          })(res);
          return res$prime;
      };
      haltWidget(state);
      return state.build(vdom);
  };
  var haltText = function (v) {
      var parent = Halogen_VDom_Util.parentNode(v.node);
      return Halogen_VDom_Util.removeChild(v.node, parent);
  };
  var patchText = function (state, vdom) {
      if (vdom instanceof Halogen_VDom_Types.Grafted) {
          return patchText(state, Halogen_VDom_Types.runGraft(vdom.value0));
      };
      if (vdom instanceof Halogen_VDom_Types.Text) {
          if (state.value === vdom.value0) {
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(state.node, state, patchText, haltText));
          };
          if (Data_Boolean.otherwise) {
              var nextState = {
                  build: state.build,
                  node: state.node,
                  value: vdom.value0
              };
              Halogen_VDom_Util.setTextContent(vdom.value0, state.node);
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(state.node, nextState, patchText, haltText));
          };
      };
      haltText(state);
      return state.build(vdom);
  };
  var haltKeyed = function (v) {
      var parent = Halogen_VDom_Util.parentNode(v.node);
      Halogen_VDom_Util.removeChild(v.node, parent);
      Halogen_VDom_Util.forInE(v.children, function (v1, s) {
          return Halogen_VDom_Machine.halt(s);
      });
      return Halogen_VDom_Machine.halt(v.attrs);
  };
  var haltElem = function (v) {
      var parent = Halogen_VDom_Util.parentNode(v.node);
      Halogen_VDom_Util.removeChild(v.node, parent);
      Halogen_VDom_Util.forEachE(v.children, Halogen_VDom_Machine.halt);
      return Halogen_VDom_Machine.halt(v.attrs);
  };
  var eqElemSpec = function (ns1, v, ns2, v1) {
      var $58 = v === v1;
      if ($58) {
          if (ns1 instanceof Data_Maybe.Just && (ns2 instanceof Data_Maybe.Just && ns1.value0 === ns2.value0)) {
              return true;
          };
          if (ns1 instanceof Data_Maybe.Nothing && ns2 instanceof Data_Maybe.Nothing) {
              return true;
          };
          return false;
      };
      return false;
  };
  var patchElem = function (state, vdom) {
      if (vdom instanceof Halogen_VDom_Types.Grafted) {
          return patchElem(state, Halogen_VDom_Types.runGraft(vdom.value0));
      };
      if (vdom instanceof Halogen_VDom_Types.Elem && eqElemSpec(state.ns, state.name, vdom.value0, vdom.value1)) {
          var v = Data_Array.length(vdom.value3);
          var v1 = Data_Array.length(state.children);
          if (v1 === 0 && v === 0) {
              var attrs2 = Halogen_VDom_Machine.step(state.attrs, vdom.value2);
              var nextState = {
                  build: state.build,
                  node: state.node,
                  attrs: attrs2,
                  ns: vdom.value0,
                  name: vdom.value1,
                  children: state.children
              };
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(state.node, nextState, patchElem, haltElem));
          };
          var onThis = function (v2, s) {
              return Halogen_VDom_Machine.halt(s);
          };
          var onThese = function (ix, s, v2) {
              var res = Halogen_VDom_Machine.step(s, v2);
              Halogen_VDom_Util.insertChildIx(ix, Halogen_VDom_Machine.extract(res), state.node);
              return res;
          };
          var onThat = function (ix, v2) {
              var res = state.build(v2);
              Halogen_VDom_Util.insertChildIx(ix, Halogen_VDom_Machine.extract(res), state.node);
              return res;
          };
          var children2 = Halogen_VDom_Util.diffWithIxE(state.children, vdom.value3, onThese, onThis, onThat);
          var attrs2 = Halogen_VDom_Machine.step(state.attrs, vdom.value2);
          var nextState = {
              build: state.build,
              node: state.node,
              attrs: attrs2,
              ns: vdom.value0,
              name: vdom.value1,
              children: children2
          };
          return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(state.node, nextState, patchElem, haltElem));
      };
      haltElem(state);
      return state.build(vdom);
  };
  var patchKeyed = function (state, vdom) {
      if (vdom instanceof Halogen_VDom_Types.Grafted) {
          return patchKeyed(state, Halogen_VDom_Types.runGraft(vdom.value0));
      };
      if (vdom instanceof Halogen_VDom_Types.Keyed && eqElemSpec(state.ns, state.name, vdom.value0, vdom.value1)) {
          var v = Data_Array.length(vdom.value3);
          if (state.length === 0 && v === 0) {
              var attrs2 = Halogen_VDom_Machine.step(state.attrs, vdom.value2);
              var nextState = {
                  build: state.build,
                  node: state.node,
                  attrs: attrs2,
                  ns: vdom.value0,
                  name: vdom.value1,
                  children: state.children,
                  length: 0
              };
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(state.node, nextState, patchKeyed, haltKeyed));
          };
          var onThis = function (v2, s) {
              return Halogen_VDom_Machine.halt(s);
          };
          var onThese = function (v2, ix$prime, s, v3) {
              var res = Halogen_VDom_Machine.step(s, v3.value1);
              Halogen_VDom_Util.insertChildIx(ix$prime, Halogen_VDom_Machine.extract(res), state.node);
              return res;
          };
          var onThat = function (v2, ix, v3) {
              var res = state.build(v3.value1);
              Halogen_VDom_Util.insertChildIx(ix, Halogen_VDom_Machine.extract(res), state.node);
              return res;
          };
          var children2 = Halogen_VDom_Util.diffWithKeyAndIxE(state.children, vdom.value3, Data_Tuple.fst, onThese, onThis, onThat);
          var attrs2 = Halogen_VDom_Machine.step(state.attrs, vdom.value2);
          var nextState = {
              build: state.build,
              node: state.node,
              attrs: attrs2,
              ns: vdom.value0,
              name: vdom.value1,
              children: children2,
              length: v
          };
          return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(state.node, nextState, patchKeyed, haltKeyed));
      };
      haltKeyed(state);
      return state.build(vdom);
  };
  var buildWidget = function (v, build, w) {
      var res = v.buildWidget(v)(w);
      var res$prime = Halogen_VDom_Machine.unStep(function (v1) {
          return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(v1.value0, {
              build: build,
              widget: res
          }, patchWidget, haltWidget));
      })(res);
      return res$prime;
  };
  var buildText = function (v, build, s) {
      var node = Halogen_VDom_Util.createTextNode(s, v.document);
      var state = {
          build: build,
          node: node,
          value: s
      };
      return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(node, state, patchText, haltText));
  };
  var buildKeyed = function (v, build, ns1, name1, as1, ch1) {
      var el = Halogen_VDom_Util.createElement(Data_Nullable.toNullable(ns1), name1, v.document);
      var node = Web_DOM_Element.toNode(el);
      var onChild = function (v1, ix, v2) {
          var res = build(v2.value1);
          Halogen_VDom_Util.insertChildIx(ix, Halogen_VDom_Machine.extract(res), node);
          return res;
      };
      var children = Halogen_VDom_Util.strMapWithIxE(ch1, Data_Tuple.fst, onChild);
      var attrs = v.buildAttributes(el)(as1);
      var state = {
          build: build,
          node: node,
          attrs: attrs,
          ns: ns1,
          name: name1,
          children: children,
          length: Data_Array.length(ch1)
      };
      return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(node, state, patchKeyed, haltKeyed));
  };
  var buildElem = function (v, build, ns1, name1, as1, ch1) {
      var el = Halogen_VDom_Util.createElement(Data_Nullable.toNullable(ns1), name1, v.document);
      var node = Web_DOM_Element.toNode(el);
      var onChild = function (ix, child) {
          var res = build(child);
          Halogen_VDom_Util.insertChildIx(ix, Halogen_VDom_Machine.extract(res), node);
          return res;
      };
      var children = Halogen_VDom_Util.forE(ch1, onChild);
      var attrs = v.buildAttributes(el)(as1);
      var state = {
          build: build,
          node: node,
          attrs: attrs,
          ns: ns1,
          name: name1,
          children: children
      };
      return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(node, state, patchElem, haltElem));
  };
  var buildVDom = function (spec) {
      var build = function (v) {
          if (v instanceof Halogen_VDom_Types.Text) {
              return buildText(spec, build, v.value0);
          };
          if (v instanceof Halogen_VDom_Types.Elem) {
              return buildElem(spec, build, v.value0, v.value1, v.value2, v.value3);
          };
          if (v instanceof Halogen_VDom_Types.Keyed) {
              return buildKeyed(spec, build, v.value0, v.value1, v.value2, v.value3);
          };
          if (v instanceof Halogen_VDom_Types.Widget) {
              return buildWidget(spec, build, v.value0);
          };
          if (v instanceof Halogen_VDom_Types.Grafted) {
              return build(Halogen_VDom_Types.runGraft(v.value0));
          };
          throw new Error("Failed pattern match at Halogen.VDom.DOM (line 58, column 27 - line 63, column 52): " + [ v.constructor.name ]);
      };
      return build;
  };
  exports["buildVDom"] = buildVDom;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.VDom.Thunk"] = $PS["Halogen.VDom.Thunk"] || {};
  var exports = $PS["Halogen.VDom.Thunk"];
  var Halogen_VDom_DOM = $PS["Halogen.VDom.DOM"];
  var Halogen_VDom_Machine = $PS["Halogen.VDom.Machine"];
  var Halogen_VDom_Util = $PS["Halogen.VDom.Util"];        
  var Thunk = (function () {
      function Thunk(value0, value1, value2, value3) {
          this.value0 = value0;
          this.value1 = value1;
          this.value2 = value2;
          this.value3 = value3;
      };
      Thunk.create = function (value0) {
          return function (value1) {
              return function (value2) {
                  return function (value3) {
                      return new Thunk(value0, value1, value2, value3);
                  };
              };
          };
      };
      return Thunk;
  })();                                          
  var unsafeEqThunk = function (v, v1) {
      return Halogen_VDom_Util.refEq(v.value0, v1.value0) && (Halogen_VDom_Util.refEq(v.value1, v1.value1) && v.value1(v.value3, v1.value3));
  };
  var thunk = function (tid, eqFn, f, a) {
      return new Thunk(tid, eqFn, f, a);
  };
  var runThunk = function (v) {
      return v.value2(v.value3);
  };
  var buildThunk = function (toVDom) {
      var haltThunk = function (state) {
          return Halogen_VDom_Machine.halt(state.vdom);
      };
      var patchThunk = function (state, t2) {
          var $43 = unsafeEqThunk(state.thunk, t2);
          if ($43) {
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(Halogen_VDom_Machine.extract(state.vdom), state, patchThunk, haltThunk));
          };
          var vdom = Halogen_VDom_Machine.step(state.vdom, toVDom(runThunk(t2)));
          return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(Halogen_VDom_Machine.extract(vdom), {
              vdom: vdom,
              thunk: t2
          }, patchThunk, haltThunk));
      };
      var renderThunk = function (spec) {
          return function (t) {
              var vdom = Halogen_VDom_DOM.buildVDom(spec)(toVDom(runThunk(t)));
              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(Halogen_VDom_Machine.extract(vdom), {
                  thunk: t,
                  vdom: vdom
              }, patchThunk, haltThunk));
          };
      };
      return renderThunk;
  };
  exports["buildThunk"] = buildThunk;
})(PS);
(function(exports) {
  "use strict";

  var getEffProp = function (name) {
    return function (node) {
      return function () {
        return node[name];
      };
    };
  };                                                   

  exports._parentNode = getEffProp("parentNode");          

  exports._nextSibling = getEffProp("nextSibling");

  exports.insertBefore = function (node1) {
    return function (node2) {
      return function (parent) {
        return function () {
          parent.insertBefore(node1, node2);
        };
      };
    };
  };

  exports.appendChild = function (node) {
    return function (parent) {
      return function () {
        parent.appendChild(node);
      };
    };
  };

  exports.removeChild = function (node) {
    return function (parent) {
      return function () {
        parent.removeChild(node);
      };
    };
  };
})(PS["Web.DOM.Node"] = PS["Web.DOM.Node"] || {});
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Web.DOM.Node"] = $PS["Web.DOM.Node"] || {};
  var exports = $PS["Web.DOM.Node"];
  var $foreign = $PS["Web.DOM.Node"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_Nullable = $PS["Data.Nullable"];
  var Effect = $PS["Effect"];
  var parentNode = (function () {
      var $2 = Data_Functor.map(Effect.functorEffect)(Data_Nullable.toMaybe);
      return function ($3) {
          return $2($foreign["_parentNode"]($3));
      };
  })();
  var nextSibling = (function () {
      var $13 = Data_Functor.map(Effect.functorEffect)(Data_Nullable.toMaybe);
      return function ($14) {
          return $13($foreign["_nextSibling"]($14));
      };
  })();
  exports["parentNode"] = parentNode;
  exports["nextSibling"] = nextSibling;
  exports["insertBefore"] = $foreign.insertBefore;
  exports["appendChild"] = $foreign.appendChild;
  exports["removeChild"] = $foreign.removeChild;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Halogen.VDom.Driver"] = $PS["Halogen.VDom.Driver"] || {};
  var exports = $PS["Halogen.VDom.Driver"];
  var Control_Applicative = $PS["Control.Applicative"];
  var Control_Bind = $PS["Control.Bind"];
  var Control_Category = $PS["Control.Category"];
  var Data_Foldable = $PS["Data.Foldable"];
  var Data_Functor = $PS["Data.Functor"];
  var Data_HeytingAlgebra = $PS["Data.HeytingAlgebra"];
  var Data_Maybe = $PS["Data.Maybe"];
  var Data_Newtype = $PS["Data.Newtype"];
  var Data_Unit = $PS["Data.Unit"];
  var Effect = $PS["Effect"];
  var Effect_Aff = $PS["Effect.Aff"];
  var Effect_Class = $PS["Effect.Class"];
  var Effect_Ref = $PS["Effect.Ref"];
  var Halogen_Aff_Driver = $PS["Halogen.Aff.Driver"];
  var Halogen_Aff_Driver_State = $PS["Halogen.Aff.Driver.State"];
  var Halogen_Component = $PS["Halogen.Component"];
  var Halogen_VDom_DOM = $PS["Halogen.VDom.DOM"];
  var Halogen_VDom_DOM_Prop = $PS["Halogen.VDom.DOM.Prop"];
  var Halogen_VDom_Machine = $PS["Halogen.VDom.Machine"];
  var Halogen_VDom_Thunk = $PS["Halogen.VDom.Thunk"];
  var Unsafe_Reference = $PS["Unsafe.Reference"];
  var Web_DOM_Node = $PS["Web.DOM.Node"];
  var Web_HTML = $PS["Web.HTML"];
  var Web_HTML_HTMLDocument = $PS["Web.HTML.HTMLDocument"];
  var Web_HTML_HTMLElement = $PS["Web.HTML.HTMLElement"];
  var Web_HTML_Window = $PS["Web.HTML.Window"];
  var substInParent = function (v) {
      return function (v1) {
          return function (v2) {
              if (v1 instanceof Data_Maybe.Just && v2 instanceof Data_Maybe.Just) {
                  return Data_Functor["void"](Effect.functorEffect)(Web_DOM_Node.insertBefore(v)(v1.value0)(v2.value0));
              };
              if (v1 instanceof Data_Maybe.Nothing && v2 instanceof Data_Maybe.Just) {
                  return Data_Functor["void"](Effect.functorEffect)(Web_DOM_Node.appendChild(v)(v2.value0));
              };
              return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
          };
      };
  };
  var removeChild = function (v) {
      return function __do() {
          var npn = Web_DOM_Node.parentNode(v.node)();
          return Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(function (pn) {
              return Web_DOM_Node.removeChild(v.node)(pn);
          })(npn)();
      };
  };
  var mkSpec = function (handler) {
      return function (renderChildRef) {
          return function (document) {
              var getNode = Halogen_Aff_Driver_State.unRenderStateX(function (v) {
                  return v.node;
              });
              var done = function (st) {
                  if (st instanceof Data_Maybe.Just) {
                      return Halogen_VDom_Machine.halt(st.value0);
                  };
                  return Data_Unit.unit;
              };
              var buildWidget = function (spec) {
                  var buildThunk = Halogen_VDom_Thunk.buildThunk(Data_Newtype.unwrap())(spec);
                  var renderComponentSlot = function (cs) {
                      var renderChild = Effect_Ref.read(renderChildRef)();
                      var rsx = renderChild(cs)();
                      var node = getNode(rsx);
                      return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(node, Data_Maybe.Nothing.value, patch, done));
                  };
                  var render = function (slot) {
                      if (slot instanceof Halogen_Component.ComponentSlot) {
                          return renderComponentSlot(slot.value0);
                      };
                      if (slot instanceof Halogen_Component.ThunkSlot) {
                          var step = buildThunk(slot.value0);
                          return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(Halogen_VDom_Machine.extract(step), new Data_Maybe.Just(step), patch, done));
                      };
                      throw new Error("Failed pattern match at Halogen.VDom.Driver (line 85, column 7 - line 90, column 75): " + [ slot.constructor.name ]);
                  };
                  var patch = function (st, slot) {
                      if (st instanceof Data_Maybe.Just) {
                          if (slot instanceof Halogen_Component.ComponentSlot) {
                              Halogen_VDom_Machine.halt(st.value0);
                              return renderComponentSlot(slot.value0);
                          };
                          if (slot instanceof Halogen_Component.ThunkSlot) {
                              var step$prime = Halogen_VDom_Machine.step(st.value0, slot.value0);
                              return Halogen_VDom_Machine.mkStep(new Halogen_VDom_Machine.Step(Halogen_VDom_Machine.extract(step$prime), new Data_Maybe.Just(step$prime), patch, done));
                          };
                          throw new Error("Failed pattern match at Halogen.VDom.Driver (line 98, column 22 - line 104, column 79): " + [ slot.constructor.name ]);
                      };
                      return render(slot);
                  };
                  return render;
              };
              var buildAttributes = Halogen_VDom_DOM_Prop.buildProp(handler);
              return {
                  buildWidget: buildWidget,
                  buildAttributes: buildAttributes,
                  document: document
              };
          };
      };
  };
  var renderSpec = function (document) {
      return function (container) {
          var render = function (handler) {
              return function (child) {
                  return function (v) {
                      return function (v1) {
                          if (v1 instanceof Data_Maybe.Nothing) {
                              return function __do() {
                                  var renderChildRef = Effect_Ref["new"](child)();
                                  var spec = mkSpec(handler)(renderChildRef)(document);
                                  var machine = Halogen_VDom_DOM.buildVDom(spec)(v);
                                  var node = Halogen_VDom_Machine.extract(machine);
                                  Data_Functor["void"](Effect.functorEffect)(Web_DOM_Node.appendChild(node)(Web_HTML_HTMLElement.toNode(container)))();
                                  return {
                                      machine: machine,
                                      node: node,
                                      renderChildRef: renderChildRef
                                  };
                              };
                          };
                          if (v1 instanceof Data_Maybe.Just) {
                              return function __do() {
                                  Effect_Ref.write(child)(v1.value0.renderChildRef)();
                                  var parent = Web_DOM_Node.parentNode(v1.value0.node)();
                                  var nextSib = Web_DOM_Node.nextSibling(v1.value0.node)();
                                  var machine$prime = Halogen_VDom_Machine.step(v1.value0.machine, v);
                                  var newNode = Halogen_VDom_Machine.extract(machine$prime);
                                  Control_Applicative.when(Effect.applicativeEffect)(Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean)))(Unsafe_Reference.unsafeRefEq)(v1.value0.node)(newNode))(substInParent(newNode)(nextSib)(parent))();
                                  return {
                                      machine: machine$prime,
                                      node: newNode,
                                      renderChildRef: v1.value0.renderChildRef
                                  };
                              };
                          };
                          throw new Error("Failed pattern match at Halogen.VDom.Driver (line 159, column 5 - line 175, column 80): " + [ v1.constructor.name ]);
                      };
                  };
              };
          };
          return {
              render: render,
              renderChild: Control_Category.identity(Control_Category.categoryFn),
              removeChild: removeChild,
              dispose: removeChild
          };
      };
  };
  var runUI = function (component) {
      return function (i) {
          return function (element) {
              return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Data_Functor.map(Effect.functorEffect)(Web_HTML_HTMLDocument.toDocument)(Control_Bind.bindFlipped(Effect.bindEffect)(Web_HTML_Window.document)(Web_HTML.window))))(function (document) {
                  return Halogen_Aff_Driver.runUI(renderSpec(document)(element))(component)(i);
              });
          };
      };
  };
  exports["runUI"] = runUI;
})(PS);
(function($PS) {
  // Generated by purs version 0.14.7
  "use strict";
  $PS["Main"] = $PS["Main"] || {};
  var exports = $PS["Main"];
  var App_Estimator = $PS["App.Estimator"];
  var Control_Bind = $PS["Control.Bind"];
  var Data_Unit = $PS["Data.Unit"];
  var Effect_Aff = $PS["Effect.Aff"];
  var Halogen_Aff_Util = $PS["Halogen.Aff.Util"];
  var Halogen_VDom_Driver = $PS["Halogen.VDom.Driver"];                
  var main = Halogen_Aff_Util.runHalogenAff(Control_Bind.bind(Effect_Aff.bindAff)(Halogen_Aff_Util.awaitBody)(function (body) {
      return Halogen_VDom_Driver.runUI(App_Estimator.component)(Data_Unit.unit)(body);
  }));
  exports["main"] = main;
})(PS);
PS["Main"].main();